webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);



var apiMixin = {
  methods: {
    hasRole: function hasRole(role) {
      var roles = JSON.parse(this.$ls.get('role'));
      for (var i = 0; i < roles.length; i++) {
        if (roles[i] === role) {
          return true;
        }
      }
      return false;
    },
    getClient: function getClient(clientId) {
      var _this = this;

      this.clientPending = true;
      this.$http.get('client/' + clientId).then(function (response) {
        _this.client = response.data;
        _this.clientPending = false;
      }, function (response) {
        _this.clientError = response.body.error;
        _this.clientPending = false;
      });
    },
    getDayVisits: function getDayVisits(getParams) {
      var _this2 = this;

      this.visitsPending = true;
      this.$http.get('visit_day', { params: getParams }).then(function (response) {
        _this2.visits = response.data;
        _this2.visitsPending = false;
        _this2.visitsDone = true;
      }).catch(function (error) {
        _this2.visitsError = error.response.data.errors;
        _this2.visitsPending = false;
      });
    },
    getDayVisitTasks: function getDayVisitTasks(getParams) {
      var _this3 = this;

      this.visitsPending = true;
      this.$http.get('visit_task/day', { params: getParams }).then(function (response) {
        _this3.visits = response.data;
        _this3.visitsPending = false;
      }).catch(function (error) {
        _this3.visitsError = error.response.data.errors;
        _this3.visitsPending = false;
      });
    },
    getAllergies: function getAllergies(getParams) {
      this.getPaginatedList('allergy', getParams);
    },
    getResults: function getResults(getParams) {
      this.getPaginatedList('result/new', getParams);
    },
    getDocuments: function getDocuments(getParams) {
      this.getPaginatedList('document', getParams);
    },
    getContractualReports: function getContractualReports(getParams) {
      this.getPaginatedList('contractual_reports', getParams);
    },
    getTasks: function getTasks(getParams) {
      this.getPaginatedList('visit_task', getParams);
    },
    getPaginatedList: function getPaginatedList(getUrl, getParams) {
      var _this4 = this;

      this.listPending = true;
      this.$http.get(getUrl, { params: getParams }).then(function (response) {
        _this4.listPending = false;
        _this4.listData = response.data.data;
        _this4.listPagination = response.data.pagination || null;
      }).catch(function (error) {
        _this4.listError = error.response.data.errors;
        _this4.listPending = false;
      });
    },
    getGenerateContractualReports: function getGenerateContractualReports(getParams) {
      var _this5 = this;

      this.generateContractualReportsPending = true;
      this.generateContractualReportsDone = false;
      this.$http.get('new_contractual_reporting_file', { params: getParams }).then(function (response) {
        _this5.generateContractualReports = response.data;
        _this5.generateContractualReportsPending = false;
        _this5.generateContractualReportsDone = true;
      }).catch(function (error) {
        _this5.generateContractualReportsError = error.response.data.errors;
        _this5.generateContractualReportsPending = false;
        _this5.generateContractualReportsDone = false;
      });
    },
    deleteContractualReport: function deleteContractualReport(id) {
      var _this6 = this;

      this.deleteContractualReportPending = true;
      this.$http.delete('contractual_report/' + id, { emulateJSON: true }).then(function (response) {
        _this6.deleteContractualReportPending = false;
        _this6.deleteContractualReportDone = true;
      }).catch(function (error) {
        _this6.deleteContractualReportError = error.response.data.errors;
        _this6.deleteContractualReportPending = false;
      });
    },
    getMonthStatistics: function getMonthStatistics(getParams) {
      var _this7 = this;

      this.monthStatisticsPending = true;
      this.monthStatisticsDone = false;
      this.$http.get('statistics/month', { params: getParams }).then(function (response) {
        _this7.monthStatistics = response.data;
        _this7.monthStatisticsPending = false;
        _this7.monthStatisticsDone = true;
      }).catch(function (error) {
        _this7.monthStatisticsError = error.response.data.errors;
        _this7.monthStatisticsPending = false;
        _this7.monthStatisticsDone = false;
      });
    },
    getTasksOld: function getTasksOld(getParams) {
      var _this8 = this;

      this.tasksPending = true;
      this.$http.get('task_for_medic', { params: getParams }).then(function (response) {
        _this8.tasks = response.data;
        _this8.tasksPending = false;
      }).catch(function (error) {
        _this8.tasksError = error.response.data.errors;
        _this8.tasksPending = false;
        _this8.tasks = false;
      });
    },
    getTasksCreatedByMedic: function getTasksCreatedByMedic(getParams) {
      var _this9 = this;

      this.tasksPending = true;
      this.$http.get('task_created_by_medic', { params: getParams }).then(function (response) {
        _this9.tasks = response.data;
        _this9.tasksPending = false;
      }).catch(function (error) {
        _this9.tasksError = error.response.data.errors;
        _this9.tasksPending = false;
        _this9.tasks = false;
      });
    },
    getClientsTasks: function getClientsTasks(getParams, clientId) {
      var _this10 = this;

      this.tasksPending = true;
      this.$http.get('client/' + clientId + '/tasks', { params: getParams }).then(function (response) {
        _this10.tasks = response.data;
        _this10.tasksPending = false;
      }).catch(function (error) {
        _this10.tasksError = error.response.data.errors;
        _this10.tasksPending = false;
      });
    },
    getTaskTemplates: function getTaskTemplates() {
      var _this11 = this;

      this.waitForData = true;
      this.$http.get('task_template').then(function (response) {
        _this11.taskTemplates = response.data;
        _this11.waitForData = false;
      }).catch(function (error) {
        _this11.taskTemplatesError = error.response.data.errors;
        _this11.waitForData = false;
      });
    },
    getMedics: function getMedics() {
      var _this12 = this;

      this.waitForData = true;
      this.$http.get('medic').then(function (response) {
        _this12.medics = response.data;
        _this12.waitForData = false;
      }).catch(function (error) {
        _this12.medicsError = error.response.data.errors;
        _this12.waitForData = false;
      });
    },
    getClientPreviousTasks: function getClientPreviousTasks(getParams) {
      var _this13 = this;

      this.clientPreviousTasksPending = true;
      this.$http.get('result', { params: getParams }).then(function (response) {
        _this13.clientPreviousTasks = response.data;
        _this13.clientPreviousTasksPending = false;
      }).catch(function (error) {
        _this13.clientPreviousTasksError = error.response.data.errors;
        _this13.clientPreviousTasksPending = false;
      });
    },
    getMedicalReportOfClient: function getMedicalReportOfClient(clientId) {
      var _this14 = this;

      this.medicalReportsPending = true;
      this.$http.get('client/' + clientId + '/medical_report').then(function (response) {
        _this14.medicalReports = response.data;
        _this14.medicalReportsPending = false;
      }).catch(function (error) {
        _this14.medicalReportsError = error.response.data.errors;
        _this14.medicalReportsPending = false;
      });
    },
    getMedicalReportAndLabResultOfClient: function getMedicalReportAndLabResultOfClient(clientId, exceptVisitId) {
      var _this15 = this;

      this.tasksPending = true;
      this.$http.get('client/' + clientId + '/medical_report_lab_result', { params: { 'visit_id': exceptVisitId } }).then(function (response) {
        _this15.tasks = response.data;
        _this15.tasksPending = false;
      }).catch(function (error) {
        _this15.tasksError = error.response.data.errors;
        _this15.tasksPending = false;
      });
    },
    getClientAnamnesisByVisit: function getClientAnamnesisByVisit(visitId) {
      var _this16 = this;

      this.clientAnamnesisPending = true;
      this.clientAnamnesisDone = false;
      this.$http.get('visit/' + visitId + '/anamnesis').then(function (response) {
        _this16.clientAnamnesis = response.data;
        _this16.clientAnamnesisPending = false;
        _this16.clientAnamnesisDone = true;
      }).catch(function (error) {
        _this16.clientAnamnesisError = error.response.data.errors;
        _this16.clientAnamnesisPending = false;
        _this16.clientAnamnesisDone = false;
      });
    },
    getActualClientAnamnesis: function getActualClientAnamnesis(clientId) {
      var _this17 = this;

      this.actualClientAnamnesisPending = true;
      this.actualClientAnamnesisDone = false;
      this.$http.get('client/' + clientId + '/actual_anamnesis').then(function (response) {
        _this17.actualClientAnamnesis = response.data;
        _this17.actualClientAnamnesisPending = false;
        _this17.actualClientAnamnesisDone = true;
      }).catch(function (error) {
        _this17.actualClientAnamnesisError = error.response.data.errors;
        _this17.actualClientAnamnesisPending = false;
        _this17.actualClientAnamnesisDone = false;
      });
    },
    getWeekCalendarForDoctor: function getWeekCalendarForDoctor(medicId, getParams) {
      var _this18 = this;

      this.calendarPending = true;
      this.$http.get('medic/' + medicId + '/calendar', { params: getParams }).then(function (response) {
        _this18.calendar = response.data;
        _this18.calendarPending = false;
      }).catch(function (error) {
        _this18.calendarError = error.response.data.errors;
        _this18.calendarPending = false;
      });
    },
    getWeekVisitsForDoctor: function getWeekVisitsForDoctor(medicId, getParams) {
      var _this19 = this;

      this.visitsPending = true;
      this.$http.get('medic/' + medicId + '/visit', { params: getParams }).then(function (response) {
        _this19.visits = response.data;
        _this19.visitsPending = false;
      }).catch(function (error) {
        _this19.visitsError = error.response.data.errors;
        _this19.visitsPending = false;
      });
    },
    getFreeTimeForDoctor: function getFreeTimeForDoctor(medicId, getParams) {
      var _this20 = this;

      this.freeTimePending = true;
      this.$http.get('medic/' + medicId + '/free', { params: getParams }).then(function (response) {
        _this20.freeTime = response.data;
        _this20.freeTimePending = false;
      }).catch(function (error) {
        _this20.freeTimeError = error.response.data.errors;
        _this20.freeTimePending = false;
      });
    },
    getDoctorsLeisureTime: function getDoctorsLeisureTime(medicId) {
      var _this21 = this;

      this.leisureTimePending = true;
      this.$http.get('medic/' + medicId + '/leisure_time').then(function (response) {
        _this21.leisureTime = response.data;
        _this21.leisureTimePending = false;
      }).catch(function (error) {
        _this21.leisureTimeError = error.response.data.errors;
        _this21.leisureTimePending = false;
      });
    },
    getResultInfo: function getResultInfo(hash) {
      var _this22 = this;

      this.resultInfoDone = false;
      this.resultInfoPending = true;
      this.$http.get('cd/auth', { params: { 'hash': hash } }).then(function (response) {
        _this22.resultInfo = response.data;
        _this22.resultInfoPending = false;
        _this22.resultInfoDone = true;
      }).catch(function (error) {
        _this22.resultInfoError = error.response.data;
        _this22.resultInfoPending = false;
      });
    },
    postResultVerify: function postResultVerify(authForm) {
      var _this23 = this;

      this.resultVerifyDone = true;
      this.$http.post('cd/verify', authForm, { emulateJSON: true }).then(function (response) {
        _this23.result = response.data;
        _this23.resultVerifyPending = false;
        _this23.resultVerifyDone = true;
        _this23.resultAuthError = false;
      }).catch(function (error) {
        _this23.resultAuthError = error.response.data.error;
        _this23.resultVerifyPending = false;
      });
    },
    postLeisureTime: function postLeisureTime(leisureTime, doctorId) {
      var _this24 = this;

      this.newLeisureTimePending = true;
      this.$http.post('medic/' + doctorId + '/leisure_time', leisureTime, { emulateJSON: true }).then(function (response) {
        _this24.newLeisureTimePending = false;
        _this24.newLeisureTimeDone = true;
      }).catch(function (error) {
        _this24.newLeisureTimeError = error.response.data.errors;
        _this24.newLeisureTimePending = false;
      });
    },
    postTask: function postTask(task, clientId) {
      var _this25 = this;

      this.newTaskPending = true;
      this.$http.post('client/' + clientId + '/task', task, { emulateJSON: true }).then(function (response) {
        _this25.newTaskPending = false;
        _this25.newTaskDone = true;
      }).catch(function (error) {
        _this25.newTaskError = error.response.data.errors;
        _this25.newTaskPending = false;
      });
    },
    putLeisureTime: function putLeisureTime(leisureTime) {
      var _this26 = this;

      this.updatedLeisureTimePending = true;
      this.$http.put('leisure_time/' + leisureTime.id, leisureTime, { emulateJSON: true }).then(function (response) {
        _this26.updatedLeisureTimePending = false;
        _this26.updatedLeisureTimeDone = true;
      }).catch(function (error) {
        _this26.updatedLeisureTimeError = error.response.data.errors;
        _this26.updatedLeisureTimePending = false;
      });
    },
    deleteLeisureTime: function deleteLeisureTime(leisureTimeId) {
      var _this27 = this;

      this.deleteLeisureTimePending = true;
      this.$http.delete('leisure_time/' + leisureTimeId, { emulateJSON: true }).then(function (response) {
        _this27.deleteLeisureTimePending = false;
        _this27.deleteLeisureTimeDone = true;
      }).catch(function (error) {
        _this27.deleteLeisureTimeError = error.response.data.errors;
        _this27.deleteLeisureTimePending = false;
      });
    },
    deleteInsurance: function deleteInsurance(insuranceId) {
      var _this28 = this;

      this.deleteInsurancePending = true;
      this.$http.delete('insurance/' + insuranceId, { emulateJSON: true }).then(function (response) {
        _this28.deleteInsurancePending = false;
        _this28.deleteInsuranceDone = true;
      }).catch(function (error) {
        _this28.deleteInsuranceError = error.response.data.errors;
        _this28.deleteInsurancePending = false;
      });
    },
    deleteMembership: function deleteMembership(membershipId) {
      var _this29 = this;

      this.deleteMembershipPending = true;
      this.$http.delete('membership/' + membershipId, { emulateJSON: true }).then(function (response) {
        _this29.deleteMembershipPending = false;
        _this29.deleteMembershipDone = true;
      }).catch(function (error) {
        _this29.deleteMembershipError = error.response.data.errors;
        _this29.deleteMembershipPending = false;
      });
    },
    deleteElectronicPrescription: function deleteElectronicPrescription(ep) {
      var _this30 = this;

      var params = {};
      if (ep.reason) {
        params = { reason: ep.reason };
      }
      this.deleteElectronicPrescriptionPending = true;
      this.$http.delete('prescription_electronic/' + ep.id, { params: params }).then(function (response) {
        _this30.deleteElectronicPrescriptionPending = false;
        _this30.deleteElectronicPrescriptionDone = true;
      }).catch(function (error) {
        _this30.deleteElectronicPrescriptionError = error.response.data.errors;
        _this30.deleteElectronicPrescriptionPending = false;
      });
    },
    sendToSuklElectronicPrescription: function sendToSuklElectronicPrescription(electronicPrescriptionId) {
      var _this31 = this;

      this.sendToSuklElectronicPrescriptionPending = true;
      this.$http.post('electronic_prescription/' + electronicPrescriptionId + '/send', { emulateJSON: true }).then(function (response) {
        _this31.sendToSuklElectronicPrescriptionPending = false;
        _this31.sendToSuklElectronicPrescriptionDone = true;
      }).catch(function (error) {
        _this31.sendToSuklElectronicPrescriptionError = error.response.data.errors;
        _this31.sendToSuklElectronicPrescriptionPending = false;
      });
    },
    sendToSuklElectronicVoucher: function sendToSuklElectronicVoucher(electronicVoucherId) {
      var _this32 = this;

      this.sendToSuklElectronicVoucherPending = true;
      this.$http.post('electronic_voucher/' + electronicVoucherId + '/send', { emulateJSON: true }).then(function (response) {
        _this32.sendToSuklElectronicVoucherPending = false;
        _this32.sendToSuklElectronicVoucherDone = true;
      }).catch(function (error) {
        _this32.sendToSuklElectronicVoucherError = error.response.data.errors;
        _this32.sendToSuklElectronicVoucherPending = false;
      });
    },
    deleteElectronicVoucher: function deleteElectronicVoucher(ep) {
      var _this33 = this;

      var params = {};
      if (ep.reason) {
        params = { reason: ep.reason };
      }
      this.deleteElectronicVoucherPending = true;
      this.$http.delete('voucher_electronic/' + ep.id, { params: params }).then(function (response) {
        _this33.deleteElectronicVoucherPending = false;
        _this33.deleteElectronicVoucherDone = true;
      }).catch(function (error) {
        _this33.deleteElectronicVoucherError = error.response.data.errors;
        _this33.deleteElectronicVoucherPending = false;
      });
    },
    getDoctorsWorkingTime: function getDoctorsWorkingTime(medicId) {
      var _this34 = this;

      this.workingTimePending = true;
      this.$http.get('medic/' + medicId + '/working_time').then(function (response) {
        _this34.workingTime = response.data;
        _this34.workingTimePending = false;
      }).catch(function (error) {
        _this34.workingTimeError = error.response.data.errors;
        _this34.workingTimePending = false;
      });
    },
    postWorkingTime: function postWorkingTime(workingTime, doctorId) {
      var _this35 = this;

      this.newWorkingTimePending = true;
      this.$http.post('medic/' + doctorId + '/working_time', workingTime, { emulateJSON: true }).then(function (response) {
        _this35.newWorkingTimePending = false;
        _this35.newWorkingTimeDone = true;
      }).catch(function (error) {
        _this35.newWorkingTimeError = error.response.data.errors;
        _this35.newWorkingTimePending = false;
      });
    },
    putWorkingTime: function putWorkingTime(workingTime) {
      var _this36 = this;

      this.updatedWorkingTimePending = true;
      this.$http.put('working_time/' + workingTime.id, workingTime, { emulateJSON: true }).then(function (response) {
        _this36.updatedWorkingTimePending = false;
        _this36.updatedWorkingTimeDone = true;
      }).catch(function (error) {
        _this36.updatedWorkingTimeError = error.response.data.errors;
        _this36.updatedWorkingTimePending = false;
      });
    },
    deleteWorkingTime: function deleteWorkingTime(workingTimeId) {
      var _this37 = this;

      this.deleteWorkingTimePending = true;
      this.$http.delete('working_time/' + workingTimeId, { emulateJSON: true }).then(function (response) {
        _this37.deleteWorkingTimePending = false;
        _this37.deleteWorkingTimeDone = true;
      }).catch(function (error) {
        _this37.deleteWorkingTimeError = error.response.data.errors;
        _this37.deleteWorkingTimePending = false;
      });
    },
    getClientsVisits: function getClientsVisits(states, clientId) {
      var _this38 = this;

      var getParams = {
        states: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(states) };
      this.visitsPending = true;
      this.$http.get('client/' + clientId + '/visit', { params: getParams }).then(function (response) {
        _this38.visits = response.data;
        _this38.visitsPending = false;
      }).catch(function (error) {
        _this38.visitsError = error.response.data.errors;
        _this38.visitsPending = false;
      });
    },
    getClientsVisitTasks: function getClientsVisitTasks(states, clientId) {
      var _this39 = this;

      var getParams = {
        states: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(states) };
      this.visitsPending = true;
      this.$http.get('client/' + clientId + '/visit_task', { params: getParams }).then(function (response) {
        _this39.visits = response.data;
        _this39.visitsPending = false;
      }).catch(function (error) {
        _this39.visitsError = error.response.data.errors;
        _this39.visitsPending = false;
      });
    },
    postVisit: function postVisit(visit) {
      var _this40 = this;

      this.visitPending = true;
      this.$http.post('visit', visit, { emulateJSON: true }).then(function (response) {
        _this40.visitPending = false;
        _this40.visitDone = true;
      }).catch(function (error) {
        _this40.visitError = error.response.data.errors;
        _this40.visitPending = false;
      });
    },
    putVisit: function putVisit(id, visit) {
      var _this41 = this;

      var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      visit = filter !== null ? this.filterData(visit, filter) : visit;
      this.putVisitPending = true;
      this.$http.put('visit/' + id, visit, { emulateJSON: true }).then(function (response) {
        _this41.putVisitPending = false;
        _this41.putVisitDone = true;
      }).catch(function (error) {
        _this41.putVisitError = error.response.data.errors;
        _this41.putVisitPending = false;
      });
    },
    filterData: function filterData(data, includeFilter) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).forEach(function (key, index) {
        if (includeFilter.indexOf(key) < 0) {
          delete data[key];
        }
      });
      return data;
    },
    postVisitTask: function postVisitTask(visit) {
      var _this42 = this;

      this.visitPending = true;
      this.$http.post('visit_task', visit, { emulateJSON: true }).then(function (response) {
        _this42.visitPending = false;
        _this42.visitDone = true;
      }).catch(function (error) {
        _this42.visitError = error.response.data.errors;
        _this42.visitPending = false;
      });
    },
    getVisit: function getVisit(visitId) {
      var _this43 = this;

      this.visitPending = true;
      this.$http.get('visit/' + visitId, { emulateJSON: true }).then(function (response) {
        _this43.visitPending = false;
        _this43.visit = response.data;
      }).catch(function (error) {
        _this43.visitError = error.response.data.errors;
        _this43.visitPending = false;
      });
    },
    getInsuranceCompanies: function getInsuranceCompanies() {
      var _this44 = this;

      this.insuranceCompaniesPending = true;
      this.$http.get('insurance_companies').then(function (response) {
        _this44.insuranceCompanies = response.data;
        _this44.insuranceCompaniesPending = false;
      }, function (response) {
        _this44.insuranceCompaniesError = response.body.error;
        _this44.insuranceCompaniesPending = false;
      });
    },
    getPrograms: function getPrograms() {
      var _this45 = this;

      this.programsPending = true;
      this.$http.get('programs').then(function (response) {
        _this45.programs = response.data;
        _this45.programsPending = false;
      }).catch(function (error) {
        _this45.programsError = error.response.data.errors;
        _this45.programsPending = false;
      });
    },
    getDoctors: function getDoctors() {
      var _this46 = this;

      this.doctorsPending = true;
      this.$http.get('doctor').then(function (response) {
        _this46.doctors = response.data;
        _this46.doctorsPending = false;
      }).catch(function (error) {
        _this46.doctorsError = error.response.data.errors;
        _this46.doctorsPending = false;
      });
    },
    getBranches: function getBranches() {
      var _this47 = this;

      this.branchesPending = true;
      this.$http.get('branch').then(function (response) {
        _this47.branches = response.data;
        _this47.branchesPending = false;
      }).catch(function (error) {
        _this47.branchesError = error.response.data.errors;
        _this47.branchesPending = false;
      });
    },
    getVisitPurposes: function getVisitPurposes() {
      var _this48 = this;

      this.visitPurposesPending = true;
      this.$http.get('visit_purpose').then(function (response) {
        _this48.visitPurposes = response.data;
        _this48.visitPurposesPending = false;
        _this48.visitPurposesDone = true;
      }).catch(function (error) {
        _this48.visitPurposeError = error.response.data.errors;
        _this48.visitPurposesPending = false;
      });
    },
    getDiagnosisTemplates: function getDiagnosisTemplates() {
      var _this49 = this;

      this.diagnosisTemplatesPending = true;
      this.$http.get('diagnosis_templates').then(function (response) {
        _this49.diagnosisTemplates = response.data;
        _this49.diagnosisTemplatesPending = false;
      }).catch(function (error) {
        _this49.diagnosisTemplatesError = error.response.data.errors;
        _this49.diagnosisTemplatesPending = false;
      });
    },
    postInsurance: function postInsurance(clientId) {
      var _this50 = this;

      this.insurancePending = true;
      this.$http.post('client/' + clientId + '/insurance', this.insurance, { emulateJSON: true }).then(function (response) {
        _this50.insurancePending = false;
        _this50.insuranceDone = true;
      }).catch(function (error) {
        _this50.insuranceError = error.response.data.errors;
        _this50.insurancePending = false;
      });
    },
    postMembership: function postMembership(clientId) {
      var _this51 = this;

      var membership = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.membership));
      membership.valid_from = this.$moment(membership.valid_from).format('DD.MM.YYYY');
      membership.valid_to = this.$moment(membership.valid_to).format('DD.MM.YYYY');
      this.membershipPending = true;
      this.$http.post('client/' + clientId + '/membership', membership, { emulateJSON: true }).then(function (response) {
        _this51.membershipPending = false;
        _this51.membershipDone = true;
      }).catch(function (error) {
        _this51.membershipError = error.response.data.errors;
        _this51.membershipPending = false;
      });
    },
    putMembership: function putMembership(membershipId) {
      var _this52 = this;

      var membership = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.membershipToUpdate));
      membership.valid_from = this.$moment(membership.valid_from).format('DD.MM.YYYY');
      membership.valid_to = this.$moment(membership.valid_to).format('DD.MM.YYYY');
      this.updateMembershipPending = true;
      this.$http.put('membership/' + membershipId + '/update', membership, { emulateJSON: true }).then(function (response) {
        _this52.updateMembershipPending = false;
        _this52.updateMembershipDone = true;
      }).catch(function (error) {
        _this52.updateMembershipError = error.response.data.errors;
        _this52.updateMembershipPending = false;
      });
    },
    getCitizenship: function getCitizenship() {
      var _this53 = this;

      this.citizenshipPending = true;
      this.$http.get('citizenship').then(function (response) {
        _this53.citizenship = response.data;
        _this53.citizenshipPending = false;
      }).catch(function (error) {
        _this53.citizenshipError = error.response.data.errors;
        _this53.citizenshipPending = false;
      });
    },
    getCountries: function getCountries() {
      var _this54 = this;

      this.countriesPending = true;
      this.$http.get('country').then(function (response) {
        _this54.countries = response.data;
        _this54.countriesPending = false;
      }).catch(function (error) {
        _this54.countriesError = error.response.data.errors;
        _this54.countriesPending = false;
      });
    },
    getClientInsurances: function getClientInsurances(clientId) {
      var _this55 = this;

      this.clientInsurancesPending = true;
      this.$http.get('client/' + clientId + '/insurance').then(function (response) {
        _this55.clientInsurances = response.data;
        _this55.clientInsurancesPending = false;
      }).catch(function (error) {
        _this55.clientInsurancesError = error.response.data.errors;
        _this55.clientInsurancesPending = false;
      });
    },
    getClientMemberships: function getClientMemberships(clientId) {
      var _this56 = this;

      this.clientMembershipsPending = true;
      this.$http.get('client/' + clientId + '/membership').then(function (response) {
        _this56.clientMemberships = response.data;
        _this56.clientMembershipsPending = false;
      }).catch(function (error) {
        _this56.clientMemberships = null;
        _this56.clientMembershipsError = error.response.data.errors;
        _this56.clientMembershipsPending = false;
      });
    },
    putClient: function putClient(client) {
      var _this57 = this;

      this.clientPending = true;
      this.$http.put('client/' + client.id, client, { emulateJSON: true }).then(function (response) {
        _this57.clientPending = false;
        _this57.clientDone = true;
      }).catch(function (error) {
        _this57.clientError = error.response.data.errors;
        _this57.clientPending = false;
      });
    },
    putAddress: function putAddress(address) {
      var _this58 = this;

      this.addressPending = true;
      this.$http.put('address/' + address.id, address, { emulateJSON: true }).then(function (response) {
        _this58.addressPending = false;
        _this58.addressDone = true;
      }).catch(function (error) {
        _this58.addressError = error.response.data.errors;
        _this58.addressPending = false;
      });
    },
    postAddress: function postAddress(address, clientId) {
      var _this59 = this;

      this.addressPending = true;
      this.$http.post('client/' + clientId + '/address', address, { emulateJSON: true }).then(function (response) {
        _this59.addressPending = false;
        _this59.addressDone = true;
      }).catch(function (error) {
        _this59.addressError = error.response.data.errors;
        _this59.addressPending = false;
      });
    },
    postEmailAddress: function postEmailAddress(emailAddress, clientId) {
      var _this60 = this;

      this.newEmailAddressPending = true;
      this.$http.post('client/' + clientId + '/email_address', emailAddress, { emulateJSON: true }).then(function (response) {
        _this60.newEmailAddressPending = false;
        _this60.newEmailAddressDone = true;
      }).catch(function (error) {
        _this60.newEmailAddressError = error.response.data.errors;
        _this60.newEmailAddressPending = false;
      });
    },
    putEmailAddress: function putEmailAddress(emailAddress) {
      var _this61 = this;

      this.updatedEmailAddressPending = true;
      this.$http.put('email_address/' + emailAddress.id, emailAddress, { emulateJSON: true }).then(function (response) {
        _this61.updatedEmailAddressPending = false;
        _this61.updatedEmailAddressDone = true;
      }).catch(function (error) {
        _this61.updatedEmailAddressError = error.response.data.errors;
        _this61.updatedEmailAddressPending = false;
      });
    },
    deleteEmailAddress: function deleteEmailAddress(emailAddressId) {
      var _this62 = this;

      this.deleteEmailAddressPending = true;
      this.$http.delete('email_address/' + emailAddressId, { emulateJSON: true }).then(function (response) {
        _this62.deleteEmailAddressPending = false;
        _this62.deleteEmailAddressDone = true;
      }).catch(function (error) {
        _this62.deleteEmailAddressError = error.response.data.errors;
        _this62.deleteEmailAddressPending = false;
      });
    },
    postPhoneNumber: function postPhoneNumber(phoneNumber, clientId) {
      var _this63 = this;

      this.newPhoneNumberPending = true;
      this.$http.post('client/' + clientId + '/phone_number', phoneNumber, { emulateJSON: true }).then(function (response) {
        _this63.newPhoneNumberPending = false;
        _this63.newPhoneNumberDone = true;
      }).catch(function (error) {
        _this63.newPhoneNumberError = error.response.data.errors;
        _this63.newPhoneNumberPending = false;
      });
    },
    putPhoneNumber: function putPhoneNumber(phoneNumber) {
      var _this64 = this;

      this.updatedPhoneNumberPending = true;
      this.$http.put('phone_number/' + phoneNumber.id, phoneNumber, { emulateJSON: true }).then(function (response) {
        _this64.updatedPhoneNumberPending = false;
        _this64.updatedPhoneNumberDone = true;
      }).catch(function (error) {
        _this64.updatedPhoneNumberError = error.response.data.errors;
        _this64.updatedPhoneNumberPending = false;
      });
    },
    deletePhoneNumber: function deletePhoneNumber(phoneNumberId) {
      var _this65 = this;

      this.deletePhoneNumberPending = true;
      this.$http.delete('phone_number/' + phoneNumberId, { emulateJSON: true }).then(function (response) {
        _this65.deletePhoneNumberPending = false;
        _this65.deletePhoneNumberDone = true;
      }).catch(function (error) {
        _this65.deletePhoneNumberError = error.response.data.errors;
        _this65.deletePhoneNumberPending = false;
      });
    },
    deleteDocument: function deleteDocument(documentId) {
      var _this66 = this;

      this.documentDeleteError = null;
      this.documentDeleteDone = false;
      this.documentDeletePending = true;
      this.$http.delete('document/' + documentId, { emulateJSON: true }).then(function (response) {
        _this66.documentDeletePending = false;
        _this66.documentDeleteDone = true;
      }).catch(function (error) {
        _this66.documentDeleteError = error.response.data.errors;
        _this66.documentDeletePending = false;
      });
    },
    postGdprConsent: function postGdprConsent(gdprConsent, clientId) {
      var _this67 = this;

      this.newGdprConsentPending = true;
      this.$http.post('client/' + clientId + '/gdpr_consent', gdprConsent, { emulateJSON: true }).then(function (response) {
        _this67.newGdprConsentPending = false;
        _this67.newGdprConsentDone = true;
      }).catch(function (error) {
        _this67.newGdprConsentError = error.response.data.errors;
        _this67.newGdprConsentPending = false;
      });
    },
    putGdprConsent: function putGdprConsent(gdprConsent) {
      var _this68 = this;

      this.updatedGdprConsentPending = true;
      this.$http.put('gdpr_consent/' + gdprConsent.id, gdprConsent, { emulateJSON: true }).then(function (response) {
        _this68.updatedGdprConsentPending = false;
        _this68.updatedGdprConsentDone = true;
      }).catch(function (error) {
        _this68.updatedGdprConsentError = error.response.data.errors;
        _this68.updatedGdprConsentPending = false;
      });
    },
    deleteGdprConsent: function deleteGdprConsent(gdprConsentId) {
      var _this69 = this;

      this.deleteGdprConsentPending = true;
      this.$http.delete('gdpr_consent/' + gdprConsentId, { emulateJSON: true }).then(function (response) {
        _this69.deleteGdprConsentPending = false;
        _this69.deleteGdprConsentDone = true;
      }).catch(function (error) {
        _this69.deleteGdprConsentError = error.response.data.errors;
        _this69.deleteGdprConsentPending = false;
      });
    },
    searchOperations: function searchOperations(searchParams) {
      var _this70 = this;

      this.operationsPending = true;
      this.$http.get('szv/operation', { params: searchParams }).then(function (response) {
        if (response.status === 204) {
          _this70.operations = [];
        } else {
          _this70.operations = response.data;
        }
        _this70.operationsPending = false;
      }).catch(function (error) {
        _this70.operations = [];
        _this70.operationsError = error.response.data.errors;
        _this70.operationsPending = false;
      });
    },
    postDiagnosis: function postDiagnosis(visitId, diagnosis) {
      var _this71 = this;

      this.diagnosisPending = true;
      this.$http.post('visit/' + visitId + '/diagnosis', diagnosis, { emulateJSON: true }).then(function (response) {
        _this71.diagnosisPending = false;
        _this71.diagnosisDone = true;
      }).catch(function (error) {
        _this71.diagnosisError = error.response.data.errors;
        _this71.diagnosisPending = false;
      });
    },
    postDiagnosisTemplate: function postDiagnosisTemplate(visitId, diagnosisTemplateId) {
      var _this72 = this;

      this.diagnosisTemplatePending = true;
      this.$http.post('visit/' + visitId + '/diagnosis_template', { 'diagnosis_template_id': diagnosisTemplateId }, { emulateJSON: true }).then(function (response) {
        _this72.diagnosisTemplatePending = false;
        _this72.diagnosisTemplateDone = true;
      }).catch(function (error) {
        _this72.diagnosisTemplateError = error.response.data.errors;
        _this72.diagnosisTemplatePending = false;
      });
    },
    postMedicament: function postMedicament(medicament, clientId) {
      var _this73 = this;

      var visitId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.medicamentPending = true;
      if (visitId !== null) {
        medicament.visit_id = visitId;
      }
      this.$http.post('client/' + clientId + '/medicament', medicament, { emulateJSON: true }).then(function (response) {
        _this73.medicamentPending = false;
        _this73.medicamentDone = true;
      }).catch(function (error) {
        _this73.medicamentError = error.response.data.errors;
        _this73.medicamentPending = false;
      });
    },
    postVoucher: function postVoucher(voucher, clientId) {
      var _this74 = this;

      var visitId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.voucherPending = true;
      if (visitId !== null) {
        voucher.visit_id = visitId;
      }
      this.$http.post('client/' + clientId + '/voucher', voucher, { emulateJSON: true }).then(function (response) {
        _this74.voucherPending = false;
        _this74.voucherDone = true;
      }).catch(function (error) {
        _this74.voucherError = error.response.data.errors;
        _this74.voucherPending = false;
      });
    },
    searchSimilarMedicineByMedicament: function searchSimilarMedicineByMedicament(medicament) {
      var _this75 = this;

      this.searchSimilarMedicinePending = true;
      this.$http.post('sukl/similar_medicine', medicament, { emulateJSON: true }).then(function (response) {
        _this75.searchSimilarMedicinePending = false;
        _this75.searchSimilarMedicineDone = true;
      }).catch(function (error) {
        _this75.searchSimilarMedicineError = error.response.data.errors;
        _this75.searchSimilarMedicinePending = false;
      });
    },
    deleteDiagnosis: function deleteDiagnosis(diagnosisId) {
      var _this76 = this;

      this.deleteDiagnosisPending = true;
      this.$http.delete('diagnosis/' + diagnosisId, { emulateJSON: true }).then(function (response) {
        _this76.deleteDiagnosisPending = false;
        _this76.deleteDiagnosisDone = true;
      }).catch(function (error) {
        _this76.deleteDiagnosisError = error.response.data.errors;
        _this76.deleteDiagnosisPending = false;
      });
    },
    deleteMedicament: function deleteMedicament(medicamentId) {
      var _this77 = this;

      this.deleteMedicamentPending = true;
      this.$http.delete('medicament/' + medicamentId, { emulateJSON: true }).then(function (response) {
        _this77.deleteMedicamentPending = false;
        _this77.deleteMedicamentDone = true;
      }).catch(function (error) {
        _this77.deleteMedicamentError = error.response.data.errors;
        _this77.deleteMedicamentPending = false;
      });
    },
    postAction: function postAction(diagnosisId, action) {
      var _this78 = this;

      this.actionPending = true;
      this.$http.post('diagnosis/' + diagnosisId + '/action', action, { emulateJSON: true }).then(function (response) {
        _this78.actionPending = false;
        _this78.actionDone = true;
      }).catch(function (error) {
        _this78.actionError = error.response.data.errors;
        _this78.actionPending = false;
      });
    },
    deleteAction: function deleteAction(actionId) {
      var _this79 = this;

      this.deleteActionPending = true;
      this.$http.delete('action/' + actionId, { emulateJSON: true }).then(function (response) {
        _this79.deleteActionPending = false;
        _this79.deleteActionDone = true;
      }).catch(function (error) {
        _this79.deleteActionError = error.response.data.errors;
        _this79.deleteActionPending = false;
      });
    },
    checkOperationLimitation: function checkOperationLimitation(operationCode, visitId) {
      var _this80 = this;

      var getParams = {
        visit: visitId
      };
      this.operationLimitationPending = true;
      this.$http.get('/action_check/' + operationCode, { params: getParams }).then(function (response) {
        _this80.operationLimitation = response.data;
        _this80.operationLimitationPending = false;
      }).catch(function (error) {
        _this80.operationLimitationError = error.response.data.errors;
        _this80.operationLimitationPending = false;
      });
    },
    postZulp: function postZulp(actionId, zulp) {
      var _this81 = this;

      this.zulpPending = true;
      this.$http.post('action/' + actionId + '/zulp', zulp, { emulateJSON: true }).then(function (response) {
        _this81.zulpPending = false;
        _this81.zulpDone = true;
      }).catch(function (error) {
        _this81.zulpError = error.response.data.errors;
        _this81.zulpPending = false;
      });
    },
    deleteZulp: function deleteZulp(zulpId) {
      var _this82 = this;

      this.deletZulpPending = true;
      this.$http.delete('zulp/' + zulpId, { emulateJSON: true }).then(function (response) {
        _this82.deletZulpPending = false;
        _this82.deletZulpDone = true;
      }).catch(function (error) {
        _this82.deletZulpError = error.response.data.errors;
        _this82.deletZulpPending = false;
      });
    },
    postZum: function postZum(actionId, zum) {
      var _this83 = this;

      this.zumPending = true;
      this.$http.post('action/' + actionId + '/zum', zum, { emulateJSON: true }).then(function (response) {
        _this83.zumPending = false;
        _this83.zumDone = true;
      }).catch(function (error) {
        _this83.zumError = error.response.data.errors;
        _this83.zumPending = false;
      });
    },
    deleteZum: function deleteZum(zumId) {
      var _this84 = this;

      this.deletZumPending = true;
      this.$http.delete('zum/' + zumId, { emulateJSON: true }).then(function (response) {
        _this84.deletZumPending = false;
        _this84.deletZumDone = true;
      }).catch(function (error) {
        _this84.deletZumError = error.response.data.errors;
        _this84.deletZumPending = false;
      });
    },
    decodePIN: function decodePIN(pin) {
      var _this85 = this;

      this.birthDateCalculated = false;
      this.decodePinPending = true;
      this.decodePinWarning = false;
      this.$http.get('validatepin', { params: { pin: pin } }).then(function (response) {
        if (response.data.birth_date) {
          _this85.clientForm.gender = response.data.gender;
          _this85.clientForm.birth_date = response.data.birth_date;
          _this85.birthDateCalculated = true;
        }
        _this85.decodePinWarning = response.data.warning;
        _this85.parsePinMessage = '';
        _this85.decodePinPending = false;
      }).catch(function (error) {
        _this85.decodePinError = error.response.data.errors;
        _this85.decodePinPending = false;
      });
    },
    getClientMedicineInfo: function getClientMedicineInfo(clientId, medicineCode) {
      var _this86 = this;

      this.clientMedicineInfoPending = true;
      this.clientMedicineInfoDone = false;
      this.$http.get('client/' + clientId + '/medicine/' + medicineCode).then(function (response) {
        _this86.clientMedicineInfo = response.data;
        _this86.clientMedicineInfoPending = false;
        _this86.clientMedicineInfoDone = true;
      }).catch(function (error) {
        _this86.clientMedicineInfoError = error.response.data.errors;
        _this86.clientMedicineInfoPending = false;
      });
    },
    getClientMedicalDeviceInfo: function getClientMedicalDeviceInfo(clientId, medicineCode) {
      var _this87 = this;

      this.clientMedicalDeviceInfoPending = true;
      this.clientMedicalDeviceInfoDone = false;
      this.$http.get('client/' + clientId + '/medicine/' + medicineCode).then(function (response) {
        _this87.clientMedicalDeviceInfo = response.data;
        _this87.clientMedicalDeviceInfoPending = false;
        _this87.clientMedicalDeviceInfoDone = true;
      }).catch(function (error) {
        _this87.clientMedicalDeviceInfoError = error.response.data.errors;
        _this87.clientMedicalDeviceInfoPending = false;
      });
    },
    getClientIndividualMedicineInfo: function getClientIndividualMedicineInfo(clientId, medicineId) {
      var _this88 = this;

      this.clientMedicineInfoPending = true;
      this.clientMedicineInfoDone = false;
      this.$http.get('client/' + clientId + '/individual_medicine/' + medicineId).then(function (response) {
        _this88.clientMedicineInfo = response.data;
        _this88.clientMedicineInfoPending = false;
        _this88.clientMedicineInfoDone = true;
      }).catch(function (error) {
        _this88.clientMedicineInfoError = error.response.data.errors;
        _this88.clientMedicineInfoPending = false;
      });
    },
    getMedicines: function getMedicines(searchText) {
      var _this89 = this;

      if (searchText.length > 2) {
        this.medicinesPending = true;
        this.$http.get('sukl/medicine', { params: { search: searchText } }).then(function (response) {
          if (response.status === 204) {
            _this89.medicines = [];
          } else {
            _this89.medicines = response.data;
          }
          _this89.medicinesPending = false;
        }).catch(function (error) {
          _this89.medicines = [];
          _this89.medicinesError = error.response.data.errors;
          _this89.medicinesPending = false;
        });
      }
    },
    getMedicalDevices: function getMedicalDevices(searchText) {
      var _this90 = this;

      if (searchText.length > 2) {
        this.medicalDevicesPending = true;
        this.$http.get('szp/medical_device', { params: { search: searchText } }).then(function (response) {
          if (response.status === 204) {
            _this90.medicalDevices = [];
          } else {
            _this90.medicalDevices = response.data;
          }
          _this90.medicalDevicesPending = false;
        }).catch(function (error) {
          _this90.medicalDevices = [];
          _this90.medicalDevicesError = error.response.data.errors;
          _this90.medicalDevicesPending = false;
        });
      }
    },
    getIndividualMedicines: function getIndividualMedicines(searchText) {
      var _this91 = this;

      if (searchText.length > 2) {
        this.individualMedicinesPending = true;
        this.$http.get('individual_medicine/search', { params: { search: searchText } }).then(function (response) {
          if (response.status === 204) {
            _this91.individualMedicines = [];
          } else {
            _this91.individualMedicines = response.data;
          }
          _this91.individualMedicinesPending = false;
        }).catch(function (error) {
          _this91.individualMedicines = [];
          _this91.individualMedicinesError = error.response.data.errors;
          _this91.individualMedicinesPending = false;
        });
      }
    },
    getMaterials: function getMaterials(searchText) {
      var _this92 = this;

      if (searchText.length > 2) {
        this.materialsPending = true;
        this.$http.get('zum/material', { params: { search: searchText } }).then(function (response) {
          if (response.status === 204) {
            _this92.materials = [];
          } else {
            _this92.materials = response.data;
          }
          _this92.materialsPending = false;
        }).catch(function (error) {
          _this92.materials = [];
          _this92.materialsError = error.response.data.errors;
          _this92.materialsPending = false;
        });
      }
    },
    searchAddresses: function searchAddresses(searchText) {
      var _this93 = this;

      if (searchText.length > 3) {
        this.searchAddressesPending = true;
        this.$http.get('search_address', { params: { search: searchText } }).then(function (response) {
          _this93.addresses = response.data;
          _this93.searchAddressesPending = false;
        }).catch(function (error) {
          _this93.searchAddresses = [];
          _this93.searchAddressesError = error.response.data.errors;
          _this93.searchAddressesPending = false;
        });
      }
    },
    searchForeignAddresses: function searchForeignAddresses(searchText) {
      var _this94 = this;

      if (searchText.length > 3) {
        this.searchForeignAddressesPending = true;
        this.$http.get('search_foreign_address', { params: { search: searchText } }).then(function (response) {
          _this94.foreignAddresses = response.data;
          _this94.searchForeignAddressesPending = false;
        }).catch(function (error) {
          _this94.searchForeignAddresses = [];
          _this94.searchForeignAddressesError = error.response.data.errors;
          _this94.searchForeignAddressesPending = false;
        });
      }
    },
    getForeignAddressDetail: function getForeignAddressDetail(placeId) {
      var _this95 = this;

      this.foreignAddressDetailPending = true;
      this.foreignAddressDetailDone = false;
      this.$http.get('load_foreign_address', { params: { place_id: placeId } }).then(function (response) {
        _this95.foreignAddressDetail = response.data;
        _this95.foreignAddressDetailPending = false;
        _this95.foreignAddressDetailDone = true;
      }).catch(function (error) {
        _this95.foreignAddressDetail = false;
        _this95.foreignAddressDetailError = error.response.data.errors;
        _this95.foreignAddressDetailPending = false;
        _this95.foreignAddressDetailDone = false;
      });
    },
    userHasRole: function userHasRole(role) {
      console.log('role:' + this.$ls.get('role'));
      var roles = JSON.parse(this.$ls.get('role'));
      for (var i = 0; i < roles.length; i++) {
        if (roles[i] === role) {
          return true;
        }
      }
      return false;
    },
    searchClients: function searchClients(text) {
      var _this96 = this;

      this.clientsPending = true;
      this.$http.get('search', {
        params: { text: text }
      }).then(function (response) {
        _this96.clients = response.data;
        _this96.clientsPending = false;
      }).catch(function (error) {
        _this96.clientsPending = false;
        _this96.clientsError = error.response.data.errors;
      });
    },
    getPrescriptions: function getPrescriptions(visitId) {
      var _this97 = this;

      this.prescriptionsPending = true;
      this.$http.get('visit/' + visitId + '/prescription').then(function (response) {
        _this97.prescriptions = response.data;
        _this97.prescriptionsPending = false;
      }).catch(function (error) {
        _this97.prescriptionsError = error.response.data.errors;
        _this97.prescriptions = false;
        _this97.prescriptionsPending = false;
      });
    },
    getClientPrescriptions: function getClientPrescriptions(clientId) {
      var _this98 = this;

      var filterDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.prescriptionsPending = true;
      this.$http.get('client/' + clientId + '/prescription?filter_date=' + filterDate).then(function (response) {
        _this98.prescriptions = response.data;
        _this98.prescriptionsPending = false;
      }).catch(function (error) {
        _this98.prescriptionsError = error.response.data.errors;
        _this98.prescriptions = false;
        _this98.prescriptionsPending = false;
      });
    },
    getVouchers: function getVouchers(visitId) {
      var _this99 = this;

      this.vouchersPending = true;
      this.$http.get('visit/' + visitId + '/voucher').then(function (response) {
        _this99.vouchers = response.data;
        _this99.vouchersPending = false;
      }).catch(function (error) {
        _this99.vouchersError = error.response.data.errors;
        _this99.vouchers = false;
        _this99.vouchersPending = false;
      });
    },
    getClientVouchers: function getClientVouchers(clientId) {
      var _this100 = this;

      var filterDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.vouchersPending = true;
      this.$http.get('client/' + clientId + '/voucher?filter_date=' + filterDate).then(function (response) {
        _this100.vouchers = response.data;
        _this100.vouchersPending = false;
      }).catch(function (error) {
        _this100.vouchersError = error.response.data.errors;
        _this100.vouchers = false;
        _this100.vouchersPending = false;
      });
    },
    getClientMedicaments: function getClientMedicaments(clientId) {
      var _this101 = this;

      var exceptVisitId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filterDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.medicamentsPending = true;
      this.medicamentsDone = false;
      this.$http.get('client/' + clientId + '/medicament?except_visit=' + exceptVisitId + '&filter_date=' + filterDate).then(function (response) {
        _this101.medicaments = response.data;
        _this101.medicamentsPending = false;
        _this101.medicamentsDone = true;
      }).catch(function (error) {
        _this101.medicamentsError = error.response.data.errors;
        _this101.medicaments = false;
        _this101.medicamentsPending = false;
        _this101.medicamentsDone = false;
      });
    },
    getClientPrescribedMedicaments: function getClientPrescribedMedicaments(clientId) {
      var _this102 = this;

      this.medicamentsPending = true;
      this.medicamentsDone = false;
      this.$http.get('client/' + clientId + '/medicament_prescribed').then(function (response) {
        _this102.medicaments = response.data;
        _this102.medicamentsPending = false;
        _this102.medicamentsDone = true;
      }).catch(function (error) {
        _this102.medicamentsError = error.response.data.errors;
        _this102.medicaments = false;
        _this102.medicamentsPending = false;
        _this102.medicamentsDone = false;
      });
    },
    getClientUnprescribedMedicaments: function getClientUnprescribedMedicaments(clientId) {
      var _this103 = this;

      this.medicamentsPending = true;
      this.medicamentsDone = false;
      this.$http.get('client/' + clientId + '/medicament_unprescribed').then(function (response) {
        _this103.medicaments = response.data;
        _this103.medicamentsPending = false;
        _this103.medicamentsDone = true;
      }).catch(function (error) {
        _this103.medicamentsError = error.response.data.errors;
        _this103.medicaments = false;
        _this103.medicamentsPending = false;
        _this103.medicamentsDone = false;
      });
    },
    getVisitUnprescribedMedicaments: function getVisitUnprescribedMedicaments(visitId) {
      var _this104 = this;

      this.medicamentsPending = true;
      this.medicamentsDone = false;
      this.$http.get('visit/' + visitId + '/medicament_unprescribed').then(function (response) {
        _this104.medicaments = response.data;
        _this104.medicamentsPending = false;
        _this104.medicamentsDone = true;
      }).catch(function (error) {
        _this104.medicamentsError = error.response.data.errors;
        _this104.medicaments = false;
        _this104.medicamentsPending = false;
        _this104.medicamentsDone = false;
      });
    },
    postPrescriptionsFromMedicamentsByClient: function postPrescriptionsFromMedicamentsByClient(clientId) {
      var _this105 = this;

      this.postPrescriptionsPending = true;
      this.postPrescriptionsDone = false;
      this.$http.post('client/' + clientId + '/prescribe_medicaments').then(function (response) {
        _this105.postPrescriptionsPending = false;
        _this105.postPrescriptionsDone = true;
      }).catch(function (error) {
        _this105.postPrescriptionsError = error.response.data.errors;
        _this105.postPrescriptionsPending = false;
      });
    },
    postPrescriptionsFromMedicamentsByVisit: function postPrescriptionsFromMedicamentsByVisit(visitId) {
      var _this106 = this;

      this.postPrescriptionsPending = true;
      this.postPrescriptionsDone = false;
      this.$http.post('visit/' + visitId + '/prescribe_medicaments').then(function (response) {
        _this106.postPrescriptionsPending = false;
        _this106.postPrescriptionsDone = true;
      }).catch(function (error) {
        _this106.postPrescriptionsError = error.response.data.errors;
        _this106.postPrescriptionsPending = false;
      });
    },
    getDiagnoses: function getDiagnoses(visitId) {
      var _this107 = this;

      this.diagnosesPending = true;
      this.diagnosesDone = false;
      this.$http.get('visit/' + visitId + '/diagnosis').then(function (response) {
        _this107.diagnoses = response.data;
        _this107.diagnosesPending = false;
        _this107.diagnosesDone = true;
      }).catch(function (error) {
        _this107.diagnosesError = error.response.data.errors;
        _this107.diagnoses = false;
        _this107.diagnosesPending = false;
        _this107.diagnosesDone = true;
      });
    },
    getDiseases: function getDiseases(search) {
      var _this108 = this;

      this.diseasesPending = true;
      this.$http.get('icd/disease', { params: { search: search } }).then(function (response) {
        if (response.status === 204) {
          _this108.diseases = [];
        } else {
          _this108.diseases = response.data;
        }
        _this108.diseasesPending = false;
      }).catch(function (error) {
        _this108.diseasesError = error.response.data.errors;
        _this108.diseases = [];
        _this108.diseasesPending = false;
      });
    },
    getMedicalReport: function getMedicalReport(visitId) {
      var _this109 = this;

      this.medicalReportLoading = true;
      this.$http.get('/visit/' + visitId + '/medical_report').then(function (response) {
        if (response.status === 200) {
          _this109.medicalReportOldText = response.data.text;
          _this109.medicalReportText = response.data.text;
          console.log('response: ' + response.data);
        }
        _this109.medicalReportLoading = false;
      }).catch(function (error) {
        _this109.medicalReportError = error.response.data.errors;
        _this109.medicalReportLoading = false;
      });
    },
    postMedicalReport: function postMedicalReport(visitId, medicalReportText) {
      var _this110 = this;

      this.medicalReportPending = true;
      this.$http.post('/visit/' + visitId + '/medical_report', { text: medicalReportText }, { emulateJSON: true }).then(function (response) {
        _this110.medicalReportPending = false;
        _this110.medicalReportDone = true;
        _this110.medicalReportOldText = _this110.medicalReportText;
      }).catch(function (error) {
        _this110.medicalReportError = error.response.data.errors;
        _this110.medicalReportPending = false;
      });
    },
    postAnamnesisByVisit: function postAnamnesisByVisit(visitId, anamnesis) {
      var _this111 = this;

      this.anamnesisPending = true;
      this.$http.post('/visit/' + visitId + '/anamnesis', anamnesis, { emulateJSON: true }).then(function (response) {
        _this111.anamnesisPending = false;
        _this111.anamnesisDone = true;
      }).catch(function (error) {
        _this111.anamnesisError = error.response.data.errors;
        _this111.anamnesisPending = false;
      });
    },
    getVisitsReporting: function getVisitsReporting(getParams) {
      var _this112 = this;

      this.visitsPending = true;
      this.$http.get('contractual_reporting', { params: getParams }).then(function (response) {
        _this112.visits = response.data;
        _this112.visitsPending = false;
      }).catch(function (error) {
        _this112.visitsError = error.response.data.errors;
        _this112.visitsPending = false;
      });
    },
    replacer: function replacer(key, value) {
      if (value === '') {
        return null;
      }
      return value;
    },
    membershipExpiresSoon: function membershipExpiresSoon(membership) {
      if (this.$moment(membership.valid_to, 'DD.MM.YYYY').diff(this.$moment(), 'days') < 31) {
        return true;
      } else {
        return false;
      }
    },
    hasLoggedUserRole: function hasLoggedUserRole(role) {
      var roles = JSON.parse(this.$ls.get('role'));
      for (var i = 0; i < roles.length; i++) {
        if (roles[i] === role) {
          return true;
        }
      }
      return false;
    },
    uploadFile: function uploadFile(data) {
      var _this113 = this;

      var clientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var visitId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.uploadPending = true;
      this.$http.post('/document/upload', data).then(function () {
        _this113.uploadDone = true;
        _this113.uploadPending = false;
      }).catch(function () {
        _this113.uploadDone = true;
        _this113.uploadPending = false;
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (apiMixin);

/***/ }),
/* 3 */
/***/ (function(module, exports) {


var runtime = typeof window !== 'undefined' && window.__AMBULIO__ || null;

if (!runtime || !runtime.hostname) {
  throw new Error('Ambulio: runtime config missing. /config.js must define ' + 'window.__AMBULIO__ = { hostname, fakturoid } and load before the app bundle.');
}

module.exports = { hostname: runtime.hostname, fakturoid: runtime.fakturoid === true };

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginationComponent_vue__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_659299a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PaginationComponent_vue__ = __webpack_require__(393);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginationComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_659299a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PaginationComponent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeVisit_vue__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790114e9_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeVisit_vue__ = __webpack_require__(620);
function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-790114e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeVisit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790114e9_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeVisit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export applyStaffSession */
/* harmony export (immutable) */ __webpack_exports__["a"] = clearStaffSession;
/* harmony export (immutable) */ __webpack_exports__["c"] = syncStaffSession;
/* harmony export (immutable) */ __webpack_exports__["b"] = stopImpersonating;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var sessionKnown = false;

function applyStaffSession(session) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.set('authenticated', session.authenticated === true);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.set('fullname', session.user.fullname);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.set('role', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(session.user.roles));
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.set('userid', session.user.id);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.set('impersonating', session.impersonating === true);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.set('originalFullname', session.actor.fullname);
  sessionKnown = true;
  return session;
}

function clearStaffSession() {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.remove('authenticated');
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.remove('role');
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.remove('fullname');
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.remove('userid');
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.remove('impersonating');
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].ls.remove('originalFullname');
  sessionKnown = false;
}

function syncStaffSession() {
  if (sessionKnown) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true);

  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('session').then(function (response) {
    applyStaffSession(response.data);
    return true;
  }).catch(function () {
    clearStaffSession();
    return false;
  });
}

function stopImpersonating() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('impersonation/stop', null, { emulateJSON: true }).then(function (response) {
    return applyStaffSession(response.data);
  });
}

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeDoctor_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_231d91c2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_HomeDoctor_vue__ = __webpack_require__(398);
function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-231d91c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeDoctor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_231d91c2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_HomeDoctor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitChangeDoctor_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1bfd45_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitChangeDoctor_vue__ = __webpack_require__(384);
function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c1bfd45"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitChangeDoctor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1bfd45_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitChangeDoctor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitChangeState_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70f20bdb_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitChangeState_vue__ = __webpack_require__(387);
function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70f20bdb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitChangeState_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70f20bdb_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitChangeState_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitTaskChangeState_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4da0e296_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitTaskChangeState_vue__ = __webpack_require__(396);
function injectStyle (ssrContext) {
  __webpack_require__(394)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4da0e296"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitTaskChangeState_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4da0e296_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitTaskChangeState_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeReceptionist_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145e2002_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_HomeReceptionist_vue__ = __webpack_require__(418);
function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-145e2002"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeReceptionist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145e2002_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_HomeReceptionist_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitChangeDoctor_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_594bd4ee_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitChangeDoctor_vue__ = __webpack_require__(406);
function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-594bd4ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitChangeDoctor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_594bd4ee_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitChangeDoctor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitChangeState_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_012ddb17_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitChangeState_vue__ = __webpack_require__(409);
function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-012ddb17"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitChangeState_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_012ddb17_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitChangeState_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitTaskChangeState_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eaa985c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitTaskChangeState_vue__ = __webpack_require__(416);
function injectStyle (ssrContext) {
  __webpack_require__(414)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9eaa985c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitTaskChangeState_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eaa985c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitTaskChangeState_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddVisit_vue__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d317e2c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddVisit_vue__ = __webpack_require__(490);
function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d317e2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddVisit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d317e2c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddVisit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicalReport_vue__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e41d2d_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MedicalReport_vue__ = __webpack_require__(551);
function injectStyle (ssrContext) {
  __webpack_require__(549)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69e41d2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicalReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e41d2d_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MedicalReport_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElectronicPrescription_vue__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28393390_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ElectronicPrescription_vue__ = __webpack_require__(565);
function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28393390"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElectronicPrescription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28393390_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ElectronicPrescription_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPrescription_vue__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e5ba8e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListPrescription_vue__ = __webpack_require__(569);
function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45e5ba8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPrescription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e5ba8e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListPrescription_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddMedicament_vue__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae38258_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AddMedicament_vue__ = __webpack_require__(576);
function injectStyle (ssrContext) {
  __webpack_require__(574)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddMedicament_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae38258_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AddMedicament_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientMedicament_vue__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de2e1d4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientMedicament_vue__ = __webpack_require__(649);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientMedicament_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de2e1d4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientMedicament_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_modal__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_tooltip__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_timepicker__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_upload_component__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_upload_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_file_upload__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_v_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_chartjs__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_ls__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_ls__);




















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$moment = __WEBPACK_IMPORTED_MODULE_14_moment___default.a;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$moment.locale('cs');

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_js_modal___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('multiselect', __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_v_tooltip__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_v_file_upload___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('chart', __WEBPACK_IMPORTED_MODULE_13_vue_chartjs__["b" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('datepicker', __WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('timepicker', __WEBPACK_IMPORTED_MODULE_10_vue2_timepicker___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('fileupload', __WEBPACK_IMPORTED_MODULE_11_vue_upload_component___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('genderToCS', function (gender) {
  if (gender === 'male') {
    return 'muž';
  } else if (gender === 'female') {
    return 'žena';
  } else {
    return 'neznámé';
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('neverEmpty', function (text) {
  if (text === '' || text === null) {
    return '-';
  } else {
    return text;
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('daysToCS', function (text) {
  if (text > 5) {
    return text + ' dnů';
  } else if (text > 1) {
    return text + ' dny';
  } else if (text > 0) {
    return text + ' den';
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('boolToCS', function (text) {
  if (text === true) {
    return 'ano';
  } else {
    return 'ne';
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('boolAndNullToCS', function (text, nullText) {
  if (text === null) {
    return nullText;
  } else if (text === true) {
    return 'ano';
  } else {
    return 'ne';
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('insuranceTypeIntToName', function (num) {
  switch (parseInt(num)) {
    case 1:
      return 'Veřejné zdravotní pojištění';
    case 2:
      return 'Smluvní připojištění';
    case 3:
      return 'Cestovní připojištění';
    case 4:
      return 'Mezistátní pojištění (včetně EU)';
    default:
      return num;
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('stateToCS', function (text) {
  switch (text) {
    case 'scheduled':
      return 'naplánováno';
    case 'arrived':
      return 'v čekárně';
    case 'elaborated':
      return 'rozpracovaný';
    case 'failed':
      return 'nepřišel (bez omluvy)';
    case 'excused':
      return 'nepřišel (omluvil se)';
    case 'completed':
      return 'dokončená';
    case 'canceled':
      return 'zrušená návštěva';
    default:
      return '';
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('taskStateToCS', function (text) {
  switch (text) {
    case 'accepted':
      return 'přijatý (nepřiřazený)';
    case 'assigned':
      return 'přijatý';
    case 'wait_for_doctor':
      return 'předáno na doktora';
    case 'elaborated':
      return 'rozpracovaný';
    case 'completed':
      return 'splněný';
    case 'canceled':
      return 'zrušená návštěva';
    default:
      return '';
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('toCSBasedOnNumber', function (text, num) {
  var dictionary = {
    day: ['den', 'dny', 'dnů'],
    week: ['týden', 'týdny', 'týdnů'],
    month: ['měsíc', 'měsíce', 'měsíců'],
    quarter: ['čtvrtletí', 'čtvrtletí', 'čtvrtletí'],
    semester: ['pololetí', 'pololetí', 'pololetí'],
    year: ['rok', 'roky', 'let']
  };
  if (num === 1) {
    return dictionary[text][0];
  } else if (num < 5) {
    return dictionary[text][1];
  } else {
    return dictionary[text][2];
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('minutesToCsTime', function (num) {
  var hours = Math.floor(num / 60);
  var minutes = num % 60;
  var returnString = '';
  if (hours === 24) {
    return 'celý den';
  } else if (hours > 4) {
    returnString = hours + ' hodin';
  } else if (hours > 1) {
    returnString = hours + ' hodiny';
  } else if (hours === 1) {
    returnString = hours + ' hodina';
  }
  if (minutes > 0) {
    if (hours > 0) {
      returnString = returnString + ' ';
    }
    returnString = returnString + minutes + ' minut';
  }
  return returnString;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('window15toTime', function (num) {
  var hoursFrom = Math.floor((num - 1) / 4);
  var hoursTo = Math.floor(num / 4);
  var minutesFrom = (num - 1) % 4 * 15;
  var minutesTo = num % 4 * 15;
  return hoursFrom + ':' + minutesFrom.toString().padStart(2, 0) + ' - ' + hoursTo + ':' + minutesTo.toString().padStart(2, 0);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('window10toTime', function (num) {
  var hoursFrom = Math.floor((num - 1) / 6);
  var hoursTo = Math.floor(num / 6);
  var minutesFrom = (num - 1) % 6 * 10;
  var minutesTo = num % 6 * 10;
  return hoursFrom + ':' + minutesFrom.toString().padStart(2, 0) + ' - ' + hoursTo + ':' + minutesTo.toString().padStart(2, 0);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('windowToMinute', function (num) {
  return num * 10;
});

var options = {
  namespace: 'clnco__'
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_ls___default.a, options);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
  created: function created() {
    var myOption = this.$options.myOption;
    if (myOption) {
      console.log(myOption);
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]
  }
});

/***/ }),
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e858f16_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(237);
function injectStyle (ssrContext) {
  __webpack_require__(233)
  __webpack_require__(235)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e858f16_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */,
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      hostname: __webpack_require__(3)
    };
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Full__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Login2__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Home__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Calendar_Calendar__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_ClientSide_Result__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Registration_Registration__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Registration_components_RegistrationClient__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Registration_components_RegistrationClientInsurance__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Registration_components_RegistrationClientEmail__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Registration_components_RegistrationClientPhone__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Registration_components_RegistrationClientAddress__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Client_AddAddress__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Client_AddContact__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Client_ShowClient__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Visit_ShowVisit__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Visit_components_VisitDiagnosis__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Visit_components_VisitMedicalReport__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Visit_components_VisitMedicament__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_Visit_components_VisitVoucher__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_Document_DocumentComponent__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_Setting_Setting__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_Client_components_AddVisit__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_Client_components_ClientVisit__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_Client_components_ClientAnamnesis__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_Client_components_ClientResult__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_Client_components_ClientMessage__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_Client_components_ClientMedicament__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_Client_components_ClientMedicalReport__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_Client_components_ClientTask__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_HomeReceptionist_HomeReceptionist__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_HomeDoctor_HomeDoctor__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_Reporting_Reporting__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_Statistic_Statistic__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_Result_Result__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_ContractualReporting_ContractualReporting__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_Task_Task__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__variables__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__variables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__variables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__services_staff_session__ = __webpack_require__(203);

























































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_40__variables___default.a.hostname.replace(/\/$/, '');
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = true;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]();

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Login2__["a" /* default */]
  }, {
    path: '/cs',
    name: 'ClientSide',
    component: __WEBPACK_IMPORTED_MODULE_8__views_ClientSide_Result__["a" /* default */],
    meta: { label: 'dokument klienta' }
  }, {
    path: '/',
    redirect: '/home',

    component: __WEBPACK_IMPORTED_MODULE_4__containers_Full__["a" /* default */],
    meta: { label: 'Domů' },
    children: [{
      path: 'home',
      name: 'Home',
      component: __WEBPACK_IMPORTED_MODULE_6__views_Home__["a" /* default */],
      meta: { auth: true, role: '', label: 'Přehled návštěv' }
    }, {
      path: 'calendar',
      name: 'Calendar',
      component: __WEBPACK_IMPORTED_MODULE_7__views_Calendar_Calendar__["a" /* default */],
      meta: { auth: true, role: '', label: 'Kalendář' }
    }, {
      path: 'result',
      name: 'Result',
      component: __WEBPACK_IMPORTED_MODULE_37__views_Result_Result__["a" /* default */],
      meta: { auth: true, role: '', label: 'Laboratorní výsledky' }
    }, {
      path: 'contractual-reporting',
      name: 'ContractualReporting',
      component: __WEBPACK_IMPORTED_MODULE_38__views_ContractualReporting_ContractualReporting__["a" /* default */],
      meta: { auth: true, role: '', label: 'Výkaz dávek' }
    }, {
      path: 'task',
      name: 'Task',
      component: __WEBPACK_IMPORTED_MODULE_39__views_Task_Task__["a" /* default */],
      meta: { auth: true, role: '', label: 'Úkoly' }
    }, {
      path: 'registration',
      name: 'ClientRegistration',
      component: __WEBPACK_IMPORTED_MODULE_9__views_Registration_Registration__["a" /* default */],
      meta: { step: 1, label: 'Registrace klienta' },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_10__views_Registration_components_RegistrationClient__["a" /* default */],
        name: 'RegistrationClient',
        meta: { step: 1, label: 'Základní údaje' }
      }, {
        path: ':clientid/insurance',
        component: __WEBPACK_IMPORTED_MODULE_11__views_Registration_components_RegistrationClientInsurance__["a" /* default */],
        name: 'RegistrationClientSelectInsurance',
        meta: { step: 2, label: 'Výběr zdravotní pojištovny' }
      }, {
        path: ':clientid/email',
        component: __WEBPACK_IMPORTED_MODULE_12__views_Registration_components_RegistrationClientEmail__["a" /* default */],
        name: 'RegistrationClientSelectEmail',
        meta: { step: 3, label: 'Přidání e-mailů' }
      }, {
        path: ':clientid/phone',
        component: __WEBPACK_IMPORTED_MODULE_13__views_Registration_components_RegistrationClientPhone__["a" /* default */],
        name: 'RegistrationClientSelectPhone',
        meta: { step: 4, label: 'Přidání telefonních čísel' }
      }, {
        path: ':clientid/address',
        component: __WEBPACK_IMPORTED_MODULE_14__views_Registration_components_RegistrationClientAddress__["a" /* default */],
        name: 'RegistrationClientSelectAddress',
        meta: { step: 5, label: 'Přidání trvalého bydliště' }
      }]
    }, {
      path: 'client/:clientid/addaddress',
      name: 'AddAddress',
      component: __WEBPACK_IMPORTED_MODULE_15__views_Client_AddAddress__["a" /* default */],
      meta: { auth: true, role: '', label: 'Přidání adresy' }
    }, {
      path: 'client/:clientid/addcontact',
      name: 'AddContact',
      component: __WEBPACK_IMPORTED_MODULE_16__views_Client_AddContact__["a" /* default */],
      meta: { auth: true, role: '', label: 'Přidání kontaktu' }
    }, {
      path: 'client/:clientid',
      name: 'ShowClient',
      component: __WEBPACK_IMPORTED_MODULE_17__views_Client_ShowClient__["a" /* default */],
      redirect: 'client/:clientid/visits',
      meta: { auth: true, role: '', label: 'Klient' },
      children: [{
        path: 'visits',
        component: __WEBPACK_IMPORTED_MODULE_26__views_Client_components_ClientVisit__["a" /* default */],
        name: 'ClientVisit',
        meta: { label: 'Návštěvy' }
      }, {
        path: 'medicament',
        component: __WEBPACK_IMPORTED_MODULE_30__views_Client_components_ClientMedicament__["a" /* default */],
        name: 'ClientMedicament',
        meta: { label: 'Léky' }
      }, {
        path: 'message',
        component: __WEBPACK_IMPORTED_MODULE_29__views_Client_components_ClientMessage__["a" /* default */],
        name: 'ClientMessage',
        meta: { label: 'Zprávy' }
      }, {
        path: 'medical_report',
        component: __WEBPACK_IMPORTED_MODULE_31__views_Client_components_ClientMedicalReport__["a" /* default */],
        name: 'ClientMedicalReport',
        meta: { label: 'Lékařské zprávy' }
      }, {
        path: 'anamnesis',
        component: __WEBPACK_IMPORTED_MODULE_27__views_Client_components_ClientAnamnesis__["a" /* default */],
        name: 'ClientAnamnesis',
        meta: { label: 'Anamnéza' }
      }, {
        path: 'result',
        component: __WEBPACK_IMPORTED_MODULE_28__views_Client_components_ClientResult__["a" /* default */],
        name: 'ClientResult',
        meta: { label: 'Laboratorní výsledky' }
      }, {
        path: 'task',
        component: __WEBPACK_IMPORTED_MODULE_32__views_Client_components_ClientTask__["a" /* default */],
        name: 'ClientTask',
        meta: { label: 'Úkoly' }
      }, {
        path: 'document',
        component: __WEBPACK_IMPORTED_MODULE_23__views_Document_DocumentComponent__["a" /* default */],
        name: 'ClientDocument',
        meta: { label: 'Dokumenty' }
      }]
    }, {
      path: 'client/:clientid/visit/:visitid',
      name: 'ShowVisit',
      component: __WEBPACK_IMPORTED_MODULE_18__views_Visit_ShowVisit__["a" /* default */],
      meta: { auth: true, role: '', label: 'Návštěva' },
      children: [{
        path: 'diagnosis',
        component: __WEBPACK_IMPORTED_MODULE_19__views_Visit_components_VisitDiagnosis__["a" /* default */],
        name: 'VisitDiagnosis',
        meta: { label: 'Diagnózy a výkony' }
      }, {
        path: 'medicament',
        component: __WEBPACK_IMPORTED_MODULE_21__views_Visit_components_VisitMedicament__["a" /* default */],
        name: 'VisitMedicament',
        meta: { label: 'Léky' }
      }, {
        path: 'voucher',
        component: __WEBPACK_IMPORTED_MODULE_22__views_Visit_components_VisitVoucher__["a" /* default */],
        name: 'VisitVoucher',
        meta: { label: 'Poukazy' }
      }, {
        path: 'medicalreport',
        component: __WEBPACK_IMPORTED_MODULE_20__views_Visit_components_VisitMedicalReport__["a" /* default */],
        name: 'VisitMedicalReport',
        meta: { label: 'Lékařská zpráva' }
      }, {
        path: 'document',
        component: __WEBPACK_IMPORTED_MODULE_23__views_Document_DocumentComponent__["a" /* default */],
        name: 'VisitDocument',
        meta: { label: 'Dokumenty' }
      }]
    }, {
      path: 'client/:clientid/addvisit',
      name: 'AddVisit',
      component: __WEBPACK_IMPORTED_MODULE_25__views_Client_components_AddVisit__["a" /* default */],
      meta: { auth: true, role: '', label: 'Přidání návštěvy' }
    }, {
      path: 'reception',
      name: 'HomeReceptionist',
      component: __WEBPACK_IMPORTED_MODULE_33__views_HomeReceptionist_HomeReceptionist__["a" /* default */]
    }, {
      path: 'doctor/:doctorid',
      name: 'HomeDoctor',
      component: __WEBPACK_IMPORTED_MODULE_34__views_HomeDoctor_HomeDoctor__["a" /* default */]
    }, {
      path: 'setting',
      name: 'Setting',
      component: __WEBPACK_IMPORTED_MODULE_24__views_Setting_Setting__["a" /* default */]
    }, {
      path: 'reporting',
      name: 'Reporting',
      component: __WEBPACK_IMPORTED_MODULE_35__views_Reporting_Reporting__["a" /* default */]
    }, {
      path: 'statistic',
      name: 'Statistic',
      component: __WEBPACK_IMPORTED_MODULE_36__views_Statistic_Statistic__["a" /* default */]
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  document.title = 'clinico';
  if (to.name === 'ClientSide') {
    next();
    return;
  }

  if (to.name === 'Login') {
    if (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.get('authenticated')) next({ name: 'Home' });else next();
    return;
  }

  Object(__WEBPACK_IMPORTED_MODULE_41__services_staff_session__["c" /* syncStaffSession */])().then(function (authenticated) {
    if (authenticated) next();else next({ name: 'Login' });
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15faad80_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(371);
function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15faad80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15faad80_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components___ = __webpack_require__(288);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_2__components___["d" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_2__components___["e" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_2__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_2__components___["c" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components___["b" /* Breadcrumb */]
  },
  data: function data() {
    return {
      needReLogin: false,
      nav: __WEBPACK_IMPORTED_MODULE_1__nav__["a" /* default */].items,
      authLocked: false,
      password: '',
      lockTimeout: false,
      tokenExpMs: this.$ls.get('token_exp_ms')
    };
  },

  methods: {
    reloginDone: function reloginDone() {
      this.authLocked = false;
      this.$ls.set('locked', false);
      this.$router.go({
        path: this.$router.path,
        query: {
          t: +new Date()
        }
      });
    },
    setAuthLock: function setAuthLock() {},
    unlock: function unlock() {
      this.$ls.set('locked', false);
    },
    submitReloginForm: function submitReloginForm() {
      this.unlock();
    },
    authChanged: function authChanged(val, oldVal, uri) {
      if (val === null && oldVal === true) {
        this.$router.push({ name: 'Login' });
      }
    },
    autoLogout: function autoLogout(val, oldVal, uri) {
      if (val > 0) {}
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    hideModal: function hideModal(name) {
      this.$modal.hide(name);
    },
    lock: function lock(val, oldVal, uri) {
      if (val === true) {
        this.authLocked = true;
      } else {
        this.authLocked = false;
      }
    }
  },
  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    },
    isAuthenticated: function isAuthenticated() {
      return this.$ls.get('authenticated');
    },
    impersonating: function impersonating() {
      return this.$ls.get('impersonating') === true;
    }
  },
  watch: {
    authLocked: function authLocked(val) {
      if (val === true) {
        this.showModal('re-login-modal');
      } else {
        this.hideModal('re-login-modal');
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      if (error.response.status === 401) {
        if (error.response.data.error.token_locked === true) {
          _this.authLocked = true;
          _this.$ls.set('locked', true);
        } else if (error.response.data.error.token_expired === true) {
          _this.authLocked = false;
          _this.$ls.remove('token');
          _this.$ls.remove('authenticated');
          _this.$ls.remove('role');
          _this.$ls.remove('fullname');
          _this.$ls.remove('userid');
          _this.$ls.remove('locked');
          _this.$router.push({ name: 'Login' });
        }
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
    this.$ls.on('authenticated', this.authChanged);
    this.$ls.on('token_exp_ms', this.autoLogout);
    this.$ls.on('locked', this.lock);
    if (this.$ls.get('locked') === true) {
      this.authLocked = true;
    }
  }
});

/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer'
  }]
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47e8adca_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(291);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47e8adca_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aside'
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside-menu"
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69639aa0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(294);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69639aa0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "breadcrumb-item"
    }, [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebb39d5a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(297);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebb39d5a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classList
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e18270_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(300);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e18270_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_vm._v("\n  © 2023 clinico.\n")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_077cba8c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(354);
function injectStyle (ssrContext) {
  __webpack_require__(302)
  __webpack_require__(303)
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-077cba8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_077cba8c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Client_components_ClientSelectInsurance_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Client_components_ClientInsurance_vue__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Client_components_ClientMembership_vue__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Client_components_ClientPSA_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Client_components_ClientAddress_vue__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Client_components_ClientGdprConsent_vue__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Client_components_ClientEmailAddress_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Client_components_ClientPhoneNumber_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Client_components_ClientDetail_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Client_components_ClientAuth_vue__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_staff_session__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Client_modals_ClientLog_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);




















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setting: __webpack_require__(3),
      selected: '',
      clients: [],
      clientsPending: false,
      clientsError: false,
      client: false,
      clientPending: false,
      clientError: false,
      clientDone: false,
      waitForSave: false,
      editingClientNote: false,
      clientForUpdate: '',
      modalClientLogOpened: false,
      clientId: false,
      stoppingImpersonation: false,
      impersonationError: ''
    };
  },

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  name: 'header',
  methods: {
    stopImpersonation: function stopImpersonation() {
      var _this = this;

      this.stoppingImpersonation = true;
      this.impersonationError = '';
      Object(__WEBPACK_IMPORTED_MODULE_12__services_staff_session__["b" /* stopImpersonating */])().then(function () {
        window.location.reload();
      }).catch(function () {
        _this.impersonationError = 'Impersonaci se nepodařilo ukončit.';
        _this.stoppingImpersonation = false;
      });
    },
    editNote: function editNote() {
      this.editingClientNote = true;
    },
    saveClient: function saveClient() {
      this.clientForUpdate = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.client, this.replacer));
      delete this.clientForUpdate['email_address'];
      delete this.clientForUpdate['client_auth'];
      delete this.clientForUpdate['phone_number'];
      delete this.clientForUpdate['address'];
      delete this.clientForUpdate['membership'];
      delete this.clientForUpdate['gdpr_consent'];
      this.clientForUpdate['citizenship'] = this.client.citizenship.id;
      this.putClient(this.clientForUpdate);
      this.editingClientNote = false;
    },
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    authLogout: function authLogout() {
      var _this2 = this;

      this.$http.post('logout', null, { emulateJSON: true }).then(function (response) {
        Object(__WEBPACK_IMPORTED_MODULE_12__services_staff_session__["a" /* clearStaffSession */])();
        _this2.$ls.remove('token');
        _this2.$ls.remove('authenticated');
        _this2.$ls.remove('role');
        _this2.$ls.remove('fullname');
        _this2.$ls.remove('userid');
        _this2.$ls.remove('locked');
        _this2.$router.push({ name: 'Login' });
      }).catch(function (error) {
        console.log(error);
      });
    },
    authLock: function authLock() {
      this.$ls.set('locked', true);
      this.$emit('lock');
    },
    openClient: function openClient(value) {
      this.selected = '';
      this.$router.push({ name: 'ShowClient', params: { clientid: value.id } });
    },

    getResult: __WEBPACK_IMPORTED_MODULE_14_lodash___default.a.debounce(function (text) {
      if (text.length > 2) {
        this.searchClients(text);
      }
    }, 600),
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    },
    reloadClient: function reloadClient(val) {
      if (val === true) {
        this.getClient(this.client.id);
      }
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    showModalClientLog: function showModalClientLog() {
      this.modalClientLogOpened = true;
      this.showModal('client-log');
    }
  },
  computed: {
    userFullname: function userFullname() {
      return this.$ls.get('fullname');
    },
    isAuthenticated: function isAuthenticated() {
      return this.$ls.get('authenticated');
    },
    impersonating: function impersonating() {
      return this.$ls.get('impersonating') === true;
    },
    originalFullname: function originalFullname() {
      return this.$ls.get('originalFullname');
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.matched[1].name === 'ClientRegistration' && typeof to.params.clientid !== 'undefined') {
        this.getClient(to.params.clientid);
      } else if (typeof to.params.clientid !== 'undefined') {
        if (String(from.params.clientid) !== String(to.params.clientid)) {
          this.client = false;
          this.getClient(to.params.clientid);
        } else if (from.matched[1].name === 'ClientRegistration' && to.matched[1].name === 'ShowClient' && String(from.params.clientid) === String(to.params.clientid)) {
          this.getClient(to.params.clientid);
        }
      } else {
        this.client = false;
      }
    },
    clientDone: function clientDone(val) {
      if (val === true) {
        this.clientDone = false;
        this.reloadClient(true);
      }
    }
  },
  beforeMount: function beforeMount() {
    if (typeof this.$route.params.clientid !== 'undefined') {
      this.getClient(this.$route.params.clientid);
    }
  },

  components: {
    ClientSelectInsurance: __WEBPACK_IMPORTED_MODULE_2__views_Client_components_ClientSelectInsurance_vue__["a" /* default */],
    ClientInsurance: __WEBPACK_IMPORTED_MODULE_3__views_Client_components_ClientInsurance_vue__["a" /* default */],
    ClientMembership: __WEBPACK_IMPORTED_MODULE_4__views_Client_components_ClientMembership_vue__["a" /* default */],
    ClientAddress: __WEBPACK_IMPORTED_MODULE_6__views_Client_components_ClientAddress_vue__["a" /* default */],
    ClientEmailAddress: __WEBPACK_IMPORTED_MODULE_8__views_Client_components_ClientEmailAddress_vue__["a" /* default */],
    ClientPhoneNumber: __WEBPACK_IMPORTED_MODULE_9__views_Client_components_ClientPhoneNumber_vue__["a" /* default */],
    ClientDetail: __WEBPACK_IMPORTED_MODULE_10__views_Client_components_ClientDetail_vue__["a" /* default */],
    ClientAuth: __WEBPACK_IMPORTED_MODULE_11__views_Client_components_ClientAuth_vue__["a" /* default */],
    ClientLog: __WEBPACK_IMPORTED_MODULE_13__views_Client_modals_ClientLog_vue__["a" /* default */],
    ClientPSA: __WEBPACK_IMPORTED_MODULE_5__views_Client_components_ClientPSA_vue__["a" /* default */],
    ClientGdprConsent: __WEBPACK_IMPORTED_MODULE_7__views_Client_components_ClientGdprConsent_vue__["a" /* default */]
  }
});

/***/ }),
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientSelectInsurance_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5af17411_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientSelectInsurance_vue__ = __webpack_require__(312);
function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5af17411"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientSelectInsurance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5af17411_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientSelectInsurance_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isOpen: false,
      insuranceCompaniesPending: true,
      insurance: {
        insurance_company: null
      },
      insurancePending: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: ['clientId'],
  methods: {
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    }
  },
  watch: {
    isOpen: function isOpen(val) {
      console.log(this.isOpen);
      if (val === true) {
        this.getInsuranceCompanies();
      } else {
        this.insuranceCompaniesPending = true;
      }
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target badge pointer badge-warning badge_health_insurance",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.open
    }
  }, [_c('i', {
    staticClass: "fa fa-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" chybí zdrav. pojišťovna")]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(!_vm.insuranceCompaniesPending) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h6', [_vm._v("Výběr zdravotního pojištění")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postInsurance(_vm.clientId)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "insuranceCompanySelect"
    }
  }, [_vm._v("Zdravotní pojišťovna")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.insurance_company),
      expression: "insurance.insurance_company"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "insuranceCompanySelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.insurance_company = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.insuranceCompanies), function(ic) {
    return _c('option', {
      domProps: {
        "value": ic.code
      }
    }, [_vm._v(_vm._s(ic.code) + " - " + _vm._s(ic.shortcut) + " - " + _vm._s(ic.name))])
  }))]), _vm._v(" "), (!_vm.insurancePending) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientInsurance_vue__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f12f7026_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientInsurance_vue__ = __webpack_require__(316);
function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f12f7026"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientInsurance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f12f7026_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientInsurance_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      insuranceCompaniesPending: true,
      editMode: false,
      insuranceDone: false,
      isOpen: false,
      insurance: {
        insurance_company: null,
        type: 1
      },
      clientInsurances: false,
      insurancePending: false,
      birthDateCalculated: false,
      possibleDates: [],

      deleteInsurancePending: false,
      deleteInsuranceDone: false,
      deleteInsuranceError: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: ['client', 'clientHeader'],
  methods: {
    open: function open() {
      this.isOpen = true;
      this.editMode = false;
    },
    close: function close() {
      this.isOpen = false;
    },
    edit: function edit() {
      this.editMode = true;
    },
    view: function view() {
      this.editMode = false;
    }
  },
  watch: {
    isOpen: function isOpen(val) {
      if (val === true) {
        var startDate = this.$moment().subtract(1, 'year').dayOfYear(1);
        this.possibleDates = [];
        for (var i = 0; i < 6; i++) {
          this.possibleDates.push(startDate.add(6, 'months').format('L'));
        }
        this.getInsuranceCompanies();
        if (this.client.health_insurance) {
          this.getClientInsurances(this.client.id);
        }
      } else {
        this.insuranceCompaniesPending = true;
      }
    },
    insuranceDone: function insuranceDone(val) {
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.insuranceDone = false;
        this.close();
      }
    },
    deleteInsuranceDone: function deleteInsuranceDone(val) {
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.deleteInsuranceDone = false;
        this.close();
      }
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-insurance"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.health_insurance) ? _c('span', {
    staticClass: "badge badge-secondary badge_health_insurance",
    class: '_' + _vm.client.health_insurance.code,
    attrs: {
      "title": _vm.client.health_insurance.name
    }
  }, [_vm._v(_vm._s(_vm.client.health_insurance.code === '---' ? _vm.client.health_insurance.shortcut : _vm.client.health_insurance.code) + "\n            "), (_vm.client.health_insurance.type === '2') ? _c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.client.health_insurance.type === '3') ? _c('i', {
    staticClass: "fa fa-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.client.health_insurance.type === '4') ? _c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _c('span', {
    staticClass: "tooltip-target badge pointer badge-warning badge_health_insurance",
    attrs: {
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" chybí zdrav. pojišťovna")])]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(!_vm.insuranceCompaniesPending) ? _c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }, [(_vm.editMode === false && _vm.client.health_insurance) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-insurance-edit"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" změnit")]) : (_vm.editMode === true) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-insurance-back"
    },
    on: {
      "click": _vm.view
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" zpět")]) : _vm._e()]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Úprava zdravotního pojištění")]) : (!_vm.client.health_insurance) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Výběr zdravotního pojištění")]) : _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Detail zdravotního pojištění")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("pojišťovna")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("druh")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3 text-right"
  }, [_vm._v("platné od")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3 text-right"
  }, [_vm._v("platné do")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.clientInsurances), function(ci) {
    return _c('tr', {
      staticClass: "row m-0 text-left",
      class: ci.is_valid ? 'font-weight-bold' : '',
      attrs: {
        "data-testid": "client-insurance-row"
      }
    }, [_c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(ci.insurance_company.shortcut))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(ci.type) + " - " + _vm._s(_vm._f("insuranceTypeIntToName")(ci.type)))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3 text-right"
    }, [_vm._v(_vm._s(ci.valid_from))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3 text-right"
    }, [_vm._v(_vm._s(ci.valid_to))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1 text-right"
    }, [(ci.valid_to === null) ? [(!_vm.deleteInsurancePending) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": "client-insurance-delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteInsurance(ci.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-outline-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e()], 2)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postInsurance(_vm.client.id)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "insuranceCompanySelect"
    }
  }, [_vm._v("Zdravotní pojišťovna")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.insurance_company),
      expression: "insurance.insurance_company"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-insurance-company",
      "id": "insuranceCompanySelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.insurance_company = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.insuranceCompanies), function(ic) {
    return _c('option', {
      domProps: {
        "value": ic.code
      }
    }, [_vm._v(_vm._s(ic.code) + " - " + _vm._s(ic.shortcut) + " - " + _vm._s(ic.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceValidFrom"
    }
  }, [_vm._v("od data")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.valid_from),
      expression: "insurance.valid_from"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-insurance-valid-from",
      "id": "insuranceValidFrom"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.valid_from = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.possibleDates), function(pd) {
    return _c('option', {
      domProps: {
        "value": pd
      }
    }, [_vm._v(_vm._s(pd))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceType"
    }
  }, [_vm._v("druh")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.type),
      expression: "insurance.type"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-insurance-type",
      "id": "insuranceType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + " - " + _vm._s(_vm._f("insuranceTypeIntToName")(n)))])
  }))]), _vm._v(" "), (!_vm.insurancePending) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "data-testid": "client-insurance-save",
      "type": "submit"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])]) : (!_vm.client.health_insurance) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postInsurance(_vm.client.id)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "insuranceCompanySelect"
    }
  }, [_vm._v("Zdravotní pojišťovna")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.insurance_company),
      expression: "insurance.insurance_company"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-insurance-company",
      "id": "insuranceCompanySelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.insurance_company = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.insuranceCompanies), function(ic) {
    return _c('option', {
      domProps: {
        "value": ic.code
      }
    }, [_vm._v(_vm._s(ic.code) + " - " + _vm._s(ic.shortcut) + " - " + _vm._s(ic.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceType"
    }
  }, [_vm._v("druh")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.type),
      expression: "insurance.type"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-insurance-type",
      "id": "insuranceType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + " - " + _vm._s(_vm._f("insuranceTypeIntToName")(n)))])
  }))]), _vm._v(" "), (!_vm.insurancePending) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "data-testid": "client-insurance-save",
      "type": "submit"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])]) : _c('div', {}, [_c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('div', {}, [_c('span', {
    staticClass: "badge badge-secondary badge_health_insurance badge_large",
    class: '_' + _vm.client.health_insurance.code,
    attrs: {
      "title": _vm.client.health_insurance.name
    }
  }, [_vm._v(_vm._s(_vm.client.health_insurance.shortcut))])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "data-testid": "client-insurance-detail"
    }
  }, [_c('div', {
    staticClass: "p-2"
  }, [_c('span', {
    staticClass: "h5"
  }, [_vm._v(_vm._s(_vm.client.health_insurance.name))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "h6"
  }, [_vm._v("(" + _vm._s(_vm._f("insuranceTypeIntToName")(_vm.client.health_insurance.type)) + ")")])])])])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientMembership_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b38395a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientMembership_vue__ = __webpack_require__(320);
function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b38395a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientMembership_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b38395a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientMembership_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setting: __webpack_require__(3),
      programsPending: true,
      programsError: false,
      programs: null,
      editMode: false,
      membershipDone: false,
      membershipPending: false,
      membershipError: false,
      isOpen: false,
      membership: {
        valid_from: new Date(),
        valid_to: null,
        program: {
          id: null
        },
        note: '',
        paid: false,
        paid_by_card: false
      },
      birthDateCalculated: false,
      possibleDates: [],
      clientMembershipsPending: false,
      clientMemberships: null,
      clientMembershipsError: false,
      selected_default_days: null,

      deleteMembershipPending: false,
      deleteMembershipDone: false,
      deleteMembershipError: false,

      updateMembershipPending: false,
      updateMembershipDone: false,
      updateMembershipError: false,
      membershipToUpdate: null,
      membershipToUpdateId: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: ['client', 'clientHeader'],
  methods: {
    init: function init() {
      this.membership = {
        valid_from: new Date(),
        valid_to: null,
        program: {
          id: null
        },
        note: '',
        paid: this.setting.fakturoid === true,
        paid_by_card: false
      };
    },
    open: function open() {
      this.init();
      this.isOpen = true;
      this.editMode = false;
    },
    close: function close() {
      this.isOpen = false;
    },
    edit: function edit() {
      this.editMode = true;
    },
    view: function view() {
      this.editMode = false;
    },
    recalculateDateProgramChanged: function recalculateDateProgramChanged(event) {
      this.selected_default_days = event.target.options[event.target.selectedIndex].getAttribute('data-days');
      console.log(event.target.options[event.target.selectedIndex].getAttribute('data-days'));
      this.recalculateValidTo();
    },
    recalculateDateValidFromChanged: function recalculateDateValidFromChanged() {
      if (this.selected_default_days !== null) {
        this.recalculateValidTo();
      }
    },
    recalculateValidTo: function recalculateValidTo() {
      this.membership.valid_to = this.$moment(this.membership.valid_from).add(this.selected_default_days, 'days').toDate();
      console.log(this.membership.valid_to);
    },
    updateMembership: function updateMembership(membership) {
      console.log(membership);
      this.membershipToUpdate = {
        valid_from: this.$moment(membership.valid_from, 'DD.MM.YYYY').toDate(),
        valid_to: this.$moment(membership.valid_to, 'DD.MM.YYYY').toDate(),
        program: {
          id: membership.program.id
        },
        note: membership.note,
        paid: membership.paid
      };
      this.membershipToUpdateId = membership.id;
      this.editMode = true;
    }
  },
  watch: {
    isOpen: function isOpen(val) {
      if (val === true) {
        var startDate = this.$moment().subtract(1, 'year').dayOfYear(1);
        this.possibleDates = [];
        for (var i = 0; i < 6; i++) {
          this.possibleDates.push(startDate.add(6, 'months').format('L'));
        }
        this.getPrograms();

        this.getClientMemberships(this.client.id);
      } else {
        this.programsPending = true;
      }
    },
    membershipDone: function membershipDone(val) {
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.membershipDone = false;
        this.close();
      }
    },
    updateMembershipDone: function updateMembershipDone(val) {
      if (val === true) {
        this.membershipToUpdateId = null;
        this.editMode = false;
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.updateMembershipDone = false;
        this.close();
      }
    },
    deleteMembershipDone: function deleteMembershipDone(val) {
      if (val === true) {
        console.log('smazal jsem zmrda');
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.deleteMembershipDone = false;
        this.close();
      }
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-membership"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.membership) ? [(_vm.membershipExpiresSoon(_vm.client.membership) && (_vm.client.membership.has_next_membership === false)) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'končí již: <b>' + _vm.client.membership.valid_to + '</b>' + (_vm.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
        placement: 'bottom-center',
        classes: ['danger']
      }),
      expression: "{\n                content: 'končí již: <b>' + client.membership.valid_to + '</b>' + (client.membership.paid === false ? '<br> <span class=\\'text-danger\\'>klient nezaplatil</span>' : ''),\n                    placement: 'bottom-center',\n                    classes: ['danger']}"
    }],
    staticClass: "badge badge-primary badge_membership",
    attrs: {
      "data-testid": "client-membership-expiring"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.client.membership.paid === false) ? _c('i', {
    staticClass: "fa fa-dollar text-danger",
    attrs: {
      "data-testid": "client-membership-unpaid"
    }
  }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.client.membership.name) + "\n            ")]) : _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'platný do: <b>' + _vm.client.membership.valid_to + '</b>' + (_vm.client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (_vm.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
        placement: 'bottom-center',
        classes: ['info']
      }),
      expression: "{\n                    content: 'platný do: <b>' + client.membership.valid_to + '</b>' + (client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (client.membership.paid === false ? '<br> <span class=\\'text-danger\\'>klient nezaplatil</span>' : ''),\n                    placement: 'bottom-center',\n                    classes: ['info']}"
    }],
    staticClass: "badge badge-primary badge_membership",
    attrs: {
      "data-testid": "client-membership-active"
    }
  }, [(_vm.client.membership.paid === false) ? _c('i', {
    staticClass: "fa fa-dollar text-danger",
    attrs: {
      "data-testid": "client-membership-unpaid"
    }
  }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.client.membership.name) + "\n            ")])] : (_vm.client.last_membership) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'skončil: <b>' + _vm.client.last_membership.valid_to,
        placement: 'bottom-center',
        classes: ['secondary']
      }),
      expression: "{\n            content: 'skončil: <b>' + client.last_membership.valid_to,\n            placement: 'bottom-center',\n            classes: ['secondary']}"
    }],
    staticClass: "badge badge-secondary badge_membership",
    attrs: {
      "data-testid": "client-membership-last"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" poslední: " + _vm._s(_vm.client.last_membership.name))]) : _c('span', {
    staticClass: "badge badge-warning badge_membership",
    attrs: {
      "data-testid": "client-membership-none"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" nemá program")])], 2), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(!_vm.programsPending) ? _c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }, [(_vm.editMode === false && _vm.client.membership) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-membership-change"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" změnit")]) : (_vm.editMode === true) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-membership-back"
    },
    on: {
      "click": _vm.view
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" zpět")]) : _vm._e()]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Úprava programu")]) : (!_vm.client.membership) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Výběr programu")]) : _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Detail programu")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("program")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3 text-right"
  }, [_vm._v("platný od")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("platný do")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("zaplaceno")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2 text-right"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.clientMemberships), function(cm) {
    return [
      [_c('tr', {
        staticClass: "row m-0 text-left",
        class: cm.is_valid ? 'font-weight-bold' : '',
        attrs: {
          "data-testid": "client-membership-row"
        }
      }, [_c('td', {
        staticClass: "col-sm-3",
        class: cm.program.is_valid ? 'font-weight-bold' : ''
      }, [_vm._v(_vm._s(cm.program.name))]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-3 text-right"
      }, [_vm._v(_vm._s(cm.valid_from))]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-2 text-right"
      }, [_vm._v(_vm._s(cm.valid_to))]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-2 text-right"
      }, [_vm._v(_vm._s(_vm._f("boolAndNullToCS")(cm.paid, ' ')) + "\n                                      "), (cm.fakturoid_invoice_id) ? [_c('a', {
        staticClass: "btn btn-sm btn-success text-white",
        attrs: {
          "target": "_blank",
          "href": _vm.setting.hostname + 'membership/' + cm.id + '/invoice/pdf'
        }
      }, [_vm._v("FA")])] : _vm._e()], 2), _vm._v(" "), _c('td', {
        staticClass: "col-sm-2 text-right"
      }, [(!_vm.updateMembershipPending && cm.id !== _vm.membershipToUpdateId) ? _c('button', {
        staticClass: "btn btn-sm btn-link",
        attrs: {
          "data-testid": "client-membership-edit"
        },
        on: {
          "click": function($event) {
            _vm.updateMembership(cm)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : (cm.id === _vm.membershipToUpdateId) ? _c('button', {
        staticClass: "btn btn-sm btn-link",
        on: {
          "click": function($event) {
            _vm.membershipToUpdateId = null
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _c('button', {
        staticClass: "btn btn-sm btn-outline-secondary disabled",
        attrs: {
          "disabled": "disabled"
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v(" "), (!_vm.deleteMembershipPending) ? _c('button', {
        staticClass: "btn btn-sm btn-outline-danger",
        attrs: {
          "data-testid": "client-membership-delete"
        },
        on: {
          "click": function($event) {
            _vm.deleteMembership(cm.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash-o",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _c('button', {
        staticClass: "btn btn-sm btn-outline-danger disabled",
        attrs: {
          "disabled": "disabled"
        }
      }, [_c('i', {
        staticClass: "fa fa-trash-o",
        attrs: {
          "aria-hidden": "true"
        }
      })])])]), _vm._v(" "), (cm.note) ? _c('tr', {
        staticClass: "row m-0 no-top-border-td no-padding-top-td"
      }, [_c('td', {
        staticClass: "col-sm-1"
      }), _vm._v(" "), _c('td', {
        staticClass: "col-sm-11 font-italic text-left"
      }, [_vm._v("\n                                        " + _vm._s(cm.note) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (cm.id === _vm.membershipToUpdateId) ? _c('tr', {
        staticClass: "row m-0 no-top-border-td no-padding-top-td"
      }, [_c('td', {
        staticClass: "col-sm-10"
      }, [_c('form', {
        on: {
          "submit": function($event) {
            $event.preventDefault();
            _vm.putMembership(cm.id)
          }
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-sm-6 form-group"
      }, [_c('label', {
        attrs: {
          "for": "programSelect"
        }
      }, [_vm._v("Program")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.membershipToUpdate.program.id),
          expression: "membershipToUpdate.program.id"
        }],
        staticClass: "form-control",
        attrs: {
          "data-testid": "client-membership-update-program",
          "id": "programSelect"
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.membershipToUpdate.program.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }, function($event) {
            _vm.recalculateDateProgramChanged($event)
          }]
        }
      }, _vm._l((_vm.programs), function(p) {
        return _c('option', {
          attrs: {
            "data-days": p.default_days
          },
          domProps: {
            "value": p.id
          }
        }, [_vm._v(_vm._s(p.name))])
      }))]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6 form-inline"
      }, [_c('label', {
        staticClass: "mr-sm-2",
        attrs: {
          "for": "paid"
        }
      }, [_vm._v("\n                                                        zaplaceno "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.membershipToUpdate.paid),
          expression: "membershipToUpdate.paid"
        }],
        staticClass: "form-check-input",
        attrs: {
          "type": "checkbox",
          "data-testid": "client-membership-update-paid",
          "id": "paid"
        },
        domProps: {
          "checked": Array.isArray(_vm.membershipToUpdate.paid) ? _vm._i(_vm.membershipToUpdate.paid, null) > -1 : (_vm.membershipToUpdate.paid)
        },
        on: {
          "__c": function($event) {
            var $$a = _vm.membershipToUpdate.paid,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.membershipToUpdate.paid = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.membershipToUpdate.paid = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.membershipToUpdate.paid = $$c
            }
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6 form-inline"
      }, [_c('label', {
        attrs: {
          "for": "validFrom"
        }
      }, [_vm._v("platnost od: ")]), _vm._v(" "), _c('datepicker', {
        attrs: {
          "placeholder": "vybrat datum",
          "format": "dd.MM.yyyy",
          "language": "cs",
          "monday-first": true,
          "full-month-name": true,
          "name": "validFrom",
          "id": "validFrom"
        },
        on: {
          "input": function($event) {
            _vm.recalculateDateValidFromChanged()
          }
        },
        model: {
          value: (_vm.membershipToUpdate.valid_from),
          callback: function($$v) {
            _vm.membershipToUpdate.valid_from = $$v
          },
          expression: "membershipToUpdate.valid_from"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6 form-inline"
      }, [_c('label', {
        attrs: {
          "for": "validTo"
        }
      }, [_vm._v("platnost do: ")]), _vm._v(" "), _c('datepicker', {
        attrs: {
          "placeholder": "vybrat datum",
          "format": "dd.MM.yyyy",
          "language": "cs",
          "monday-first": true,
          "full-month-name": true,
          "name": "validTo",
          "id": "validTo"
        },
        model: {
          value: (_vm.membershipToUpdate.valid_to),
          callback: function($$v) {
            _vm.membershipToUpdate.valid_to = $$v
          },
          expression: "membershipToUpdate.valid_to"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 form-group"
      }, [_c('label', {
        attrs: {
          "for": "note"
        }
      }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.membershipToUpdate.note),
          expression: "membershipToUpdate.note"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "data-testid": "client-membership-update-note",
          "aria-describedby": "noteHelp",
          "id": "note"
        },
        domProps: {
          "value": (_vm.membershipToUpdate.note)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.membershipToUpdate.note = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 form-group text-center"
      }, [(!_vm.updateMembershipPending) ? _c('button', {
        staticClass: "btn btn-success btn-sm",
        attrs: {
          "data-testid": "client-membership-update-save",
          "type": "submit"
        }
      }, [_vm._v("Uložit")]) : _c('button', {
        staticClass: "btn btn-primary btn-sm disabled",
        attrs: {
          "disabled": "disabled"
        }
      }, [_c('i', {
        staticClass: "fa fa-spinner fa-pulse fa-fw"
      }), _vm._v(" Ukládám")])])])])])]) : _vm._e()]
    ]
  })], 2)])])]), _vm._v(" "), (!_vm.client.membership || (_vm.editMode === true && _vm.membershipToUpdateId === null)) ? _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postMembership(_vm.client.id)
      }
    }
  }, [_c('div', {
    staticClass: "row bg-light"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('h5', [_vm._v("Přidání nového programu")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', {
    attrs: {
      "for": "programSelect"
    }
  }, [_vm._v("Program")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.program.id),
      expression: "membership.program.id"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-membership-program",
      "id": "programSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.membership.program.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.recalculateDateProgramChanged($event)
      }]
    }
  }, _vm._l((_vm.programs), function(p) {
    return _c('option', {
      attrs: {
        "data-days": p.default_days
      },
      domProps: {
        "value": p.id
      }
    }, [_vm._v(_vm._s(p.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-inline"
  }, [(_vm.setting.fakturoid === true) ? [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "paid_by_card"
    }
  }, [_vm._v("\n                              platí kartou "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.paid_by_card),
      expression: "membership.paid_by_card"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "data-testid": "client-membership-paid-by-card",
      "id": "paid_by_card"
    },
    domProps: {
      "checked": Array.isArray(_vm.membership.paid_by_card) ? _vm._i(_vm.membership.paid_by_card, null) > -1 : (_vm.membership.paid_by_card)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.membership.paid_by_card,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.membership.paid_by_card = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.membership.paid_by_card = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.membership.paid_by_card = $$c
        }
      }
    }
  }), _vm._v(" (jinak hotově)\n                            ")])] : [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "paid"
    }
  }, [_vm._v("\n                              zaplaceno "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.paid),
      expression: "membership.paid"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "data-testid": "client-membership-paid",
      "id": "paid"
    },
    domProps: {
      "checked": Array.isArray(_vm.membership.paid) ? _vm._i(_vm.membership.paid, null) > -1 : (_vm.membership.paid)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.membership.paid,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.membership.paid = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.membership.paid = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.membership.paid = $$c
        }
      }
    }
  })])]], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-inline"
  }, [_c('label', {
    attrs: {
      "for": "validFrom"
    }
  }, [_vm._v("platnost od: ")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "validFrom",
      "id": "validFrom"
    },
    on: {
      "input": function($event) {
        _vm.recalculateDateValidFromChanged()
      }
    },
    model: {
      value: (_vm.membership.valid_from),
      callback: function($$v) {
        _vm.membership.valid_from = $$v
      },
      expression: "membership.valid_from"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-inline"
  }, [_c('label', {
    attrs: {
      "for": "validTo"
    }
  }, [_vm._v("platnost do: ")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "validTo",
      "id": "validTo"
    },
    model: {
      value: (_vm.membership.valid_to),
      callback: function($$v) {
        _vm.membership.valid_to = $$v
      },
      expression: "membership.valid_to"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.note),
      expression: "membership.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-membership-note",
      "aria-describedby": "noteHelp",
      "id": "note"
    },
    domProps: {
      "value": (_vm.membership.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membership.note = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group text-center"
  }, [(!_vm.membershipPending) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "data-testid": "client-membership-save",
      "type": "submit"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])]) : _vm._e()]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientPSA_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2589b611_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientPSA_vue__ = __webpack_require__(324);
function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2589b611"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientPSA_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2589b611_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientPSA_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isOpen: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: ['client', 'clientHeader'],
  methods: {
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    }
  },
  watch: {
    isOpen: function isOpen(val) {}
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-psa"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.sorted_measurement_records && _vm.client.sorted_measurement_records.psa) ? [_c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'měřeno: <b>' + _vm.client.sorted_measurement_records.psa.data[0].measure_date + '</b>',
        placement: 'bottom-center',
        classes: ['info']
      }),
      expression: "{\n                    content: 'měřeno: <b>' + client.sorted_measurement_records.psa.data[0].measure_date + '</b>',\n                    placement: 'bottom-center',\n                    classes: ['info']}"
    }],
    staticClass: "badge badge-primary",
    attrs: {
      "data-testid": "client-psa-badge"
    }
  }, [_c('strong', [_vm._v("PSA:")]), _vm._v(" " + _vm._s(_vm.client.sorted_measurement_records.psa.data[0].value) + " " + _vm._s(_vm.client.sorted_measurement_records.psa.measurand.unit) + "\n            ")])] : _vm._e()], 2), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(_vm.client.sorted_measurement_records && _vm.client.sorted_measurement_records.psa) ? _c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col",
    attrs: {
      "data-testid": "client-psa-popover"
    }
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("PSA")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_vm._l((_vm.client.sorted_measurement_records.psa.data), function(record) {
    return [
      [_c('tr', {
        staticClass: "row m-0 text-left",
        attrs: {
          "data-testid": "client-psa-row"
        }
      }, [_c('td', {
        staticClass: "col-sm-6 text-left"
      }, [_c('strong', [_vm._v(_vm._s(record.value))]), _vm._v(" " + _vm._s(_vm.client.sorted_measurement_records.psa.measurand.unit))]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-6 text-right"
      }, [_vm._v(_vm._s(record.measure_date))])]), _vm._v(" "), (record.note) ? _c('tr', {
        staticClass: "row m-0 no-top-border-td no-padding-top-td"
      }, [_c('td', {
        staticClass: "col-sm-1"
      }), _vm._v(" "), _c('td', {
        staticClass: "col-sm-11 font-italic text-left"
      }, [_c('span', {
        attrs: {
          "data-testid": "client-psa-note"
        }
      }, [_vm._v(_vm._s(record.note))])])]) : _vm._e()]
    ]
  })], 2)])])])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAddress_vue__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_157bc2c7_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientAddress_vue__ = __webpack_require__(328);
function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-157bc2c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_157bc2c7_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientAddress_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      editMode: false,
      isOpen: false,
      countries: null,
      countriesPending: true,
      countriesError: false,
      hadAddress: false,
      addressPending: false,
      addressDone: false,
      addressError: false,
      lastAddressIsOld: false,
      addressForm: {
        country: 1,
        street: '',
        house_number: '',
        city: '',
        zip_code: '',
        district: '',
        region: '',
        full_maps_data: null
      },
      lastAddress: false,
      selected: '',
      addresses: [],
      foreignAddresses: [],
      foreignAddressDetail: {},
      toSearchText: '',
      toSearchForeignText: '',
      searchOutsideCzechia: false,
      foreignAddressDetailDone: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: ['client', 'clientHeader'],
  methods: {
    init: function init() {
      this.addressError = false;
    },
    open: function open() {
      this.init();
      if (this.client.address) {
        this.hadAddress = true;
        this.editMode = false;

        this.addressForm.id = this.client.address.id;
        this.lastAddress = this.client.address.full_address;
        this.lastAddressIsOld = this.client.address.is_old_address === true;
      } else {
        this.hadAddress = false;
        this.addressForm = { country: 1 };
        this.editMode = true;
      }
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    },
    edit: function edit() {
      this.editMode = true;
    },
    view: function view() {
      this.editMode = false;
    },
    submitForm: function submitForm() {
      if (this.hadAddress && this.lastAddressIsOld === false) {
        this.putAddress(this.addressForm);
      } else {
        this.postAddress(this.addressForm, this.client.id);
      }
    },
    getResult: function getResult(text) {
      this.toSearchText = text;
    },
    getForeignAddressResult: function getForeignAddressResult(text) {
      this.toSearchForeignText = text;
    },
    openAddress: function openAddress(value) {
      this.addressForm.street = value.values.STREET;
      this.addressForm.house_number = value.values.NUMBER;
      this.addressForm.city = value.values.CITY;
      this.addressForm.zip_code = value.values.ZIP;
      this.addressForm.district = value.values.DISTRICT;
      this.addressForm.region = value.values.REGION;
      this.addressForm.full_maps_data = null;
    },
    openForeignAddress: function openForeignAddress(value) {
      this.getForeignAddressDetail(value.place_id);
    }
  },
  watch: {
    isOpen: function isOpen(val) {
      if (val === true) {
        if (this.countries === null) {
          this.getCountries();
        }
      } else {}
    },
    addressDone: function addressDone(val) {
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.addressDone = false;
        this.close();
      }
    },
    searchOutsideCzechia: function searchOutsideCzechia(val) {
      if (val === true) {
        this.addressForm.country = null;
      } else {
        this.addressForm.country = 1;
      }
    },

    toSearchText: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (text) {
      this.searchAddresses(text);
    }, 1500),
    toSearchForeignText: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (text) {
      this.searchForeignAddresses(text);
    }, 1500),
    foreignAddressDetailDone: function foreignAddressDetailDone(val) {
      if (val === true) {
        this.addressForm.country = null;
        this.addressForm.street = '';
        this.addressForm.house_number = '';
        this.addressForm.city = '';
        this.addressForm.zip_code = '';
        this.addressForm.district = '';
        this.addressForm.region = '';
        this.addressForm.full_maps_data = null;

        var city = [];
        for (var i = 0, len = this.foreignAddressDetail.address_components.length; i < len; i++) {
          var addressPart = this.foreignAddressDetail.address_components[i];
          if (addressPart.types.includes('street_number')) {
            this.addressForm.house_number = addressPart.long_name;
          }
          if (addressPart.types.includes('postal_code')) {
            this.addressForm.zip_code = addressPart.long_name;
          }
          if (addressPart.types.includes('locality')) {
            city[0] = addressPart.long_name;
          }
          if (addressPart.types.includes('sublocality')) {
            city[1] = addressPart.long_name;
          }
          if (addressPart.types.includes('route')) {
            this.addressForm.street = addressPart.long_name;
          }
          if (addressPart.types.includes('administrative_area_level_1')) {
            this.addressForm.region = addressPart.long_name;
          }
          if (addressPart.types.includes('administrative_area_level_2')) {
            this.addressForm.district = addressPart.long_name;
          }
        }
        city = city.filter(function (el) {
          return el != null;
        });
        this.addressForm.city = city.join(', ');
        this.addressForm.full_maps_data = this.foreignAddressDetail;
      }
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-address"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.address !== null) ? _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [(_vm.client.address.is_old_address === true) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.client.address.full_address))])]) : _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chybí adresa bydliště")])])]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container tooltip_container tooltip_1_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }, [(_vm.editMode === false && _vm.client.address) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-address-edit"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" upravit")]) : (_vm.editMode === true && _vm.client.address) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-address-back"
    },
    on: {
      "click": _vm.view
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" zpět")]) : _vm._e()]), _vm._v(" "), (_vm.client.address === null && _vm.editMode === true) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Nastavení adresy trvalého bydliště")]) : (_vm.editMode === true) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Úprava adresy trvalého bydliště")]) : _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Adresa trvalého bydliště")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 tooltip_body text-left"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-around"
  }, [_c('span', [_vm._v("Česká")]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-lg switch-text switch-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOutsideCzechia),
      expression: "searchOutsideCzechia"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "searchInCzechia",
      "data-testid": "client-address-foreign-toggle"
    },
    domProps: {
      "checked": Array.isArray(_vm.searchOutsideCzechia) ? _vm._i(_vm.searchOutsideCzechia, null) > -1 : (_vm.searchOutsideCzechia)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.searchOutsideCzechia,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.searchOutsideCzechia = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.searchOutsideCzechia = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.searchOutsideCzechia = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "",
      "data-off": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('span', [_vm._v("zahraniční")])]), _vm._v(" "), (!_vm.searchOutsideCzechia) ? [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('multiselect', {
    attrs: {
      "reset-after": true,
      "id": "search",
      "data-testid": "client-address-search-czech",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat adresu",
      "open-direction": "bottom",
      "options": _vm.addresses,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "clear-on-select": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getResult,
      "select": _vm.openAddress
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(_vm._s(props.option.values.WHOLE_ADDRESS))])]), _vm._v(" "), _c('div', {
          staticClass: "row m-0 font-sm"
        }, [_c('div', {
          staticClass: "col-sm-12"
        }, [_c('span', [_vm._v(_vm._s(props.option.values.DISTRICT))]), _vm._v(", \n                                                            "), _c('span', [_vm._v(_vm._s(props.option.values.REGION))])])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])] : [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('multiselect', {
    attrs: {
      "reset-after": true,
      "id": "searchForeign",
      "data-testid": "client-address-search-foreign",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat adresu v cizině",
      "open-direction": "bottom",
      "options": _vm.foreignAddresses,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "clear-on-select": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getForeignAddressResult,
      "select": _vm.openForeignAddress
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(_vm._s(props.option.description))])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])], _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-9"
  }, [_c('label', {
    attrs: {
      "for": "street"
    }
  }, [_vm._v("Ulice")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.street),
      expression: "addressForm.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-street",
      "aria-describedby": "streetHelp",
      "id": "street",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.street = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.street) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "streetError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.street.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "houseNumber"
    }
  }, [_vm._v("Číslo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.house_number),
      expression: "addressForm.house_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-house-number",
      "aria-describedby": "houseNumberHelp",
      "id": "houseNumber",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.house_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.house_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.housenumber) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "houseNumberError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.housenumber.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "zip_code"
    }
  }, [_vm._v("PSČ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.zip_code),
      expression: "addressForm.zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-zip-code",
      "aria-describedby": "zip_codeHelp",
      "id": "zip_code",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.zip_code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.zipcode) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "zipCodeError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.zipcode.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Město")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.city),
      expression: "addressForm.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-city",
      "aria-describedby": "cityHelp",
      "id": "city",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.city) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "cityError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.city.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "district"
    }
  }, [_vm._v("Okres")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.district),
      expression: "addressForm.district"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-district",
      "aria-describedby": "districtHelp",
      "id": "district",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.district)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.district = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.district) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "districtError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.district.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "region"
    }
  }, [_vm._v("Kraj")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.region),
      expression: "addressForm.region"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-region",
      "aria-describedby": "regionHelp",
      "id": "region",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.region = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.region) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "regionError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.region.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [(_vm.lastAddress) ? _c('span', [_vm._v("Předchozí adresa: " + _vm._s(_vm.lastAddress))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.addressPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "client-address-save",
      "type": "submit"
    }
  }, [_vm._v("Uložit adresu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])], 2)])]) : (_vm.client.address) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table_labeled table-bordered",
    attrs: {
      "data-testid": "client-address-table"
    }
  }, [_c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("ulice a čp.")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.address.street)))])]), _vm._v(" "), _c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("PSČ")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.address.zip_code)))]), _vm._v(" "), _c('td', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("obec")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.address.city)))])]), _vm._v(" "), _c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-sm-12",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("stát")]), _vm._v(_vm._s(_vm._f("neverEmpty")((_vm.client.address.country ? _vm.client.address.country.name : ''))))])])])]) : _vm._e()])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientGdprConsent_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52e91564_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientGdprConsent_vue__ = __webpack_require__(333);
function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52e91564"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientGdprConsent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52e91564_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientGdprConsent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      editMode: false,
      isOpen: false,
      newGdprConsent: {
        agreed: true,
        recorded_on: ''
      },
      setting: __webpack_require__(3),
      selectedDate: '',
      newGdprConsentError: false,
      newGdprConsentPending: false,
      newGdprConsentDone: false,
      updatedGdprConsent: {},
      updatedGdprConsentError: false,
      updatedGdprConsentPending: false,
      updatedGdprConsentDone: false,
      deleteGdprConsentError: false,
      deleteGdprConsentPending: false,
      deleteGdprConsentDone: false,
      editingId: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  props: ['client', 'clientHeader'],
  methods: {
    init: function init() {
      this.newGdprConsent = { agreed: true };
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate();
      this.newGdprConsentError = false;
      this.editingId = false;
      this.updatedGdprConsent = {};
      this.updatedGdprConsentError = false;
      this.updatedGdprConsentPending = false;
      this.updatedGdprConsentDone = false;
      this.deleteGdprConsentError = false;
      this.deleteGdprConsentPending = false;
      this.deleteGdprConsentDone = false;
    },
    open: function open() {
      this.init();
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    },
    edit: function edit() {
      this.editMode = true;
    },
    view: function view() {
      this.editMode = false;
    },
    submitFormAddGdprConsent: function submitFormAddGdprConsent() {
      this.newGdprConsentError = false;
      this.postGdprConsent(this.newGdprConsent, this.client.id);
    },
    submitFormUpdateGdprConsent: function submitFormUpdateGdprConsent() {
      this.updatedGdprConsentError = false;
      this.putGdprConsent(this.updatedGdprConsent);
    },
    setEditingGdprConsent: function setEditingGdprConsent(gdprConsent) {
      if (this.editingId === false) {
        this.updatedGdprConsent = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(gdprConsent));
        this.editingId = gdprConsent.id;
      } else {
        this.updatedGdprConsent = {};
        this.editingId = false;
      }
    }
  },
  watch: {
    isOpen: function isOpen(val) {
      if (val === true) {} else {}
    },

    selectedDate: function selectedDate(val) {
      this.newGdprConsent.recorded_on = __WEBPACK_IMPORTED_MODULE_2_moment___default()(val).format('DD.MM.YYYY');
    },
    newGdprConsentDone: function newGdprConsentDone(val) {
      this.newGdprConsent = { agreed: true };
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.newGdprConsentDone = false;
      }
    },
    deleteGdprConsentDone: function deleteGdprConsentDone(val) {
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.deleteGdprConsentDone = false;
      }
    },
    updatedGdprConsentDone: function updatedGdprConsentDone(val) {
      if (val === true) {
        this.editingId = false;
        this.updatedGdprConsent = {};
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.updatedGdprConsentDone = false;
      }
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 80,
	"./af.js": 80,
	"./ar": 81,
	"./ar-dz": 82,
	"./ar-dz.js": 82,
	"./ar-kw": 83,
	"./ar-kw.js": 83,
	"./ar-ly": 84,
	"./ar-ly.js": 84,
	"./ar-ma": 85,
	"./ar-ma.js": 85,
	"./ar-sa": 86,
	"./ar-sa.js": 86,
	"./ar-tn": 87,
	"./ar-tn.js": 87,
	"./ar.js": 81,
	"./az": 88,
	"./az.js": 88,
	"./be": 89,
	"./be.js": 89,
	"./bg": 90,
	"./bg.js": 90,
	"./bm": 91,
	"./bm.js": 91,
	"./bn": 92,
	"./bn.js": 92,
	"./bo": 93,
	"./bo.js": 93,
	"./br": 94,
	"./br.js": 94,
	"./bs": 95,
	"./bs.js": 95,
	"./ca": 96,
	"./ca.js": 96,
	"./cs": 97,
	"./cs.js": 97,
	"./cv": 98,
	"./cv.js": 98,
	"./cy": 99,
	"./cy.js": 99,
	"./da": 100,
	"./da.js": 100,
	"./de": 101,
	"./de-at": 102,
	"./de-at.js": 102,
	"./de-ch": 103,
	"./de-ch.js": 103,
	"./de.js": 101,
	"./dv": 104,
	"./dv.js": 104,
	"./el": 105,
	"./el.js": 105,
	"./en-au": 106,
	"./en-au.js": 106,
	"./en-ca": 107,
	"./en-ca.js": 107,
	"./en-gb": 108,
	"./en-gb.js": 108,
	"./en-ie": 109,
	"./en-ie.js": 109,
	"./en-il": 110,
	"./en-il.js": 110,
	"./en-nz": 111,
	"./en-nz.js": 111,
	"./eo": 112,
	"./eo.js": 112,
	"./es": 113,
	"./es-do": 114,
	"./es-do.js": 114,
	"./es-us": 115,
	"./es-us.js": 115,
	"./es.js": 113,
	"./et": 116,
	"./et.js": 116,
	"./eu": 117,
	"./eu.js": 117,
	"./fa": 118,
	"./fa.js": 118,
	"./fi": 119,
	"./fi.js": 119,
	"./fo": 120,
	"./fo.js": 120,
	"./fr": 121,
	"./fr-ca": 122,
	"./fr-ca.js": 122,
	"./fr-ch": 123,
	"./fr-ch.js": 123,
	"./fr.js": 121,
	"./fy": 124,
	"./fy.js": 124,
	"./gd": 125,
	"./gd.js": 125,
	"./gl": 126,
	"./gl.js": 126,
	"./gom-latn": 127,
	"./gom-latn.js": 127,
	"./gu": 128,
	"./gu.js": 128,
	"./he": 129,
	"./he.js": 129,
	"./hi": 130,
	"./hi.js": 130,
	"./hr": 131,
	"./hr.js": 131,
	"./hu": 132,
	"./hu.js": 132,
	"./hy-am": 133,
	"./hy-am.js": 133,
	"./id": 134,
	"./id.js": 134,
	"./is": 135,
	"./is.js": 135,
	"./it": 136,
	"./it.js": 136,
	"./ja": 137,
	"./ja.js": 137,
	"./jv": 138,
	"./jv.js": 138,
	"./ka": 139,
	"./ka.js": 139,
	"./kk": 140,
	"./kk.js": 140,
	"./km": 141,
	"./km.js": 141,
	"./kn": 142,
	"./kn.js": 142,
	"./ko": 143,
	"./ko.js": 143,
	"./ky": 144,
	"./ky.js": 144,
	"./lb": 145,
	"./lb.js": 145,
	"./lo": 146,
	"./lo.js": 146,
	"./lt": 147,
	"./lt.js": 147,
	"./lv": 148,
	"./lv.js": 148,
	"./me": 149,
	"./me.js": 149,
	"./mi": 150,
	"./mi.js": 150,
	"./mk": 151,
	"./mk.js": 151,
	"./ml": 152,
	"./ml.js": 152,
	"./mn": 153,
	"./mn.js": 153,
	"./mr": 154,
	"./mr.js": 154,
	"./ms": 155,
	"./ms-my": 156,
	"./ms-my.js": 156,
	"./ms.js": 155,
	"./mt": 157,
	"./mt.js": 157,
	"./my": 158,
	"./my.js": 158,
	"./nb": 159,
	"./nb.js": 159,
	"./ne": 160,
	"./ne.js": 160,
	"./nl": 161,
	"./nl-be": 162,
	"./nl-be.js": 162,
	"./nl.js": 161,
	"./nn": 163,
	"./nn.js": 163,
	"./pa-in": 164,
	"./pa-in.js": 164,
	"./pl": 165,
	"./pl.js": 165,
	"./pt": 166,
	"./pt-br": 167,
	"./pt-br.js": 167,
	"./pt.js": 166,
	"./ro": 168,
	"./ro.js": 168,
	"./ru": 169,
	"./ru.js": 169,
	"./sd": 170,
	"./sd.js": 170,
	"./se": 171,
	"./se.js": 171,
	"./si": 172,
	"./si.js": 172,
	"./sk": 173,
	"./sk.js": 173,
	"./sl": 174,
	"./sl.js": 174,
	"./sq": 175,
	"./sq.js": 175,
	"./sr": 176,
	"./sr-cyrl": 177,
	"./sr-cyrl.js": 177,
	"./sr.js": 176,
	"./ss": 178,
	"./ss.js": 178,
	"./sv": 179,
	"./sv.js": 179,
	"./sw": 180,
	"./sw.js": 180,
	"./ta": 181,
	"./ta.js": 181,
	"./te": 182,
	"./te.js": 182,
	"./tet": 183,
	"./tet.js": 183,
	"./tg": 184,
	"./tg.js": 184,
	"./th": 185,
	"./th.js": 185,
	"./tl-ph": 186,
	"./tl-ph.js": 186,
	"./tlh": 187,
	"./tlh.js": 187,
	"./tr": 188,
	"./tr.js": 188,
	"./tzl": 189,
	"./tzl.js": 189,
	"./tzm": 190,
	"./tzm-latn": 191,
	"./tzm-latn.js": 191,
	"./tzm.js": 190,
	"./ug-cn": 192,
	"./ug-cn.js": 192,
	"./uk": 193,
	"./uk.js": 193,
	"./ur": 194,
	"./ur.js": 194,
	"./uz": 195,
	"./uz-latn": 196,
	"./uz-latn.js": 196,
	"./uz.js": 195,
	"./vi": 197,
	"./vi.js": 197,
	"./x-pseudo": 198,
	"./x-pseudo.js": 198,
	"./yo": 199,
	"./yo.js": 199,
	"./zh-cn": 200,
	"./zh-cn.js": 200,
	"./zh-hk": 201,
	"./zh-hk.js": 201,
	"./zh-tw": 202,
	"./zh-tw.js": 202
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332;

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-gdpr"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.gdpr_consent) ? [(_vm.client.gdpr_consent.agreed) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'souhlasil dne: <b>' + _vm.client.gdpr_consent.recorded_on + '</b>',
        placement: 'bottom-center',
        classes: ['info']
      }),
      expression: "{\n                    content: 'souhlasil dne: <b>' + client.gdpr_consent.recorded_on + '</b>',\n                    placement: 'bottom-center',\n                    classes: ['info']}"
    }],
    staticClass: "badge badge-success",
    attrs: {
      "data-testid": "client-gdpr-badge-agreed"
    }
  }, [_vm._v("\n            GDPR\n          "), _c('i', {
    staticClass: "fa fa-check text-white",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'NEsouhlasil dne: <b>' + _vm.client.gdpr_consent.recorded_on + '</b>',
        placement: 'bottom-center',
        classes: ['secondary']
      }),
      expression: "{\n                    content: 'NEsouhlasil dne: <b>' + client.gdpr_consent.recorded_on + '</b>',\n                    placement: 'bottom-center',\n                    classes: ['secondary']}"
    }],
    staticClass: "badge badge-secondary",
    attrs: {
      "data-testid": "client-gdpr-badge-disagreed"
    }
  }, [_vm._v("\n            GDPR\n          "), _c('i', {
    staticClass: "fa fa-times text-white",
    attrs: {
      "aria-hidden": "true"
    }
  })])] : _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'nemá vyplněné GDPR',
        placement: 'bottom-center',
        classes: ['danger']
      }),
      expression: "{\n                    content: 'nemá vyplněné GDPR',\n                    placement: 'bottom-center',\n                    classes: ['danger']}"
    }],
    staticClass: "badge badge-danger",
    attrs: {
      "data-testid": "client-gdpr-badge-missing"
    }
  }, [_vm._v("\n            bez GDPR\n          "), _c('i', {
    staticClass: "fa fa-exclamation-triangle text-white",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }, [_c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "target": "_blank",
      "href": _vm.setting.hostname + 'client/' + _vm.client.id + '/gdpr/pdf'
    }
  }, [_vm._v("Formulář")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("GDPR souhlas klienta")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), (_vm.client.gdpr_consent) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-7"
  }, [_vm._v("souhlasí s GDPR")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("datum (ne)souhlasu")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  })])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "row m-0 text-left",
    attrs: {
      "data-testid": "client-gdpr-row"
    }
  }, [_c('td', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm._f("boolToCS")(_vm.client.gdpr_consent.agreed)))]), _vm._v(" "), _c('td', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.client.gdpr_consent.recorded_on))]), _vm._v(" "), _c('td', {
    staticClass: "text-right col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "data-testid": "client-gdpr-delete"
    },
    on: {
      "click": function($event) {
        _vm.deleteGdprConsent(_vm.client.gdpr_consent.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.client.gdpr_consent) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitFormAddGdprConsent($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {}, [_c('span', [_vm._v("Datum (ne)souhlasu:")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum (ne)souhlasu",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput"
    },
    on: {
      "input": function($event) {
        _vm.manualSelectDate($event)
      }
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                      Souhlasil: \n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGdprConsent.agreed),
      expression: "newGdprConsent.agreed"
    }],
    attrs: {
      "type": "checkbox",
      "data-testid": "client-gdpr-agreed"
    },
    domProps: {
      "checked": Array.isArray(_vm.newGdprConsent.agreed) ? _vm._i(_vm.newGdprConsent.agreed, null) > -1 : (_vm.newGdprConsent.agreed)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.newGdprConsent.agreed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newGdprConsent.agreed = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.newGdprConsent.agreed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newGdprConsent.agreed = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.newGdprConsentPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "client-gdpr-submit"
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.newGdprConsentError.number) ? _c('small', {
    staticClass: "form-text text-danger text-left",
    attrs: {
      "id": "numberError"
    }
  }, [_vm._v(_vm._s(_vm.newGdprConsentError.number.message))]) : _vm._e()])])]) : _vm._e()])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientEmailAddress_vue__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da495f5_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientEmailAddress_vue__ = __webpack_require__(337);
function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6da495f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientEmailAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da495f5_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientEmailAddress_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      editMode: false,
      isOpen: false,
      newEmailAddress: {
        default: true
      },
      newEmailAddressError: false,
      newEmailAddressPending: false,
      newEmailAddressDone: false,
      updatedEmailAddress: {},
      updatedEmailAddressError: false,
      updatedEmailAddressPending: false,
      updatedEmailAddressDone: false,
      deleteEmailAddressError: false,
      deleteEmailAddressPending: false,
      deleteEmailAddressDone: false,
      editingId: false,
      clientForUpdate: {},
      clientPending: false,
      clientDone: false,
      clientError: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  props: ['client', 'clientHeader'],
  methods: {
    init: function init() {
      this.newEmailAddress = {
        default: true
      };
      this.newEmailAddressError = false;
      this.editingId = false;
      this.updatedEmailAddress = {};
      this.updatedEmailAddressError = false;
      this.updatedEmailAddressPending = false;
      this.updatedEmailAddressDone = false;
      this.deleteEmailAddressError = false;
      this.deleteEmailAddressPending = false;
      this.deleteEmailAddressDone = false;
      this.clientForUpdate.using_email = this.client.using_email;
      this.clientForUpdate.id = this.client.id;
      this.clientPending = false;
      this.clientDone = false;
      this.clientError = false;
    },
    open: function open() {
      this.init();
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    },
    edit: function edit() {
      this.editMode = true;
    },
    view: function view() {
      this.editMode = false;
    },
    submitFormAddEmailAddress: function submitFormAddEmailAddress() {
      this.newEmailAddressError = false;
      this.postEmailAddress(this.newEmailAddress, this.client.id);
    },
    submitFormUpdateEmailAddress: function submitFormUpdateEmailAddress() {
      this.updatedEmailAddressError = false;
      this.putEmailAddress(this.updatedEmailAddress);
    },
    setEditingEmailAddress: function setEditingEmailAddress(emailAddress) {
      if (this.editingId === false) {
        this.updatedEmailAddress = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(emailAddress, this.replacer));
        this.editingId = emailAddress.id;
      } else {
        this.updatedEmailAddress = {};
        this.editingId = false;
      }
    },
    saveUsingMail: function saveUsingMail() {
      this.putClient(this.clientForUpdate);
    }
  },
  watch: {
    isOpen: function isOpen(val) {
      if (val === true) {} else {}
    },
    newEmailAddressDone: function newEmailAddressDone(val) {
      if (val === true) {
        this.newEmailAddress = {
          default: true
        };
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.newEmailAddressDone = false;
      }
    },
    deleteEmailAddressDone: function deleteEmailAddressDone(val) {
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.deleteEmailAddressDone = false;
      }
    },
    updatedEmailAddressDone: function updatedEmailAddressDone(val) {
      if (val === true) {
        this.editingId = false;
        this.updatedEmailAddress = {};
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.updatedEmailAddressDone = false;
      }
    },
    clientDone: function clientDone(val) {
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.clientDone = false;
      }
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-email"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.email_address.length > 0) ? _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.client.default_email_address))])]) : (_vm.client.using_email === false) ? _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('span', {
    staticClass: "text-secondary"
  }, [_c('i', {
    staticClass: "fa fa-envelope-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Klient nepoužívá email")])]) : _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-envelope-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chybí emailová adresa")])])]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("E-mailové adresy klienta")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_vm._v("Klient používá email ")]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForUpdate.using_email),
      expression: "clientForUpdate.using_email"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "usingEmail",
      "data-testid": "client-email-using-toggle",
      "disabled": _vm.clientPending
    },
    domProps: {
      "checked": Array.isArray(_vm.clientForUpdate.using_email) ? _vm._i(_vm.clientForUpdate.using_email, null) > -1 : (_vm.clientForUpdate.using_email)
    },
    on: {
      "change": _vm.saveUsingMail,
      "__c": function($event) {
        var $$a = _vm.clientForUpdate.using_email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.clientForUpdate.using_email = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clientForUpdate.using_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clientForUpdate.using_email = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), (_vm.client.using_email) ? [(_vm.client.email_address.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-7"
  }, [_vm._v("emailová adresa")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("výchozí")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.client.email_address), function(ea) {
    return [_c('tr', {
      staticClass: "row m-0 text-left",
      class: ea.default ? 'font-weight-bold' : '',
      attrs: {
        "data-testid": "client-email-row"
      }
    }, [(_vm.editingId !== ea.id) ? _c('td', {
      staticClass: "col-sm-7"
    }, [_vm._v(_vm._s(ea.email))]) : _vm._e(), _vm._v(" "), (_vm.editingId !== ea.id) ? _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(_vm._f("boolToCS")(ea.default)))]) : _c('td', {
      staticClass: "col-sm-10"
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.submitFormUpdateEmailAddress($event)
        }
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedEmailAddress.email),
        expression: "updatedEmailAddress.email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "e-mailová adresa",
        "data-testid": "client-email-edit-input",
        "id": "emailAddress"
      },
      domProps: {
        "value": (_vm.updatedEmailAddress.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedEmailAddress.email = $event.target.value
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                                                  Výchozí: \n                                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedEmailAddress.default),
        expression: "updatedEmailAddress.default"
      }],
      attrs: {
        "type": "checkbox",
        "data-testid": "client-email-edit-default"
      },
      domProps: {
        "checked": Array.isArray(_vm.updatedEmailAddress.default) ? _vm._i(_vm.updatedEmailAddress.default, null) > -1 : (_vm.updatedEmailAddress.default)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.updatedEmailAddress.default,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.updatedEmailAddress.default = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.updatedEmailAddress.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.updatedEmailAddress.default = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedEmailAddress.note),
        expression: "updatedEmailAddress.note"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "data-testid": "client-email-edit-note",
        "id": "emailAddressNote",
        "placeholder": "poznámka"
      },
      domProps: {
        "value": (_vm.updatedEmailAddress.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedEmailAddress.note = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.updatedEmailAddressPending === false) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "data-testid": "client-email-edit-save",
        "type": "submit"
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.updatedEmailAddressError.email) ? _c('small', {
      staticClass: "form-text text-danger text-left",
      attrs: {
        "id": "emailError"
      }
    }, [_vm._v(_vm._s(_vm.updatedEmailAddressError.email.message))]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "text-right col-sm-2"
    }, [(_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": "client-email-delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteEmailAddress(ea.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (_vm.editingId === ea.id) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": "client-email-edit-cancel"
      },
      on: {
        "click": function($event) {
          _vm.setEditingEmailAddress(ea)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : (_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": "client-email-edit"
      },
      on: {
        "click": function($event) {
          _vm.setEditingEmailAddress(ea)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), (ea.note !== null && ea.note !== '' && _vm.editingId !== ea.id) ? _c('tr', {
      staticClass: "row m-0 "
    }, [_c('td', {
      staticClass: "col-sm-12 text-left border-top-0 pt-0 font-italic"
    }, [_vm._v("Poznámka: " + _vm._s(ea.note))])]) : _vm._e()]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editingId === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitFormAddEmailAddress($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmailAddress.email),
      expression: "newEmailAddress.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "e-mailová adresa",
      "data-testid": "client-email-input",
      "id": "emailAddress"
    },
    domProps: {
      "value": (_vm.newEmailAddress.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmailAddress.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                      Výchozí: \n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmailAddress.default),
      expression: "newEmailAddress.default"
    }],
    attrs: {
      "type": "checkbox",
      "data-testid": "client-email-default"
    },
    domProps: {
      "checked": Array.isArray(_vm.newEmailAddress.default) ? _vm._i(_vm.newEmailAddress.default, null) > -1 : (_vm.newEmailAddress.default)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.newEmailAddress.default,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newEmailAddress.default = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.newEmailAddress.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newEmailAddress.default = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmailAddress.note),
      expression: "newEmailAddress.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-email-note",
      "id": "emailAddressNote",
      "placeholder": "poznámka"
    },
    domProps: {
      "value": (_vm.newEmailAddress.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmailAddress.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newEmailAddressPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "client-email-add",
      "type": "submit"
    }
  }, [_vm._v("Přidat e-mail")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.newEmailAddressError.email) ? _c('small', {
    staticClass: "form-text text-danger text-left",
    attrs: {
      "id": "emailError"
    }
  }, [_vm._v(_vm._s(_vm.newEmailAddressError.email.message))]) : _vm._e()])])]) : _vm._e()] : _vm._e()], 2)])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientPhoneNumber_vue__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a753bac_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientPhoneNumber_vue__ = __webpack_require__(341);
function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a753bac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientPhoneNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a753bac_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientPhoneNumber_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      editMode: false,
      isOpen: false,
      newPhoneNumber: {
        default: true
      },
      newPhoneNumberError: false,
      newPhoneNumberPending: false,
      newPhoneNumberDone: false,
      updatedPhoneNumber: {},
      updatedPhoneNumberError: false,
      updatedPhoneNumberPending: false,
      updatedPhoneNumberDone: false,
      deletePhoneNumberError: false,
      deletePhoneNumberPending: false,
      deletePhoneNumberDone: false,
      editingId: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  props: ['client', 'clientHeader'],
  methods: {
    init: function init() {
      this.newPhoneNumber = { default: true };
      this.newPhoneNumberError = false;
      this.editingId = false;
      this.updatedPhoneNumber = {};
      this.updatedPhoneNumberError = false;
      this.updatedPhoneNumberPending = false;
      this.updatedPhoneNumberDone = false;
      this.deletePhoneNumberError = false;
      this.deletePhoneNumberPending = false;
      this.deletePhoneNumberDone = false;
    },
    open: function open() {
      this.init();
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    },
    edit: function edit() {
      this.editMode = true;
    },
    view: function view() {
      this.editMode = false;
    },
    submitFormAddPhoneNumber: function submitFormAddPhoneNumber() {
      this.newPhoneNumberError = false;
      this.postPhoneNumber(this.newPhoneNumber, this.client.id);
    },
    submitFormUpdatePhoneNumber: function submitFormUpdatePhoneNumber() {
      this.updatedPhoneNumberError = false;
      this.putPhoneNumber(this.updatedPhoneNumber);
    },
    setEditingPhoneNumber: function setEditingPhoneNumber(phoneNumber) {
      if (this.editingId === false) {
        this.updatedPhoneNumber = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(phoneNumber));
        this.editingId = phoneNumber.id;
      } else {
        this.updatedPhoneNumber = {};
        this.editingId = false;
      }
    }
  },
  watch: {
    isOpen: function isOpen(val) {
      if (val === true) {} else {}
    },
    newPhoneNumberDone: function newPhoneNumberDone(val) {
      this.newPhoneNumber = { default: true };
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.newPhoneNumberDone = false;
      }
    },
    deletePhoneNumberDone: function deletePhoneNumberDone(val) {
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.deletePhoneNumberDone = false;
      }
    },
    updatedPhoneNumberDone: function updatedPhoneNumberDone(val) {
      if (val === true) {
        this.editingId = false;
        this.updatedPhoneNumber = {};
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.updatedPhoneNumberDone = false;
      }
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-phone"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.phone_number.length > 0) ? _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.client.default_phone_number.length === 9) ? _c('span', [_vm._v(_vm._s(_vm.client.default_phone_number.substring(0, 3)) + " " + _vm._s(_vm.client.default_phone_number.substring(3, 6)) + " " + _vm._s(_vm.client.default_phone_number.substring(6, 9)))]) : (_vm.client.default_phone_number.length === 13) ? _c('span', [_vm._v(_vm._s(_vm.client.default_phone_number.substring(0, 4)) + " " + _vm._s(_vm.client.default_phone_number.substring(4, 7)) + " " + _vm._s(_vm.client.default_phone_number.substring(7, 10)) + " " + _vm._s(_vm.client.default_phone_number.substring(10, 13)))]) : _c('span', [_vm._v(_vm._s(_vm.client.default_phone_number))])]) : _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-phone-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chybí telefonní číslo")])])]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Telefonní čísla klienta")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), (_vm.client.phone_number.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-7"
  }, [_vm._v("telefonní číslo")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("výchozí")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.client.phone_number), function(ea) {
    return [_c('tr', {
      staticClass: "row m-0 text-left",
      class: ea.default ? 'font-weight-bold' : '',
      attrs: {
        "data-testid": "client-phone-row"
      }
    }, [(_vm.editingId !== ea.id) ? _c('td', {
      staticClass: "col-sm-7"
    }, [_vm._v(_vm._s(ea.number))]) : _vm._e(), _vm._v(" "), (_vm.editingId !== ea.id) ? _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(_vm._f("boolToCS")(ea.default)))]) : _c('td', {
      staticClass: "col-sm-10"
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.submitFormUpdatePhoneNumber($event)
        }
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedPhoneNumber.number),
        expression: "updatedPhoneNumber.number"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "telefonní číslo",
        "data-testid": "client-phone-edit-input",
        "id": "phoneNumber"
      },
      domProps: {
        "value": (_vm.updatedPhoneNumber.number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedPhoneNumber.number = $event.target.value
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                                                  Výchozí: \n                                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedPhoneNumber.default),
        expression: "updatedPhoneNumber.default"
      }],
      attrs: {
        "type": "checkbox",
        "data-testid": "client-phone-edit-default"
      },
      domProps: {
        "checked": Array.isArray(_vm.updatedPhoneNumber.default) ? _vm._i(_vm.updatedPhoneNumber.default, null) > -1 : (_vm.updatedPhoneNumber.default)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.updatedPhoneNumber.default,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.updatedPhoneNumber.default = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.updatedPhoneNumber.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.updatedPhoneNumber.default = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedPhoneNumber.note),
        expression: "updatedPhoneNumber.note"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "data-testid": "client-phone-edit-note",
        "id": "phoneNumberNote",
        "placeholder": "poznámka"
      },
      domProps: {
        "value": (_vm.updatedPhoneNumber.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedPhoneNumber.note = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.updatedPhoneNumberPending === false) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "data-testid": "client-phone-edit-save",
        "type": "submit"
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.updatedPhoneNumberError.number) ? _c('small', {
      staticClass: "form-text text-danger text-left",
      attrs: {
        "id": "numberError"
      }
    }, [_vm._v(_vm._s(_vm.updatedPhoneNumberError.number.message))]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "text-right col-sm-2"
    }, [(_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": "client-phone-delete"
      },
      on: {
        "click": function($event) {
          _vm.deletePhoneNumber(ea.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (_vm.editingId === ea.id) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": "client-phone-edit-cancel"
      },
      on: {
        "click": function($event) {
          _vm.setEditingPhoneNumber(ea)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : (_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": "client-phone-edit"
      },
      on: {
        "click": function($event) {
          _vm.setEditingPhoneNumber(ea)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), (ea.note !== null && ea.note !== '' && _vm.editingId !== ea.id) ? _c('tr', {
      staticClass: "row m-0 "
    }, [_c('td', {
      staticClass: "col-sm-12 text-left border-top-0 pt-0 font-italic"
    }, [_vm._v("Poznámka: " + _vm._s(ea.note))])]) : _vm._e()]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editingId === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitFormAddPhoneNumber($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPhoneNumber.number),
      expression: "newPhoneNumber.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "telefonní číslo",
      "data-testid": "client-phone-input",
      "id": "phoneNumber"
    },
    domProps: {
      "value": (_vm.newPhoneNumber.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPhoneNumber.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                      Výchozí: \n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPhoneNumber.default),
      expression: "newPhoneNumber.default"
    }],
    attrs: {
      "type": "checkbox",
      "data-testid": "client-phone-default"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPhoneNumber.default) ? _vm._i(_vm.newPhoneNumber.default, null) > -1 : (_vm.newPhoneNumber.default)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.newPhoneNumber.default,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPhoneNumber.default = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.newPhoneNumber.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newPhoneNumber.default = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPhoneNumber.note),
      expression: "newPhoneNumber.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-phone-note",
      "id": "phoneNumberNote",
      "placeholder": "poznámka"
    },
    domProps: {
      "value": (_vm.newPhoneNumber.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPhoneNumber.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newPhoneNumberPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "client-phone-add",
      "type": "submit"
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.newPhoneNumberError.number) ? _c('small', {
    staticClass: "form-text text-danger text-left",
    attrs: {
      "id": "numberError"
    }
  }, [_vm._v(_vm._s(_vm.newPhoneNumberError.number.message))]) : _vm._e()])])]) : _vm._e()])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientDetail_vue__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ed78ce_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientDetail_vue__ = __webpack_require__(345);
function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72ed78ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ed78ce_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientDetail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      editMode: false,
      parsePinMessage: '',
      clientDone: false,
      clientForChange: false,
      clientForm: {
        p_i_n: false
      },
      isOpen: false,
      citizenshipPending: true,
      citizenshipError: true,
      insurance: {
        insurance_company: null
      },
      insurancePending: false,
      clientError: false,
      clientPending: false,
      birthDateCalculated: false,
      decodePinPending: false,
      decodePinWarning: false,
      decodePinError: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  props: ['client', 'clientHeader'],
  methods: {
    open: function open() {
      this.isOpen = true;
      this.editMode = false;
    },
    close: function close() {
      this.isOpen = false;
    },
    submitForm: function submitForm() {
      this.clientForUpdate = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.clientForm, this.replacer));
      delete this.clientForUpdate['email_address'];
      delete this.clientForUpdate['phone_number'];
      delete this.clientForUpdate['client_auth'];
      delete this.clientForUpdate['address'];
      delete this.clientForUpdate['gdpr_consent'];
      this.clientForUpdate.citizenship = this.clientForm.citizenship.id;
      this.putClient(this.clientForUpdate);
    },
    edit: function edit() {
      this.clientForm = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.client));
      this.clientForm.health_insurance = null;
      this.clientForm.membership = null;
      this.clientForm.address = null;
      this.editMode = true;
    },
    view: function view() {
      this.editMode = false;
    }
  },
  watch: {
    isOpen: function isOpen(val) {
      if (val === true) {
        this.getCitizenship();
        this.decodePinPending = false;
        this.clientError = false;
      } else {
        this.citizenshipPending = true;
      }
    },

    'clientForm.p_i_n': function clientFormP_i_n(val) {
      var _this = this;

      if (val) {
        this.clientForm.p_i_n = val.replace(/\D/g, '');

        if (val !== this.clientForm.p_i_n) {
          return;
        }

        if (this.clientForm.citizenship.id === 1) {
          if (val.length < 9) {
            this.parsePinMessage = 'příliš krátké';
            this.clientForm.gender = 'unknown';
            this.clientForm.birth_date = '';
          } else if (val.length > 10) {
            this.parsePinMessage = 'příliš dlouhé';
            this.clientForm.gender = 'unknown';
            this.clientForm.birth_date = '';
          } else {
            this.parsePinMessage = '<i class="fa fa-spinner fa-pulse fa-fw"></i>' + 'načítám';
            setTimeout(function () {
              _this.decodePIN(_this.clientForm.p_i_n);
            }, 500);
          }
        } else {
          this.birthDateCalculated = false;
        }
      }
    },
    'clientForm.insurance_number': function clientFormInsurance_number(val) {
      if (val) {
        this.clientForm.insurance_number = val.replace(/\D/g, '');
      }
    },
    'clientForm.citizenship.id': function clientFormCitizenshipId(val) {
      var _this2 = this;

      if (val !== 1) {
        this.birthDateCalculated = false;
      } else {
        if (this.clientForm.p_i_n) {
          if (this.clientForm.p_i_n.length < 9) {
            this.parsePinMessage = 'příliš krátké';
            this.clientForm.gender = 'unknown';
            this.clientForm.birth_date = '';
          } else if (this.clientForm.p_i_n.length > 10) {
            this.parsePinMessage = 'příliš dlouhé';
            this.clientForm.gender = 'unknown';
            this.clientForm.birth_date = '';
          } else {
            this.parsePinMessage = '<i class="fa fa-spinner fa-pulse fa-fw"></i>' + 'načítám';
            setTimeout(function () {
              _this2.decodePIN(_this2.clientForm.p_i_n);
            }, 500);
          }
        }
      }
    },
    clientDone: function clientDone(val) {
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.clientDone = false;
        this.close();
      }
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-detail"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.gender === 'male') ? _c('i', {
    staticClass: "fa fa-lg fa-mars icon-male",
    attrs: {
      "aria-hidden": "true",
      "title": "muž"
    }
  }) : (_vm.client.gender === 'female') ? _c('i', {
    staticClass: "fa fa-lg fa-venus icon-female",
    attrs: {
      "aria-hidden": "true",
      "title": "žena"
    }
  }) : _c('i', {
    staticClass: "fa fa-lg fa-genderless icon-genderless",
    attrs: {
      "aria-hidden": "true",
      "title": "neznámé pohlaví"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.client.full_name))])]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), (_vm.client.insurance_number !== null) ? _c('span', [_vm._v("ČP: "), _c('b', [_vm._v(_vm._s(_vm.client.insurance_number))])]) : (_vm.client.p_i_n !== false) ? _c('span', [_vm._v("RČ: "), _c('b', [_vm._v(_vm._s(_vm.client.p_i_n))])]) : _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chybí RČ / ČP")]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.client.age_with_suffix) + " (" + _vm._s(_vm.client.birth_date) + ")")]), _vm._v(" "), (_vm.client.employer) ? [_c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.client.employer))])] : _vm._e()], 2)]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(!_vm.citizenshipPending) ? _c('div', {
    staticClass: "container tooltip_container tooltip_2_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }, [(_vm.editMode === false) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-detail-edit"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" upravit")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-detail-back"
    },
    on: {
      "click": _vm.view
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" zpět")])]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Úprava klienta")]) : _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Detail klienta")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 tooltip_body text-left"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "titlesPreName"
    }
  }, [_vm._v("Tituly před jménem:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.title_before),
      expression: "clientForm.title_before"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-title-before",
      "aria-describedby": "titlesPreNameHelp",
      "id": "titlesPreName"
    },
    domProps: {
      "value": (_vm.clientForm.title_before)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.title_before = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "titlesPreNameError"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Jméno:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.first_name),
      expression: "clientForm.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-first-name",
      "aria-describedby": "firstnameHelp",
      "id": "firstname"
    },
    domProps: {
      "value": (_vm.clientForm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.first_name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.firstname) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "firstnameError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.firstname.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Příjmení:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.last_name),
      expression: "clientForm.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-last-name",
      "aria-describedby": "lastnameHelp",
      "id": "lastname"
    },
    domProps: {
      "value": (_vm.clientForm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.last_name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.lastname) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "lastnameError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.lastname.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "titlesAfterName"
    }
  }, [_vm._v("Tituly za jménem:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.title_after),
      expression: "clientForm.title_after"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-title-after",
      "aria-describedby": "titlesAfterNameHelp",
      "id": "titlesAfterName"
    },
    domProps: {
      "value": (_vm.clientForm.title_after)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.title_after = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "titlesAfterNameError"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "citizenshipGov"
    }
  }, [_vm._v("Státní příslušnost (občanství):")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.citizenship.id),
      expression: "clientForm.citizenship.id"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-detail-citizenship",
      "aria-describedby": "citizenshipGovHelp",
      "id": "citizenshipGov"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.clientForm.citizenship.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.citizenship), function(c) {
    return _c('option', {
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name_cz) + " - " + _vm._s(c.code) + " - " + _vm._s(c.name_en))])
  })), _vm._v(" "), (_vm.clientError.citizenship) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "citizenshipError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.citizenship.message))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "personalid"
    }
  }, [_vm._v("Rodné číslo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.p_i_n),
      expression: "clientForm.p_i_n"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-pin",
      "aria-describedby": "personalidHelp",
      "id": "personalid"
    },
    domProps: {
      "value": (_vm.clientForm.p_i_n)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.p_i_n = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.pin) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "personalidError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.pin.message) + " " + _vm._s(_vm.parsePinMessage))]) : _vm._e(), _vm._v(" "), (_vm.decodePinWarning !== null) ? _vm._l((_vm.decodePinWarning), function(warning, index) {
    return _c('div', [(index === 'duplicate' && warning.clients.length > 1) ? [_c('small', {
      staticClass: "form-text text-danger"
    }, [_vm._v(_vm._s(warning.text))]), _vm._v(" "), _vm._l((warning.clients), function(client) {
      return _c('small', {
        staticClass: "form-text text-danger"
      }, [_vm._v(" - " + _vm._s(client.full_name))])
    })] : (index !== 'duplicate') ? [_c('small', {
      staticClass: "form-text text-danger"
    }, [_vm._v(_vm._s(warning.text))])] : _vm._e()], 2)
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "insuranceNumber"
    }
  }, [_vm._v("Číslo pojištěnce:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.insurance_number),
      expression: "clientForm.insurance_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-insurance-number",
      "aria-describedby": "insuranceNumberHelp",
      "id": "insuranceNumber"
    },
    domProps: {
      "value": (_vm.clientForm.insurance_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.insurance_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.insurancenumber) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "insuranceNumberError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.insurancenumber.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Pohlaví:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.gender),
      expression: "clientForm.gender"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-detail-gender",
      "aria-describedby": "genderHelp",
      "id": "gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.clientForm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("muž")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("žena")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("nezjištěno")])]), _vm._v(" "), (_vm.clientError.gender) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "genderError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.gender.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "birthdate"
    }
  }, [_vm._v("Datum narození:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.birth_date),
      expression: "clientForm.birth_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-birth-date",
      "aria-describedby": "birthdateHelp",
      "id": "birthdate"
    },
    domProps: {
      "value": (_vm.clientForm.birth_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.birth_date = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.birthdate) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "birthdateError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.birthdate.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "employer"
    }
  }, [_vm._v("Zaměstnavatel/firma:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForm.employer),
      expression: "clientForm.employer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-detail-employer",
      "aria-describedby": "firstnameHelp",
      "id": "employer"
    },
    domProps: {
      "value": (_vm.clientForm.employer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientForm.employer = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.employer) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "employerError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.employer.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.decodePinPending) ? _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Čekám")]) : (_vm.clientPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "client-detail-save"
    }
  }, [_vm._v("Uložit změny")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])])]) : _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table_labeled table-bordered",
    attrs: {
      "data-testid": "client-detail-table"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "w-25"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("tituly před jménem")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.title_before)))]), _vm._v(" "), _c('td', {
    staticClass: "w-25"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("jméno")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.first_name)))]), _vm._v(" "), _c('td', {
    staticClass: "w-25"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("příjmení")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.last_name)))]), _vm._v(" "), _c('td', {
    staticClass: "w-25"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("tituly za jménem")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.title_after)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("státní příslušnost (občanství)")]), _vm._v(_vm._s(_vm.client.citizenship ? _vm.client.citizenship.name_cz : '-'))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("rodné číslo")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.p_i_n)))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("číslo pojištěnce")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.insurance_number)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("pohlaví")]), _vm._v(_vm._s(_vm._f("genderToCS")(_vm.client.gender)))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("datum narození")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.birth_date)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("zaměstnavatel/firma:")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.employer)))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  })])])])])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAuth_vue__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b1e036_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientAuth_vue__ = __webpack_require__(349);
function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53b1e036"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAuth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b1e036_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientAuth_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isOpen: false,
      changePass: false,
      clientAuthCreateError: false,
      clientAuthCreatePending: false,
      clientAuthCreateDone: false,
      isVerified: false,
      clientAuthCreateForm: {
        plain_password: '',
        help: ''
      },
      clientAuthVerifyError: false,
      clientAuthVerifyPending: false,
      clientAuthVerifyDone: false,
      clientAuthVerify: {
        plain_password: ''
      }
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: ['client', 'clientHeader'],
  methods: {
    open: function open() {
      this.isOpen = true;
      this.changePass = false;
    },
    close: function close() {
      this.isOpen = false;
    },
    createUpdateClientAuth: function createUpdateClientAuth() {
      if (this.changePass === true) {
        this.updateClientAuth();
      } else {
        this.createClientAuth();
      }
    },
    createClientAuth: function createClientAuth() {
      var _this = this;

      this.clientAuthCreatePending = true;
      this.$http.post('client/' + this.client.id + '/password', this.clientAuthCreateForm, { emulateJSON: true }).then(function (response) {
        _this.clientAuthCreatePending = false;
        _this.clientAuthCreateDone = true;
      }).catch(function (error) {
        _this.clientAuthCreateError = error.response.data.errors;
        console.log(_this.clientAuthCreateError);
        _this.clientAuthCreatePending = false;
      });
    },
    updateClientAuth: function updateClientAuth() {
      var _this2 = this;

      this.clientAuthCreatePending = true;
      this.$http.put('client/' + this.client.id + '/password', this.clientAuthCreateForm, { emulateJSON: true }).then(function (response) {
        _this2.clientAuthCreatePending = false;
        _this2.clientAuthCreateDone = true;
      }).catch(function (error) {
        _this2.clientAuthCreateError = error.response.data.errors;
        console.log(_this2.clientAuthCreateError);
        _this2.clientAuthCreatePending = false;
      });
    },
    verifyClientAuth: function verifyClientAuth() {
      var _this3 = this;

      this.clientAuthVerifyPending = true;
      this.$http.post('client/' + this.client.id + '/verify', this.clientAuthVerify, { emulateJSON: true }).then(function (response) {
        _this3.clientAuthVerifyPending = false;
        _this3.clientAuthVerifyDone = true;
      }).catch(function (error) {
        _this3.clientAuthVerifyError = error.response.data.error;
        _this3.clientAuthVerifyPending = false;
      });
    },
    edit: function edit() {
      this.changePass = !this.changePass;
    },
    view: function view() {
      this.editMode = false;
    }
  },
  watch: {
    isOpen: function isOpen(val) {
      if (val === true) {
        this.clientAuthVerifyError = false;
        this.clientAuthVerifyDone = false;
        this.clientAuthCreateForm = {
          plain_password: '',
          help: ''
        };
        this.clientAuthVerify = {
          plain_password: ''
        };
      } else {}
    },
    clientAuthCreateDone: function clientAuthCreateDone(val) {
      if (val === true) {
        this.$emit('reload-client', true);
        this.$emit('reload-client', false);
        this.clientAuthCreateDone = false;
        this.changePass = false;
        this.close();
      }
    },
    clientAuthVerifyDone: function clientAuthVerifyDone(val) {
      if (val === true) {
        this.clientAuthVerify = {
          plain_password: ''
        };
        this.close();
      }
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true,
      "placement": "left"
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('div', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-auth"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.has_pin === false) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Vytvořit PIN klienta'),
      expression: "'Vytvořit PIN klienta'"
    }],
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "data-testid": "client-auth-none"
    }
  }, [_vm._v("nemá PIN")]) : [(_vm.clientAuthVerifyDone === true) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Klient ověřen'),
      expression: "'Klient ověřen'"
    }],
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "data-testid": "client-auth-verified"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" ověřen")]) : _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Ověřit klienta'),
      expression: "'Ověřit klienta'"
    }],
    staticClass: "btn btn-sm btn-outline-success",
    attrs: {
      "data-testid": "client-auth-verify"
    }
  }, [_vm._v("ověřit")])]], 2), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container tooltip_container tooltip_1_col p-0"
  }, [(_vm.client.has_pin === false || _vm.changePass === true) ? [_c('div', {
    staticClass: "row tooltip_header m-0"
  }, [(_vm.changePass === false) ? [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("Vytvořit PIN klienta")])] : [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Zrušit změnu'),
      expression: "'Zrušit změnu'"
    }],
    staticClass: "btn btn-sm btn-outline-success",
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_vm._v("Změnit PIN klienta")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  })]], 2), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createUpdateClientAuth($event)
      }
    }
  }, [_c('div', {
    staticClass: "row tooltip_body m-0"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "clientAuthPass"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "personalid"
    }
  }, [_vm._v("PIN:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientAuthCreateForm.plain_password),
      expression: "clientAuthCreateForm.plain_password"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "aria-describedby": "clientAuthPassHelp",
      "id": "clientAuthPass",
      "name": "clientAuthPass",
      "data-testid": "client-auth-pin-input"
    },
    domProps: {
      "value": (_vm.clientAuthCreateForm.plain_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientAuthCreateForm.plain_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.clientAuthCreateError.plainpassword ? _vm.clientAuthCreateError.plainpassword.message : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "personalid"
    }
  }, [_vm._v("Nápověda k PINu:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientAuthCreateForm.help),
      expression: "clientAuthCreateForm.help"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "aria-describedby": "personalidHelp",
      "id": "personalid",
      "data-testid": "client-auth-help-input"
    },
    domProps: {
      "value": (_vm.clientAuthCreateForm.help)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientAuthCreateForm.help = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.clientAuthCreateError.help ? _vm.clientAuthCreateError.help.message : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 text-center"
  }, [(_vm.changePass === false) ? [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "client-auth-save"
    }
  }, [_vm._v("Uložit PIN")])] : [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "client-auth-save"
    }
  }, [_vm._v("Změnit PIN")])]], 2)])])] : [_c('div', {
    staticClass: "row tooltip_header m-0"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Změnit PIN'),
      expression: "'Změnit PIN'"
    }],
    staticClass: "btn btn-sm btn-outline-success",
    attrs: {
      "data-testid": "client-auth-change"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_vm._v("Ověřit PIN klienta")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  })]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.verifyClientAuth($event)
      }
    }
  }, [_c('div', {
    staticClass: "row tooltip_body m-0"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "personalid"
    }
  }, [_vm._v("PIN:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientAuthVerify.plain_password),
      expression: "clientAuthVerify.plain_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "aria-describedby": "personalidHelp",
      "id": "personalid",
      "data-testid": "client-auth-verify-input"
    },
    domProps: {
      "value": (_vm.clientAuthVerify.plain_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientAuthVerify.plain_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "data-testid": "client-auth-verify-error"
    }
  }, [_vm._v(_vm._s(_vm.clientAuthVerifyError ? _vm.clientAuthVerifyError : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('small', [_vm._v("Nápověda: ")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-testid": "client-auth-help"
    }
  }, [_vm._v(_vm._s(_vm.client.client_auth.help))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12 text-center"
  }, [
    [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "data-testid": "client-auth-verify-submit"
      }
    }, [_vm._v("Ověřit PIN")])]
  ], 2)])])]], 2)])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientLog_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05f38b67_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientLog_vue__ = __webpack_require__(353);
function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05f38b67"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05f38b67_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientLog_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      modalOpened: false,
      logClient: false,
      logClientPending: true,
      logClientError: false
    };
  },

  props: ['opened', 'clientId'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    onHidden: function onHidden() {},
    onOpen: function onOpen() {
      this.init();
      this.getLogClient(this.clientId);
    },
    getLogClient: function getLogClient(clientId) {
      var _this = this;

      this.logClientPending = true;
      this.$http.get('log_client/' + clientId).then(function (response) {
        _this.logClient = response.data;
        _this.logClientPending = false;
      }, function (response) {
        _this.logClientError = response.body.error;
        _this.logClientPending = false;
      });
    },
    init: function init() {
      this.logClient = false;
      this.logClientPending = false;
      this.logClientError = false;
    }
  },
  watch: {
    opened: function opened(val) {
      if (val === true) {}
    },
    visitDone: function visitDone(val) {
      if (val === true) {
        this.$emit('close');

        this.$modal.hide('client-visit-now-add');
      }
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {}
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "90%",
      "scrollable": true,
      "name": "client-log",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "opened": _vm.onOpen,
      "closed": _vm.onHidden
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "client-log-modal"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Historie úprav klienta\n    ")]), _vm._v(" "), (_vm.logClient.length > 0 && _vm.logClientPending !== true) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("verze")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("akce")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("změna")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("provedl")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("datum a čas")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.logClient), function(log) {
    return _c('tr', {
      attrs: {
        "data-testid": "client-log-row"
      }
    }, [_c('td', [_vm._v(_vm._s(log.version))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.action))]), _vm._v(" "), _c('td', [_vm._l((log.data), function(value, key) {
      return [_c('span', [_c('i', [_vm._v(_vm._s(key))]), _vm._v(": "), _c('b', [_vm._v(_vm._s(value))])]), _c('br')]
    })], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.logged_at))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.logClient.length < 1 && _vm.logClientPending !== true) ? _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "client-log-empty"
    }
  }, [_vm._v("\n        klient bez historie\n    ")]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "custom_header"
  }, [(_vm.impersonating) ? _c('div', {
    staticClass: "impersonation-banner",
    attrs: {
      "data-testid": "impersonation-banner"
    }
  }, [_c('strong', [_vm._v("Impersonace:")]), _vm._v("\n        " + _vm._s(_vm.originalFullname) + " pracuje jako " + _vm._s(_vm.userFullname) + ".\n        "), _c('button', {
    staticClass: "btn btn-sm btn-light ml-2",
    attrs: {
      "type": "button",
      "data-testid": "stop-impersonation",
      "disabled": _vm.stoppingImpersonation
    },
    on: {
      "click": _vm.stopImpersonation
    }
  }, [_vm._v("Vrátit se k původnímu uživateli")]), _vm._v(" "), (_vm.impersonationError) ? _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.impersonationError))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userFullname) ? _c('div', {
    staticClass: "app-header navbar justify-content-between"
  }, [_c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "#"
    }
  }, [_vm._v("clinico")]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'Home') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-home fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'Result') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Result'
      },
      "data-testid": "nav-lab-results"
    }
  }, [_c('i', {
    staticClass: "fa fa-flask fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-flask fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'Calendar') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Calendar'
      },
      "data-testid": "nav-calendar"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-calendar fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientRegistration') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'ClientRegistration'
      },
      "data-testid": "nav-register-client"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-user-plus fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1), _vm._v(" "), (_vm.hasRole('manager')) ? _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ContractualReporting') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'ContractualReporting'
      },
      "data-testid": "nav-contractual-reporting"
    }
  }, [_c('i', {
    staticClass: "fa fa-coins fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-coins fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasRole('analyst')) ? _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'Statistic') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Statistic'
      },
      "data-testid": "nav-statistics"
    }
  }, [_c('i', {
    staticClass: "fa fa-chart-line fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-chart-line fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "reset-after": true,
      "id": "search",
      "data-testid": "client-search",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat klienta",
      "open-direction": "bottom",
      "options": _vm.clients,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "clear-on-select": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getResult,
      "select": _vm.openClient
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc",
          attrs: {
            "data-testid": "client-search-option"
          }
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6",
          attrs: {
            "data-testid": "client-search-option-name"
          }
        }, [_vm._v(_vm._s(props.option.full_name_reversed))]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-6 text-right",
          attrs: {
            "data-testid": "client-search-option-pin"
          }
        }, [_vm._v(_vm._s(props.option.pin_in_bd))])]), _vm._v(" "), _c('div', {
          staticClass: "row m-0 font-sm"
        }, [_c('div', {
          staticClass: "col-sm-12"
        }, [_c('span', [_vm._v(_vm._s(props.option.default_email_address))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.option.default_phone_number))])])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('span', {}, [_c('span', {
    attrs: {
      "data-testid": "medic-name"
    }
  }, [_vm._v(_vm._s(_vm.userFullname))]), _c('i', {
    staticClass: "navbar-toggler fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.authLock
    }
  }), _c('i', {
    staticClass: "navbar-toggler fa fa-sign-out",
    attrs: {
      "data-testid": "logout",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.authLogout
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated && _vm.client) ? _c('div', {
    staticClass: "app-header navbar second_row",
    attrs: {
      "data-testid": "client-banner"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between w-100 align-items-center"
  }, [_c('div', {}, [_c('client-detail', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('client-insurance', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('client-membership', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('client-address', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('client-email-address', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('client-phone-number', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('client-gdpr-consent', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('router-link', {
    staticClass: "text-secondary",
    attrs: {
      "to": {
        name: 'ShowClient',
        params: {
          clientid: _vm.client.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "text-secondary",
    attrs: {
      "data-testid": "client-banner-log"
    },
    on: {
      "click": _vm.showModalClientLog
    }
  }, [_c('i', {
    staticClass: "fa fa-history",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "text-secondary",
    attrs: {
      "target": "_blank",
      "href": _vm.setting.hostname + 'client/' + _vm.client.id + '/label/pdf'
    }
  }, [_c('i', {
    staticClass: "fa fa-tag",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('client-p-s-a', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), (_vm.editingClientNote === true) ? [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveClient()
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.note),
      expression: "client.note"
    }],
    staticClass: "form-control ml-sm-1 mr-sm-2 col-sm-4",
    attrs: {
      "type": "text",
      "aria-describedby": "noteHelp",
      "id": "note",
      "data-testid": "client-banner-note-input"
    },
    domProps: {
      "value": (_vm.client.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.note = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "client-banner-note-save"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])] : [_c('button', {
    staticClass: "btn btn-sm btn-link text-secondary",
    attrs: {
      "data-testid": "client-banner-note-edit"
    },
    on: {
      "click": _vm.editNote
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.client.note) ? _c('i', [_vm._v("Poznámka: ")]) : _vm._e(), _c('span', {
    attrs: {
      "data-testid": "client-banner-note"
    }
  }, [_vm._v(_vm._s(_vm.client.note))])]], 2), _vm._v(" "), _c('div', {}, [_c('client-auth', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('client-log', {
    attrs: {
      "opened": _vm.modalClientLogOpened,
      "clientId": _vm.client.id
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f83167f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(367);
function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f83167f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarNavDropdown__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavLink__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavTitle__ = __webpack_require__(364);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_0__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_1__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_2__SidebarNavTitle__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376b9485_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(360);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376b9485_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": _vm.url,
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.name))]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fa271ee_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(363);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fa271ee_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      default: ''
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": _vm.url
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.name) + "\n  "), _c('b-badge', {
    attrs: {
      "variant": _vm.badge.variant
    }
  }, [_vm._v(_vm._s(_vm.badge.text))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce604fd8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(366);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce604fd8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n  " + _vm._s(_vm.name) + "\n")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('div', {
    slot: "header"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [(item.title) ? [_c('SidebarNavTitle', {
      attrs: {
        "name": item.name
      }
    })] : (item.divider) ? [_c('li', {
      staticClass: "divider"
    })] : [(item.children) ? [_c('SidebarNavDropdown', {
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon
      }
    }, [_vm._l((item.children), function(child, index) {
      return [(child.children) ? [_c('SidebarNavDropdown', {
        attrs: {
          "name": child.name,
          "url": child.url,
          "icon": child.icon
        }
      }, _vm._l((item.children), function(child, index) {
        return _c('li', {
          staticClass: "nav-item"
        }, [_c('SidebarNavLink', {
          attrs: {
            "name": child.name,
            "url": child.url,
            "icon": child.icon,
            "badge": child.badge
          }
        })], 1)
      }))] : [_c('li', {
        staticClass: "nav-item"
      }, [_c('SidebarNavLink', {
        attrs: {
          "name": child.name,
          "url": child.url,
          "icon": child.icon,
          "badge": child.badge
        }
      })], 1)]]
    })], 2)] : [_c('SidebarNavLink', {
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon,
        "badge": item.badge
      }
    })]]], 2)
  })), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    slot: "footer"
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71afcbe1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(370);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71afcbe1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.classList
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(" "), (_vm.isOn) ? [_c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": _vm.on,
      "data-off": _vm.off
    }
  })] : [_c('span', {
    staticClass: "switch-label"
  })], _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "app",
    class: _vm.authLocked === true ? 'blured-5px' : ''
  }, [(_vm.isAuthenticated) ? _c('AppHeader', {
    attrs: {
      "list": _vm.list
    },
    on: {
      "lock": _vm.setAuthLock
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-body",
    class: _vm.impersonating ? 'impersonating-offset' : ''
  }, [_c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('AppAside')], 1), _vm._v(" "), _c('AppFooter')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login2_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a69e9cf4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login2_vue__ = __webpack_require__(374);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a69e9cf4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      user: {
        pin_0: '',
        pin_1: '',
        pin_2: '',
        pin_3: '',
        pin_4: ''
      },
      prihlasen: '',
      login: false,
      loginDone: false,
      loginError: false,
      loginPending: false,
      pinExpTime: false,
      pinExpired: false,
      remainingPINTime: null
    };
  },

  methods: {
    test: function test() {
      this.pinExpTime = true;
    },
    postLogin: function postLogin(params) {
      var _this = this;

      this.loginPending = true;
      this.$http.post('login2', params, { emulateJSON: true }).then(function (response) {
        if (response.data.error) {
          if (response.data.error.pin_exp_time) {
            _this.pinExpTime = response.data.error.pin_exp_time;
          }
        } else if (response.data.auth) {
          _this.$ls.set('fullname', response.data.auth.fullname);
          _this.$ls.set('authenticated', !!response.data.auth);
          _this.$ls.set('role', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.auth.role));
          _this.$ls.set('userid', response.data.auth.id);

          _this.loginPending = false;
          _this.loginDone = true;
        }
      }).catch(function (error) {
        if (error.response.data.error.pin_exp_time) {
          _this.pinExpTime = error.response.data.error.pin_exp_time;
        }
        _this.loginError = error.response.data.errors;
        _this.loginPending = false;
      });
    },
    submitLoginForm: function submitLoginForm() {
      var params = {
        username: this.user.username,
        password: this.user.password,
        pin: this.user.pin_0 + '' + this.user.pin_1 + '' + this.user.pin_2 + '' + this.user.pin_3 + '' + this.user.pin_4
      };
      this.postLogin(params);
    },
    deletePIN: function deletePIN(index, event) {
      if (index > 0 && event.target.value.length < 1) {
        var input = document.getElementById('inputPIN_' + (index - 1));
        input.focus();
        input.setSelectionRange(0, input.value.length);
      }
    },
    writePIN: function writePIN(index, event) {
      if (event.key === 'Tab') {
        var input = document.getElementById('inputPIN_' + (index + 1));

        input.setSelectionRange(0, input.value.length);
      } else if (event.target.value.length > 0 && (event.key >= 1 && event.key <= 9 || event.key === '0')) {
        if (index < 4) {
          var _input = document.getElementById('inputPIN_' + (index + 1));
          _input.focus();
          _input.setSelectionRange(0, _input.value.length);
        } else {
          document.getElementById('submitLogin').focus();
        }
      } else {
        event.target.value = '';
      }
    },
    selectAll: function selectAll(index) {
      var input = document.getElementById('inputPIN_' + index);
      input.setSelectionRange(0, input.value.length);
    },
    redirectIfLoggedIn: function redirectIfLoggedIn(val, oldVal, uri) {
      if (val === true) {
        this.$router.push({ name: 'Home' });
      }
    }
  },
  computed: {
    pinRemainingTime: function pinRemainingTime() {
      this.intervalid1 = setInterval(function () {
        var now = new Date().getTime();
        var pinTimeTo = this.$moment(this.pinExpTime, 'DD.MM.YYYY HH:mm:ss').toDate().getTime();
        var distance = pinTimeTo - now;
        var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
        var seconds = Math.floor(distance % (1000 * 60) / 1000);
        if (distance < 1) {
          this.pinExpired = true;
        } else {
          this.remainingPINTime = minutes + ':' + (seconds < 10 ? '0' + seconds : seconds);
        }
      }.bind(this), 1000);

      return this.remainingPINTime;
    }
  },
  watch: {
    loginDone: function loginDone(val) {
      if (val === true) {
        this.$router.push({ name: 'Home' });
      }
    },
    'user.pin_0': function userPin_0(val) {
      if (isNaN(val)) {
        this.user.pin_0 = '';
      }
    },
    'user.pin_1': function userPin_1(val) {
      if (isNaN(val)) {
        this.user.pin_1 = '';
      }
    },
    'user.pin_2': function userPin_2(val) {
      if (isNaN(val)) {
        this.user.pin_2 = '';
      }
    },
    'user.pin_3': function userPin_3(val) {
      if (isNaN(val)) {
        this.user.pin_3 = '';
      }
    },
    'user.pin_4': function userPin_4(val) {
      if (isNaN(val)) {
        this.user.pin_4 = '';
      }
    }
  },
  mounted: function mounted() {
    this.$ls.on('authenticated', this.redirectIfLoggedIn);
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Přihlášení\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitLoginForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Uživatelské jméno")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "exampleInputEmail1",
      "data-testid": "login-username",
      "placeholder": "Uživatelské jméno"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.loginError) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "usernameError"
    }
  }, [_vm._v(_vm._s(_vm.loginError.username))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputPassword1"
    }
  }, [_vm._v("Heslo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "exampleInputPassword1",
      "data-testid": "login-password",
      "placeholder": "Heslo"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.loginError) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "passwordError"
    }
  }, [_vm._v(_vm._s(_vm.loginError.password))]) : _vm._e()]), _vm._v(" "), (_vm.pinExpTime !== false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPIN_0"
    }
  }, [_vm._v("PIN")]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between m-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.pin_0),
      expression: "user.pin_0"
    }],
    staticStyle: {
      "width": "2.5rem",
      "font-size": "2rem",
      "text-align": "center"
    },
    attrs: {
      "maxlength": "1",
      "type": "text",
      "autofocus": "",
      "id": "inputPIN_0",
      "data-testid": "login-pin-0",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.pin_0)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        _vm.deletePIN(0, $event)
      }, function($event) {
        _vm.writePIN(0, $event)
      }],
      "click": function($event) {
        _vm.selectAll(0)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.pin_0 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.pin_1),
      expression: "user.pin_1"
    }],
    staticStyle: {
      "width": "2.5rem",
      "font-size": "2rem",
      "text-align": "center"
    },
    attrs: {
      "maxlength": "1",
      "type": "text",
      "id": "inputPIN_1",
      "data-testid": "login-pin-1",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.pin_1)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        _vm.deletePIN(1, $event)
      }, function($event) {
        _vm.writePIN(1, $event)
      }],
      "click": function($event) {
        _vm.selectAll(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.pin_1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.pin_2),
      expression: "user.pin_2"
    }],
    staticStyle: {
      "width": "2.5rem",
      "font-size": "2rem",
      "text-align": "center"
    },
    attrs: {
      "maxlength": "1",
      "type": "text",
      "id": "inputPIN_2",
      "data-testid": "login-pin-2",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.pin_2)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        _vm.deletePIN(2, $event)
      }, function($event) {
        _vm.writePIN(2, $event)
      }],
      "click": function($event) {
        _vm.selectAll(2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.pin_2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.pin_3),
      expression: "user.pin_3"
    }],
    staticStyle: {
      "width": "2.5rem",
      "font-size": "2rem",
      "text-align": "center"
    },
    attrs: {
      "maxlength": "1",
      "type": "text",
      "id": "inputPIN_3",
      "data-testid": "login-pin-3",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.pin_3)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        _vm.deletePIN(3, $event)
      }, function($event) {
        _vm.writePIN(3, $event)
      }],
      "click": function($event) {
        _vm.selectAll(3)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.pin_3 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.pin_4),
      expression: "user.pin_4"
    }],
    staticStyle: {
      "width": "2.5rem",
      "font-size": "2rem",
      "text-align": "center"
    },
    attrs: {
      "maxlength": "1",
      "type": "text",
      "id": "inputPIN_4",
      "data-testid": "login-pin-4",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.pin_4)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        _vm.deletePIN(4, $event)
      }, function($event) {
        _vm.writePIN(4, $event)
      }],
      "click": function($event) {
        _vm.selectAll(4)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.pin_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.loginError) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "pinError"
    }
  }, [_vm._v(_vm._s(_vm.loginError.pin))]) : _vm._e(), _vm._v(" "), (_vm.pinExpTime) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "pinError"
    }
  }, [_vm._v(_vm._s(_vm.pinRemainingTime))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "submitLogin",
      "data-testid": "login-submit"
    }
  }, [_vm._v("Přihlásit se")])])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74a64a88_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(419);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74a64a88_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomeDoctor_HomeDoctor_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HomeReceptionist_HomeReceptionist_vue__ = __webpack_require__(208);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {};
  },

  methods: {
    contains: function contains(role) {
      var roles = JSON.parse(this.$ls.get('role'));
      for (var i = 0; i < roles.length; i++) {
        if (roles[i] === role) {
          return true;
        }
      }
      return false;
    }
  },
  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$ls.get('authenticated');
    }
  },
  components: {
    HomeDoctor: __WEBPACK_IMPORTED_MODULE_0__HomeDoctor_HomeDoctor_vue__["a" /* default */],
    HomeReceptionist: __WEBPACK_IMPORTED_MODULE_1__HomeReceptionist_HomeReceptionist_vue__["a" /* default */]
  }
});

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Visits_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Tasks_vue__ = __webpack_require__(389);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    Visits: __WEBPACK_IMPORTED_MODULE_0__components_Visits_vue__["a" /* default */],
    Tasks: __WEBPACK_IMPORTED_MODULE_1__components_Tasks_vue__["a" /* default */]
  },
  methods: {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visits_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5de81a6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Visits_vue__ = __webpack_require__(388);
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5de81a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5de81a6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Visits_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VisitChangeDoctor_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VisitChangeState_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      visits_header_title: '',
      showedVisitDetail: [],
      selected_date: '',
      get_params: {
        date: ''
      },
      selectedStates: [],
      print_date: '',
      plannedFor: this.$ls.get('userid'),
      selectedBranch: '',
      doctors: [],
      doctorsPending: false,
      doctorsError: false,
      branches: [],
      branchesPending: false,
      branchesError: false,
      selectedDoctorId: null,
      showDoctorModal: false,
      selectedDate: '',
      waiting: true,
      editingVisitId: false,
      editingVisit: {},
      waitForSave: false,

      visits: false,
      visitsError: false,
      visitsPending: true,
      visitsDone: false,

      filteredVisits: false,
      remainingVisits: false,
      showRemainingVisitsToo: false,

      visitPurposes: [],
      visitPurposesPending: false,
      visitPurposeError: false,
      visitPurposesDone: false,

      selectedVisitPurposes: [],
      filteredVisitPurposesId: [1, 2, 3, 4, 5, 8, 9, 10, 15],
      address: ''
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  methods: {
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.address = addressData;
    },
    showHideRemainingVisits: function showHideRemainingVisits() {
      this.showRemainingVisitsToo = !this.showRemainingVisitsToo;
      this.visitFiltering();
    },
    visitFiltering: function visitFiltering() {
      if (this.visits !== false) {
        this.filteredVisits = [];
        this.remainingVisits = [];
        if (this.showRemainingVisitsToo === true) {
          this.filteredVisits = this.visits;
        } else {
          for (var index = 0; index < this.visits.length; ++index) {
            if (this.filteredVisitPurposesId.indexOf(this.visits[index].visit_purpose.id) > -1) {
              this.filteredVisits.push(this.visits[index]);
            } else {
              this.remainingVisits.push(this.visits[index]);
            }
          }
        }
      }
    },
    editVisit: function editVisit(note, id) {
      this.editingVisitId = id;
      this.editingVisit = {
        note: note
      };
    },
    putVisit: function putVisit() {
      var _this = this;

      this.waitForSave = true;
      this.$http.put('visit/' + this.editingVisitId, this.editingVisit, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.editingVisitId = false;
        _this.editingVisit = {};
        _this.getDoctorsDayVisits();
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    changeState: function changeState(visitId, event) {
      var _this2 = this;

      this.$http.put('visit/' + visitId + '/change_state', { state: event.target.value }, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        _this2.waitForResponse = false;
        _this2.getDoctorsDayVisits();
      }, function (response) {
        _this2.errors = response.data.errors;
        _this2.waitForResponse = false;
      });
    },
    showHideVisitDetail: function showHideVisitDetail(index) {
      if (this.showedVisitDetail.indexOf(index) === -1) {
        this.showedVisitDetail.push(index);
      } else {
        this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1);
      }
    },
    getDoctorsDayVisits: function getDoctorsDayVisits() {
      var getParams = {
        date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('DD.MM.YYYY'),
        planned_for: this.plannedFor,
        branch_id: this.selectedBranch,
        states: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedStates) };
      this.getDayVisits(getParams);
    },
    selectToday: function selectToday() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate();
    },
    selectTomorrow: function selectTomorrow() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').toDate();
    },
    setDateAndLoad: function setDateAndLoad() {
      switch (this.selected_date.startOf('day').diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('day'), 'days')) {
        case 0:
          this.print_date = 'Dnes (' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        case 1:
          this.print_date = 'Zítra (' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        case -1:
          this.print_date = 'Včera (' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        default:
          this.print_date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('dddd') + ' (' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
      }
      this.getDoctorsDayVisits();
      this.waiting = false;
    },

    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date);
    },
    showModalChangeVisitDoctor: function showModalChangeVisitDoctor(selectedDoctorId) {
      this.selectedDoctorId = selectedDoctorId;
      this.showModal('visit-change-doctor');
    },
    showModal: function showModal(name) {
      console.log('zobrazuji modal');
      this.$modal.show(name);
    },
    membershipExpiresSoon: function membershipExpiresSoon(membership) {
      if (this.$moment(membership.valid_to, 'DD.MM.YYYY').diff(this.$moment(), 'days') < 31) {
        return true;
      } else {
        return false;
      }
    },
    limitText: function limitText(count) {
      if (count > 4) {
        return 'a ' + count + ' dal\u0161\xEDch';
      } else {
        return 'a ' + count + ' dal\u0161\xED';
      }
    },
    selectVisitPurposesId: function selectVisitPurposesId() {
      this.filteredVisitPurposesId = [];
      for (var index = 0; index < this.selectedVisitPurposes.length; ++index) {
        this.filteredVisitPurposesId.push(this.selectedVisitPurposes[index].id);
      }
      this.visitFiltering();
    }
  },
  beforeMount: function beforeMount() {
    this.getDoctors();
    this.getBranches();
    this.getVisitPurposes();
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('cs');
    if (this.$ls.get('home_date')) {
      this.waiting = true;
      this.plannedFor = this.$ls.get('userid');
      this.selectedStates = JSON.parse(this.$ls.get('home_states'));
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.$ls.get('home_date'), 'DD.MM.YYYY').toDate();
    } else {
      this.selectToday();
      this.$ls.set('home_date', __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('DD.MM.YYYY'));
      this.selectedStates = ['scheduled', 'arrived', 'elaborated'];
    }
  },

  watch: {
    visitsDone: function visitsDone(val) {
      if (val === true) {
        this.visitFiltering();
        this.visitsDone = false;
      }
    },
    visitPurposesDone: function visitPurposesDone(val) {
      if (val === true) {
        for (var index = 0; index < this.visitPurposes.length; ++index) {
          if (this.filteredVisitPurposesId.indexOf(this.visitPurposes[index].id) > -1) {
            this.selectedVisitPurposes.push(this.visitPurposes[index]);
          }
        }
      }
    },

    selectedStates: function selectedStates(val) {
      this.$ls.set('home_states', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
      if (!this.waiting) {
        this.getDoctorsDayVisits();
      }
    },
    plannedFor: function plannedFor() {
      if (!this.waiting) {
        this.getDoctorsDayVisits();
      }
    },
    selectedBranch: function selectedBranch() {
      if (!this.waiting) {
        this.getDoctorsDayVisits();
      }
    },
    selectedDate: function selectedDate(val) {
      this.$ls.set('home_date', __WEBPACK_IMPORTED_MODULE_2_moment___default()(val).format('DD.MM.YYYY'));
      this.selected_date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(val);
      this.setDateAndLoad();
    }
  },
  components: {
    VisitChangeDoctor: __WEBPACK_IMPORTED_MODULE_3__components_VisitChangeDoctor_vue__["a" /* default */],
    VisitChangeState: __WEBPACK_IMPORTED_MODULE_4__components_VisitChangeState_vue__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a
  }
});

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setting: __webpack_require__(3),
      changePending: false,
      changeError: null,
      visit: {},
      isOpen: false
    };
  },

  props: ['doctors', 'selectedDoctorId', 'visitId'],
  methods: {
    changeDoctor: function changeDoctor(doctorId) {
      var _this = this;

      this.changePending = true;
      this.visit.planned_for = doctorId;
      this.$http.put('visit/' + this.visitId, this.visit, { emulateJSON: true }).then(function (response) {
        _this.submited = response.data;
        _this.changePending = false;
        _this.$emit('update');
        _this.close();
      }).catch(function (error) {
        _this.changeError = error.response.data.errors;
        _this.changePending = false;
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    }
  },
  watch: {}
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "manual",
      "autoHide": false
    }
  }, [_c('button', {
    staticClass: "tooltip-target btn btn-sm btn-link",
    attrs: {
      "data-testid": 'doctor-visit-doctor-' + _vm.visitId
    },
    on: {
      "click": _vm.open
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h3', [_vm._v("změna doktora")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.doctors), function(doctor) {
    return [(doctor.id !== _vm.selectedDoctorId) ? _c('button', {
      staticClass: "btn btn-primary m-1",
      attrs: {
        "data-testid": 'doctor-visit-doctor-option-' + _vm.visitId + '-' + doctor.id
      },
      on: {
        "click": function($event) {
          _vm.changeDoctor(doctor.id)
        }
      }
    }, [_vm._v(_vm._s(doctor.fullname))]) : _c('button', {
      staticClass: "btn btn-primary disabled m-1",
      attrs: {
        "disabled": "disabled"
      }
    }, [_vm._v(_vm._s(doctor.fullname))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger mt-3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("zavřít")])])])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setting: __webpack_require__(3),
      changePending: false,
      changeError: null,
      visit: {},
      isOpen: false,
      states: {
        scheduled: 'naplánováno',
        arrived: 'v čekárně',
        elaborated: 'rozpracovaný',
        failed: 'nepřišel (bez omluvy)',
        excused: 'nepřišel (omluvil se)',
        completed: 'dokončený',
        canceled: 'zrušený'
      }
    };
  },

  props: ['actualState', 'selectedDoctorId', 'visitId', 'testPrefix'],
  methods: {
    changeState: function changeState(newState) {
      var _this = this;

      this.changePending = true;
      this.visit.state = newState;
      this.$http.put('visit/' + this.visitId, this.visit, { emulateJSON: true }).then(function (response) {
        _this.submited = response.data;
        _this.changePending = false;
        _this.$emit('update');
        _this.close();
      }).catch(function (error) {
        _this.changeError = error.response.data.errors;
        _this.changePending = false;
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    }
  },
  watch: {}
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "manual",
      "autoHide": false
    }
  }, [_c('button', {
    staticClass: "tooltip-target btn btn-sm btn-link",
    attrs: {
      "data-testid": (_vm.testPrefix || 'doctor') + '-visit-state-' + _vm.visitId
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.actualState === 'scheduled') ? _c('i', {
    staticClass: "fa fa-2x fa-circle-o text-info",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'arrived') ? _c('i', {
    staticClass: "fa fa-2x fa-clock-o text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'completed') ? _c('i', {
    staticClass: "fa fa-2x fa-check-circle text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'elaborated') ? _c('i', {
    staticClass: "fa fa-2x fa-dot-circle-o text-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'failed') ? _c('i', {
    staticClass: "fa fa-2x fa-times-circle-o text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'excused') ? _c('i', {
    staticClass: "fa fa-2x fa-dot-circle-o text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'canceled') ? _c('i', {
    staticClass: "fa fa-2x fa-times-circle text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.states[_vm.actualState]))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.actualState !== 'completed' && _vm.actualState !== 'elaborated' && _vm.actualState !== 'canceled') ? [(_vm.actualState !== 'scheduled') ? _c('button', {
    staticClass: "btn btn-primary m-1",
    attrs: {
      "data-testid": (_vm.testPrefix || 'doctor') + '-visit-state-scheduled-' + _vm.visitId
    },
    on: {
      "click": function($event) {
        _vm.changeState('scheduled')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.scheduled))]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'arrived') ? _c('button', {
    staticClass: "btn btn-success m-1",
    attrs: {
      "data-testid": (_vm.testPrefix || 'doctor') + '-visit-state-arrived-' + _vm.visitId
    },
    on: {
      "click": function($event) {
        _vm.changeState('arrived')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.arrived))]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'failed') ? _c('button', {
    staticClass: "btn btn-danger m-1",
    on: {
      "click": function($event) {
        _vm.changeState('failed')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.failed))]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'excused') ? _c('button', {
    staticClass: "btn btn-danger m-1",
    on: {
      "click": function($event) {
        _vm.changeState('excused')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-dot-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.excused))]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'completed') ? _c('button', {
    staticClass: "btn btn-success m-1",
    on: {
      "click": function($event) {
        _vm.changeState('completed')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.completed))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.actualState === 'completed' || _vm.actualState === 'elaborated') ? [(_vm.actualState !== 'elaborated') ? _c('button', {
    staticClass: "btn btn-warning m-1",
    on: {
      "click": function($event) {
        _vm.changeState('elaborated')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-dot-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.elaborated))]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'completed') ? _c('button', {
    staticClass: "btn btn-success m-1",
    on: {
      "click": function($event) {
        _vm.changeState('completed')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.completed))]) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger mt-3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("zavřít")])])])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "doctor-visits"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Návštěvy")]), _vm._v(" " + _vm._s(_vm.print_date) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "data-testid": "doctor-visits-today"
    },
    on: {
      "click": function($event) {
        _vm.selectToday()
      }
    }
  }, [_vm._v("dnes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "doctor-visits-tomorrow"
    },
    on: {
      "click": function($event) {
        _vm.selectTomorrow()
      }
    }
  }, [_vm._v("zítra")])]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "validFrom",
      "input-class": "datapickerInput"
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": function($event) {
        _vm.getDoctorsDayVisits()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-left"
  }, [(_vm.doctors.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plannedFor),
      expression: "plannedFor"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "doctor-visits-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.plannedFor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("všichni doktoři")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-left"
  }, [(_vm.branches.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedBranch),
      expression: "selectedBranch"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "branchHelp",
      "id": "branch",
      "placeholder": "vybrat pobočku",
      "data-testid": "doctor-visits-branch"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedBranch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("obě pobočky")]), _vm._v(" "), _vm._l((_vm.branches), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.label))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-right"
  }, [(_vm.showRemainingVisitsToo) ? [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    on: {
      "click": _vm.showHideRemainingVisits
    }
  }, [_vm._v("filtrovat dle důvodu")])] : [_c('multiselect', {
    staticClass: "trolo",
    attrs: {
      "id": "medics",
      "props": "options",
      "options": _vm.visitPurposes,
      "track-by": "id",
      "label": "purpose",
      "placeholder": "důvod návštěvy",
      "multiple": true,
      "limit": 1,
      "limit-text": _vm.limitText,
      "option-height": 104,
      "open-direction": "down",
      "show-labels": false,
      "TagPlaceholder": "",
      "selectLabel": ""
    },
    on: {
      "input": _vm.selectVisitPurposesId
    },
    model: {
      value: (_vm.selectedVisitPurposes),
      callback: function($$v) {
        _vm.selectedVisitPurposes = $$v
      },
      expression: "selectedVisitPurposes"
    }
  })]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 text-left"
  }, [(_vm.selectedStates.indexOf('scheduled') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('scheduled')
      }
    }
  }, [_vm._v("plánovaní")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('scheduled'), 1)
      }
    }
  }, [_vm._v("plánovaní")]), _vm._v(" "), (_vm.selectedStates.indexOf('arrived') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "arrived"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('arrived')
      }
    }
  }, [_vm._v("v čekárně")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "arrived"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('arrived'), 1)
      }
    }
  }, [_vm._v("v čekárně")]), _vm._v(" "), (_vm.selectedStates.indexOf('elaborated') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('elaborated')
      }
    }
  }, [_vm._v("rozpracovaní")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('elaborated'), 1)
      }
    }
  }, [_vm._v("rozpracovaní")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("splněno")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("splněno")]), _vm._v(" "), (_vm.selectedStates.indexOf('failed') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('failed') + _vm.selectedStates.push('excused')
      }
    }
  }, [_vm._v("nepřišel")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('failed'), 1) + _vm.selectedStates.splice(_vm.selectedStates.indexOf('excused'), 1)
      }
    }
  }, [_vm._v("nepřišel")]), _vm._v(" "), (_vm.selectedStates.indexOf('canceled') < 0) ? _c('button', {
    staticClass: "btn btn-xs btn-outline-danger",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('canceled')
      }
    }
  }, [_vm._v("zrušeno")]) : _c('button', {
    staticClass: "btn btn-xs btn-success",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('canceled'), 1)
      }
    }
  }, [_vm._v("zrušeno")])])])]), _vm._v(" "), (_vm.visits.length > 0) ? [(_vm.filteredVisits.length > 0) ? _c('div', {
    staticClass: "card-body pl-0 pr-0"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_vm._l((_vm.filteredVisits), function(visit, index) {
    return [_c('tr', {
      attrs: {
        "data-testid": 'doctor-visit-' + visit.id
      }
    }, [_c('td', {
      staticClass: "align-middle",
      style: ({
        borderLeft: (visit.visit_purpose.color !== '' ? '5px solid #' + visit.visit_purpose.color : '5px solid transparent')
      }),
      attrs: {
        "rowspan": "2"
      }
    }, [_c('visit-change-state', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id
      },
      on: {
        "update": _vm.getDoctorsDayVisits
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(visit.hasData) ? [_c('button', {
      staticClass: "btn btn-sm btn_extra_small btn-primary",
      attrs: {
        "data-testid": 'doctor-visit-detail-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.showHideVisitDetail(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'ShowVisit',
          params: {
            clientid: visit.client.id,
            visitid: visit.id
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(visit.date) + " od " + _vm._s(visit.timeFrom) + " do " + _vm._s(visit.timeTo) + " (" + _vm._s(_vm._f("minutesToCsTime")(visit.duration * 5)) + ")\n                            ")])], 2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "align-middle pr-2",
      attrs: {
        "colspan": "2"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ShowVisit',
          params: {
            clientid: visit.client.id,
            visitid: visit.id
          }
        }
      }
    }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))])]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('label', {
      attrs: {
        "for": "note"
      }
    }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.putVisit(visit)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingVisit.note),
        expression: "editingVisit.note"
      }],
      staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "noteHelp",
        "id": "note",
        "data-testid": 'doctor-visit-note-' + visit.id
      },
      domProps: {
        "value": (_vm.editingVisit.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingVisit.note = $event.target.value
        }
      }
    }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "data-testid": 'doctor-visit-save-' + visit.id
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])])] : [_c('button', {
      staticClass: "btn btn-sm btn-link text-secondary",
      attrs: {
        "data-testid": 'doctor-visit-edit-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.editVisit(visit.note, visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "no-top-border",
      attrs: {
        "colspan": "3"
      }
    }, [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: visit.client.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(visit.client.full_name))]), _vm._v(" - "), (visit.client.insurance_number) ? _c('span', [_vm._v("ČP: "), _c('b', [_vm._v(_vm._s(visit.client.insurance_number))])]) : _c('span', [_vm._v("RČ: "), _c('b', [_vm._v(_vm._s(visit.client.p_i_n))])]), _vm._v(" "), (visit.client.health_insurance && visit.client.health_insurance.code === '---') ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("SAMOPLÁTCE")]) : (visit.client.health_insurance) ? _c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v(_vm._s(visit.client.health_insurance.code))]) : _c('span', {
      staticClass: "badge badge-danger"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybí zdrav. pojišťovna")]), _vm._v(" "), (visit.client.membership) ? [(_vm.membershipExpiresSoon(visit.client.membership) && (visit.client.membership.has_next_membership === false)) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'končí již: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
          placement: 'bottom-center',
          classes: ['danger']
        }),
        expression: "{\n                                  content: 'končí již: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.paid === false ? '<br> <span class=\\'text-danger\\'>klient nezaplatil</span>' : ''),\n                                  placement: 'bottom-center',\n                                  classes: ['danger']}"
      }],
      staticClass: "badge badge-primary",
      class: [visit.client.membership.name === 'VIP' ? 'badge-danger' : (visit.client.membership.name === 'PREVENCE PLUS' ? 'badge-success' : ''), 'badge-primary']
    }, [_c('i', {
      staticClass: "fa fa-warning text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), (visit.client.membership.paid === false) ? _c('i', {
      staticClass: "fa fa-dollar text-danger"
    }) : _vm._e(), _vm._v("\n                                    " + _vm._s(visit.client.membership.name) + "\n                                  "), (visit.client.membership.name === 'VIP') ? [_c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    })] : _vm._e()], 2) : _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'platný do: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (visit.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                  content: 'platný do: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (visit.client.membership.paid === false ? '<br> <span class=\\'text-danger\\'>klient nezaplatil</span>' : ''),\n                                  placement: 'bottom-center',\n                                  classes: ['info']}"
      }],
      staticClass: "badge",
      class: [visit.client.membership.name === 'VIP' ? 'badge-danger' : (visit.client.membership.name === 'PREVENCE PLUS' ? 'badge-success' : ''), 'badge-primary']
    }, [(visit.client.membership.paid === false) ? _c('i', {
      staticClass: "fa fa-dollar text-danger"
    }) : _vm._e(), _vm._v("\n                                    " + _vm._s(visit.client.membership.name) + "\n                                  "), (visit.client.membership.name === 'VIP') ? [_c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    })] : _vm._e()], 2)] : (visit.client.last_membership) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'skončil: <b>' + visit.client.last_membership.valid_to + '</b>',
          placement: 'bottom-center',
          classes: ['secondary']
        }),
        expression: "{\n                                  content: 'skončil: <b>' + visit.client.last_membership.valid_to + '</b>',\n                                  placement: 'bottom-center',\n                                  classes: ['secondary']}"
      }],
      staticClass: "badge badge-secondary"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" poslední: " + _vm._s(visit.client.last_membership.name))]) : _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" nemá program")]), _vm._v(" "), (visit.client.missing_data) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybějící údaje")]) : _vm._e(), _vm._v(" "), (visit.client.missing_contact) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybějící kontakty")]) : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "no-top-border text-right pr-2",
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v("\n                            " + _vm._s(visit.planned_for.fullname) + "\n                            "), _c('visit-change-doctor', {
      attrs: {
        "doctors": _vm.doctors,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id
      },
      on: {
        "update": _vm.getDoctorsDayVisits
      }
    }), _vm._v(" "), (visit.planned_by && visit.planned_at) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                  content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',\n                                  placement: 'bottom-center',\n                                  classes: ['info']}"
      }],
      staticClass: "text-info fa fa-lg fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()], 1)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('tr', {
      attrs: {
        "data-testid": 'doctor-visit-details-' + visit.id
      }
    }, [_c('td', {
      staticClass: "border-top-0"
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {}, [_c('h6', [_vm._v("Výsledná zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "pr-2",
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                            " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                        ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                            ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                            ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(0, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Recepty")]), _vm._v(" "), _c('div', [(visit.prescriptions.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.prescriptions), function(p) {
      return [_vm._l((p.medicaments), function(m, index) {
        return [(p.status === 'PREPARED' || p.type === 'printed') ? _c('tr', {
          staticClass: "row m-0"
        }, [(index === 0) ? _c('td', {
          staticClass: "text-center col-md-1"
        }, [(p.type === 'printed') ? _c('span', [_c('i', {
          staticClass: "fa fa-print",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e(), _vm._v(" "), (p.type === 'electronic') ? _c('span', {
          staticClass: "font-weight-bold"
        }, [_c('span', {
          staticClass: "green"
        }, [_vm._v("E")]), _vm._v("R.\n                                                            ")]) : _vm._e()]) : _c('td', {
          staticClass: "col-md-1 empty_cell"
        }), _vm._v(" "), _c('td', {
          staticClass: "align-middle col-md-7"
        }, [_vm._v("\n                                                          " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                                                          " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                                                        ")]), _vm._v(" "), _c('td', {
          staticClass: "align-middle col-md-1"
        }, [_vm._v("\n                                                            " + _vm._s(m.amount) + "\n                                                        ")]), _vm._v(" "), _c('td', {
          staticClass: "align-middle col-md-2"
        }, [_vm._v("\n                                                            " + _vm._s(m.dosage) + "\n                                                        ")]), _vm._v(" "), (index === 0) ? _c('td', {
          staticClass: "align-middle col-md-1"
        }, [(p.patient_notification_type === 'SMS') ? _c('i', {
          staticClass: "fa fa-mobile-phone",
          attrs: {
            "aria-hidden": "true"
          }
        }) : (p.patient_notification_type === 'EMAIL') ? _c('i', {
          staticClass: "fa fa-envelope-o",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _c('i', {
          staticClass: "fa fa-ban text-danger",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _c('td', {
          staticClass: "col-md-1 empty_cell"
        })]) : _vm._e()]
      })]
    })], 2)])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])])]) : _vm._e()]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.remainingVisits.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-text"
  }, [_vm._v("... a " + _vm._s(_vm.remainingVisits.length) + " " + _vm._s(_vm.remainingVisits.length > 4 ? 'vyfiltrovaných' : 'vyfiltrovaný') + "\n                "), _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "data-testid": "doctor-visits-show-filtered"
    },
    on: {
      "click": _vm.showHideRemainingVisits
    }
  }, [_vm._v("zobrazit také")])])]) : _vm._e()] : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)])], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a34d79_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__ = __webpack_require__(397);
function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35a34d79"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a34d79_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PaginationComponent_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VisitChangeDoctor_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VisitTaskChangeState_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showedVisitDetail: [],
      visits_header_title: '',
      setting: __webpack_require__(3),
      selected_date: '',
      getParams: {
        p: 1,
        s: 'acute-planned_at+',
        f: {
          state: 'scheduled'
        },
        pp: 15
      },
      print_date: '',
      plannedFor: '',
      doctors: [],
      doctorsPending: false,
      doctorsError: false,
      selectedDoctorId: null,
      showDoctorModal: false,
      selectedDate: '',
      listData: false,
      listError: false,
      listPagination: null,
      listPending: false,
      waiting: true,
      editingVisitId: false,
      editingVisit: {},
      waitForSave: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    setPage: function setPage(number) {
      this.getParams.p = number;
      this.getDoctorsDayVisits();
    },
    showHideVisitDetail: function showHideVisitDetail(index) {
      if (this.showedVisitDetail.indexOf(index) === -1) {
        this.showedVisitDetail.push(index);
      } else {
        this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1);
      }
    },
    editVisit: function editVisit(visit, id) {
      this.editingVisitId = id;
      this.editingVisit = {
        note: visit.note,
        acute: visit.acute,
        planned_for: visit.planned_for.id
      };
    },
    putVisit: function putVisit() {
      var _this = this;

      this.waitForSave = true;
      this.$http.put('visit_task/' + this.editingVisitId, this.editingVisit, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.editingVisitId = false;
        _this.editingVisit = {};
        _this.getDoctorsDayVisits();
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    changeState: function changeState(visitId, event) {
      var _this2 = this;

      this.$http.put('visit_task/' + visitId + '/change_state', { state: event.target.value }, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        _this2.waitForResponse = false;
        _this2.getDoctorsDayVisits();
      }, function (response) {
        _this2.errors = response.data.errors;
        _this2.waitForResponse = false;
      });
    },
    getDoctorsDayVisits: function getDoctorsDayVisits() {
      this.getTasks(this.getParams);
    },
    selectToday: function selectToday() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate();
    },
    selectTomorrow: function selectTomorrow() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').toDate();
    },
    setDateAndLoad: function setDateAndLoad() {
      switch (this.selected_date.startOf('day').diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('day'), 'days')) {
        case 0:
          this.print_date = 'Dnes (' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        case 1:
          this.print_date = 'Zítra (' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        case -1:
          this.print_date = 'Včera (' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        default:
          this.print_date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('dddd') + ' (' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
      }
      this.getDoctorsDayVisits();
      this.waiting = false;
    },

    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date);
    },
    showModalChangeVisitDoctor: function showModalChangeVisitDoctor(selectedDoctorId) {
      this.selectedDoctorId = selectedDoctorId;
      this.showModal('visit-change-doctor');
    },
    showModal: function showModal(name) {
      console.log('zobrazuji modal');
      this.$modal.show(name);
    },
    membershipExpiresSoon: function membershipExpiresSoon(membership) {
      if (this.$moment(membership.valid_to, 'DD.MM.YYYY').diff(this.$moment(), 'days') < 31) {
        return true;
      } else {
        return false;
      }
    },
    selectScheduledState: function selectScheduledState() {
      this.getParams.f.state = 'scheduled';
      this.getParams.s = 'acute-planned_at+';
      this.getDoctorsDayVisits();
    },
    selectCompletedState: function selectCompletedState() {
      this.getParams.f.state = 'completed';
      this.getParams.s = 'completed_at-';
      this.getDoctorsDayVisits();
    },
    selectCanceledState: function selectCanceledState() {
      this.getParams.f.state = 'canceled';
      this.getParams.s = 'planned_at-';
      this.getDoctorsDayVisits();
    }
  },
  beforeMount: function beforeMount() {
    this.getDoctors();
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('cs');
    this.plannedFor = this.$ls.get('userid');
    if (this.$ls.get('home_date')) {
      this.waiting = true;
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.$ls.get('home_date'), 'DD.MM.YYYY').toDate();
    } else {
      this.selectToday();
      this.$ls.set('home_date', __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('DD.MM.YYYY'));
    }
  },

  watch: {
    plannedFor: function plannedFor(val) {
      if (val === null) {
        delete this.getParams.f.planned_for;
      } else {
        this.getParams.f.planned_for = val;
      }

      this.getDoctorsDayVisits();
    },
    selectedDate: function selectedDate(val) {
      this.$ls.set('home_date', __WEBPACK_IMPORTED_MODULE_2_moment___default()(val).format('DD.MM.YYYY'));
      this.selected_date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(val);
      this.setDateAndLoad();
    }
  },
  components: {
    PaginationComponent: __WEBPACK_IMPORTED_MODULE_1__components_PaginationComponent_vue__["a" /* default */],
    VisitChangeDoctor: __WEBPACK_IMPORTED_MODULE_3__components_VisitChangeDoctor_vue__["a" /* default */],
    VisitTaskChangeState: __WEBPACK_IMPORTED_MODULE_4__components_VisitTaskChangeState_vue__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: {
    listPagination: {
      type: Object,
      required: true
    }
  },
  methods: {
    setPage: function setPage(page) {
      this.$emit('set-page', page);
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.listPagination !== null) ? _c('nav', {
    attrs: {
      "aria-label": "pagination"
    }
  }, [_c('ul', {
    staticClass: "pagination justify-content-center"
  }, [(_vm.listPagination.pages < 7) ? [_vm._l((_vm.listPagination.pages), function(item) {
    return [_c('li', {
      staticClass: "page-item",
      class: item === _vm.listPagination.page ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.listPagination.page !== item ? _vm.setPage(item) : null
        }
      }
    }, [_c('a', {
      staticClass: "page-link"
    }, [_vm._v(_vm._s(item))])])]
  })] : [_c('li', {
    staticClass: "page-item",
    class: _vm.listPagination.page === 1 ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.listPagination.page !== 1 ? _vm.setPage(1) : null
      }
    }
  }, [_c('a', {
    staticClass: "page-link"
  }, [_vm._v("1")])]), _vm._v(" "), (_vm.listPagination.page > 3) ? _c('li', {
    staticClass: "page-item disabled"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.listPagination.page > 2) ? _c('li', {
    staticClass: "page-item",
    on: {
      "click": function($event) {
        _vm.setPage(_vm.listPagination.page - 1)
      }
    }
  }, [_c('a', {
    staticClass: "page-link"
  }, [_vm._v(_vm._s(_vm.listPagination.page - 1))])]) : _vm._e(), _vm._v(" "), (_vm.listPagination.page > 1 && _vm.listPagination.page < _vm.listPagination.pages) ? _c('li', {
    staticClass: "page-item active"
  }, [_c('a', {
    staticClass: "page-link"
  }, [_vm._v(_vm._s(_vm.listPagination.page))])]) : _vm._e(), _vm._v(" "), (_vm.listPagination.page < (_vm.listPagination.pages - 1)) ? _c('li', {
    staticClass: "page-item",
    on: {
      "click": function($event) {
        _vm.setPage(_vm.listPagination.page + 1)
      }
    }
  }, [_c('a', {
    staticClass: "page-link"
  }, [_vm._v(_vm._s(_vm.listPagination.page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.listPagination.page < (_vm.listPagination.pages - 2)) ? _c('li', {
    staticClass: "page-item disabled"
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: _vm.listPagination.page === _vm.listPagination.pages ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.listPagination.page !== _vm.listPagination.pages ? _vm.setPage(_vm.listPagination.pages) : null
      }
    }
  }, [_c('a', {
    staticClass: "page-link"
  }, [_vm._v(_vm._s(_vm.listPagination.pages))])])]], 2)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setting: __webpack_require__(3),
      changePending: false,
      changeError: null,
      visit: {},
      isOpen: false,
      states: {
        scheduled: 'naplánováno',
        arrived: 'v čekárně',
        elaborated: 'rozpracovaný',
        failed: 'nepřišel (bez omluvy)',
        excused: 'nepřišel (omluvil se)',
        completed: 'dokončený',
        canceled: 'zrušený'
      }
    };
  },

  props: ['actualState', 'selectedDoctorId', 'visitId', 'testPrefix'],
  methods: {
    changeState: function changeState(newState) {
      var _this = this;

      this.changePending = true;
      this.visit.state = newState;
      this.$http.put('visit_task/' + this.visitId, this.visit, { emulateJSON: true }).then(function (response) {
        _this.submited = response.data;
        _this.changePending = false;
        _this.$emit('update');
        _this.close();
      }).catch(function (error) {
        _this.changeError = error.response.data.errors;
        _this.changePending = false;
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    }
  },
  watch: {}
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "manual",
      "autoHide": false
    }
  }, [_c('button', {
    staticClass: "tooltip-target btn btn-sm btn-link",
    attrs: {
      "data-testid": (_vm.testPrefix || 'doctor-task') + '-state-' + _vm.visitId
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.actualState === 'scheduled') ? _c('i', {
    staticClass: "fa fa-2x fa-circle-o text-info",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'arrived') ? _c('i', {
    staticClass: "fa fa-2x fa-clock-o text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'completed') ? _c('i', {
    staticClass: "fa fa-2x fa-check-circle text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'elaborated') ? _c('i', {
    staticClass: "fa fa-2x fa-dot-circle-o text-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'failed') ? _c('i', {
    staticClass: "fa fa-2x fa-times-circle-o text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'excused') ? _c('i', {
    staticClass: "fa fa-2x fa-dot-circle-o text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'canceled') ? _c('i', {
    staticClass: "fa fa-2x fa-times-circle text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.states[_vm.actualState]))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [
    [(_vm.actualState !== 'completed') ? _c('button', {
      staticClass: "btn btn-success m-1",
      attrs: {
        "data-testid": (_vm.testPrefix || 'doctor-task') + '-state-completed-' + _vm.visitId
      },
      on: {
        "click": function($event) {
          _vm.changeState('completed')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-check-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" dokončit")]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'canceled') ? _c('button', {
      staticClass: "btn btn-danger m-1",
      on: {
        "click": function($event) {
          _vm.changeState('canceled')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-times-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" zrušit")]) : _vm._e()]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger mt-3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("zavřít")])])])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "doctor-tasks"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.getParams.f.state === 'scheduled') ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "data-testid": "doctor-tasks-filter-scheduled"
    }
  }, [_vm._v("nevyřízeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "doctor-tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectScheduledState()
      }
    }
  }, [_vm._v("nevyřízeno")]), _vm._v(" "), (_vm.getParams.f.state === 'completed') ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "data-testid": "doctor-tasks-filter-completed"
    }
  }, [_vm._v("splněno")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "doctor-tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectCompletedState()
      }
    }
  }, [_vm._v("splněno")]), _vm._v(" "), (_vm.getParams.f.state === 'canceled') ? _c('button', {
    staticClass: "btn btn-sm btn-success"
  }, [_vm._v("zrušeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    on: {
      "click": function($event) {
        _vm.selectCanceledState()
      }
    }
  }, [_vm._v("zrušeno")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 text-center"
  }, [(_vm.doctors.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plannedFor),
      expression: "plannedFor"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "doctor-tasks-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.plannedFor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("všichni doktoři")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": function($event) {
        _vm.getDoctorsDayVisits()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.listData.length > 0) ? _c('div', {
    staticClass: "card-body pl-0 pr-0"
  }, [_vm._l((_vm.listData), function(visit, index) {
    return [_c('div', {
      staticClass: "row ml-0 mr-0 card_row",
      attrs: {
        "data-testid": 'doctor-task-' + visit.id
      }
    }, [_c('div', {
      staticClass: "col-sm-auto pl-2 pr-0 pt-2"
    }, [_c('i', {
      staticClass: "fa fa-2x fa-exclamation text-danger text_blink",
      class: visit.acute === true ? '' : 'invisible',
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-auto pl-0 pr-0"
    }, [_c('visit-task-change-state', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id
      },
      on: {
        "update": _vm.getDoctorsDayVisits
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col pl-0 pr-0"
    }, [_c('div', {
      staticClass: "row m-0"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: visit.client.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(visit.client.first_name) + " " + _vm._s(visit.client.last_name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b>',
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                content: 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b>',\n                                placement: 'bottom-center',\n                                classes: ['info']}"
      }]
    }, [_vm._v("\n                                " + _vm._s(visit.planned_at) + "\n                            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "row m-0"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [
      [_c('button', {
        staticClass: "btn btn-sm btn_extra_small btn-primary",
        attrs: {
          "data-testid": 'doctor-task-detail-' + visit.id
        },
        on: {
          "click": function($event) {
            _vm.showHideVisitDetail(index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-info-circle",
        attrs: {
          "aria-hidden": "true"
        }
      })])], _vm._v(" "), _c('router-link', {
        attrs: {
          "to": {
            name: 'ShowVisit',
            params: {
              clientid: visit.client.id,
              visitid: visit.id
            }
          }
        }
      }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))])]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('form', {
        staticClass: "form-inline",
        on: {
          "submit": function($event) {
            $event.preventDefault();
            _vm.putVisit(visit)
          }
        }
      }, [_c('label', {
        attrs: {
          "for": "note"
        }
      }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editingVisit.note),
          expression: "editingVisit.note"
        }],
        staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
        attrs: {
          "type": "text",
          "aria-describedby": "noteHelp",
          "id": "note",
          "data-testid": 'doctor-task-note-' + visit.id
        },
        domProps: {
          "value": (_vm.editingVisit.note)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.editingVisit.note = $event.target.value
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "mr-sm-2",
        attrs: {
          "for": "doctor"
        }
      }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editingVisit.planned_for),
          expression: "editingVisit.planned_for"
        }],
        staticClass: "form-control mr-sm-2",
        attrs: {
          "aria-describedby": "doctorHelp",
          "id": "doctor",
          "placeholder": "vybrat doktora",
          "autofocus": "autofocus"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.editingVisit.planned_for = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }
        }
      }, _vm._l((_vm.doctors), function(row) {
        return _c('option', {
          domProps: {
            "value": row.id
          }
        }, [_vm._v(_vm._s(row.fullname))])
      })), _vm._v(" "), _c('label', {
        staticClass: "mr-sm-2",
        attrs: {
          "for": "acute"
        }
      }, [_vm._v("\n                                        prioritní "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editingVisit.acute),
          expression: "editingVisit.acute"
        }],
        staticClass: "form-check-input",
        attrs: {
          "type": "checkbox",
          "id": "acute"
        },
        domProps: {
          "checked": Array.isArray(_vm.editingVisit.acute) ? _vm._i(_vm.editingVisit.acute, null) > -1 : (_vm.editingVisit.acute)
        },
        on: {
          "__c": function($event) {
            var $$a = _vm.editingVisit.acute,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.editingVisit.acute = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.editingVisit.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.editingVisit.acute = $$c
            }
          }
        }
      })]), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
        staticClass: "btn btn-primary",
        attrs: {
          "type": "submit",
          "data-testid": 'doctor-task-save-' + visit.id
        }
      }, [_vm._v("Uložit")]) : _c('button', {
        staticClass: "btn btn-primary disabled",
        attrs: {
          "disabled": "disabled"
        }
      }, [_c('i', {
        staticClass: "fa fa-spinner fa-pulse fa-fw"
      }), _vm._v(" Ukládám")])])] : [_c('button', {
        staticClass: "btn btn-sm btn-link text-secondary",
        attrs: {
          "data-testid": 'doctor-task-edit-' + visit.id
        },
        on: {
          "click": function($event) {
            _vm.editVisit(visit, visit.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]
    ], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-auto pl-0 pr-0"
    }, [_c('button', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'naplánováno pro: <b>' + visit.planned_for.fullname + '</b> <br>' + 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                content: 'naplánováno pro: <b>' + visit.planned_for.fullname + '</b> <br>' + 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',\n                                placement: 'bottom-center',\n                                classes: ['info']}"
      }],
      staticClass: "btn btn-primary btn_circle btn_md vertically_centered",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("\n                        " + _vm._s(visit.planned_for.monogram.toUpperCase()) + "\n                    ")])]), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('div', {
      staticClass: "card_row"
    }, [_c('div', {
      staticClass: "p-2"
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v("Lékařská zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e(), _vm._v(" "), (visit.diagnosis.length > 0) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                        " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                    ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                        ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                        ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(2, true)])]]
    })], 2)])])]) : _vm._e(), _vm._v(" "), (visit.medicament.length > 0) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                                              " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])])]) : _vm._e()])]) : _vm._e()]
  }), _vm._v(" "), _c('pagination-component', {
    attrs: {
      "list-pagination": _vm.listPagination
    },
    on: {
      "set-page": _vm.setPage
    }
  })], 2) : (_vm.listPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(3)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(4)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Úkoly")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-auto"
  }, [_c('span', {
    staticClass: "fa fa-2x fa-angle-right text-primary vertically_centered invisible",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_doctor",
    attrs: {
      "data-testid": "doctor-dashboard"
    }
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('visits')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('tasks')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Visits_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Tasks_vue__ = __webpack_require__(411);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    Visits: __WEBPACK_IMPORTED_MODULE_0__components_Visits_vue__["a" /* default */],
    Tasks: __WEBPACK_IMPORTED_MODULE_1__components_Tasks_vue__["a" /* default */]
  },
  methods: {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visits_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2f2969_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Visits_vue__ = __webpack_require__(410);
function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b2f2969"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2f2969_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Visits_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VisitChangeDoctor_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VisitChangeState_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(2);










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      visits_header_title: '',
      showedVisitDetail: [],

      selected_date: '',
      get_params: {
        date: ''
      },
      selectedStates: [],
      print_date: '',
      plannedFor: null,
      doctors: [],
      doctorsPending: false,
      doctorsError: false,
      selectedDoctorId: null,
      showDoctorModal: false,
      selectedDate: '',
      selectedVisitId: null,
      visits: false,
      visitsError: false,
      visitsPending: true,
      visitsDone: false,
      waiting: true,
      editingVisitId: false,
      editingVisit: {},
      waitForSave: false,

      filteredVisits: false,
      remainingVisits: false,
      showRemainingVisitsToo: false,

      visitPurposes: [],
      visitPurposesPending: false,
      visitPurposeError: false,
      visitPurposesDone: false,

      selectedVisitPurposes: [],
      filteredVisitPurposesId: [1, 2, 3, 4, 5, 8, 9, 10, 15]
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins__["a" /* default */]],
  methods: {
    showHideRemainingVisits: function showHideRemainingVisits() {
      this.showRemainingVisitsToo = !this.showRemainingVisitsToo;
      this.visitFiltering();
    },
    visitFiltering: function visitFiltering() {
      if (this.visits !== false) {
        this.filteredVisits = [];
        this.remainingVisits = [];
        if (this.showRemainingVisitsToo === true) {
          this.filteredVisits = this.visits;
        } else {
          for (var index = 0; index < this.visits.length; ++index) {
            if (this.filteredVisitPurposesId.indexOf(this.visits[index].visit_purpose.id) > -1) {
              this.filteredVisits.push(this.visits[index]);
            } else {
              this.remainingVisits.push(this.visits[index]);
            }
          }
        }
      }
    },
    editVisit: function editVisit(note, id) {
      this.editingVisitId = id;
      this.editingVisit = {
        note: note
      };
    },
    putVisit: function putVisit() {
      var _this = this;

      this.waitForSave = true;
      this.$http.put('visit/' + this.editingVisitId, this.editingVisit, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.editingVisitId = false;
        _this.editingVisit = {};
        _this.getDoctorsDayVisits();
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    changeState: function changeState(visitId, event) {
      var _this2 = this;

      this.$http.put('visit/' + visitId + '/change_state', { state: event.target.value }, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        _this2.waitForResponse = false;
        _this2.getDoctorsDayVisits();
      }, function (response) {
        _this2.errors = response.data.errors;
        _this2.waitForResponse = false;
      });
    },
    showHideVisitDetail: function showHideVisitDetail(index) {
      if (this.showedVisitDetail.indexOf(index) === -1) {
        this.showedVisitDetail.push(index);
      } else {
        this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1);
      }
    },
    getDoctorsDayVisits: function getDoctorsDayVisits() {
      this.showedVisitDetail = [];
      var getParams = {
        date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('DD.MM.YYYY'),
        planned_for: this.plannedFor,
        states: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedStates) };
      this.getDayVisits(getParams);
    },
    selectToday: function selectToday() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate();
    },
    selectTomorrow: function selectTomorrow() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'days').toDate();
    },
    setDateAndLoad: function setDateAndLoad() {
      switch (this.selected_date.startOf('day').diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf('day'), 'days')) {
        case 0:
          this.print_date = 'Dnes (' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        case 1:
          this.print_date = 'Zítra (' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        case -1:
          this.print_date = 'Včera (' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        default:
          this.print_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('dddd') + ' (' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
      }
      this.getDoctorsDayVisits();
      this.waiting = false;
    },

    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date);
    },
    showModalChangeVisitDoctor: function showModalChangeVisitDoctor(selectedDoctorId) {
      this.selectedDoctorId = selectedDoctorId;
      this.showModal('visit-change-doctor');
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    membershipExpiresSoon: function membershipExpiresSoon(membership) {
      if (this.$moment(membership.valid_to, 'DD.MM.YYYY').diff(this.$moment(), 'days') < 31) {
        return true;
      } else {
        return false;
      }
    },
    limitText: function limitText(count) {
      if (count > 4) {
        return 'a ' + count + ' dal\u0161\xEDch';
      } else {
        return 'a ' + count + ' dal\u0161\xED';
      }
    },
    selectVisitPurposesId: function selectVisitPurposesId() {
      this.filteredVisitPurposesId = [];
      for (var index = 0; index < this.selectedVisitPurposes.length; ++index) {
        this.filteredVisitPurposesId.push(this.selectedVisitPurposes[index].id);
      }
      this.visitFiltering();
    }
  },
  beforeMount: function beforeMount() {
    this.getDoctors();
    this.getVisitPurposes();
    __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('cs');
    if (this.$ls.get('home_date')) {
      this.waiting = true;
      this.plannedFor = this.$ls.get('home_plannedfor');
      this.selectedStates = JSON.parse(this.$ls.get('home_states'));
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$ls.get('home_date'), 'DD.MM.YYYY').toDate();
    } else {
      this.selectToday();
      this.$ls.set('home_date', __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('DD.MM.YYYY'));
      this.selectedStates = ['scheduled', 'arrived', 'elaborated'];
    }
  },

  watch: {
    visitsDone: function visitsDone(val) {
      if (val === true) {
        this.visitFiltering();
        this.visitsDone = false;
      }
    },
    visitPurposesDone: function visitPurposesDone(val) {
      if (val === true) {
        for (var index = 0; index < this.visitPurposes.length; ++index) {
          if (this.filteredVisitPurposesId.indexOf(this.visitPurposes[index].id) > -1) {
            this.selectedVisitPurposes.push(this.visitPurposes[index]);
          }
        }
      }
    },

    selectedStates: function selectedStates(val) {
      this.$ls.set('home_states', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
      if (!this.waiting) {
        this.getDoctorsDayVisits();
      }
    },
    plannedFor: function plannedFor(val) {
      this.$ls.set('home_plannedfor', val);
      if (!this.waiting) {
        this.getDoctorsDayVisits();
      }
    },
    selectedDate: function selectedDate(val) {
      this.$ls.set('home_date', __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format('DD.MM.YYYY'));
      this.selected_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(val);
      this.setDateAndLoad();
    }
  },
  components: {
    VisitChangeDoctor: __WEBPACK_IMPORTED_MODULE_2__components_VisitChangeDoctor_vue__["a" /* default */],
    VisitChangeState: __WEBPACK_IMPORTED_MODULE_3__components_VisitChangeState_vue__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default.a
  }
});

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      changePending: false,
      changeError: null,
      visit: {},
      isOpen: false
    };
  },

  props: ['doctors', 'selectedDoctorId', 'visitId'],
  methods: {
    changeDoctor: function changeDoctor(doctorId) {
      var _this = this;

      this.changePending = true;
      this.visit.planned_for = doctorId;
      this.$http.put('visit/' + this.visitId, this.visit, { emulateJSON: true }).then(function (response) {
        _this.submited = response.data;
        _this.changePending = false;
        _this.$emit('update');
        _this.close();
      }).catch(function (error) {
        _this.changeError = error.response.data.errors;
        _this.changePending = false;
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    }
  },
  watch: {}
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "manual",
      "autoHide": false
    }
  }, [_c('button', {
    staticClass: "tooltip-target btn btn-sm btn-link",
    attrs: {
      "data-testid": 'reception-visit-doctor-' + _vm.visitId
    },
    on: {
      "click": _vm.open
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h3', [_vm._v("změna doktora")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.doctors), function(doctor) {
    return [(doctor.id !== _vm.selectedDoctorId) ? _c('button', {
      staticClass: "btn btn-primary m-1",
      attrs: {
        "data-testid": 'reception-visit-doctor-option-' + _vm.visitId + '-' + doctor.id
      },
      on: {
        "click": function($event) {
          _vm.changeDoctor(doctor.id)
        }
      }
    }, [_vm._v(_vm._s(doctor.fullname))]) : _c('button', {
      staticClass: "btn btn-primary disabled m-1",
      attrs: {
        "disabled": "disabled"
      }
    }, [_vm._v(_vm._s(doctor.fullname))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger mt-3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("zavřít")])])])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setting: __webpack_require__(3),
      changePending: false,
      changeError: null,
      visit: {},
      isOpen: false,
      states: {
        scheduled: 'naplánováno',
        arrived: 'v čekárně',
        elaborated: 'rozpracovaný',
        failed: 'nepřišel (bez omluvy)',
        excused: 'nepřišel (omluvil se)',
        completed: 'dokončený',
        canceled: 'zrušený'
      }
    };
  },

  props: ['actualState', 'selectedDoctorId', 'visitId', 'testPrefix'],
  methods: {
    changeState: function changeState(newState) {
      var _this = this;

      this.changePending = true;
      this.visit.state = newState;
      this.$http.put('visit/' + this.visitId, this.visit, { emulateJSON: true }).then(function (response) {
        _this.submited = response.data;
        _this.changePending = false;
        _this.$emit('update');
        _this.close();
      }).catch(function (error) {
        _this.changeError = error.response.data.errors;
        _this.changePending = false;
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    }
  },
  watch: {}
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "manual",
      "autoHide": false
    }
  }, [_c('button', {
    staticClass: "tooltip-target btn btn-sm btn-link",
    attrs: {
      "data-testid": (_vm.testPrefix || 'reception') + '-visit-state-' + _vm.visitId
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.actualState === 'scheduled') ? _c('i', {
    staticClass: "fa fa-2x fa-circle-o text-info",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'arrived') ? _c('i', {
    staticClass: "fa fa-2x fa-clock-o text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'completed') ? _c('i', {
    staticClass: "fa fa-2x fa-check-circle text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'elaborated') ? _c('i', {
    staticClass: "fa fa-2x fa-dot-circle-o text-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'failed') ? _c('i', {
    staticClass: "fa fa-2x fa-times-circle-o text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'excused') ? _c('i', {
    staticClass: "fa fa-2x fa-dot-circle-o text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'canceled') ? _c('i', {
    staticClass: "fa fa-2x fa-times-circle text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.states[_vm.actualState]))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.actualState !== 'completed' && _vm.actualState !== 'elaborated' && _vm.actualState !== 'canceled') ? [(_vm.actualState !== 'scheduled') ? _c('button', {
    staticClass: "btn btn-primary m-1",
    attrs: {
      "data-testid": (_vm.testPrefix || 'reception') + '-visit-state-scheduled-' + _vm.visitId
    },
    on: {
      "click": function($event) {
        _vm.changeState('scheduled')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.scheduled))]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'arrived') ? _c('button', {
    staticClass: "btn btn-success m-1",
    attrs: {
      "data-testid": (_vm.testPrefix || 'reception') + '-visit-state-arrived-' + _vm.visitId
    },
    on: {
      "click": function($event) {
        _vm.changeState('arrived')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.arrived))]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'failed') ? _c('button', {
    staticClass: "btn btn-danger m-1",
    on: {
      "click": function($event) {
        _vm.changeState('failed')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.failed))]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'excused') ? _c('button', {
    staticClass: "btn btn-danger m-1",
    on: {
      "click": function($event) {
        _vm.changeState('excused')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-dot-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.excused))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.actualState === 'completed' || _vm.actualState === 'elaborated') ? [(_vm.actualState !== 'elaborated') ? _c('button', {
    staticClass: "btn btn-warning m-1",
    on: {
      "click": function($event) {
        _vm.changeState('elaborated')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-dot-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.elaborated))]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'completed') ? _c('button', {
    staticClass: "btn btn-success m-1",
    on: {
      "click": function($event) {
        _vm.changeState('completed')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.completed))]) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger mt-3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("zavřít")])])])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "reception-visits"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Návštěvy")]), _vm._v(" " + _vm._s(_vm.print_date) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "data-testid": "reception-visits-today"
    },
    on: {
      "click": function($event) {
        _vm.selectToday()
      }
    }
  }, [_vm._v("dnes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "reception-visits-tomorrow"
    },
    on: {
      "click": function($event) {
        _vm.selectTomorrow()
      }
    }
  }, [_vm._v("zítra")])]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "validFrom"
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": function($event) {
        _vm.getDoctorsDayVisits()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 text-left"
  }, [(_vm.doctors.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plannedFor),
      expression: "plannedFor"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "reception-visits-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.plannedFor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("všichni doktoři")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.selectedStates.indexOf('scheduled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "scheduled",
      "data-testid": "reception-visits-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('scheduled')
      }
    }
  }, [_vm._v("plánovaní")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "scheduled",
      "data-testid": "reception-visits-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('scheduled'), 1)
      }
    }
  }, [_vm._v("plánovaní")]), _vm._v(" "), (_vm.selectedStates.indexOf('arrived') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "arrived"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('arrived')
      }
    }
  }, [_vm._v("v čekárně")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "arrived"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('arrived'), 1)
      }
    }
  }, [_vm._v("v čekárně")]), _vm._v(" "), (_vm.selectedStates.indexOf('elaborated') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('elaborated')
      }
    }
  }, [_vm._v("rozpracovaní")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('elaborated'), 1)
      }
    }
  }, [_vm._v("rozpracovaní")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("splněno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("splněno")]), _vm._v(" "), (_vm.selectedStates.indexOf('failed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('failed') + _vm.selectedStates.push('excused')
      }
    }
  }, [_vm._v("nepřišel")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('failed'), 1) + _vm.selectedStates.splice(_vm.selectedStates.indexOf('excused'), 1)
      }
    }
  }, [_vm._v("nepřišel")]), _vm._v(" "), (_vm.selectedStates.indexOf('canceled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('canceled')
      }
    }
  }, [_vm._v("zrušeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('canceled'), 1)
      }
    }
  }, [_vm._v("zrušeno")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-right"
  }, [(_vm.showRemainingVisitsToo) ? [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    on: {
      "click": _vm.showHideRemainingVisits
    }
  }, [_vm._v("filtrovat dle důvodu")])] : [_c('multiselect', {
    attrs: {
      "id": "medics",
      "props": "options",
      "options": _vm.visitPurposes,
      "track-by": "id",
      "label": "purpose",
      "placeholder": "důvod návštěvy",
      "multiple": true,
      "limit": 1,
      "limit-text": _vm.limitText,
      "option-height": 104,
      "open-direction": "down",
      "show-labels": false,
      "TagPlaceholder": "",
      "selectLabel": ""
    },
    on: {
      "input": _vm.selectVisitPurposesId
    },
    model: {
      value: (_vm.selectedVisitPurposes),
      callback: function($$v) {
        _vm.selectedVisitPurposes = $$v
      },
      expression: "selectedVisitPurposes"
    }
  })]], 2)])]), _vm._v(" "), (_vm.visits.length > 0) ? [(_vm.filteredVisits.length > 0) ? _c('div', {
    staticClass: "card-body pl-0 pr-0"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_vm._l((_vm.filteredVisits), function(visit, index) {
    return [_c('tr', {
      attrs: {
        "data-testid": 'reception-visit-' + visit.id
      }
    }, [_c('td', {
      staticClass: "align-middle",
      style: ({
        borderLeft: (visit.visit_purpose.color !== '' ? '5px solid #' + visit.visit_purpose.color : '5px solid transparent')
      }),
      attrs: {
        "rowspan": "2"
      }
    }, [_c('visit-change-state', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id
      },
      on: {
        "update": _vm.getDoctorsDayVisits
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(visit.hasData) ? [_c('button', {
      staticClass: "btn btn-sm btn_extra_small btn-primary",
      on: {
        "click": function($event) {
          _vm.showHideVisitDetail(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v("\n                            " + _vm._s(visit.date) + " od " + _vm._s(visit.timeFrom) + " do " + _vm._s(visit.timeTo) + "  (" + _vm._s(_vm._f("minutesToCsTime")(visit.duration * 5)) + ")\n                        ")], 2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "align-middle pr-2",
      attrs: {
        "colspan": "2"
      }
    }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('label', {
      attrs: {
        "for": "note"
      }
    }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.putVisit(visit)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingVisit.note),
        expression: "editingVisit.note"
      }],
      staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "noteHelp",
        "id": "note",
        "data-testid": 'reception-visit-note-' + visit.id
      },
      domProps: {
        "value": (_vm.editingVisit.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingVisit.note = $event.target.value
        }
      }
    }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "data-testid": 'reception-visit-save-' + visit.id
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])])] : [_c('button', {
      staticClass: "btn btn-sm btn-link text-secondary",
      attrs: {
        "data-testid": 'reception-visit-edit-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.editVisit(visit.note, visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "no-top-border",
      attrs: {
        "colspan": "3"
      }
    }, [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: visit.client.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(visit.client.full_name))]), _vm._v(" - "), (visit.client.insurance_number) ? _c('span', [_vm._v("ČP: "), _c('b', [_vm._v(_vm._s(visit.client.insurance_number))])]) : _c('span', [_vm._v("RČ: "), _c('b', [_vm._v(_vm._s(visit.client.p_i_n))])]), _vm._v(" "), (visit.client.health_insurance && visit.client.health_insurance.code === '---') ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("SAMOPLÁTCE")]) : (visit.client.health_insurance) ? _c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v(_vm._s(visit.client.health_insurance.code))]) : _c('span', {
      staticClass: "badge badge-danger"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybí zdrav. pojišťovna")]), _vm._v(" "), (visit.client.membership) ? [(_vm.membershipExpiresSoon(visit.client.membership) && (visit.client.membership.has_next_membership === false)) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'končí již: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
          placement: 'bottom-center',
          classes: ['danger']
        }),
        expression: "{\n                                  content: 'končí již: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.paid === false ? '<br> <span class=\\'text-danger\\'>klient nezaplatil</span>' : ''),\n                                  placement: 'bottom-center',\n                                  classes: ['danger']}"
      }],
      staticClass: "badge",
      class: [visit.client.membership.name === 'VIP' ? 'badge-danger' : (visit.client.membership.name === 'PREVENCE PLUS' ? 'badge-success' : ''), 'badge-primary']
    }, [_c('i', {
      staticClass: "fa fa-warning text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), (visit.client.membership.paid === false) ? _c('i', {
      staticClass: "fa fa-dollar text-danger"
    }) : _vm._e(), _vm._v("\n                                    " + _vm._s(visit.client.membership.name) + "\n                                  "), (visit.client.membership.name === 'VIP') ? [_c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    })] : _vm._e()], 2) : _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'platný do: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (visit.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                  content: 'platný do: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (visit.client.membership.paid === false ? '<br> <span class=\\'text-danger\\'>klient nezaplatil</span>' : ''),\n                                  placement: 'bottom-center',\n                                  classes: ['info']}"
      }],
      staticClass: "badge",
      class: [visit.client.membership.name === 'VIP' ? 'badge-danger' : (visit.client.membership.name === 'PREVENCE PLUS' ? 'badge-success' : ''), 'badge-primary']
    }, [(visit.client.membership.paid === false) ? _c('i', {
      staticClass: "fa fa-dollar text-danger"
    }) : _vm._e(), _vm._v("\n                                    " + _vm._s(visit.client.membership.name) + "\n                                  "), (visit.client.membership.name === 'VIP') ? [_c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white"
    })] : _vm._e()], 2)] : (visit.client.last_membership) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'skončil: <b>' + visit.client.last_membership.valid_to,
          placement: 'bottom-center',
          classes: ['secondary']
        }),
        expression: "{\n                                  content: 'skončil: <b>' + visit.client.last_membership.valid_to,\n                                  placement: 'bottom-center',\n                                  classes: ['secondary']}"
      }],
      staticClass: "badge badge-secondary"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" poslední: " + _vm._s(visit.client.last_membership.name))]) : _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" nemá program")]), _vm._v(" "), (visit.client.gdpr_consent) ? [(visit.client.gdpr_consent.agreed) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'souhlasil dne: <b>' + visit.client.gdpr_consent.recorded_on + '</b>',
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                        content: 'souhlasil dne: <b>' + visit.client.gdpr_consent.recorded_on + '</b>',\n                                        placement: 'bottom-center',\n                                        classes: ['info']}"
      }],
      staticClass: "badge badge-success"
    }, [_vm._v("\n                                GDPR\n                              "), _c('i', {
      staticClass: "fa fa-check text-white",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'NEsouhlasil dne: <b>' + visit.client.gdpr_consent.recorded_on + '</b>',
          placement: 'bottom-center',
          classes: ['secondary']
        }),
        expression: "{\n                                        content: 'NEsouhlasil dne: <b>' + visit.client.gdpr_consent.recorded_on + '</b>',\n                                        placement: 'bottom-center',\n                                        classes: ['secondary']}"
      }],
      staticClass: "badge badge-secondary"
    }, [_vm._v("\n                                GDPR\n                              "), _c('i', {
      staticClass: "fa fa-times text-white",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'nemá vyplněné GDPR',
          placement: 'bottom-center',
          classes: ['danger']
        }),
        expression: "{\n                                      content: 'nemá vyplněné GDPR',\n                                      placement: 'bottom-center',\n                                      classes: ['danger']}"
      }],
      staticClass: "badge badge-danger"
    }, [_vm._v("\n                              bez GDPR\n                            "), _c('i', {
      staticClass: "fa fa-exclamation-triangle text-white",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (visit.client.missing_data) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybějící údaje")]) : _vm._e(), _vm._v(" "), (visit.client.missing_contact) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybějící kontakty")]) : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "border-top-0 text-right pr-2",
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v("\n                            " + _vm._s(visit.planned_for.fullname) + "\n                            "), _c('visit-change-doctor', {
      attrs: {
        "doctors": _vm.doctors,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id
      },
      on: {
        "update": _vm.getDoctorsDayVisits
      }
    }), _vm._v(" "), (visit.planned_by && visit.planned_at) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne ' + visit.planned_at,
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                  content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne ' + visit.planned_at,\n                                  placement: 'bottom-center',\n                                  classes: ['info']}"
      }],
      staticClass: "text-info fa fa-lg fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()], 1)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('tr', [_c('td', {
      staticClass: "border-top-0"
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {}, [_c('h6', [_vm._v("Výsledná zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "pr-2",
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                            " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                        ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                            ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                            ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(0, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Recepty")]), _vm._v(" "), _c('div', [(visit.prescriptions.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.prescriptions), function(p) {
      return [_vm._l((p.medicaments), function(m, index) {
        return [(p.status === 'PREPARED' || p.type === 'printed') ? _c('tr', {
          staticClass: "row m-0"
        }, [(index === 0) ? _c('td', {
          staticClass: "text-center col-md-1"
        }, [(p.type === 'printed') ? _c('span', [_c('i', {
          staticClass: "fa fa-print",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e(), _vm._v(" "), (p.type === 'electronic') ? _c('span', {
          staticClass: "font-weight-bold"
        }, [_c('span', {
          staticClass: "green"
        }, [_vm._v("E")]), _vm._v("R.\n                                                            ")]) : _vm._e()]) : _c('td', {
          staticClass: "col-md-1 empty_cell"
        }), _vm._v(" "), _c('td', {
          staticClass: "align-middle col-md-7"
        }, [_vm._v("\n                                                          " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                                                          " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                                                        ")]), _vm._v(" "), _c('td', {
          staticClass: "align-middle col-md-1"
        }, [_vm._v("\n                                                            " + _vm._s(m.amount) + "\n                                                        ")]), _vm._v(" "), _c('td', {
          staticClass: "align-middle col-md-2"
        }, [_vm._v("\n                                                            " + _vm._s(m.dosage) + "\n                                                        ")]), _vm._v(" "), (index === 0) ? _c('td', {
          staticClass: "align-middle col-md-1"
        }, [(p.patient_notification_type === 'SMS') ? _c('i', {
          staticClass: "fa fa-mobile-phone",
          attrs: {
            "aria-hidden": "true"
          }
        }) : (p.patient_notification_type === 'EMAIL') ? _c('i', {
          staticClass: "fa fa-envelope-o",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _c('i', {
          staticClass: "fa fa-ban text-danger",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _c('td', {
          staticClass: "col-md-1 empty_cell"
        })]) : _vm._e()]
      })]
    })], 2)])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])])]) : _vm._e()]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.remainingVisits.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-text"
  }, [_vm._v("... a " + _vm._s(_vm.remainingVisits.length) + " " + _vm._s(_vm.remainingVisits.length > 4 ? 'vyfiltrovaných' : 'vyfiltrovaný') + "\n                "), _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "data-testid": "reception-visits-show-filtered"
    },
    on: {
      "click": _vm.showHideRemainingVisits
    }
  }, [_vm._v("zobrazit také")])])]) : _vm._e()] : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)])], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2130abbd_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__ = __webpack_require__(417);
function injectStyle (ssrContext) {
  __webpack_require__(412)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2130abbd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2130abbd_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VisitChangeDoctor_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VisitTaskChangeState_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PaginationComponent_vue__ = __webpack_require__(25);











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showedVisitDetail: [],
      visits_header_title: '',
      setting: __webpack_require__(3),
      selected_date: '',
      getParams: {
        p: 1,
        s: 'acute-planned_at+',
        f: {
          state: 'scheduled'
        },
        pp: 15
      },
      selectedStates: [],
      print_date: '',
      plannedFor: '',
      doctors: [],
      doctorsPending: false,
      doctorsError: false,
      selectedDoctorId: null,
      showDoctorModal: false,
      selectedDate: '',
      listData: false,
      listError: false,
      listPagination: null,
      listPending: false,
      waiting: true,
      editingVisitId: false,
      editingVisit: {},
      waitForSave: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    setPage: function setPage(number) {
      this.getParams.p = number;
      this.getDoctorsDayVisits();
    },
    showHideVisitDetail: function showHideVisitDetail(index) {
      if (this.showedVisitDetail.indexOf(index) === -1) {
        this.showedVisitDetail.push(index);
      } else {
        this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1);
      }
    },
    editVisit: function editVisit(visit, id) {
      this.editingVisitId = id;
      this.editingVisit = {
        note: visit.note,
        acute: visit.acute,
        planned_for: visit.planned_for.id
      };
    },
    putVisit: function putVisit() {
      var _this = this;

      this.waitForSave = true;
      this.$http.put('visit_task/' + this.editingVisitId, this.editingVisit, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.editingVisitId = false;
        _this.editingVisit = {};
        _this.getDoctorsDayVisits();
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    changeState: function changeState(visitId, event) {
      var _this2 = this;

      this.$http.put('visit_task/' + visitId + '/change_state', { state: event.target.value }, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        _this2.waitForResponse = false;
        _this2.getDoctorsDayVisits();
      }, function (response) {
        _this2.errors = response.data.errors;
        _this2.waitForResponse = false;
      });
    },
    getDoctorsDayVisits: function getDoctorsDayVisits() {
      this.getTasks(this.getParams);
    },
    selectToday: function selectToday() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate();
    },
    selectTomorrow: function selectTomorrow() {
      this.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'days').toDate();
    },
    setDateAndLoad: function setDateAndLoad() {
      switch (this.selected_date.startOf('day').diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf('day'), 'days')) {
        case 0:
          this.print_date = 'Dnes (' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        case 1:
          this.print_date = 'Zítra (' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        case -1:
          this.print_date = 'Včera (' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        default:
          this.print_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('dddd') + ' (' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected_date).format('DD.MM.YYYY') + ')';
      }
      this.getDoctorsDayVisits();
      this.waiting = false;
    },

    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date);
    },
    showModalChangeVisitDoctor: function showModalChangeVisitDoctor(selectedDoctorId) {
      this.selectedDoctorId = selectedDoctorId;
      this.showModal('visit-change-doctor');
    },
    showModal: function showModal(name) {
      console.log('zobrazuji modal');
      this.$modal.show(name);
    },
    membershipExpiresSoon: function membershipExpiresSoon(membership) {
      if (this.$moment(membership.valid_to, 'DD.MM.YYYY').diff(this.$moment(), 'days') < 31) {
        return true;
      } else {
        return false;
      }
    },
    selectScheduledState: function selectScheduledState() {
      this.getParams.f.state = 'scheduled';
      this.getParams.s = 'acute-planned_at+';
      this.getDoctorsDayVisits();
    },
    selectCompletedState: function selectCompletedState() {
      this.getParams.f.state = 'completed';
      this.getParams.s = 'completed_at-';
      this.getDoctorsDayVisits();
    },
    selectCanceledState: function selectCanceledState() {
      this.getParams.f.state = 'canceled';
      this.getParams.s = 'planned_at-';
      this.getDoctorsDayVisits();
    }
  },
  beforeMount: function beforeMount() {
    this.getDoctors();
    __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('cs');
    if (this.$ls.get('home_date')) {
      this.waiting = true;

      this.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$ls.get('home_date'), 'DD.MM.YYYY').toDate();
    } else {
      this.selectToday();
      this.$ls.set('home_date', __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('DD.MM.YYYY'));
    }
  },

  watch: {
    plannedFor: function plannedFor(val) {
      if (val === null) {
        delete this.getParams.f.planned_for;
      } else {
        this.getParams.f.planned_for = val;
      }

      this.getDoctorsDayVisits();
    },
    selectedDate: function selectedDate(val) {
      this.$ls.set('home_date', __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format('DD.MM.YYYY'));
      this.selected_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(val);
      this.setDateAndLoad();
    }
  },
  components: {
    PaginationComponent: __WEBPACK_IMPORTED_MODULE_5__components_PaginationComponent_vue__["a" /* default */],
    VisitChangeDoctor: __WEBPACK_IMPORTED_MODULE_2__components_VisitChangeDoctor_vue__["a" /* default */],
    VisitTaskChangeState: __WEBPACK_IMPORTED_MODULE_3__components_VisitTaskChangeState_vue__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default.a
  }
});

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setting: __webpack_require__(3),
      changePending: false,
      changeError: null,
      visit: {},
      isOpen: false,
      states: {
        scheduled: 'naplánováno',
        arrived: 'v čekárně',
        elaborated: 'rozpracovaný',
        failed: 'nepřišel (bez omluvy)',
        excused: 'nepřišel (omluvil se)',
        completed: 'dokončený',
        canceled: 'zrušený'
      }
    };
  },

  props: ['actualState', 'selectedDoctorId', 'visitId', 'testPrefix'],
  methods: {
    changeState: function changeState(newState) {
      var _this = this;

      this.changePending = true;
      this.visit.state = newState;
      this.$http.put('visit_task/' + this.visitId, this.visit, { emulateJSON: true }).then(function (response) {
        _this.submited = response.data;
        _this.changePending = false;
        _this.$emit('update');
        _this.close();
      }).catch(function (error) {
        _this.changeError = error.response.data.errors;
        _this.changePending = false;
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    }
  },
  watch: {}
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "manual",
      "autoHide": false
    }
  }, [_c('button', {
    staticClass: "tooltip-target btn btn-sm btn-link",
    attrs: {
      "data-testid": (_vm.testPrefix || 'reception-task') + '-state-' + _vm.visitId
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.actualState === 'scheduled') ? _c('i', {
    staticClass: "fa fa-2x fa-circle-o text-info",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'arrived') ? _c('i', {
    staticClass: "fa fa-2x fa-clock-o text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'completed') ? _c('i', {
    staticClass: "fa fa-2x fa-check-circle text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'elaborated') ? _c('i', {
    staticClass: "fa fa-2x fa-dot-circle-o text-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'failed') ? _c('i', {
    staticClass: "fa fa-2x fa-times-circle-o text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'excused') ? _c('i', {
    staticClass: "fa fa-2x fa-dot-circle-o text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'canceled') ? _c('i', {
    staticClass: "fa fa-2x fa-times-circle text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.states[_vm.actualState]))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [
    [(_vm.actualState !== 'completed') ? _c('button', {
      staticClass: "btn btn-success m-1",
      attrs: {
        "data-testid": (_vm.testPrefix || 'reception-task') + '-state-completed-' + _vm.visitId
      },
      on: {
        "click": function($event) {
          _vm.changeState('completed')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-check-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" dokončit")]) : _vm._e(), _vm._v(" "), (_vm.actualState !== 'canceled') ? _c('button', {
      staticClass: "btn btn-danger m-1",
      on: {
        "click": function($event) {
          _vm.changeState('canceled')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-times-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" zrušit")]) : _vm._e()]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger mt-3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("zavřít")])])])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "reception-tasks"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.getParams.f.state === 'scheduled') ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "data-testid": "reception-tasks-filter-scheduled"
    }
  }, [_vm._v("nevyřízeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "reception-tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectScheduledState()
      }
    }
  }, [_vm._v("nevyřízeno")]), _vm._v(" "), (_vm.getParams.f.state === 'completed') ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "data-testid": "reception-tasks-filter-completed"
    }
  }, [_vm._v("splněno")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "reception-tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectCompletedState()
      }
    }
  }, [_vm._v("splněno")]), _vm._v(" "), (_vm.getParams.f.state === 'canceled') ? _c('button', {
    staticClass: "btn btn-sm btn-success"
  }, [_vm._v("zrušeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    on: {
      "click": function($event) {
        _vm.selectCanceledState()
      }
    }
  }, [_vm._v("zrušeno")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 text-center"
  }, [(_vm.doctors.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plannedFor),
      expression: "plannedFor"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "reception-tasks-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.plannedFor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("všichni doktoři")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": function($event) {
        _vm.getDoctorsDayVisits()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.listData.length > 0) ? _c('div', {
    staticClass: "card-body pl-0 pr-0"
  }, [_vm._l((_vm.listData), function(visit, index) {
    return [_c('div', {
      staticClass: "row ml-0 mr-0 card_row",
      attrs: {
        "data-testid": 'reception-task-' + visit.id
      }
    }, [_c('div', {
      staticClass: "col-sm-auto pl-2 pr-0 pt-2"
    }, [_c('i', {
      staticClass: "fa fa-2x fa-exclamation text-danger text_blink",
      class: visit.acute === true ? '' : 'invisible',
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-auto pl-0 pr-0"
    }, [_c('visit-task-change-state', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id
      },
      on: {
        "update": _vm.getDoctorsDayVisits
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col pl-0 pr-0"
    }, [_c('div', {
      staticClass: "row m-0"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: visit.client.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(visit.client.first_name) + " " + _vm._s(visit.client.last_name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b>',
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                content: 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b>',\n                                placement: 'bottom-center',\n                                classes: ['info']}"
      }]
    }, [_vm._v("\n                                " + _vm._s(visit.planned_at) + "\n                            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "row m-0"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [
      [_c('button', {
        staticClass: "btn btn-sm btn_extra_small btn-primary",
        attrs: {
          "data-testid": 'reception-task-detail-' + visit.id
        },
        on: {
          "click": function($event) {
            _vm.showHideVisitDetail(index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-info-circle",
        attrs: {
          "aria-hidden": "true"
        }
      })])], _vm._v(" "), _c('router-link', {
        attrs: {
          "to": {
            name: 'ShowVisit',
            params: {
              clientid: visit.client.id,
              visitid: visit.id
            }
          }
        }
      }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))])]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('form', {
        staticClass: "form-inline",
        on: {
          "submit": function($event) {
            $event.preventDefault();
            _vm.putVisit(visit)
          }
        }
      }, [_c('label', {
        attrs: {
          "for": "note"
        }
      }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editingVisit.note),
          expression: "editingVisit.note"
        }],
        staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
        attrs: {
          "type": "text",
          "aria-describedby": "noteHelp",
          "id": "note",
          "data-testid": 'reception-task-note-' + visit.id
        },
        domProps: {
          "value": (_vm.editingVisit.note)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.editingVisit.note = $event.target.value
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "mr-sm-2",
        attrs: {
          "for": "doctor"
        }
      }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editingVisit.planned_for),
          expression: "editingVisit.planned_for"
        }],
        staticClass: "form-control mr-sm-2",
        attrs: {
          "aria-describedby": "doctorHelp",
          "id": "doctor",
          "placeholder": "vybrat doktora",
          "autofocus": "autofocus"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.editingVisit.planned_for = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }
        }
      }, _vm._l((_vm.doctors), function(row) {
        return _c('option', {
          domProps: {
            "value": row.id
          }
        }, [_vm._v(_vm._s(row.fullname))])
      })), _vm._v(" "), _c('label', {
        staticClass: "mr-sm-2",
        attrs: {
          "for": "acute"
        }
      }, [_vm._v("\n                                        prioritní "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.editingVisit.acute),
          expression: "editingVisit.acute"
        }],
        staticClass: "form-check-input",
        attrs: {
          "type": "checkbox",
          "id": "acute"
        },
        domProps: {
          "checked": Array.isArray(_vm.editingVisit.acute) ? _vm._i(_vm.editingVisit.acute, null) > -1 : (_vm.editingVisit.acute)
        },
        on: {
          "__c": function($event) {
            var $$a = _vm.editingVisit.acute,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.editingVisit.acute = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.editingVisit.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.editingVisit.acute = $$c
            }
          }
        }
      })]), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
        staticClass: "btn btn-primary",
        attrs: {
          "type": "submit",
          "data-testid": 'reception-task-save-' + visit.id
        }
      }, [_vm._v("Uložit")]) : _c('button', {
        staticClass: "btn btn-primary disabled",
        attrs: {
          "disabled": "disabled"
        }
      }, [_c('i', {
        staticClass: "fa fa-spinner fa-pulse fa-fw"
      }), _vm._v(" Ukládám")])])] : [_c('button', {
        staticClass: "btn btn-sm btn-link text-secondary",
        attrs: {
          "data-testid": 'reception-task-edit-' + visit.id
        },
        on: {
          "click": function($event) {
            _vm.editVisit(visit, visit.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]
    ], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-auto pl-0 pr-0"
    }, [_c('button', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'naplánováno pro: <b>' + visit.planned_for.fullname + '</b> <br>' + 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                                content: 'naplánováno pro: <b>' + visit.planned_for.fullname + '</b> <br>' + 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',\n                                placement: 'bottom-center',\n                                classes: ['info']}"
      }],
      staticClass: "btn btn-primary btn_circle btn_md vertically_centered",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("\n                        " + _vm._s(visit.planned_for.monogram.toUpperCase()) + "\n                    ")])]), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('div', {
      staticClass: "card_row"
    }, [_c('div', {
      staticClass: "p-2"
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v("Lékařská zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e(), _vm._v(" "), (visit.diagnosis.length > 0) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                        " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                    ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                        ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                        ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(2, true)])]]
    })], 2)])])]) : _vm._e(), _vm._v(" "), (visit.medicament.length > 0) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                                              " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])])]) : _vm._e()])]) : _vm._e()]
  }), _vm._v(" "), _c('pagination-component', {
    attrs: {
      "list-pagination": _vm.listPagination
    },
    on: {
      "set-page": _vm.setPage
    }
  })], 2) : (_vm.listPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(3)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(4)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Úkoly")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-auto"
  }, [_c('span', {
    staticClass: "fa fa-2x fa-angle-right text-primary vertically_centered invisible",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_doctor",
    attrs: {
      "data-testid": "reception-dashboard"
    }
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('visits')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('tasks')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isAuthenticated) ? [(_vm.contains('doctor')) ? _c('home-doctor') : (_vm.contains('receptionist') || _vm.contains('nurse')) ? _c('home-receptionist') : _vm._e()] : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56fccb82_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__(448);
function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56fccb82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56fccb82_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Calendar_components_Calendar_vue__ = __webpack_require__(423);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_0__views_Calendar_components_Calendar_vue__["a" /* default */]
  },
  methods: {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_184a257a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-184a257a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_184a257a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_LeisureTime_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals_WorkingTime_vue__ = __webpack_require__(443);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      waitForSave: false,
      calendarSize: 'week',
      startWindow: 43,
      endWindow: 127,
      windowsPerHour: 6,
      startHour: 7,
      selectedWindow: null,
      lastDuration: '',
      selected_element: null,
      get_params: {
        from: '',
        to: '',
        doctorid: ''
      },
      start_date: '',
      end_date: '',
      begin_of_month: '',
      end_of_month: '',
      today: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
      actual_select: {
        selected: false,
        time: '',
        date: '',
        window: '',
        day: ''
      },
      modalOpened: false,
      render_end_date: '',
      render_start_date: '',
      selectedDate: null,

      calendar: false,
      calendarPending: false,
      calendarError: false,
      doctors: null,
      doctorsPending: false,
      doctorsError: false,
      doctorId: null,

      showModalCalendarLeisureTimeOpened: false,
      showModalCalendarWorkingTimeOpened: false,

      visits: false,
      visitsPending: false,
      visitsError: false,
      showedVisitDetail: [],
      editingVisitId: false,
      editingVisit: {}
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* default */]],
  methods: {
    editVisit: function editVisit(note, id) {
      this.editingVisitId = id;
      this.editingVisit = {
        note: note
      };
    },
    putVisit: function putVisit() {
      var _this = this;

      this.waitForSave = true;
      this.$http.put('visit/' + this.editingVisitId, this.editingVisit, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.editingVisitId = false;
        _this.editingVisit = {};
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    showModalCalendarLeisureTime: function showModalCalendarLeisureTime() {
      this.showModalCalendarLeisureTimeOpened = true;
      this.showModal('calendar-leisure-time');
    },
    showModalCalendarWorkingTime: function showModalCalendarWorkingTime() {
      this.showModalCalendarWorkingTimeOpened = true;
      this.showModal('calendar-working-time');
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    window10toTime: function window10toTime(num) {
      var hoursFrom = Math.floor((num - 1) / 6);
      var hoursTo = Math.floor(num / 6);
      var minutesFrom = (num - 1) % 6 * 10;
      var minutesTo = num % 6 * 10;
      return hoursFrom + ':' + minutesFrom.toString().padStart(2, 0) + ' - ' + hoursTo + ':' + minutesTo.toString().padStart(2, 0);
    },
    windowToTime: function windowToTime(window) {
      window = window - 1;
      var hour = Math.floor(window / this.windowsPerHour);
      var minute = window % this.windowsPerHour * 15;
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().hour(hour).minute(minute);
    },
    clearLastSelect: function clearLastSelect() {
      if (this.selectedWindow) {
        var element = this.selectedWindow;
        for (var i = 0; i < this.lastDuration; i++) {
          element.classList.remove('selected_window');
          if (element.nextSibling === null) {
            break;
          }
          element = element.nextSibling;
        }
      }
    },
    getRightClassForTd: function getRightClassForTd(item) {
      var classes = item.type;

      if (item.clients > 0) {
        classes += ' clients';
      }

      return classes;
    },
    getVisitsForWindow: function getVisitsForWindow(date, window) {
      this.visits = false;
      this.showedVisitDetail = [];
      var getParams = {
        date: date,
        planned_for: this.doctorId,
        window: window,
        states: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(['scheduled', 'arrived', 'elaborated', 'completed'])
      };
      this.getDayVisits(getParams);
    },
    getVisitsForDay: function getVisitsForDay(date) {
      this.visits = false;
      var getParams = {
        date: date,
        planned_for: this.doctorId,
        states: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(['scheduled', 'arrived', 'elaborated', 'completed'])
      };
      this.getDayVisits(getParams);
    },
    initialSet: function initialSet() {
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('cs');
      this.get_params = {
        from: '',
        to: '',
        doctorid: ''
      };
      this.actualPeriod();
    },
    getCalendar: function getCalendar() {
      this.getWeekCalendarForDoctor(this.get_params.doctorid, this.get_params);
    },
    actualPeriod: function actualPeriod() {
      this.start_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf('isoWeek');
      this.end_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().endOf('isoWeek');
      this.renderDates();
      this.loadCalendar();
    },
    nextPeriod: function nextPeriod() {
      this.start_date = this.start_date.add(1, 'weeks');
      this.end_date = this.end_date.add(1, 'weeks');
      this.renderDates();
      this.loadCalendar();
    },
    previousPeriod: function previousPeriod() {
      this.start_date = this.start_date.subtract(1, 'weeks');
      this.end_date = this.end_date.subtract(1, 'weeks');
      this.renderDates();
      this.loadCalendar();
    },
    renderDates: function renderDates() {
      this.render_start_date = this.start_date;
      this.render_end_date = this.end_date;
      this.get_params.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.start_date).format('DD.MM.YYYY');
      this.get_params.from = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.start_date).format('DD.MM.YYYY');
      this.get_params.to = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.end_date).format('DD.MM.YYYY');
    },
    loadCalendar: function loadCalendar() {
      this.get_params.doctorid = this.doctorId;
      if (this.doctorId !== null && this.doctorId !== undefined) {
        this.getCalendar();
      }
    },

    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date);
    },
    init: function init() {
      this.initialSet();
      this.getDoctors();
      this.selectedDate = null;
      this.loadCalendar();
    },
    manualSelectDate: function manualSelectDate(value) {
      this.start_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).startOf('isoWeek');
      this.end_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).endOf('isoWeek');
      this.renderDates();
      this.loadCalendar();
      this.selectedDate = null;
    },
    showHideVisitDetail: function showHideVisitDetail(index) {
      if (this.showedVisitDetail.indexOf(index) === -1) {
        this.showedVisitDetail.push(index);
      } else {
        this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1);
      }
    },
    findDoctorById: function findDoctorById(doctor) {
      return doctor.id === this.doctorId;
    },
    windowsHover: function windowsHover(num) {
      return '00:00';
    },
    windowsHoverVisits: function windowsHoverVisits(visits) {
      var returnString = '';
      visits.forEach(function (visit) {
        returnString += '<br>' + visit.visit.timeFrom + ' - ' + visit.visit.timeTo + '<br>' + visit.visit_purpose.purpose;
      });

      return returnString;
    },
    visitSlotHover: function visitSlotHover(visit) {
      return visit.visit_purpose.purpose;
    }
  },
  watch: {
    doctorId: function doctorId(val) {
      this.visits = false;
      if (val !== null && val !== undefined) {
        document.title = 'clinico - ' + this.doctors.find(this.findDoctorById).fullname;
        this.loadCalendar();
      }
    }
  },
  beforeMount: function beforeMount() {
    this.init();
  },

  components: {
    CalendarLeisureTime: __WEBPACK_IMPORTED_MODULE_3__modals_LeisureTime_vue__["a" /* default */],
    CalendarWorkingTime: __WEBPACK_IMPORTED_MODULE_4__modals_WorkingTime_vue__["a" /* default */]
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeisureTime_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c708ed_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_LeisureTime_vue__ = __webpack_require__(442);
function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54c708ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeisureTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c708ed_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_LeisureTime_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      leisureTime: null,
      leisureTimePending: true,
      leisureTimeError: false,
      newLeisureTime: {},
      newLeisureTimeError: false,
      newLeisureTimePending: false,
      newLeisureTimeDone: false,
      updatedLeisureTime: {},
      originalLeisureTime: {},
      formLeisureTime: {
        id: null,
        timeFrom: {
          H: '',
          mm: ''
        },
        timeTo: {
          H: '',
          mm: ''
        },
        valid: null,
        note: '',
        allDay: false
      },
      updatedLeisureTimeError: false,
      updatedLeisureTimePending: false,
      updatedLeisureTimeDone: false,
      deleteLeisureTimeError: false,
      deleteLeisureTimePending: false,
      deleteLeisureTimeDone: false,
      editingId: false
    };
  },

  props: ['opened', 'doctorId'],
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* default */]],
  methods: {
    beforeOpen: function beforeOpen() {
      console.log('oteviram modalko' + this.doctorId);
      this.getDoctorsLeisureTime(this.doctorId);
    },
    setEditingLeisureTime: function setEditingLeisureTime(leisureTime) {
      if (this.editingId === false) {
        this.formLeisureTime.valid = this.$moment(leisureTime.valid, 'D.M.YYYY').toDate();
        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.calculateHourFromWindow(leisureTime.time_window)) + ':' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.calculateMinuteFromWindow(leisureTime.time_window)) + '--' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.calculateHourFromWindow(leisureTime.time_window + leisureTime.duration)) + ':' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.calculateMinuteFromWindow(leisureTime.time_window + leisureTime.duration)));
        console.log(this.calculateHourFromWindow(leisureTime.time_window) + ':' + this.calculateMinuteFromWindow(leisureTime.time_window) + '--' + this.calculateHourFromWindow(leisureTime.time_window + leisureTime.duration) + ':' + this.calculateMinuteFromWindow(leisureTime.time_window + leisureTime.duration));
        this.formLeisureTime.timeFrom.H = this.calculateHourFromWindow(leisureTime.time_window) + '';
        this.formLeisureTime.timeFrom.mm = (this.calculateMinuteFromWindow(leisureTime.time_window) + '').padStart(2, '0');
        this.formLeisureTime.timeTo.H = this.calculateHourFromWindow(leisureTime.time_window + leisureTime.duration) % 24 + '';
        this.formLeisureTime.timeTo.mm = (this.calculateMinuteFromWindow(leisureTime.time_window + leisureTime.duration) + '').padStart(2, '0');
        this.formLeisureTime.note = leisureTime.note;
        this.formLeisureTime.allDay = leisureTime.all_day;
        this.editingId = leisureTime.id;
        this.originalLeisureTime = this.populateToSave(this.formLeisureTime);
      } else {
        this.formLeisureTime = {
          id: null,
          timeFrom: {
            H: '',
            mm: ''
          },
          timeTo: {
            H: '',
            mm: ''
          },
          valid: null,
          note: '',
          allDay: false
        };
        this.editingId = false;
      }
    },
    calculateHourFromWindow: function calculateHourFromWindow(window) {
      return Math.floor((window - 1) / 12);
    },
    calculateMinuteFromWindow: function calculateMinuteFromWindow(window) {
      return (window - 1) % 12 * 5;
    },
    calculateWindowFromTime: function calculateWindowFromTime(hours, minutes) {
      return hours * 12 + minutes / 5 + 1;
    },
    calculateWindowDurationFromTime: function calculateWindowDurationFromTime(hoursFrom, minutesFrom, hoursTo, minutesTo) {
      if (hoursTo + '' + minutesTo === '000') {
        hoursTo = 24;
      }
      return this.calculateWindowFromTime(hoursTo, minutesTo) - this.calculateWindowFromTime(hoursFrom, minutesFrom);
    },

    isTimeFilled: function isTimeFilled(from, to) {
      return from.H !== '' && from.mm !== '' && to.H !== '' && to.mm !== '';
    },
    isDurationPositive: function isDurationPositive(from, to) {
      return this.calculateWindowDurationFromTime(from.H, from.mm, to.H, to.mm) > 0;
    },
    tryPopulateFromForm: function tryPopulateFromForm() {
      if (this.possibleToSave === true) {
        if (this.editingId !== false) {
          this.updatedLeisureTime = this.populateToSave(this.formLeisureTime);
        } else {
          this.newLeisureTime = this.populateToSave(this.formLeisureTime);
          delete this.newLeisureTime.id;
        }
      } else {
        this.updatedLeisureTime = {};
      }
    },
    populateToSave: function populateToSave(formData) {
      var saveData = {};
      if (formData.allDay === false) {
        saveData.time_window = this.calculateWindowFromTime(formData.timeFrom.H, formData.timeFrom.mm);
        saveData.duration = this.calculateWindowDurationFromTime(formData.timeFrom.H, formData.timeFrom.mm, formData.timeTo.H, formData.timeTo.mm);
      } else {
        saveData.time_window = 1;
        saveData.duration = 288;
      }
      saveData.id = this.editingId;
      saveData.valid = this.$moment(formData.valid).format('L');
      saveData.note = formData.note;
      return saveData;
    },
    submitFormUpdateLeisureTime: function submitFormUpdateLeisureTime() {
      this.putLeisureTime(this.updatedLeisureTime);
    },
    submitFormAddLeisureTime: function submitFormAddLeisureTime() {
      this.postLeisureTime(this.newLeisureTime, this.doctorId);
    }
  },
  watch: {
    'formLeisureTime.timeFrom': function formLeisureTimeTimeFrom() {
      this.tryPopulateFromForm();
    },
    'formLeisureTime.allDay': function formLeisureTimeAllDay() {
      this.tryPopulateFromForm();
    },
    'formLeisureTime.timeTo': function formLeisureTimeTimeTo() {
      this.tryPopulateFromForm();
    },
    'formLeisureTime.valid': function formLeisureTimeValid() {
      this.tryPopulateFromForm();
    },
    'formLeisureTime.note': function formLeisureTimeNote() {
      this.tryPopulateFromForm();
    },
    newLeisureTimeDone: function newLeisureTimeDone(val) {
      this.newLeisureTime = {};
      if (val === true) {
        this.getDoctorsLeisureTime(this.doctorId);
        this.newLeisureTimeDone = false;
      }
    },
    deleteLeisureTimeDone: function deleteLeisureTimeDone(val) {
      if (val === true) {
        this.getDoctorsLeisureTime(this.doctorId);
        this.deleteLeisureTimeDone = false;
      }
    },
    updatedLeisureTimeDone: function updatedLeisureTimeDone(val) {
      if (val === true) {
        this.$emit('leisure-time-updated');
        this.editingId = false;
        this.updatedLeisureTime = {};
        this.getDoctorsLeisureTime(this.doctorId);
        this.updatedLeisureTimeDone = false;
      }
    }
  },
  computed: {
    possibleToSave: function possibleToSave() {
      return this.isDurationPositive(this.formLeisureTime.timeFrom, this.formLeisureTime.timeTo) && this.isTimeFilled(this.formLeisureTime.timeFrom, this.formLeisureTime.timeTo) || this.formLeisureTime.allDay === true;
    },
    formChanged: function formChanged() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.originalLeisureTime) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.updatedLeisureTime);
    }
  }
});

/***/ }),
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "80%",
      "scrollable": true,
      "name": "calendar-leisure-time",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "calendar-leisure-dialog"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Přehled volna\n    ")]), _vm._v(" "), (_vm.leisureTimePending) ? _c('div', {
    staticClass: "card-body"
  }) : _c('div', {
    staticClass: "card-body"
  }, [(_vm.leisureTime.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("datum")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("od - do")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("délka")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-6"
  }, [_vm._v("poznámka")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.leisureTime), function(lt) {
    return [_c('tr', {
      staticClass: "row m-0 text-left",
      attrs: {
        "data-testid": 'calendar-leisure-row-' + lt.id
      }
    }, [(_vm.editingId !== lt.id) ? _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(lt.valid))]) : _vm._e(), _vm._v(" "), (_vm.editingId !== lt.id) ? _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(lt.time_from) + " - " + _vm._s(lt.time_to))]) : _vm._e(), _vm._v(" "), (_vm.editingId !== lt.id) ? _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(_vm._f("minutesToCsTime")(lt.duration * 5)))]) : _vm._e(), _vm._v(" "), (_vm.editingId !== lt.id) ? _c('td', {
      staticClass: "col-sm-5"
    }, [_vm._v(_vm._s(lt.note))]) : _c('td', {
      staticClass: "col-sm-11"
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.submitFormUpdateLeisureTime($event)
        }
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("datum")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "placeholder": "vybrat datum",
        "format": "dd.MM.yyyy",
        "language": "cs",
        "monday-first": true,
        "full-month-name": true,
        "name": "chooseDate",
        "input-class": "datapickerInput"
      },
      model: {
        value: (_vm.formLeisureTime.valid),
        callback: function($$v) {
          _vm.formLeisureTime.valid = $$v
        },
        expression: "formLeisureTime.valid"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                                                      Celý den: \n                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formLeisureTime.allDay),
        expression: "formLeisureTime.allDay"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.formLeisureTime.allDay) ? _vm._i(_vm.formLeisureTime.allDay, null) > -1 : (_vm.formLeisureTime.allDay)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.formLeisureTime.allDay,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.formLeisureTime.allDay = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.formLeisureTime.allDay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.formLeisureTime.allDay = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("od")]), _vm._v(" "), _c('timepicker', {
      attrs: {
        "minute-interval": 10,
        "format": "H:mm",
        "disabled": ""
      },
      model: {
        value: (_vm.formLeisureTime.timeFrom),
        callback: function($$v) {
          _vm.formLeisureTime.timeFrom = $$v
        },
        expression: "formLeisureTime.timeFrom"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("do")]), _vm._v(" "), _c('timepicker', {
      attrs: {
        "minute-interval": 10,
        "format": "H:mm",
        "disabled": ""
      },
      model: {
        value: (_vm.formLeisureTime.timeTo),
        callback: function($$v) {
          _vm.formLeisureTime.timeTo = $$v
        },
        expression: "formLeisureTime.timeTo"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("poznámka")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formLeisureTime.note),
        expression: "formLeisureTime.note"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "leisureTimeNote",
        "placeholder": "poznámka"
      },
      domProps: {
        "value": (_vm.formLeisureTime.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.formLeisureTime.note = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.updatedLeisureTimePending === false && _vm.possibleToSave === true) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Uložit")]) : (_vm.updatedLeisureTimePending === false) ? _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "type": "submit",
        "disabled": "disabled"
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])], 1)])]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1 text-right"
    }, [(_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": 'calendar-leisure-delete-' + lt.id
      },
      on: {
        "click": function($event) {
          _vm.deleteLeisureTime(lt.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (_vm.editingId === lt.id) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      on: {
        "click": function($event) {
          _vm.setEditingLeisureTime(lt)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : (_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'calendar-leisure-edit-' + lt.id
      },
      on: {
        "click": function($event) {
          _vm.setEditingLeisureTime(lt)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editingId === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('form', {
    attrs: {
      "data-testid": "calendar-leisure-add-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitFormAddLeisureTime($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("datum")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput"
    },
    model: {
      value: (_vm.formLeisureTime.valid),
      callback: function($$v) {
        _vm.formLeisureTime.valid = $$v
      },
      expression: "formLeisureTime.valid"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                                                      Celý den: \n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLeisureTime.allDay),
      expression: "formLeisureTime.allDay"
    }],
    attrs: {
      "type": "checkbox",
      "data-testid": "calendar-leisure-all-day"
    },
    domProps: {
      "checked": Array.isArray(_vm.formLeisureTime.allDay) ? _vm._i(_vm.formLeisureTime.allDay, null) > -1 : (_vm.formLeisureTime.allDay)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formLeisureTime.allDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formLeisureTime.allDay = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formLeisureTime.allDay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formLeisureTime.allDay = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("od")]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "minute-interval": 10,
      "format": "H:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.formLeisureTime.timeFrom),
      callback: function($$v) {
        _vm.formLeisureTime.timeFrom = $$v
      },
      expression: "formLeisureTime.timeFrom"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("do")]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "minute-interval": 10,
      "format": "H:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.formLeisureTime.timeTo),
      callback: function($$v) {
        _vm.formLeisureTime.timeTo = $$v
      },
      expression: "formLeisureTime.timeTo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("poznámka")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLeisureTime.note),
      expression: "formLeisureTime.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "leisureTimeNote",
      "placeholder": "poznámka",
      "data-testid": "calendar-leisure-note"
    },
    domProps: {
      "value": (_vm.formLeisureTime.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formLeisureTime.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newLeisureTimePending === false && _vm.possibleToSave === true) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "data-testid": "calendar-leisure-add"
    }
  }, [_vm._v("Přidat")]) : (_vm.newLeisureTimePending === false) ? _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "type": "submit",
      "disabled": "disabled"
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])], 1)])])]) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkingTime_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4d17c0e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_WorkingTime_vue__ = __webpack_require__(446);
function injectStyle (ssrContext) {
  __webpack_require__(444)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4d17c0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkingTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4d17c0e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_WorkingTime_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      workingTime: null,
      workingTimePending: true,
      workingTimeError: false,
      newWorkingTime: {},
      newWorkingTimeError: false,
      newWorkingTimePending: false,
      newWorkingTimeDone: false,
      updatedWorkingTime: {},
      originalWorkingTime: {},
      formWorkingTime: {
        branchId: null,
        id: null,
        timeFrom: {
          H: '',
          mm: ''
        },
        timeTo: {
          H: '',
          mm: ''
        },
        validFrom: null,
        validTo: null,
        note: '',
        repeating: null
      },
      updatedWorkingTimeError: false,
      updatedWorkingTimePending: false,
      updatedWorkingTimeDone: false,
      deleteWorkingTimeError: false,
      deleteWorkingTimePending: false,
      deleteWorkingTimeDone: false,
      editingId: false,

      branches: false,
      branchesPending: false,
      branchesError: false,

      disabledDateFrom: {
        customPredictor: function customPredictor(date) {
          if (date.getDay() !== 1) {
            return true;
          }
        }
      },
      disabledDateTo: {
        customPredictor: function customPredictor(date) {
          if (date.getDay() !== 0) {
            return true;
          }
        }
      }
    };
  },

  props: ['opened', 'doctorId'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  methods: {
    beforeOpen: function beforeOpen() {
      this.getDoctorsWorkingTime(this.doctorId);
      this.getBranches();
    },
    setEditingWorkingTime: function setEditingWorkingTime(workingTime) {
      if (this.editingId === false) {
        this.formWorkingTime.validFrom = this.$moment(workingTime.valid_from, 'D.M.YYYY').toDate();
        this.formWorkingTime.validTo = this.$moment(workingTime.valid_to, 'D.M.YYYY').toDate();
        this.formWorkingTime.day = workingTime.day;
        this.formWorkingTime.timeFrom.H = this.calculateHourFromWindow(workingTime.time_window) + '';
        this.formWorkingTime.timeFrom.mm = (this.calculateMinuteFromWindow(workingTime.time_window) + '').padStart(2, '0');
        this.formWorkingTime.timeTo.H = this.calculateHourFromWindow(workingTime.time_window + workingTime.duration) % 24 + '';
        this.formWorkingTime.timeTo.mm = (this.calculateMinuteFromWindow(workingTime.time_window + workingTime.duration) + '').padStart(2, '0');
        this.formWorkingTime.note = workingTime.note;
        this.formWorkingTime.branchId = workingTime.branch.id;
        this.formWorkingTime.allDay = workingTime.all_day;
        if (workingTime.odd_week === true && workingTime.even_week === true) {
          this.formWorkingTime.repeating = 2;
        } else if (workingTime.odd_week === true) {
          this.formWorkingTime.repeating = 0;
        } else {
          this.formWorkingTime.repeating = 1;
        }
        this.editingId = workingTime.id;
        this.originalWorkingTime = this.populateToSave(this.formWorkingTime);
      } else {
        this.formWorkingTime = {
          id: null,
          timeFrom: {
            H: '',
            mm: ''
          },
          timeTo: {
            H: '',
            mm: ''
          },
          validFrom: null,
          validTo: null,
          note: '',
          repeating: null,
          branchId: null
        };
        this.editingId = false;
      }
    },
    calculateHourFromWindow: function calculateHourFromWindow(window) {
      return Math.floor((window - 1) / 12);
    },
    calculateMinuteFromWindow: function calculateMinuteFromWindow(window) {
      return (window - 1) % 12 * 5;
    },
    calculateWindowFromTime: function calculateWindowFromTime(hours, minutes) {
      return hours * 12 + minutes / 5 + 1;
    },
    calculateWindowDurationFromTime: function calculateWindowDurationFromTime(hoursFrom, minutesFrom, hoursTo, minutesTo) {
      if (hoursTo + '' + minutesTo === '000') {
        hoursTo = 24;
      }
      return this.calculateWindowFromTime(hoursTo, minutesTo) - this.calculateWindowFromTime(hoursFrom, minutesFrom);
    },

    isTimeFilled: function isTimeFilled(from, to) {
      return from.H !== '' && from.mm !== '' && to.H !== '' && to.mm !== '';
    },
    isDurationPositive: function isDurationPositive(from, to) {
      return this.calculateWindowDurationFromTime(from.H, from.mm, to.H, to.mm) > 0;
    },
    tryPopulateFromForm: function tryPopulateFromForm() {
      if (this.possibleToSave === true) {
        if (this.editingId !== false) {
          this.updatedWorkingTime = this.populateToSave(this.formWorkingTime);
        } else {
          this.newWorkingTime = this.populateToSave(this.formWorkingTime);
          delete this.newWorkingTime.id;
        }
      } else {
        this.updatedWorkingTime = {};
      }
    },
    populateToSave: function populateToSave(formData) {
      var saveData = {};
      saveData.time_window = this.calculateWindowFromTime(formData.timeFrom.H, formData.timeFrom.mm);
      saveData.duration = this.calculateWindowDurationFromTime(formData.timeFrom.H, formData.timeFrom.mm, formData.timeTo.H, formData.timeTo.mm);
      saveData.id = this.editingId;
      saveData.valid_from = this.$moment(formData.validFrom).format('L');
      saveData.valid_to = this.$moment(formData.validTo).format('L');
      saveData.branch_id = formData.branchId;

      if (formData.repeating === 0) {
        saveData.odd_week = true;
        saveData.even_week = false;
      } else if (formData.repeating === 1) {
        saveData.odd_week = false;
        saveData.even_week = true;
      } else {
        saveData.odd_week = true;
        saveData.even_week = true;
      }
      saveData.note = formData.note;
      saveData.day = formData.day;
      return saveData;
    },
    submitFormUpdateWorkingTime: function submitFormUpdateWorkingTime() {
      this.putWorkingTime(this.updatedWorkingTime);
    },
    submitFormAddWorkingTime: function submitFormAddWorkingTime() {
      this.postWorkingTime(this.newWorkingTime, this.doctorId);
    },
    getDayNumToCS: function getDayNumToCS(num) {
      return this.$moment().day(num + 1).format('dddd');
    },
    getWeeksRepeatCS: function getWeeksRepeatCS(odd, even) {
      if (odd === true && even === true) {
        return 'každý týden';
      } else if (odd === true) {
        return 'lichý týden';
      } else if (even === true) {
        return 'sudý týden';
      } else {
        return 'žádný týden';
      }
    }
  },
  watch: {
    'formWorkingTime.timeFrom': function formWorkingTimeTimeFrom() {
      this.tryPopulateFromForm();
    },
    'formWorkingTime.timeTo': function formWorkingTimeTimeTo() {
      this.tryPopulateFromForm();
    },
    'formWorkingTime.validFrom': function formWorkingTimeValidFrom() {
      this.tryPopulateFromForm();
    },
    'formWorkingTime.validTo': function formWorkingTimeValidTo() {
      this.tryPopulateFromForm();
    },
    'formWorkingTime.day': function formWorkingTimeDay() {
      this.tryPopulateFromForm();
    },
    'formWorkingTime.note': function formWorkingTimeNote() {
      this.tryPopulateFromForm();
    },
    'formWorkingTime.branchId': function formWorkingTimeBranchId() {
      this.tryPopulateFromForm();
    },
    'formWorkingTime.repeating': function formWorkingTimeRepeating() {
      this.tryPopulateFromForm();
    },
    newWorkingTimeDone: function newWorkingTimeDone(val) {
      this.newWorkingTime = {};
      if (val === true) {
        this.getDoctorsWorkingTime(this.doctorId);
        this.newWorkingTimeDone = false;
      }
    },
    deleteWorkingTimeDone: function deleteWorkingTimeDone(val) {
      if (val === true) {
        this.getDoctorsWorkingTime(this.doctorId);
        this.deleteWorkingTimeDone = false;
      }
    },
    updatedWorkingTimeDone: function updatedWorkingTimeDone(val) {
      if (val === true) {
        this.$emit('working-time-updated');
        this.editingId = false;
        this.updatedWorkingTime = {};
        this.getDoctorsWorkingTime(this.doctorId);
        this.updatedWorkingTimeDone = false;
      }
    },
    branchesPending: function branchesPending(val) {
      if (val === false) {
        for (var i = 0; i < this.branches.length; i++) {
          if (this.branches[i].default === true) {
            this.formWorkingTime.branchId = this.branches[i].id;
          }
        }
      }
    }
  },
  computed: {
    possibleToSave: function possibleToSave() {
      return this.isDurationPositive(this.formWorkingTime.timeFrom, this.formWorkingTime.timeTo) && this.isTimeFilled(this.formWorkingTime.timeFrom, this.formWorkingTime.timeTo) || this.formWorkingTime.allDay === true;
    },
    formChanged: function formChanged() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.originalWorkingTime) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.updatedWorkingTime);
    }
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "90%",
      "scrollable": true,
      "name": "calendar-working-time",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "calendar-working-time-dialog"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Přehled pracovních termínů\n    ")]), _vm._v(" "), (_vm.workingTimePending) ? _c('div', {
    staticClass: "card-body"
  }) : _c('div', {
    staticClass: "card-body"
  }, [(_vm.workingTime.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("platné od")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("platné do")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("den / opakování")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("čas od - do")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("délka")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("pobočka")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("poznámka")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.workingTime), function(wt) {
    return [_c('tr', {
      staticClass: "row m-0 text-left",
      attrs: {
        "data-testid": 'calendar-working-time-row-' + wt.id
      }
    }, [(_vm.editingId !== wt.id) ? [_c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v(_vm._s(wt.valid_from))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v(_vm._s(wt.valid_to))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(_vm.getDayNumToCS(wt.day)) + " / " + _vm._s(_vm.getWeeksRepeatCS(wt.odd_week, wt.even_week)))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(wt.time_from) + " - " + _vm._s(wt.time_to))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(_vm._f("minutesToCsTime")(wt.duration * 5)))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v(_vm._s(wt.branch ? wt.branch.label : ''))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(wt.note))])] : _c('td', {
      staticClass: "col-sm-11"
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.submitFormUpdateWorkingTime($event)
        }
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("platné od")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "placeholder": "vybrat datum",
        "format": "dd.MM.yyyy",
        "language": "cs",
        "monday-first": true,
        "full-month-name": true,
        "name": "chooseDate",
        "input-class": "datapickerInput",
        "disabled": _vm.disabledDateFrom
      },
      model: {
        value: (_vm.formWorkingTime.validFrom),
        callback: function($$v) {
          _vm.formWorkingTime.validFrom = $$v
        },
        expression: "formWorkingTime.validFrom"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("do")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "placeholder": "vybrat datum",
        "format": "dd.MM.yyyy",
        "language": "cs",
        "monday-first": true,
        "full-month-name": true,
        "name": "chooseDate",
        "input-class": "datapickerInput",
        "disabled": _vm.disabledDateTo
      },
      model: {
        value: (_vm.formWorkingTime.validTo),
        callback: function($$v) {
          _vm.formWorkingTime.validTo = $$v
        },
        expression: "formWorkingTime.validTo"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("den")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formWorkingTime.day),
        expression: "formWorkingTime.day"
      }],
      staticClass: "form-control mr-sm-2",
      attrs: {
        "aria-describedby": "doctorHelp",
        "id": "day",
        "placeholder": "vybrat den"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.formWorkingTime.day = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((7), function(n) {
      return _c('option', {
        domProps: {
          "value": n - 1
        }
      }, [_vm._v(_vm._s(_vm.getDayNumToCS(n - 1)))])
    })), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("týden")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formWorkingTime.repeating),
        expression: "formWorkingTime.repeating"
      }],
      staticClass: "form-control mr-sm-2",
      attrs: {
        "aria-describedby": "doctorHelp",
        "id": "repeating",
        "placeholder": "vybrat týden"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.formWorkingTime.repeating = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("lichý")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("sudý")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("každý")])]), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("čas od")]), _vm._v(" "), _c('timepicker', {
      attrs: {
        "minute-interval": 10,
        "format": "H:mm",
        "disabled": ""
      },
      model: {
        value: (_vm.formWorkingTime.timeFrom),
        callback: function($$v) {
          _vm.formWorkingTime.timeFrom = $$v
        },
        expression: "formWorkingTime.timeFrom"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("do")]), _vm._v(" "), _c('timepicker', {
      attrs: {
        "minute-interval": 10,
        "format": "H:mm",
        "disabled": ""
      },
      model: {
        value: (_vm.formWorkingTime.timeTo),
        callback: function($$v) {
          _vm.formWorkingTime.timeTo = $$v
        },
        expression: "formWorkingTime.timeTo"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("pobočka")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formWorkingTime.branchId),
        expression: "formWorkingTime.branchId"
      }],
      staticClass: "form-control mr-sm-2",
      attrs: {
        "aria-describedby": "branchHelp",
        "id": "branch",
        "placeholder": "vybrat pobočku"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.formWorkingTime.branchId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "disabled": "",
        "selected": ""
      }
    }, [_vm._v("pobočka")]), _vm._v(" "), _vm._l((_vm.branches), function(row) {
      return _c('option', {
        domProps: {
          "value": row.id
        }
      }, [_vm._v(_vm._s(row.label))])
    })], 2), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("poznámka")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formWorkingTime.note),
        expression: "formWorkingTime.note"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "workingTimeNote",
        "placeholder": "poznámka"
      },
      domProps: {
        "value": (_vm.formWorkingTime.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.formWorkingTime.note = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.updatedWorkingTimePending === false && _vm.possibleToSave === true) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Uložit")]) : (_vm.updatedWorkingTimePending === false) ? _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "type": "submit",
        "disabled": "disabled"
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])], 1)])]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1 text-right"
    }, [(_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": 'calendar-working-time-delete-' + wt.id
      },
      on: {
        "click": function($event) {
          _vm.deleteWorkingTime(wt.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (_vm.editingId === wt.id) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      on: {
        "click": function($event) {
          _vm.setEditingWorkingTime(wt)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : (_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'calendar-working-time-edit-' + wt.id
      },
      on: {
        "click": function($event) {
          _vm.setEditingWorkingTime(wt)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 2)]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editingId === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('form', {
    attrs: {
      "data-testid": "calendar-working-time-add-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitFormAddWorkingTime($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("platné od")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput",
      "disabled": _vm.disabledDateFrom
    },
    model: {
      value: (_vm.formWorkingTime.validFrom),
      callback: function($$v) {
        _vm.formWorkingTime.validFrom = $$v
      },
      expression: "formWorkingTime.validFrom"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("do")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput",
      "disabled": _vm.disabledDateTo
    },
    model: {
      value: (_vm.formWorkingTime.validTo),
      callback: function($$v) {
        _vm.formWorkingTime.validTo = $$v
      },
      expression: "formWorkingTime.validTo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("den")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formWorkingTime.day),
      expression: "formWorkingTime.day"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "day",
      "placeholder": "vybrat den"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.formWorkingTime.day = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((7), function(n) {
    return _c('option', {
      domProps: {
        "value": n - 1
      }
    }, [_vm._v(_vm._s(_vm.getDayNumToCS(n - 1)))])
  })), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("týden")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formWorkingTime.repeating),
      expression: "formWorkingTime.repeating"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "repeating",
      "placeholder": "vybrat týden"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.formWorkingTime.repeating = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("lichý")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("sudý")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("každý")])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("čas od")]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "minute-interval": 10,
      "format": "H:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.formWorkingTime.timeFrom),
      callback: function($$v) {
        _vm.formWorkingTime.timeFrom = $$v
      },
      expression: "formWorkingTime.timeFrom"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("do")]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "minute-interval": 10,
      "format": "H:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.formWorkingTime.timeTo),
      callback: function($$v) {
        _vm.formWorkingTime.timeTo = $$v
      },
      expression: "formWorkingTime.timeTo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("pobočka")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formWorkingTime.branchId),
      expression: "formWorkingTime.branchId"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "branchHelp",
      "id": "branch",
      "placeholder": "vybrat pobočku"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.formWorkingTime.branchId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("pobočka")]), _vm._v(" "), _vm._l((_vm.branches), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.label))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("poznámka")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formWorkingTime.note),
      expression: "formWorkingTime.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "workingTimeNote",
      "placeholder": "poznámka",
      "data-testid": "calendar-working-time-note"
    },
    domProps: {
      "value": (_vm.formWorkingTime.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formWorkingTime.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newWorkingTimePending === false && _vm.possibleToSave === true) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "data-testid": "calendar-working-time-add"
    }
  }, [_vm._v("Přidat")]) : (_vm.newWorkingTimePending === false) ? _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "type": "submit",
      "disabled": "disabled"
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])], 1)])])]) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "calendar-page"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "doctor"
    }
  }, [_vm._v("Kalendář")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctorId),
      expression: "doctorId"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "calendar-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.doctorId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit doktora")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2)])]), _vm._v(" "), (_vm.doctorId) ? _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-primary",
    attrs: {
      "type": "button",
      "data-testid": "calendar-edit-leisure"
    },
    on: {
      "click": _vm.showModalCalendarLeisureTime
    }
  }, [_c('i', {
    staticClass: "fa fa-smile-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upravit volno")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-outline-primary",
    attrs: {
      "type": "button",
      "data-testid": "calendar-edit-working-time"
    },
    on: {
      "click": _vm.showModalCalendarWorkingTime
    }
  }, [_c('i', {
    staticClass: "fa fa-suitcase",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upravit pracovní dobu")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-testid": "calendar-previous-week"
    },
    on: {
      "click": function($event) {
        _vm.previousPeriod()
      }
    }
  }, [_vm._v("Předchozí týden")])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "mr-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "data-testid": "calendar-current-week"
    },
    on: {
      "click": _vm.actualPeriod
    }
  }, [_vm._v("Aktuální týden")])]), _vm._v(" "), _c('div', {}, [_c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput",
      "data-testid": "calendar-date"
    },
    on: {
      "input": function($event) {
        _vm.manualSelectDate($event)
      }
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-testid": "calendar-next-week"
    },
    on: {
      "click": function($event) {
        _vm.nextPeriod()
      }
    }
  }, [_vm._v("Následující týden")])])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "h4",
    attrs: {
      "data-testid": "calendar-week-range"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.get_params.from) + " - " + _vm._s(_vm.get_params.to) + " (" + _vm._s((_vm.moment(this.start_date).isoWeek()) % 2 === 1 ? 'lichý' : 'sudý') + ")\n            ")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "div_table"
  }, [_c('table', {
    staticClass: "table table_calendar",
    attrs: {
      "data-testid": "calendar-grid"
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / _vm.windowsPerHour)), function(times, index) {
    return _c('th', {
      attrs: {
        "colspan": _vm.windowsPerHour
      }
    }, [_vm._v("\n                        " + _vm._s((index + _vm.startHour) < 10 ? '0' + (index + _vm.startHour) : (index + _vm.startHour)) + "\n                    ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / (_vm.windowsPerHour / 2))), function(times, index) {
    return _c('th', {
      staticClass: "halfHour",
      attrs: {
        "colspan": (_vm.windowsPerHour / 2)
      }
    }, [_vm._v("\n                         \n                    ")])
  })], 2), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.calendar !== false) ? _c('tbody', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._l((7), function(n) {
    return [_c('tr', [_c('td', {
      attrs: {
        "data-testid": 'calendar-day-' + _vm.moment(_vm.render_start_date).add(n - 1, 'days').format('YYYY-MM-DD')
      },
      on: {
        "click": function($event) {
          _vm.getVisitsForDay(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('L'))
        }
      }
    }, [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ({
            content: _vm.calendar[n - 1][cell + _vm.startWindow - 1]['visit'].length > 0 ? _vm.windowsHoverVisits(_vm.calendar[n - 1][cell + _vm.startWindow - 1]['visit']) : '',
            placement: 'bottom-center',
            classes: ['info']
          }),
          expression: "{\n                              content: calendar[n-1][cell + startWindow - 1]['visit'].length > 0 ? windowsHoverVisits(calendar[n-1][cell + startWindow - 1]['visit']) : '',\n                              placement: 'bottom-center',\n                              classes: ['info']}"
        }],
        class: _vm.getRightClassForTd(_vm.calendar[n - 1][cell + _vm.startWindow - 1]) + ' ' + ((cell % _vm.windowsPerHour === 0) ? 'hourly' : '') + ' ' + ((cell % _vm.windowsPerHour === _vm.windowsPerHour / 2) ? 'halfhourly' : ''),
        attrs: {
          "data-window-id": (n - 1) + '_' + (_vm.startWindow + cell - 1),
          "data-testid": 'calendar-cell-' + (n - 1) + '-' + (_vm.startWindow + cell - 1)
        },
        on: {
          "click": function($event) {
            _vm.getVisitsForWindow(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('L'), _vm.startWindow + cell - 1)
          }
        }
      }, [_vm._v("\n                       \n                      "), _vm._l((_vm.calendar[n - 1][cell + _vm.startWindow - 1]['visit']), function(visit) {
        return [_c('div', {
          staticStyle: {
            "position": "relative"
          }
        }, [_c('div', {
          staticClass: "visit_slot",
          staticStyle: {
            "position": "absolute"
          },
          style: ({
            backgroundColor: '#' + visit.visit_purpose.color,
            top: visit.row_slot_number * 6 + 'px'
          }),
          attrs: {
            "title": _vm.visitSlotHover(visit),
            "data-testid": 'calendar-visit-strip-' + visit.id
          }
        })])]
      })], 2)
    })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return [(_vm.calendar[n - 1][cell + _vm.startWindow - 1]['skipNote'] === 0 || _vm.calendar[n - 1][cell + _vm.startWindow - 1]['type'] !== 'work') ? _c('td', {
        staticStyle: {
          "position": "relative"
        },
        attrs: {
          "colspan": _vm.calendar[n - 1][cell + _vm.startWindow - 1]['note'] ? _vm.calendar[n - 1][cell + _vm.startWindow - 1]['note']['windowsCount'] : 1
        }
      }, [_c('div', {
        staticStyle: {
          "position": "absolute",
          "overflow": "hidden",
          "text-overflow": "ellipsis",
          "width": "100%",
          "text-align": "center"
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.calendar[n - 1][cell + _vm.startWindow - 1]['note'] ? _vm.calendar[n - 1][cell + _vm.startWindow - 1]['note']['text'] : '') + "\n                        ")])]) : _vm._e()]
    })], 2)]
  })], 2) : _c('tbody', _vm._l((7), function(n) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        staticClass: "blank_windows"
      }, [_vm._v("\n                             \n                        ")])
    })], 2)
  }))]), _vm._v(" "), (_vm.calendar === false || _vm.calendarPending === true) ? _c('div', {
    staticClass: "table_overlay"
  }, [(_vm.calendarPending === true) ? _c('div', {}, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : (_vm.calendar === false) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.visits.length > 0) ? _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "calendar-visits"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_vm._l(((_vm.visits)), function(visit, index) {
    return [_c('tr', {
      attrs: {
        "data-testid": 'calendar-visit-' + visit.id
      }
    }, [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "rowspan": "2"
      }
    }, [(visit.state === 'scheduled') ? _c('i', {
      staticClass: "fa fa-2x fa-circle-o text-info",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'arrived') ? _c('i', {
      staticClass: "fa fa-2x fa-clock-o text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'completed') ? _c('i', {
      staticClass: "fa fa-2x fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'elaborated') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'failed') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'excused') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'canceled') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(visit.hasData) ? [_c('button', {
      staticClass: "btn btn-sm btn_extra_small btn-primary",
      on: {
        "click": function($event) {
          _vm.showHideVisitDetail(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v("\n                        " + _vm._s(visit.date) + " od " + _vm._s(visit.timeFrom) + " do " + _vm._s(visit.timeTo) + " (" + _vm._s(_vm._f("minutesToCsTime")(visit.duration * 5)) + ")\n                    ")], 2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "colspan": "2"
      }
    }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('label', {
      attrs: {
        "for": "note"
      }
    }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.putVisit(visit)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingVisit.note),
        expression: "editingVisit.note"
      }],
      staticClass: "form-control ml-sm-1 mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "noteHelp",
        "id": "note"
      },
      domProps: {
        "value": (_vm.editingVisit.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingVisit.note = $event.target.value
        }
      }
    }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])])] : [_c('button', {
      staticClass: "btn btn-sm btn-link text-secondary",
      attrs: {
        "data-testid": 'calendar-visit-edit-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.editVisit(visit.note, visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "border-top-0",
      attrs: {
        "colspan": "3"
      }
    }, [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: visit.client.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(visit.client.first_name) + " " + _vm._s(visit.client.last_name))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(visit.client.p_i_n))]), _vm._v(" "), (visit.client.health_insurance) ? _c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v(_vm._s(visit.client.health_insurance.code))]) : _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybí zdrav. pojišťovna")]), _vm._v(" "), (visit.client.membership) ? _c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v(_vm._s(visit.client.membership.name))]) : _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" nemá program")]), _vm._v(" "), (visit.client.missing_data) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybějící údaje")]) : _vm._e(), _vm._v(" "), (visit.client.missing_contact) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybějící kontakty")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "border-top-0 text-right",
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v("\n                        " + _vm._s(visit.planned_for.fullname) + "\n                        ")])]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('tr', [_c('td', {
      staticClass: "border-top-0"
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {}, [_c('h6', [_vm._v("Výsledná zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? _vm._l((diagnose.actions), function(action) {
        return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                    " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                ")])])
      }) : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(6, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(visit.medicament.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                                              " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])])]) : _vm._e()]
  })], 2)])]) : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), _c('calendar-leisure-time', {
    attrs: {
      "opened": _vm.showModalCalendarLeisureTimeOpened,
      "doctor-id": _vm.doctorId
    },
    on: {
      "leisure-time-updated": _vm.loadCalendar
    }
  }), _vm._v(" "), _c('calendar-working-time', {
    attrs: {
      "opened": _vm.showModalCalendarWorkingTimeOpened,
      "doctor-id": _vm.doctorId
    },
    on: {
      "working-time-updated": _vm.loadCalendar
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "h4"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "h4"
  }, [_vm._v("Musíte zvolit doktora")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Datum / čas"), _c('br'), _vm._v("Klient")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('calendar')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Result_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406d0a1d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Result_vue__ = __webpack_require__(451);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Result_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406d0a1d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Result_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      resultInfoPending: false,
      resultInfoError: false,
      resultInfoDone: false,
      resultInfo: false,
      authForm: {
        password: '',
        hash: ''
      },
      resultAuthError: false,
      resultVerifyDone: false,
      resultVerifyPending: false,
      resultVerifyError: false,
      result: ''
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    test: function test() {
      this.pinExpTime = true;
    },
    loadResultInfo: function loadResultInfo() {
      this.getResultInfo(this.$route.query.h);
    },
    submitAuthForm: function submitAuthForm() {
      this.authForm.hash = this.$route.query.h;
      this.postResultVerify(this.authForm);
    }
  },
  beforeMount: function beforeMount() {
    this.loadResultInfo();
  },
  mounted: function mounted() {}
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [(_vm.resultVerifyDone === false) ? _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Ověření uživatele\n        ")]), _vm._v(" "), (_vm.resultInfoDone === true) ? _c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.resultInfo.client.anonymised_data))])]) : _vm._e(), _vm._v(" "), (_vm.resultInfoDone === true) ? _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitAuthForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputPassword1"
    }
  }, [_vm._v("Heslo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authForm.password),
      expression: "authForm.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "clientPin",
      "placeholder": "Heslo"
    },
    domProps: {
      "value": (_vm.authForm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.authForm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.resultAuthError) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "passwordError"
    }
  }, [_vm._v(_vm._s(_vm.resultAuthError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.resultInfo.client.client_auth.help) ? [_c('span', [_vm._v("Nápověda:")]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.resultInfo.client.client_auth.help))])])] : void 0], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "submitLogin"
    }
  }, [_vm._v("Ověřit")])])]) : _vm._e(), _vm._v(" "), (_vm.resultInfoError) ? _c('div', {
    staticClass: "card-body"
  }, [_c('span', [_vm._v(_vm._s(_vm.resultInfoError.lookup_error))])]) : _vm._e()])]) : (_vm.result) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.result.evaluation) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(0), _c('br'), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.result.evaluation))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._m(1), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-4",
    staticStyle: {
      "white-space": "pre-wrap",
      "font-family": "monospace, monospace"
    },
    attrs: {
      "id": "result_text"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.result.result)
    }
  })])])]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Hodnocení lékařem:")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Detalní laboratorní zpráva:")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af1803c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__ = __webpack_require__(455);
function injectStyle (ssrContext) {
  __webpack_require__(453)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0af1803c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af1803c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      completedStep: null,
      clientId: null,
      clientIdFromFirstStep: null
    };
  },

  methods: {
    setClientId: function setClientId(value) {
      this.clientIdFromFirstStep = value;
    },
    stepDone: function stepDone(value) {
      this.completedStep = value;
      if (value === 1) {
        this.clientId = this.clientIdFromFirstStep;
        this.$router.push({ name: 'RegistrationClientSelectInsurance', params: { clientid: this.clientId } });
      } else if (value === 2) {
        this.clientId = this.$route.params.clientid;
        this.$router.push({ name: 'RegistrationClientSelectEmail', params: { clientid: this.clientId } });
      } else if (value === 3) {
        this.clientId = this.$route.params.clientid;
        this.$router.push({ name: 'RegistrationClientSelectPhone', params: { clientid: this.clientId } });
      } else if (value === 4) {
        this.clientId = this.$route.params.clientid;
        this.$router.push({ name: 'RegistrationClientSelectAddress', params: { clientid: this.clientId } });
      }
    }
  },
  beforeMount: function beforeMount() {},

  watch: {}
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('div', [_c('span', {
    staticClass: "badge",
    class: _vm.$route.meta.step === 1 ? 'badge-primary' : 'badge-secondary'
  }, [_vm._v("1.")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "badge",
    class: _vm.$route.meta.step === 2 ? 'badge-primary' : 'badge-secondary'
  }, [_vm._v("2.")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "badge",
    class: _vm.$route.meta.step === 3 ? 'badge-primary' : 'badge-secondary'
  }, [_vm._v("3.")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "badge",
    class: _vm.$route.meta.step === 4 ? 'badge-primary' : 'badge-secondary'
  }, [_vm._v("4.")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "badge",
    class: _vm.$route.meta.step === 5 ? 'badge-primary' : 'badge-secondary'
  }, [_vm._v("5.")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header text-center",
    attrs: {
      "data-testid": "registration-step-label"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$route.meta.label) + "\n      ")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('router-view', {
    on: {
      "completed-step": _vm.stepDone,
      "client-id": _vm.setClientId
    }
  })], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationClient_vue__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c68e8e4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationClient_vue__ = __webpack_require__(459);
function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c68e8e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationClient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c68e8e4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationClient_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      clientError: {},
      clientPending: false,
      client: {
        gender: 'unknown',
        first_name: '',
        last_name: '',
        p_i_n: '',
        citizenship: 1,
        birth_date: '',

        birthplace: '',
        insurance: {
          company_code: '',
          type: 1
        }
      },
      citizenshipError: {},
      birthDateCalculated: false,
      insuranceFound: false,

      setting: __webpack_require__(3),
      clientid: '',
      waitForResponse: false,
      waitForData: false,
      decodePinPending: false,
      message: '',
      submited: '',
      countries: [],
      citizenship: [],
      healthinsurance: [],
      pinDecodeError: false,
      pinDecodeWarning: false,

      insuranceCompanies: {},
      insuranceCompaniesError: {},
      selectedInsuranceCompany: null,
      insurancePending: false,
      insuranceError: {},
      insurance: {
        insurancecompany: null,
        valid_from: '',
        type: 1
      }
    };
  },

  methods: {
    submitForm: function submitForm() {
      this.postClient();
    },
    getCitizenship: function getCitizenship() {
      var _this = this;

      this.waitForData = true;
      this.$http.get(this.setting.hostname + 'citizenship').then(function (response) {
        _this.citizenship = response.data;

        _this.waitForData = false;
      }).catch(function (error) {
        console.log(error.response);
        _this.citizenshipError = error.response.data.errors;
        _this.waitForData = false;
      });
    },
    getInfoDecodePIN: function getInfoDecodePIN() {
      var _this2 = this;

      this.pinDecodeError = false;
      this.decodePinPending = true;
      this.insuranceFound = false;
      this.pinDecodeWarning = null;
      this.birthDateCalculated = false;
      this.insurance = {
        insurancecompany: null,
        valid_from: '',
        type: 1
      };
      this.$http.get(this.setting.hostname + 'validatepin', { params: { pin: this.client.p_i_n } }).then(function (response) {
        if (response.data.birth_date) {
          _this2.client.gender = response.data.gender;
          _this2.client.birth_date = response.data.birth_date;
          _this2.birthDateCalculated = true;
        }

        if (response.data.insurance !== null) {
          _this2.selectInsuranceCompany(response.data.insurance.company);
          _this2.client.insurance.type = response.data.insurance.type;
          _this2.client.insurance.company_code = response.data.insurance.company;
          _this2.insuranceFound = true;
        }

        _this2.pinDecodeError = false;
        _this2.message = '';
        _this2.pinDecodeWarning = response.data.warning;

        _this2.decodePinPending = false;
      }).catch(function (error) {
        _this2.pinDecodeError = error.response.data.error;
        _this2.decodePinPending = false;
      });
    },
    postClient: function postClient() {
      var _this3 = this;

      this.clientPending = true;

      var client = this.client;
      client.citizenship_id = this.client.citizenship;
      delete client.citizenship;

      this.$http.post(this.setting.hostname + 'client', client, { emulateJSON: true }).then(function (response) {
        _this3.submited = response.data;
        _this3.clientid = response.data.id;
        _this3.clientPending = false;
        _this3.$emit('client-id', _this3.clientid);
        _this3.$emit('completed-step', 1);
      }).catch(function (error) {
        _this3.clientError = error.response.data.errors;
        _this3.clientPending = false;
      });
    },
    selectInsuranceCompany: function selectInsuranceCompany(code) {
      for (var index = 0; index < this.insuranceCompanies.length; index++) {
        if (code === null && this.insuranceCompanies[index].code === '---') {
          this.selectedInsuranceCompany = this.insuranceCompanies[index];
          continue;
        }
        if (this.insuranceCompanies[index].code === code) {
          this.selectedInsuranceCompany = this.insuranceCompanies[index];
          continue;
        }
      }
    },
    getInsuranceCompanies: function getInsuranceCompanies() {
      var _this4 = this;

      this.waitForData = true;
      this.$http.get(this.setting.hostname + 'insurance_companies').then(function (response) {
        _this4.insuranceCompanies = response.data;
        _this4.waitForData = false;
      }).catch(function (error) {
        _this4.insuranceCompaniesError = error.response.data.errors;
        _this4.waitForData = false;
      });
    },
    customLabel: function customLabel(_ref) {
      var code = _ref.code,
          name = _ref.name;

      return code + ' \u2013 ' + name;
    }
  },
  beforeMount: function beforeMount() {
    this.getInsuranceCompanies();
    this.getCitizenship();
  },

  watch: {
    'client.p_i_n': function clientP_i_n(val, oldVal) {
      var _this5 = this;

      if (this.client.citizenship === 1) {
        this.client.p_i_n = val.replace(/\D/g, '');

        if (val !== this.client.p_i_n) {
          return;
        }

        if (val.length < 9) {
          this.message = 'příliš krátké';
          this.client.gender = 'unknown';
          this.client.birth_date = '';
        } else if (val.length > 10) {
          this.message = 'příliš dlouhé';
          this.client.gender = 'unknown';
          this.client.birth_date = '';
        } else {
          this.message = '<i class="fa fa-spinner fa-pulse fa-fw"></i>' + 'načítám';
          setTimeout(function () {
            _this5.getInfoDecodePIN();
          }, 500);
        }
      }
    },
    'selectedInsuranceCompany': function selectedInsuranceCompany(val) {
      this.client.insurance.company_code = val.code;
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(!_vm.waitForData) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "citizenshipGov"
    }
  }, [_vm._v("Státní příslušnost (občanství):")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.citizenship),
      expression: "client.citizenship"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "citizenshipGovHelp",
      "id": "citizenshipGov",
      "data-testid": "registration-citizenship"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.client.citizenship = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.citizenship), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.name_cz) + " - " + _vm._s(row.code) + " - " + _vm._s(row.name_en))])
  })), _vm._v(" "), (_vm.clientError.citizenship) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "citizenshipError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.citizenship.message))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "personalid"
    }
  }, [_vm._v("Rodné číslo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.client.p_i_n),
      expression: "client.p_i_n",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "personalidHelp",
      "id": "personalid",
      "data-testid": "registration-pin"
    },
    domProps: {
      "value": (_vm.client.p_i_n)
    },
    on: {
      "change": _vm.clientPINChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.p_i_n = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.pinDecodeWarning !== null) ? _c('div', {
    attrs: {
      "data-testid": "registration-pin-warnings"
    }
  }, _vm._l((_vm.pinDecodeWarning), function(warning, index) {
    return _c('div', [_c('small', {
      staticClass: "form-text text-danger"
    }, [_vm._v(_vm._s(warning.text))]), _vm._v(" "), (index === 'duplicate') ? _vm._l((warning.clients), function(client) {
      return _c('small', {
        staticClass: "form-text text-danger"
      }, [_vm._v(" - " + _vm._s(client.full_name))])
    }) : _vm._e()], 2)
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Jméno:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.first_name),
      expression: "client.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "firstnameHelp",
      "id": "firstname",
      "data-testid": "registration-first-name"
    },
    domProps: {
      "value": (_vm.client.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.first_name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.firstname) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "firstnameError",
      "data-testid": "registration-first-name-error"
    }
  }, [_vm._v(_vm._s(_vm.clientError.firstname.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Příjmení:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.last_name),
      expression: "client.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "lastnameHelp",
      "id": "lastname",
      "data-testid": "registration-last-name"
    },
    domProps: {
      "value": (_vm.client.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.last_name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.lastname) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "lastnameError",
      "data-testid": "registration-last-name-error"
    }
  }, [_vm._v(_vm._s(_vm.clientError.lastname.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Pohlaví:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.gender),
      expression: "client.gender"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "genderHelp",
      "id": "gender",
      "data-testid": "registration-gender",
      "disabled": _vm.birthDateCalculated
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.client.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("muž")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("žena")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("nezjištěno")])]), _vm._v(" "), (_vm.clientError.gender) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "genderError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.gender.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "birthdate"
    }
  }, [_vm._v("Datum narození:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.birth_date),
      expression: "client.birth_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "birthdateHelp",
      "id": "birthdate",
      "data-testid": "registration-birth-date",
      "disabled": _vm.birthDateCalculated
    },
    domProps: {
      "value": (_vm.client.birth_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.birth_date = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.birthdate) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "birthdateError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.birthdate.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "insuranceCompany"
    }
  }, [_vm._v("Zdravotní pojišťovna:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "insuranceCompany",
      "data-testid": "registration-insurance-company",
      "props": "options",
      "options": _vm.insuranceCompanies,
      "track-by": "name",
      "label": "name",
      "placeholder": "vybrat pojišťovnu",
      "option-height": 104,
      "open-direction": "down",
      "custom-label": _vm.customLabel,
      "show-labels": false,
      "TagPlaceholder": "",
      "allow-empty": true,
      "disabled": _vm.insuranceFound,
      "selectLabel": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          attrs: {
            "data-testid": 'registration-insurance-company-option-' + props.option.code
          }
        }, [_vm._v(_vm._s(_vm.customLabel(props.option)))])]
      }
    }]),
    model: {
      value: (_vm.selectedInsuranceCompany),
      callback: function($$v) {
        _vm.selectedInsuranceCompany = $$v
      },
      expression: "selectedInsuranceCompany"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceType"
    }
  }, [_vm._v("Druh: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.insurance.type),
      expression: "client.insurance.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "insuranceType",
      "data-testid": "registration-insurance-type",
      "disabled": _vm.insuranceFound
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.client.insurance.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + " - " + _vm._s(_vm._f("insuranceTypeIntToName")(n)))])
  }))], 1)]), _vm._v(" "), (_vm.client.citizenship !== 1) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "insuranceNumber"
    }
  }, [_vm._v("Číslo pojištěnce:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.nationality),
      expression: "client.nationality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "insuranceNumberHelp",
      "id": "insuranceNumber",
      "data-testid": "registration-insurance-number"
    },
    domProps: {
      "value": (_vm.client.nationality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.nationality = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.decodePinPending) ? _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Čekám")]) : (_vm.clientPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "registration-submit"
    }
  }, [_vm._v("Zaregistrovat klienta")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])]) : _vm._e(), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(0)]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationClientInsurance_vue__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e5ab86_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationClientInsurance_vue__ = __webpack_require__(463);
function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49e5ab86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationClientInsurance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e5ab86_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationClientInsurance_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      insuranceCompanies: {},
      insuranceCompaniesError: {},

      selectedInsuranceCompany: null,
      insurancePending: false,
      insuranceError: {},
      insurance: {
        insurancecompany: '',
        valid_from: '',
        type: 1
      },

      clientError: '',
      client: '',

      setting: __webpack_require__(3),
      clientid: '',
      waitForResponse: false,
      waitForData: false,
      decodePinPending: false,
      message: '',
      submited: '',
      countries: [],
      citizenship: [],
      healthinsurance: [],
      pinDecodeError: []
    };
  },

  methods: {
    submitForm: function submitForm() {
      if (this.selectedInsuranceCompany === null) {
        this.$emit('completed-step', 2);
      } else {
        this.postInsurance();
      }
    },
    getInsuranceCompanies: function getInsuranceCompanies() {
      var _this = this;

      this.waitForData = true;
      this.$http.get(this.setting.hostname + 'insurance_companies').then(function (response) {
        _this.insuranceCompanies = response.data;
        _this.waitForData = false;
      }).catch(function (error) {
        _this.insuranceCompaniesError = error.response.data.errors;
        _this.waitForData = false;
      });
    },
    customLabel: function customLabel(_ref) {
      var code = _ref.code,
          name = _ref.name;

      return code + ' \u2013 ' + name;
    },
    postInsurance: function postInsurance() {
      var _this2 = this;

      this.insurancePending = true;
      this.insurance.insurancecompany = this.selectedInsuranceCompany.code;
      this.insurance.valid_from = this.client.birth_date;
      this.$http.post(this.setting.hostname + 'client/' + this.$route.params.clientid + '/insurance', this.insurance, { emulateJSON: true }).then(function (response) {
        _this2.insurancePending = false;
        _this2.$emit('completed-step', 2);
      }).catch(function (error) {
        _this2.insuranceError = error.response.data.errors;
        _this2.insurancePending = false;
      });
    },
    getClient: function getClient() {
      var _this3 = this;

      this.waitForData = true;
      this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid).then(function (response) {
        _this3.client = response.data;
        _this3.waitForData = false;
        if (_this3.client.health_insurance !== null) {
          _this3.$emit('completed-step', 2);
        }
      }).catch(function (error) {
        _this3.clientError = error.response.data.errors;
        _this3.waitForData = false;
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getInsuranceCompanies();
    this.getClient();
  },

  watch: {}
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(!_vm.waitForData) ? _c('form', {
    attrs: {
      "data-testid": "registration-insurance-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "insuranceCompany"
    }
  }, [_vm._v("Zdravotní pojišťovna:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "insuranceCompany",
      "data-testid": "registration-insurance-company",
      "props": "options",
      "options": _vm.insuranceCompanies,
      "track-by": "name",
      "label": "name",
      "placeholder": "vybrat pojišťovnu",
      "option-height": 104,
      "open-direction": "down",
      "custom-label": _vm.customLabel,
      "show-labels": false,
      "TagPlaceholder": "",
      "allow-empty": true,
      "selectLabel": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          attrs: {
            "data-testid": 'registration-insurance-company-option-' + props.option.code
          }
        }, [_vm._v(_vm._s(_vm.customLabel(props.option)))])]
      }
    }]),
    model: {
      value: (_vm.selectedInsuranceCompany),
      callback: function($$v) {
        _vm.selectedInsuranceCompany = $$v
      },
      expression: "selectedInsuranceCompany"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceType"
    }
  }, [_vm._v("Druh: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.type),
      expression: "insurance.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "insuranceType",
      "data-testid": "registration-insurance-step-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + " - " + _vm._s(_vm._f("insuranceTypeIntToName")(n)))])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.selectedInsuranceCompany === null) ? _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "submit",
      "data-testid": "registration-insurance-skip"
    }
  }, [_vm._v("Přeskočit (bez pojištění)")]) : (_vm.insurancePending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "registration-insurance-save"
    }
  }, [_vm._v("Vybrat zdravotní pojišťovnu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])]) : _vm._e(), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(0)]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationClientEmail_vue__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6413c948_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationClientEmail_vue__ = __webpack_require__(467);
function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6413c948"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationClientEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6413c948_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationClientEmail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      emailAddressError: {},
      emailAddressPending: false,
      emailAddress: {
        email: '',
        default: true,
        note: ''
      },

      emailAddressesPending: false,
      emailAddresses: [],
      emailAddressesError: {},

      clientError: '',
      client: '',

      setting: __webpack_require__(3),
      clientid: '',
      waitForResponse: false,
      waitForData: false,
      decodePinPending: false,
      message: '',
      submited: '',
      countries: [],
      citizenship: [],
      healthinsurance: [],
      pinDecodeError: []
    };
  },

  methods: {
    submitForm: function submitForm() {
      this.postEmailAddress();
    },
    nextStep: function nextStep() {
      this.$emit('completed-step', 3);
    },
    getEmailAddresses: function getEmailAddresses() {
      var _this = this;

      this.emailAddressesPending = true;
      this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid + '/email_address').then(function (response) {
        _this.emailAddresses = response.data;
        _this.emailAddressesPending = false;
      }).catch(function (error) {
        _this.emailAddressesError = error.response.data.errors;
        _this.emailAddressesPending = false;
      });
    },
    postEmailAddress: function postEmailAddress() {
      var _this2 = this;

      this.emailAddressPending = true;
      this.$http.post(this.setting.hostname + 'client/' + this.$route.params.clientid + '/email_address', this.emailAddress, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        _this2.emailAddressPending = false;
        _this2.getEmailAddresses();
      }).catch(function (error) {
        _this2.emailAddressError = error.response.data.errors;
        _this2.emailAddressPending = false;
      });
    },
    getClient: function getClient() {
      var _this3 = this;

      this.waitForData = true;
      this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid).then(function (response) {
        _this3.client = response.data;
        _this3.waitForData = false;
        if (_this3.client.health_insurance !== null) {
          _this3.$emit('completed-step', 2);
        }
      }).catch(function (error) {
        _this3.clientError = error.response.data.errors;
        _this3.waitForData = false;
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getEmailAddresses();
  },

  watch: {}
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.emailAddresses.length > 0) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "data-testid": "registration-email-list"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.emailAddresses), function(emailAddr) {
    return [_c('tr', [_c('td', {
      staticClass: "align-middle"
    }, [_vm._v("\n                " + _vm._s(emailAddr.email) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(emailAddr.default === true ? 'výchozí' : '') + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(emailAddr.note) + "\n              ")])])]
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [(!_vm.waitForData) ? _c('form', {
    attrs: {
      "data-testid": "registration-email-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress.email),
      expression: "emailAddress.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "e-mailová adresa",
      "id": "emailAddress",
      "data-testid": "registration-email-address"
    },
    domProps: {
      "value": (_vm.emailAddress.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        Výchozí: \n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress.default),
      expression: "emailAddress.default"
    }],
    attrs: {
      "type": "checkbox",
      "aria-label": "Checkbox for following text input",
      "data-testid": "registration-email-default"
    },
    domProps: {
      "checked": Array.isArray(_vm.emailAddress.default) ? _vm._i(_vm.emailAddress.default, null) > -1 : (_vm.emailAddress.default)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.emailAddress.default,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.emailAddress.default = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.emailAddress.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.emailAddress.default = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress.note),
      expression: "emailAddress.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "emailAddressNote",
      "data-testid": "registration-email-note",
      "placeholder": "poznámka"
    },
    domProps: {
      "value": (_vm.emailAddress.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.emailAddressPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "registration-email-add"
    }
  }, [_vm._v("Přidat e-mail")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.emailAddressError.email) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "numberError",
      "data-testid": "registration-email-error"
    }
  }, [_vm._v(_vm._s(_vm.emailAddressError.email.message))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.emailAddressPending || _vm.emailAddressesPending) ? _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Čekám")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "registration-email-next"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Další krok "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(1)]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("E-mailová adresa")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationClientPhone_vue__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af48fbcc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationClientPhone_vue__ = __webpack_require__(471);
function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af48fbcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationClientPhone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af48fbcc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationClientPhone_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      phoneNumberError: {},
      phoneNumberPending: false,
      phoneNumber: {
        number: '',
        default: true,
        note: ''
      },
      selectedPhoneNumberPrefix: '+420',
      selectedPhoneNumber: '',

      phoneNumbersPending: false,
      phoneNumbers: [],
      phoneNumbersError: {},

      clientError: '',
      client: '',

      setting: __webpack_require__(3),
      clientid: '',
      waitForResponse: false,
      waitForData: false,
      decodePinPending: false,
      message: '',
      submited: '',
      countries: [],
      citizenship: [],
      healthinsurance: [],
      pinDecodeError: []
    };
  },

  methods: {
    submitForm: function submitForm() {
      this.postPhoneNumber();
    },
    nextStep: function nextStep() {
      this.$emit('completed-step', 4);
    },
    getPhoneNumbers: function getPhoneNumbers() {
      var _this = this;

      this.phoneNumbersPending = true;
      this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid + '/phone_number').then(function (response) {
        _this.phoneNumbers = response.data;
        _this.phoneNumbersPending = false;
      }).catch(function (error) {
        _this.phoneNumbersError = error.response.data.errors;
        _this.phoneNumbersPending = false;
      });
    },
    customLabel: function customLabel(_ref) {
      var code = _ref.code,
          name = _ref.name;

      return code + ' \u2013 ' + name;
    },
    postPhoneNumber: function postPhoneNumber() {
      var _this2 = this;

      this.phoneNumberPending = true;
      this.phoneNumber.number = this.selectedPhoneNumberPrefix + this.selectedPhoneNumber;
      this.$http.post(this.setting.hostname + 'client/' + this.$route.params.clientid + '/phone_number', this.phoneNumber, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        _this2.phoneNumberPending = false;
        _this2.getPhoneNumbers();
      }).catch(function (error) {
        _this2.phoneNumberError = error.response.data.errors;
        _this2.phoneNumberPending = false;
      });
    },
    getClient: function getClient() {
      var _this3 = this;

      this.waitForData = true;
      this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid).then(function (response) {
        _this3.client = response.data;
        _this3.waitForData = false;
        if (_this3.client.health_insurance !== null) {
          _this3.$emit('completed-step', 2);
        }
      }).catch(function (error) {
        _this3.clientError = error.response.data.errors;
        _this3.waitForData = false;
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getPhoneNumbers();
  },

  watch: {}
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.phoneNumbers.length > 0) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "data-testid": "registration-phone-list"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.phoneNumbers), function(phoneNum) {
    return [_c('tr', [_c('td', {
      staticClass: "align-middle"
    }, [_vm._v("\n                " + _vm._s(phoneNum.number) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(phoneNum.default === true ? 'výchozí' : '') + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(phoneNum.note) + "\n              ")])])]
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [(!_vm.waitForData) ? _c('form', {
    attrs: {
      "data-testid": "registration-phone-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.selectedPhoneNumberPrefix))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPhoneNumber),
      expression: "selectedPhoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "telefonní číslo",
      "id": "phoneNumber",
      "data-testid": "registration-phone-number"
    },
    domProps: {
      "value": (_vm.selectedPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPhoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        Výchozí: \n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber.default),
      expression: "phoneNumber.default"
    }],
    attrs: {
      "type": "checkbox",
      "aria-label": "Checkbox for following text input",
      "data-testid": "registration-phone-default"
    },
    domProps: {
      "checked": Array.isArray(_vm.phoneNumber.default) ? _vm._i(_vm.phoneNumber.default, null) > -1 : (_vm.phoneNumber.default)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.phoneNumber.default,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.phoneNumber.default = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.phoneNumber.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.phoneNumber.default = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber.note),
      expression: "phoneNumber.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phoneNumberf",
      "data-testid": "registration-phone-note",
      "placeholder": "poznámka"
    },
    domProps: {
      "value": (_vm.phoneNumber.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phoneNumberPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "registration-phone-add"
    }
  }, [_vm._v("Přidat telefon")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.phoneNumberError.number) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "numberError",
      "data-testid": "registration-phone-error"
    }
  }, [_vm._v(_vm._s(_vm.phoneNumberError.number.message))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.phoneNumberPending || _vm.phoneNumbersPending) ? _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Čekám")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "registration-phone-next"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Další krok "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(1)]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Telefonní číslo")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationClientAddress_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aff38a0_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationClientAddress_vue__ = __webpack_require__(475);
function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2aff38a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationClientAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aff38a0_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationClientAddress_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      addressDone: false,
      addressPending: false,
      addressError: false,
      address: {
        country: 1,
        street: '',
        house_number: '',
        city: '',
        zip_code: '',
        district: '',
        region: '',
        full_maps_data: null
      },

      setting: __webpack_require__(3),
      waitForResponse: false,
      waitForData: false,
      message: '',
      submited: '',
      countries: [],
      citizenship: [],
      healthinsurance: [],
      selected: '',
      addresses: [],
      foreignAddresses: [],
      foreignAddressDetail: {},
      toSearchText: '',
      toSearchForeignText: '',
      searchOutsideCzechia: false,
      foreignAddressDetailDone: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    submitForm: function submitForm() {
      this.postAddress(this.address, this.$route.params.clientid);
    },
    getResult: function getResult(text) {
      this.toSearchText = text;
    },
    getForeignAddressResult: function getForeignAddressResult(text) {
      this.toSearchForeignText = text;
    },
    openAddress: function openAddress(value) {
      this.address.street = value.values.STREET;
      this.address.house_number = value.values.NUMBER;
      this.address.city = value.values.CITY;
      this.address.zip_code = value.values.ZIP;
      this.address.district = value.values.DISTRICT;
      this.address.region = value.values.REGION;
    },
    openForeignAddress: function openForeignAddress(value) {
      this.getForeignAddressDetail(value.place_id);
    }
  },
  beforeMount: function beforeMount() {
    this.getCountries();
  },

  watch: {
    toSearchText: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (text) {
      this.searchAddresses(text);
    }, 500),
    addressDone: function addressDone(val) {
      if (val === true) {
        this.$router.push({ name: 'ShowClient', params: { clientid: this.$route.params.clientid } });
      }
    },
    searchOutsideCzechia: function searchOutsideCzechia(val) {
      if (val === true) {
        this.address.country = null;
      } else {
        this.address.country = 1;
      }
    },

    toSearchForeignText: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (text) {
      this.searchForeignAddresses(text);
    }, 1500),
    foreignAddressDetailDone: function foreignAddressDetailDone(val) {
      if (val === true) {
        this.addressForm.country = null;
        this.addressForm.street = '';
        this.addressForm.house_number = '';
        this.addressForm.city = '';
        this.addressForm.zip_code = '';
        this.addressForm.district = '';
        this.addressForm.region = '';
        this.addressForm.full_maps_data = null;

        var city = [];
        for (var i = 0, len = this.foreignAddressDetail.address_components.length; i < len; i++) {
          var addressPart = this.foreignAddressDetail.address_components[i];
          if (addressPart.types.includes('street_number')) {
            this.address.house_number = addressPart.long_name;
          }
          if (addressPart.types.includes('postal_code')) {
            this.address.zip_code = addressPart.long_name;
          }
          if (addressPart.types.includes('locality')) {
            city[0] = addressPart.long_name;
          }
          if (addressPart.types.includes('sublocality')) {
            city[1] = addressPart.long_name;
          }
          if (addressPart.types.includes('route')) {
            this.address.street = addressPart.long_name;
          }
          if (addressPart.types.includes('administrative_area_level_1')) {
            this.address.region = addressPart.long_name;
          }
          if (addressPart.types.includes('administrative_area_level_2')) {
            this.address.district = addressPart.long_name;
          }
        }
        city = city.filter(function (el) {
          return el != null;
        });
        this.address.city = city.join(', ');
        this.address.full_maps_data = this.foreignAddressDetail;
      }
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(!_vm.waitForData) ? _c('form', {
    attrs: {
      "data-testid": "registration-address-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-around"
  }, [_c('span', {
    attrs: {
      "data-testid": "registration-address-czech-label"
    }
  }, [_vm._v("Česká")]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-lg switch-text switch-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOutsideCzechia),
      expression: "searchOutsideCzechia"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "searchInCzechia",
      "data-testid": "registration-address-foreign-toggle"
    },
    domProps: {
      "checked": Array.isArray(_vm.searchOutsideCzechia) ? _vm._i(_vm.searchOutsideCzechia, null) > -1 : (_vm.searchOutsideCzechia)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.searchOutsideCzechia,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.searchOutsideCzechia = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.searchOutsideCzechia = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.searchOutsideCzechia = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "",
      "data-off": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "data-testid": "registration-address-foreign-label"
    }
  }, [_vm._v("zahraniční")])]), _vm._v(" "), (!_vm.searchOutsideCzechia) ? [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('multiselect', {
    attrs: {
      "reset-after": true,
      "id": "search",
      "data-testid": "registration-address-search-czech",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat adresu",
      "open-direction": "bottom",
      "options": _vm.addresses,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "clear-on-select": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getResult,
      "select": _vm.openAddress
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(_vm._s(props.option.values.WHOLE_ADDRESS))])]), _vm._v(" "), _c('div', {
          staticClass: "row m-0 font-sm"
        }, [_c('div', {
          staticClass: "col-sm-12"
        }, [_c('span', [_vm._v(_vm._s(props.option.values.DISTRICT))]), _vm._v(", \n                                                              "), _c('span', [_vm._v(_vm._s(props.option.values.REGION))])])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])] : [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('multiselect', {
    attrs: {
      "reset-after": true,
      "id": "searchForeign",
      "data-testid": "registration-address-search-foreign",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat adresu v cizině",
      "open-direction": "bottom",
      "options": _vm.foreignAddresses,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "clear-on-select": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getForeignAddressResult,
      "select": _vm.openForeignAddress
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(_vm._s(props.option.description))])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])], _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-9"
  }, [_c('label', {
    attrs: {
      "for": "street"
    }
  }, [_vm._v("Ulice")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.street),
      expression: "address.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "streetHelp",
      "id": "street",
      "data-testid": "registration-address-street",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.street = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.street) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "streetError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.street.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "houseNumber"
    }
  }, [_vm._v("Číslo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.house_number),
      expression: "address.house_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "houseNumberHelp",
      "id": "houseNumber",
      "data-testid": "registration-address-house-number",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.house_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.house_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.housenumber) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "houseNumberError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.housenumber.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "zip_code"
    }
  }, [_vm._v("PSČ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.zip_code),
      expression: "address.zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "zip_codeHelp",
      "id": "zip_code",
      "data-testid": "registration-address-zip-code",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.zip_code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.zipcode) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "zipCodeError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.zipcode.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Město")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.city),
      expression: "address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "cityHelp",
      "id": "city",
      "data-testid": "registration-address-city",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.city) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "cityError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.city.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "district"
    }
  }, [_vm._v("Okres")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.district),
      expression: "address.district"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "districtHelp",
      "id": "district",
      "data-testid": "registration-address-district",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.district)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.district = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.district) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "districtError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.district.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "region"
    }
  }, [_vm._v("Kraj")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.region),
      expression: "address.region"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "regionHelp",
      "id": "region",
      "data-testid": "registration-address-region",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.region = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.region) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "regionError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.region.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.addressPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "registration-address-save"
    }
  }, [_vm._v("Uložit adresu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])], 2) : _vm._e(), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(0)]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAddress_vue__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c5c052c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddAddress_vue__ = __webpack_require__(479);
function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c5c052c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c5c052c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddAddress_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      addressError: {},
      addressPending: false,
      address: {
        city: '',
        street: '',

        zip_code: '',
        country: 1
      },

      setting: __webpack_require__(3),
      waitForResponse: false,
      waitForData: false,
      message: '',
      submited: '',
      countries: [],
      citizenship: [],
      healthinsurance: []
    };
  },

  methods: {
    submitForm: function submitForm() {
      this.postAddress();
    },
    getCountries: function getCountries() {
      var _this = this;

      this.waitForData = true;
      this.$http.get(this.setting.hostname + 'country').then(function (response) {
        _this.countries = response.data;

        _this.waitForData = false;
      }, function (response) {
        _this.waitForData = false;
      });
    },
    postAddress: function postAddress() {
      var _this2 = this;

      this.addressPending = true;
      this.$http.post(this.setting.hostname + 'client/' + this.$route.params.clientid + '/address', this.address, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        _this2.addressPending = false;
      }).catch(function (error) {
        _this2.addressError = error.response.data.errors;
        _this2.addressPending = false;
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getCountries();
  },

  watch: {}
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Registrace klienta\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [(!_vm.waitForData) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "street"
    }
  }, [_vm._v("Ulice a čp.:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.street),
      expression: "address.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "streetHelp",
      "id": "street"
    },
    domProps: {
      "value": (_vm.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.street = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.street) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "streetError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.street.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Město:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.city),
      expression: "address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "cityHelp",
      "id": "city"
    },
    domProps: {
      "value": (_vm.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.city) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "cityError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.city.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "zipcode"
    }
  }, [_vm._v("PSČ:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.zip_code),
      expression: "address.zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "zipcodeHelp",
      "id": "zipcode"
    },
    domProps: {
      "value": (_vm.address.zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.zip_code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.zipcode) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "zipcodeError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.zipcode.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Země:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.country),
      expression: "address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "countryHelp",
      "id": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.address.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countries), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.name))])
  })), _vm._v(" "), (_vm.addressError.country) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "countryError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.country.message))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [(_vm.addressPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Přidat adresu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])]) : _vm._e(), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(1)]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('strong', [_vm._v("Přidání adresy:")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddContact_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06598f96_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddContact_vue__ = __webpack_require__(483);
function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06598f96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddContact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06598f96_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddContact_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      emailAddressError: {},
      emailAddressPending: false,
      emailAddress: {
        email: ''
      },

      phoneNumberError: {},
      phoneNumberPending: false,
      phoneNumber: {
        number: '',
        default: true,
        note: ''
      },
      selectedPhoneNumberPrefix: '+420',
      selectedPhoneNumber: '',

      phoneNumbers: [],
      phoneNumbersError: {},

      setting: __webpack_require__(3),
      waitForResponse: false,
      waitForData: false,
      message: '',
      submited: '',
      countries: [],
      citizenship: [],
      healthinsurance: []
    };
  },

  methods: {
    submitForm: function submitForm() {
      this.postPhoneNumber();
    },
    getCountries: function getCountries() {
      var _this = this;

      this.waitForData = true;
      this.$http.get(this.setting.hostname + 'country').then(function (response) {
        _this.countries = response.data;

        _this.waitForData = false;
      }, function (response) {
        _this.waitForData = false;
      });
    },
    postPhoneNumber: function postPhoneNumber() {
      var _this2 = this;

      this.phoneNumberPending = true;
      this.phoneNumber.number = this.selectedPhoneNumberPrefix + this.selectedPhoneNumber;
      this.$http.post(this.setting.hostname + 'client/' + this.$route.params.clientid + '/phone_number', this.phoneNumber, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        _this2.phoneNumberPending = false;
        _this2.getPhoneNumbers();
      }).catch(function (error) {
        _this2.phoneNumberError = error.response.data.errors;
        _this2.phoneNumberPending = false;
      });
    },
    getPhoneNumbers: function getPhoneNumbers() {
      var _this3 = this;

      this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid + '/phone_number').then(function (response) {
        _this3.phoneNumbers = response.data;
      }).catch(function (error) {
        _this3.phoneNumbersError = error.response.data.errors;
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getPhoneNumbers();
  },

  watch: {}
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      Správa telefonních čísel klienta\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [(_vm.phoneNumbers.length > 0) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.phoneNumbers), function(phoneNum) {
    return [_c('tr', [_c('td', {
      staticClass: "align-middle"
    }, [_vm._v("\n                                  " + _vm._s(phoneNum.number) + "\n                              ")]), _vm._v(" "), _c('td', [_vm._v("\n                                  " + _vm._s(phoneNum.default === true ? 'výchozí' : '') + "\n                              ")]), _vm._v(" "), _c('td', [_vm._v("\n                                  " + _vm._s(phoneNum.note) + "\n                              ")])])]
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [(!_vm.waitForData) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.selectedPhoneNumberPrefix))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPhoneNumber),
      expression: "selectedPhoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "telefonní číslo",
      "id": "phoneNumber"
    },
    domProps: {
      "value": (_vm.selectedPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPhoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        Výchozí: \n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber.default),
      expression: "phoneNumber.default"
    }],
    attrs: {
      "type": "checkbox",
      "aria-label": "Checkbox for following text input"
    },
    domProps: {
      "checked": Array.isArray(_vm.phoneNumber.default) ? _vm._i(_vm.phoneNumber.default, null) > -1 : (_vm.phoneNumber.default)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.phoneNumber.default,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.phoneNumber.default = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.phoneNumber.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.phoneNumber.default = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber.note),
      expression: "phoneNumber.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phoneNumberf",
      "placeholder": "poznámka"
    },
    domProps: {
      "value": (_vm.phoneNumber.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phoneNumberPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Přidat telefon")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.phoneNumberError.number) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "numberError"
    }
  }, [_vm._v(_vm._s(_vm.phoneNumberError.number.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  })]) : _vm._e()]), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(1)]) : _vm._e()])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Telefonní číslo")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowClient_vue__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f9d3fff_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ShowClient_vue__ = __webpack_require__(491);
function injectStyle (ssrContext) {
  __webpack_require__(485)
  __webpack_require__(486)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f9d3fff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowClient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f9d3fff_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ShowClient_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_AddVisit_vue__ = __webpack_require__(214);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      modalAddVisitOpened: false
    };
  },

  components: {
    ClientVisitAdd: __WEBPACK_IMPORTED_MODULE_0__modals_AddVisit_vue__["a" /* default */]
  },

  methods: {
    showModalClientVisitAdd: function showModalClientVisitAdd() {
      this.modalAddVisitOpened = true;
      this.showModal('client-visit-add');
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    customLabel: function customLabel(_ref) {
      var code = _ref.code,
          name = _ref.name;

      return code + ' \u2013 ' + name;
    },
    updateClientVisits: function updateClientVisits() {
      this.modalAddVisitOpened = false;
      this.reloadClientVisits = true;
    },
    updateClientVisitsDone: function updateClientVisitsDone() {
      this.reloadClientVisits = false;
    }
  },
  beforeMount: function beforeMount() {},

  watch: {
    selectedInsuranceCompany: function selectedInsuranceCompany() {
      this.newInsurance.insurance_company_code = this.selectedInsuranceCompany.code;
    },
    '$route': function $route() {
      this.$forceUpdate();

      this.updateClientVisits();
    }
  },
  created: function created() {}
});

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(22);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasData: false,

      calendarSize: 'week',
      startWindow: 43,
      endWindow: 127,
      windowsPerHour: 6,
      windowSize: 5,
      startHour: 7,
      setting: __webpack_require__(3),

      selectedWindow: null,
      lastDuration: '',
      visit_purposes: '',
      selected_element: null,
      visit: {
        time_window: '',
        date: '',
        client_id: null,
        planned_for: null,
        branch_id: null,
        duration: 6,
        note: '',
        acute: false,
        purpose_id: '',
        notify: true,
        visit_template_id: false
      },
      get_params: {
        from: '',
        to: '',
        doctorid: ''
      },
      get_free_time_params: {
        minimal_length: ''
      },
      start_date: '',
      end_date: '',
      begin_of_month: '',
      end_of_month: '',
      today: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
      actual_select: {
        selected: false,
        time: '',
        date: '',
        window: '',
        day: ''
      },
      modalOpened: false,
      visitPurposeError: '',
      render_end_date: '',
      render_start_date: '',
      selectedDate: new Date(),

      visits: false,
      visitsPending: false,
      visitsError: false,

      visitPending: false,
      visitDone: false,
      visitError: false,

      doctors: false,
      doctorsPending: false,
      doctorsError: false,

      branches: false,
      branchesPending: false,
      branchesError: false,

      visitTemplates: false,

      freeTimePending: false,
      freeTime: false,
      freeTimeError: false,
      preselectedWindow: false,
      preselectedDate: false
    };
  },

  props: ['opened'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  methods: {
    onOpen: function onOpen() {
      document.getElementById('doctor').focus();
    },
    windowToTime: function windowToTime(window) {
      window = window - 1;
      var hour = Math.floor(window / this.windowsPerHour);
      var minute = window % this.windowsPerHour * 10;
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().hour(hour).minute(minute);
    },
    clearLastSelect: function clearLastSelect() {
      if (this.selectedWindow) {
        var element = this.selectedWindow;
        for (var i = 0; i < this.lastDuration; i++) {
          element.classList.remove('selected_window');
          if (element.nextSibling === null) {
            break;
          }
          element = element.nextSibling;
        }
      }
    },
    setCalendarTo: function setCalendarTo(date, window) {
      var selectedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'DD.MM.YYYY');
      this.hasData = false;
      this.new_start_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(selectedDate).startOf('isoWeek');
      if (!this.new_start_date.isSame(this.start_date, 'day')) {
        this.start_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.new_start_date);
        this.end_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(selectedDate).endOf('isoWeek');
        this.renderDates();
        this.loadCalendar();
      }
      this.preselectedWindow = window;
      this.preselectedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(selectedDate);
    },
    visitPurposeChanged: function visitPurposeChanged(event) {
      this.visit.duration = event.target.options[event.target.selectedIndex].getAttribute('data-duration');
      if (this.visit_purposes[event.target.selectedIndex].visit_normal_templates.length > 0) {
        this.visitTemplates = this.visit_purposes[event.target.selectedIndex].visit_normal_templates;
        this.visit.visit_template_id = this.visitTemplates[0].id;
      } else {
        this.visitTemplates = false;
      }
    },
    doctorChanged: function doctorChanged() {
      if (this.visit.planned_for && this.doctors[this.visit.planned_for].default_branch_id) {
        this.visit.branch_id = this.doctors[this.visit.planned_for].default_branch_id;
      }
    },
    prepareVisit: function prepareVisit(window, date, target) {
      if (target.getAttribute('data-branch-id')) {
        this.visit.branch_id = target.getAttribute('data-branch-id');
      }
      this.actual_select.window = window;
      this.actual_select.selected = true;
      var forTime = this.windowToTime(window);
      this.actual_select.date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).hour(forTime.hour()).minute(forTime.minute());
      this.visit.date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('L');
      this.visit.time_window = window * 2 - 1;

      this.clearLastSelect();
      var element = target;
      this.selectedWindow = target;
      this.lastDuration = this.visit.duration / 2;
      for (var i = 0; i < this.visit.duration / 2; i++) {
        element.classList.add('selected_window');
        if (element.nextSibling === null) {
          break;
        }
        element = element.nextSibling;
      }
    },
    changeSelectedWindows: function changeSelectedWindows() {
      if (this.selectedWindow) {
        var element = this.selectedWindow;
        this.clearLastSelect();
        this.lastDuration = this.visit.duration / 2;
        for (var i = 0; i < this.visit.duration / 2; i++) {
          element.classList.add('selected_window');
          if (element.nextSibling === null) {
            break;
          }
          element = element.nextSibling;
        }
        if (this.visit.duration === 0) {
          element.classList.add('selected_window');
        }
      }
    },
    getRightClassForTd: function getRightClassForTd(item) {
      var classes = item.type;

      if (item.clients > 0) {
        classes += ' clients';
      }

      return classes;
    },
    getBranchIdForTd: function getBranchIdForTd(item) {
      return item.branchId;
    },
    initialSet: function initialSet() {
      __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('cs');
      this.hasData = false;
      this.visit = {
        time_window: '',
        date: '',
        client_id: null,
        planned_for: null,
        branch_id: null,
        duration: 6,
        note: '',
        acute: false,
        purpose_id: '',
        notify: true,
        visit_template_id: false
      };
      this.get_params = {
        from: '',
        to: '',
        doctorid: ''
      };
      this.get_free_time_params = {
        minimal_length: ''
      };
      this.actualPeriod();
    },
    getVisits: function getVisits() {
      var params = { date: this.get_params.from };
      this.getWeekVisitsForDoctor(this.get_params.doctorid, params);
    },
    actualPeriod: function actualPeriod() {
      this.hasData = false;
      this.start_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('isoWeek');
      this.end_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('isoWeek');
      this.renderDates();
      this.loadCalendar();
    },
    nextPeriod: function nextPeriod() {
      this.hasData = false;
      this.start_date = this.start_date.add(1, 'weeks');
      this.end_date = this.end_date.add(1, 'weeks');
      this.renderDates();
      this.loadCalendar();
    },
    previousPeriod: function previousPeriod() {
      this.hasData = false;
      this.start_date = this.start_date.subtract(1, 'weeks');
      this.end_date = this.end_date.subtract(1, 'weeks');
      this.renderDates();
      this.loadCalendar();
    },
    renderDates: function renderDates() {
      this.render_start_date = this.start_date;
      this.render_end_date = this.end_date;
      this.get_params.from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.start_date).format('DD.MM.YYYY');
      this.get_params.to = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.end_date).format('DD.MM.YYYY');
    },
    loadCalendar: function loadCalendar() {
      this.get_params.doctorid = this.visit.planned_for;
      if (this.visit.planned_for !== null && this.visit.planned_for !== undefined) {
        this.getVisits();
      }
    },
    loadFreeTime: function loadFreeTime() {
      this.get_free_time_params.minimal_length = this.visit.duration / 2;
      if (this.visit.planned_for !== null && this.visit.planned_for !== undefined) {
        this.getFreeTimeForDoctor(this.visit.planned_for, this.get_free_time_params);
      }
    },

    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date);
    },
    hoverWindows: function hoverWindows(event) {
      var element = event.currentTarget;
      for (var i = 0; i < this.visit.duration / 2; i++) {
        element.classList.add('hovered_window');
        if (element.nextSibling === null) {
          break;
        }
        element = element.nextSibling;
      }
    },
    unhoverWindows: function unhoverWindows(event) {
      var element = event.currentTarget;
      for (var i = 0; i < this.visit.duration / 2; i++) {
        element.classList.remove('hovered_window');
        if (element.nextSibling === null) {
          break;
        }
        element = element.nextSibling;
      }
    },
    getVisitPurposes: function getVisitPurposes() {
      var _this = this;

      this.waitForResponse = true;
      this.$http.get('visit_purpose').then(function (response) {
        _this.visit_purposes = response.data;
        var visit = _this.visit;
        _this.visit_purposes.forEach(function (visitPurpose) {
          if (visitPurpose.default === true) {
            visit.purpose_id = visitPurpose.id;
          }
        });
        _this.waitForResponse = false;
      }).catch(function (error) {
        _this.visitPurposeError = error.response.data.errors;
        _this.waitForResponse = false;
      });
    },
    init: function init() {
      this.initialSet();
      this.visit.client_id = this.$route.params.clientid;
      this.visit.planned_for = null;
      this.visit.branch_id = null;
      this.visit.note = '';
      this.freeTime = false;
      this.getDoctors();
      this.getBranches();
      this.getVisitPurposes();
      this.selectedDate = new Date();
      this.loadCalendar();
    },
    manualSelectDate: function manualSelectDate() {
      this.hasData = false;
      this.start_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDate).startOf('isoWeek');
      this.end_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDate).endOf('isoWeek');
      this.renderDates();
      this.loadCalendar();
    },
    changeNotification: function changeNotification() {
      this.visit.notify = !this.visit.notify;
    },
    windowsHover: function windowsHover(num) {
      var hoursFrom = Math.floor((num - 1) / 6);
      var hoursTo = Math.floor((Number(this.visit.duration) / 2 + num - 1) / 6);
      var minutesFrom = (num - 1) % 6 * 10;
      var minutesTo = (num - 1 + Number(this.visit.duration) / 2) % 6 * 10;
      return hoursFrom + ':' + minutesFrom.toString().padStart(2, 0) + ' - ' + hoursTo + ':' + minutesTo.toString().padStart(2, 0);
    },
    windowsHoverVisits: function windowsHoverVisits(visits) {
      var returnString = '';
      visits.forEach(function (visit) {
        returnString += '<br>' + visit.visit.timeFrom + ' - ' + visit.visit.timeTo + '<br>' + visit.visit_purpose.purpose;
      });

      return returnString;
    },
    visitSlotHover: function visitSlotHover(visit) {
      return visit.visit_purpose.purpose;
    }
  },
  watch: {
    opened: function opened(val) {
      if (val === true) {
        this.init();
      }
    },

    'visit.planned_for': function visitPlanned_for(val) {
      if (val !== null && val !== undefined) {
        this.loadCalendar();
        this.loadFreeTime();
      }
    },
    'visit.duration': function visitDuration(val) {
      if (this.visit.planned_for !== null) {
        this.loadFreeTime();
      }
    },
    branchesPending: function branchesPending(val) {
      if (val === false) {
        for (var i = 0; i < this.branches.length; i++) {}
      }
    },
    visitsPending: function visitsPending(val) {
      if (val === false && this.preselectedWindow !== false) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
          this.prepareVisit(this.preselectedWindow, this.preselectedDate, document.querySelectorAll('td[data-window-id="' + (this.preselectedDate.isoWeekday() - 1) + '_' + this.preselectedWindow + '"]')[0]);
          this.preselectedDate = false;
          this.preselectedWindow = false;
        }.bind(this));
      }
    },
    preselectedDate: function preselectedDate(val) {
      if (val !== false && this.visitsPending === false) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick().then(function () {
          this.prepareVisit(this.preselectedWindow, this.preselectedDate, document.querySelectorAll('td[data-window-id="' + (this.preselectedDate.isoWeekday() - 1) + '_' + this.preselectedWindow + '"]')[0]);
          this.preselectedDate = false;
          this.preselectedWindow = false;
        }.bind(this));
      }
    },
    visitDone: function visitDone(val) {
      if (val === true) {
        this.$emit('update');
        this.visitDone = false;
        this.visits = false;
        this.$modal.hide('client-visit-add');
      }
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {
        this.init();
      }
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "95%",
      "scrollable": true,
      "name": "client-visit-add",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "opened": _vm.onOpen
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "visit-schedule-dialog"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Naplánovat návštěvu\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('form', [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "doctor"
    }
  }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.planned_for),
      expression: "visit.planned_for"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "visit-schedule-doctor"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.planned_for = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.doctorChanged()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit doktora")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.branch_id),
      expression: "visit.branch_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "branchHelp",
      "id": "branch",
      "placeholder": "vybrat pobočku",
      "data-testid": "visit-schedule-branch"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.branch_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit pobočku")]), _vm._v(" "), _vm._l((_vm.branches), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "doctorHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("za účelem")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.purpose_id),
      expression: "visit.purpose_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "operation",
      "data-testid": "visit-schedule-purpose"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.purpose_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.visitPurposeChanged($event)
      }]
    }
  }, _vm._l((_vm.visit_purposes), function(visit_purpose) {
    return _c('option', {
      attrs: {
        "data-duration": visit_purpose.duration
      },
      domProps: {
        "value": visit_purpose.id
      }
    }, [_vm._v(_vm._s(visit_purpose.purpose))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.visit_template_id),
      expression: "visit.visit_template_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "visitTemplateSelect",
      "disabled": _vm.visitTemplates === false,
      "data-testid": "visit-schedule-template"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.visit_template_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.visitTemplates), function(visit_template, index) {
    return _c('option', {
      domProps: {
        "value": visit_template.id,
        "selected": index === 0
      }
    }, [_vm._v(_vm._s(visit_template.name))])
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("bez šablony")])], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "operationHelp"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-inline mt-2"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Délka návštěvy:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.duration),
      expression: "visit.duration"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "id": "duration",
      "data-testid": "visit-schedule-duration"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeSelectedWindows()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit čas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("0 minut")]), _vm._v(" "), _vm._l((24), function(duration) {
    return (duration % 2 === 0) ? _c('option', {
      domProps: {
        "value": duration
      }
    }, [_vm._v(_vm._s(duration * 5) + " minut")]) : _vm._e()
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "acute"
    }
  }, [_vm._v("\n                                akutní "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.acute),
      expression: "visit.acute"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "acute",
      "data-testid": "visit-schedule-acute"
    },
    domProps: {
      "checked": Array.isArray(_vm.visit.acute) ? _vm._i(_vm.visit.acute, null) > -1 : (_vm.visit.acute)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.visit.acute,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.visit.acute = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.visit.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.visit.acute = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.visit.notify) ? _c('i', {
    staticClass: "fa fa-bell-o fa-2x text-success",
    attrs: {
      "title": "notifikace jsou zapnuté",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.changeNotification
    }
  }) : _c('i', {
    staticClass: "fa fa-bell-slash fa-2x text-danger",
    attrs: {
      "title": "notifikace jsou VYPNUTY",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.changeNotification
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka:")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.note),
      expression: "visit.note"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "note",
      "rows": "2",
      "data-testid": "visit-schedule-note"
    },
    domProps: {
      "value": (_vm.visit.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visit.note = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('table', {
    staticClass: "table table_free_time"
  }, _vm._l((_vm.freeTime), function(ft) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ft.date) + " (" + _vm._s(_vm.$moment(ft.date, 'DD.MM.YYYY').format('dddd')) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$moment(_vm.windowToTime(ft.window)).format('LT')) + " (" + _vm._s(_vm._f("minutesToCsTime")(_vm._f("windowToMinute")(ft.length))) + ")")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-outline-success btn-xs m-1",
      on: {
        "click": function($event) {
          _vm.setCalendarTo(ft.date, ft.window)
        }
      }
    }, [_vm._v("vybrat")])])])
  }))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.actual_select.selected) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.moment(_vm.actual_select.date).format('dddd')) + " " + _vm._s(_vm.moment(_vm.actual_select.date).format('LL')) + " v " + _vm._s(_vm.moment(_vm.actual_select.date).format('LT'))), _c('br')]) : _c('div', [_vm._v("\n                Vyberte den a čas v kalendáři\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-testid": "visit-schedule-previous-week"
    },
    on: {
      "click": function($event) {
        _vm.previousPeriod()
      }
    }
  }, [_vm._v("Předchozí")])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.actualPeriod
    }
  }, [_vm._v("aktuální týden")])]), _vm._v(" "), _c('div', [_c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput"
    },
    on: {
      "input": _vm.manualSelectDate
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-testid": "visit-schedule-next-week"
    },
    on: {
      "click": function($event) {
        _vm.nextPeriod()
      }
    }
  }, [_vm._v("Následující")])])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div'), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.get_params.from) + " - " + _vm._s(_vm.get_params.to) + "\n                ")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "div_table"
  }, [_c('table', {
    staticClass: "table table_calendar"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / _vm.windowsPerHour)), function(times, index) {
    return _c('th', {
      attrs: {
        "colspan": _vm.windowsPerHour
      }
    }, [_vm._v("\n                            " + _vm._s((index + _vm.startHour) < 10 ? '0' + (index + _vm.startHour) : (index + _vm.startHour)) + "\n                        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / (_vm.windowsPerHour / 2))), function(times, index) {
    return _c('th', {
      staticClass: "halfHour",
      attrs: {
        "colspan": (_vm.windowsPerHour / 2)
      }
    }, [_vm._v("\n                             \n                        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th')])]), _vm._v(" "), (_vm.visits !== false) ? _c('tbody', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._l((7), function(n) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ({
            content: '<b>' + _vm.windowsHover(_vm.startWindow + cell - 1) + '</b><br>' + (_vm.visits[n - 1][cell + _vm.startWindow - 1]['visit'].length > 0 ? _vm.windowsHoverVisits(_vm.visits[n - 1][cell + _vm.startWindow - 1]['visit']) : ''),
            placement: 'bottom-center',
            classes: ['info']
          }),
          expression: "{\n                                  content: '<b>' + windowsHover(startWindow + cell - 1) + '</b><br>' + (visits[n-1][cell + startWindow - 1]['visit'].length > 0 ? windowsHoverVisits(visits[n-1][cell + startWindow - 1]['visit']) : ''),\n                                  placement: 'bottom-center',\n                                  classes: ['info']}"
        }],
        class: _vm.getRightClassForTd(_vm.visits[n - 1][cell + _vm.startWindow - 1]) + ' ' + ((cell % _vm.windowsPerHour === 0) ? 'hourly' : '') + ' ' + ((cell % _vm.windowsPerHour === _vm.windowsPerHour / 2) ? 'halfhourly' : ''),
        attrs: {
          "data-window-id": (n - 1) + '_' + (_vm.startWindow + cell - 1),
          "data-testid": 'visit-schedule-slot-' + (n - 1) + '-' + (_vm.startWindow + cell - 1),
          "data-branch-id": _vm.getBranchIdForTd(_vm.visits[n - 1][cell + _vm.startWindow - 1])
        },
        on: {
          "mouseover": function($event) {
            _vm.hoverWindows($event)
          },
          "mouseleave": function($event) {
            _vm.unhoverWindows($event)
          },
          "click": function($event) {
            _vm.prepareVisit(_vm.startWindow + cell - 1, _vm.moment(_vm.render_start_date).add(n - 1, 'days'), $event.currentTarget)
          }
        }
      }, [_vm._v("\n                                 \n                                "), _vm._l((_vm.visits[n - 1][cell + _vm.startWindow - 1]['visit']), function(visit) {
        return [_c('div', {
          staticStyle: {
            "position": "relative"
          }
        }, [_c('div', {
          staticClass: "visit_slot",
          staticStyle: {
            "position": "absolute"
          },
          style: ({
            backgroundColor: '#' + visit.visit_purpose.color,
            top: visit.row_slot_number * 6 + 'px'
          }),
          attrs: {
            "title": _vm.visitSlotHover(visit)
          }
        })])]
      })], 2)
    })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return [(_vm.visits[n - 1][cell + _vm.startWindow - 1]['skipNote'] === 0 || _vm.visits[n - 1][cell + _vm.startWindow - 1]['type'] !== 'work') ? _c('td', {
        staticStyle: {
          "position": "relative"
        },
        attrs: {
          "colspan": _vm.visits[n - 1][cell + _vm.startWindow - 1]['note'] ? _vm.visits[n - 1][cell + _vm.startWindow - 1]['note']['windowsCount'] : 1
        }
      }, [_c('div', {
        staticStyle: {
          "position": "absolute",
          "overflow": "hidden",
          "text-overflow": "ellipsis",
          "width": "100%",
          "text-align": "center"
        }
      }, [_vm._v("\n                                  " + _vm._s(_vm.visits[n - 1][cell + _vm.startWindow - 1]['note'] ? _vm.visits[n - 1][cell + _vm.startWindow - 1]['note']['text'] : '') + "\n                                ")])]) : _vm._e()]
    })], 2)]
  })], 2) : _c('tbody', _vm._l((7), function(n) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        staticClass: "blank_windows"
      }, [_vm._v("\n                             \n                        ")])
    })], 2)
  }))]), _vm._v(" "), (_vm.visits === false || _vm.visitsPending === true) ? _c('div', {
    staticClass: "table_overlay"
  }, [(_vm.visitsPending === true) ? _c('div', {}, [_c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "h4"
  })])]) : (_vm.visits === false) ? _c('div', {
    staticClass: "text-danger"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "h4"
  }, [_vm._v("Musíte zvolit doktora")])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body text-center pt-0"
  }, [(!_vm.visitPending) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "data-testid": "visit-schedule-submit"
    },
    on: {
      "click": function($event) {
        _vm.postVisit(_vm.visit)
      }
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client",
    attrs: {
      "data-testid": "client-file"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientVisit') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientVisit'
      },
      "data-testid": "client-tab-visits"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Návštěvy")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-visits"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Návštěvy")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientAnamnesis') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientAnamnesis'
      },
      "data-testid": "client-tab-anamnesis"
    }
  }, [_c('i', {
    staticClass: "fa fa-notes-medical fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Anamnéza")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-anamnesis"
    }
  }, [_c('i', {
    staticClass: "fa fa-notes-medical fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Anamnéza")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientMedicament') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientMedicament'
      },
      "data-testid": "client-tab-medicaments"
    }
  }, [_c('i', {
    staticClass: "fa fa-adjust fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Léky a recepty")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-medicaments"
    }
  }, [_c('i', {
    staticClass: "fa fa-adjust fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Léky a recepty")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientMedicalReport') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientMedicalReport'
      },
      "data-testid": "client-tab-medical-reports"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lékařské zprávy")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-medical-reports"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lékařské zprávy")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientResult') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientResult'
      },
      "data-testid": "client-tab-results"
    }
  }, [_c('i', {
    staticClass: "fa fa-flask fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Laboratorní výsledky")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-results"
    }
  }, [_c('i', {
    staticClass: "fa fa-flask fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Laboratorní výsledky")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientTask') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientTask'
      },
      "data-testid": "client-tab-tasks"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Úkoly")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-tasks"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Úkoly")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientDocument') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ClientDocument'
      },
      "data-testid": "client-tab-document"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Dokumenty")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "client-tab-document"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Dokumenty")])], 1)])]), _vm._v(" "), _c('router-view')], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowVisit_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3b043c6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ShowVisit_vue__ = __webpack_require__(495);
function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3b043c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowVisit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3b043c6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ShowVisit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      update_visit: {
        state: ''
      },
      changeStatePending: false,
      changeStateError: false,

      visit: false,
      visitPending: false,
      visitError: false,
      editingVisitId: false,
      editingVisit: {},
      waitForSave: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  watch: {
    visit: function visit(val) {
      this.$store.commit('setClientId', val.client.id);
    },
    '$route.params.visitid': function $routeParamsVisitid() {
      this.getVisit(this.$route.params.visitid);
    }
  },
  components: {},
  methods: {
    editVisit: function editVisit(note, id) {
      this.editingVisitId = id;
      this.editingVisit = {
        note: note
      };
    },
    putVisit: function putVisit() {
      var _this = this;

      this.waitForSave = true;
      this.$http.put('visit/' + this.editingVisitId, this.editingVisit, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.editingVisitId = false;
        _this.editingVisit = {};
        _this.getVisit(_this.$route.params.visitid);
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    completeVisit: function completeVisit() {
      var _this2 = this;

      this.changeStatePending = true;
      this.update_visit.state = 'completed';
      if (this.visit.type === 'normal') {
        this.$http.put('visit/' + this.$route.params.visitid, this.update_visit, { emulateJSON: true }).then(function (response) {
          _this2.submited = response.data;
          _this2.changeStatePending = false;
          _this2.$router.push({ name: 'Home' });
        }).catch(function (error) {
          _this2.changeStateError = error.response.data.errors;
          _this2.changeStatePending = false;
        });
      } else if (this.visit.type === 'task') {
        this.$http.put('visit_task/' + this.$route.params.visitid, this.update_visit, { emulateJSON: true }).then(function (response) {
          _this2.submited = response.data;
          _this2.changeStatePending = false;
          _this2.$router.push({ name: 'Home' });
        }).catch(function (error) {
          _this2.changeStateError = error.response.data.errors;
          _this2.changeStatePending = false;
        });
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getVisit(this.$route.params.visitid);
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visit",
    attrs: {
      "data-testid": "visit-detail"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.visit) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between",
    attrs: {
      "data-testid": "visit-header"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.visit.type === 'normal') ? [_vm._v("\n              Návštěva " + _vm._s(_vm.visit.date) + " (" + _vm._s(_vm.visit.timeFrom) + " - " + _vm._s(_vm.visit.timeTo) + "): "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.visit.visit_purpose.purpose))])] : (_vm.visit.type === 'task') ? [_vm._v("\n              Úkol " + _vm._s(_vm.visit.date) + ": "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.visit.visit_purpose.purpose))])] : _vm._e(), _vm._v(" "), (_vm.editingVisitId === _vm.visit.id) ? [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.putVisit(_vm.visit)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingVisit.note),
      expression: "editingVisit.note"
    }],
    staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
    attrs: {
      "type": "text",
      "aria-describedby": "noteHelp",
      "id": "note",
      "data-testid": "visit-note-input"
    },
    domProps: {
      "value": (_vm.editingVisit.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editingVisit.note = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "visit-note-save"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])] : [_c('button', {
    staticClass: "btn btn-sm btn-link text-secondary",
    attrs: {
      "data-testid": "visit-note-edit"
    },
    on: {
      "click": function($event) {
        _vm.editVisit(_vm.visit.note, _vm.visit.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('i', [_vm._v("poznámka: " + _vm._s(_vm.visit.note))])]], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_vm._v("\n            " + _vm._s(_vm._f("stateToCS")(_vm.visit.state)) + "\n            "), (_vm.visit.state !== 'failed' && _vm.visit.state !== 'excused' && _vm.visit.state !== 'completed' && _vm.visit.state !== 'canceled') ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "data-testid": "visit-complete"
    },
    on: {
      "click": _vm.completeVisit
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" dokončit návštěvu")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-header justify-content-between"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'VisitMedicalReport') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'VisitMedicalReport'
      },
      "data-testid": "visit-tab-medical-report"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lékařská zpráva")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "visit-tab-medical-report"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lékařská zpráva")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'VisitDiagnosis') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'VisitDiagnosis'
      },
      "data-testid": "visit-tab-diagnosis"
    }
  }, [_c('i', {
    staticClass: "fa fa-stethoscope fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Diagnózy a výkony")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "visit-tab-diagnosis"
    }
  }, [_c('i', {
    staticClass: "fa fa-stethoscope fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Diagnózy a výkony")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'VisitMedicament') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'VisitMedicament'
      },
      "data-testid": "visit-tab-medicament"
    }
  }, [_c('i', {
    staticClass: "fa fa-adjust fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Léky a recepty")]) : _c('span', {
    staticClass: "nav-link active"
  }, [_c('i', {
    staticClass: "fa fa-adjust fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Léky a recepty")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'VisitVoucher') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'VisitVoucher'
      },
      "data-testid": "visit-tab-voucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-crutch fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Poukazy")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "visit-tab-voucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-crutch fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Poukazy")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'VisitDocument') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'VisitDocument'
      },
      "data-testid": "visit-tab-document"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Dokumenty")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "visit-tab-document"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Dokumenty")])], 1)])]), _vm._v(" "), _c('router-view')], 1) : (_vm.visitPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n      ")]) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitDiagnosis_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e0294e4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitDiagnosis_vue__ = __webpack_require__(542);
function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e0294e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitDiagnosis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e0294e4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitDiagnosis_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListDiagnosis_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddDiagnosis_vue__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddDiagnosisTemplate_vue__ = __webpack_require__(538);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reloadDiagnosis: false,
      focusAddDiagnosisInput: false,
      focusAddActionInput: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    isFocused: function isFocused() {
      this.focusAddActionInput = false;
    },
    updateDiagnosis: function updateDiagnosis() {
      this.reloadDiagnosis = true;
      this.focusAddDiagnosisInput = false;
      this.focusAddActionInput = false;
    },

    updateDiagnosisDone: function updateDiagnosisDone(diagnosisCount) {
      this.focusAddDiagnosisInput = false;
      this.focusAddActionInput = false;
      this.reloadDiagnosis = false;
      this.chooseWhereToFocus(diagnosisCount);
    },
    chooseWhereToFocus: function chooseWhereToFocus(diagnosisCount) {
      if (diagnosisCount > 0) {
        this.focusAddActionInput = true;
      } else {
        this.focusAddDiagnosisInput = true;
      }
    },
    primaryDisease: function primaryDisease(disease) {}
  },
  beforeMount: function beforeMount() {},

  watch: {},
  components: {
    ListDiagnosis: __WEBPACK_IMPORTED_MODULE_1__ListDiagnosis_vue__["a" /* default */],
    AddDiagnosis: __WEBPACK_IMPORTED_MODULE_2__AddDiagnosis_vue__["a" /* default */],
    AddDiagnosisTemplate: __WEBPACK_IMPORTED_MODULE_3__AddDiagnosisTemplate_vue__["a" /* default */]
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListDiagnosis_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a7c86fb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListDiagnosis_vue__ = __webpack_require__(533);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListDiagnosis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a7c86fb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListDiagnosis_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddAction_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListActions_vue__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Visit_modals_OperationInfo_vue__ = __webpack_require__(529);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reloadActions: {},
      diagnosesPending: false,
      diagnosesError: false,
      diagnosesDone: false,
      diagnoses: [],

      deleteDiagnosisPending: false,
      deleteDiagnosisDone: false,
      deleteDiagnosisError: false,

      selectedOperation: false,
      focusAddActionInput: false
    };
  },

  props: ['doUpdate', 'focusInput'],
  components: {
    AddAction: __WEBPACK_IMPORTED_MODULE_1__AddAction_vue__["a" /* default */],
    ListActions: __WEBPACK_IMPORTED_MODULE_2__ListActions_vue__["a" /* default */],
    OperationInfo: __WEBPACK_IMPORTED_MODULE_3__views_Visit_modals_OperationInfo_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    removeDiagnosis: function removeDiagnosis(id) {
      this.deleteDiagnosis(id);
    },
    updateDiagnosis: function updateDiagnosis() {
      this.getDiagnoses(this.$route.params.visitid);
    },
    isFocused: function isFocused() {
      this.$emit('focused');
    },
    openModalWithOperation: function openModalWithOperation(operation) {
      this.selectedOperation = operation;
      this.$modal.show('operation-info');
    }
  },
  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.getDiagnoses(this.$route.params.visitid);
      }
    },
    deleteDiagnosisDone: function deleteDiagnosisDone(val) {
      if (val === true) {
        this.getDiagnoses(this.$route.params.visitid);
        this.deleteDiagnosisDone = false;
      }
    },
    '$route.params.visitid': function $routeParamsVisitid() {
      this.getDiagnoses(this.$route.params.visitid);
    },
    diagnosesDone: function diagnosesDone(val) {
      if (val === true) {
        this.$emit('updated', this.diagnoses.length);
      }
    },
    focusInput: function focusInput(val) {
      if (val === true) {
        this.$nextTick(function () {
          this.focusAddActionInput = true;
        });
      } else {
        this.focusAddActionInput = false;
      }
    }
  },
  filters: {
    str: function str(text) {
      var countSpaces = 8 - text.length;

      for (var i = 0; i < countSpaces; i++) {
        text += ' ';
      }
      return text;
    }
  },
  beforeMount: function beforeMount() {
    this.getDiagnoses(this.$route.params.visitid);
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAction_vue__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f051182_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddAction_vue__ = __webpack_require__(505);
function injectStyle (ssrContext) {
  __webpack_require__(502)
  __webpack_require__(503)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f051182"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f051182_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddAction_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selected: '',

      operations: [],
      operationsError: false,
      operationsPending: false,

      action: {
        operation: '',
        quantity: 1,
        reported: true,
        internal: false
      },
      actionPending: false,
      actionDone: false,
      actionError: false,

      operationLimitationPending: false,
      operationLimitation: false,
      operationLimitationError: false,

      modalOperationInfoOpened: false
    };
  },

  props: ['diagnosisId', 'focusInput', 'diagnosisListIndex'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    saveAction: function saveAction() {
      this.postAction(this.diagnosisId, this.action);
    },
    getOperations: function getOperations(search) {
      this.operationLimitation = false;
      this.operationLimitationError = false;
      if (search.length > 2) {
        this.searchOperations({ search: search });
      }
    },
    selectOperation: function selectOperation(val) {
      this.operationLimitation = false;
      this.operationLimitationError = false;
      this.action.operation = val.code;
      document.getElementById('addActionButton').focus();
    },
    changeInternal: function changeInternal() {
      this.action.internal = !this.action.internal;
    },
    showModalOperationInfo: function showModalOperationInfo() {
      this.$emit('openOperationModal', this.selected);
    }
  },
  beforeMount: function beforeMount() {},

  watch: {
    focusInput: function focusInput(val) {
      if (val === true) {
        console.log('focusuji input');
        this.$refs.addActionSearchInput.$el.focus();
        this.$emit('focused');
      }
    },
    actionDone: function actionDone(val) {
      if (val === true) {
        this.operationLimitation = false;
        this.operationLimitationError = false;
        this.action = {
          operation: '',
          quantity: 1,
          reported: true,
          internal: false
        };
        this.$emit('update');
        this.actionDone = false;
        this.operations = [];
        this.selected = '';
      }
    }
  }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.operationLimitation !== false ? 'has_error' : ''
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveAction($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("Výkon")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('multiselect', {
    ref: "addActionSearchInput",
    attrs: {
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat výkon",
      "open-direction": "bottom",
      "options": _vm.operations,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": true,
      "selectLabel": "",
      "data-testid": 'visit-action-search-' + _vm.diagnosisId
    },
    on: {
      "search-change": _vm.getOperations,
      "select": _vm.selectOperation
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), (_vm.action.internal) ? _c('i', {
    staticClass: "fa fa-hand-spock-o fa-2x text-danger",
    attrs: {
      "title": "interní výkon",
      "aria-hidden": "true",
      "data-testid": 'visit-action-internal-' + _vm.diagnosisId
    },
    on: {
      "click": _vm.changeInternal
    }
  }) : _c('i', {
    staticClass: "fa fa-hand-paper-o fa-2x text-light fa-flip-horizontal",
    attrs: {
      "title": "běžný výkon",
      "aria-hidden": "true",
      "data-testid": 'visit-action-internal-' + _vm.diagnosisId
    },
    on: {
      "click": _vm.changeInternal
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label ml-sm-2"
  }, [_vm._v("Vykazovat")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.action.reported),
      expression: "action.reported"
    }],
    staticClass: "form-check-input mr-sm-2 form-control-sm",
    attrs: {
      "type": "checkbox",
      "id": "inlineCheckbox1",
      "value": "option1",
      "data-testid": 'visit-action-reported-' + _vm.diagnosisId
    },
    domProps: {
      "checked": Array.isArray(_vm.action.reported) ? _vm._i(_vm.action.reported, "option1") > -1 : (_vm.action.reported)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.action.reported,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "option1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.action.reported = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.action.reported = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.action.reported = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Počet")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.action.quantity),
      expression: "action.quantity"
    }],
    staticClass: "form-control mr-sm-2 form-control-sm col-sm-1",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "amount",
      "data-testid": 'visit-action-quantity-' + _vm.diagnosisId
    },
    domProps: {
      "value": (_vm.action.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.action.quantity = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.selected !== '') ? _c('button', {
    staticClass: "btn btn-sm btn-outline-primary mr-sm-2",
    attrs: {
      "type": "button",
      "id": "infoActionButton"
    },
    on: {
      "click": _vm.showModalOperationInfo
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]) : _c('a', {
    staticClass: "btn btn-sm btn-outline-secondary disabled mr-sm-2",
    attrs: {
      "href": "#",
      "id": "infoActionButtonDisabled",
      "aria-disabled": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]), _vm._v(" "), (!_vm.actionPending) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "id": "addActionButton",
      "data-testid": 'visit-action-add-' + _vm.diagnosisId
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [(_vm.operationLimitation) ? _c('span', {
    staticClass: "text-danger font-weight-bold"
  }, _vm._l((_vm.operationLimitation), function(ol) {
    return _c('span', [_vm._v("\n                Lze vykázat maximálně " + _vm._s(ol.per_period) + " za " + _vm._s(ol.number_of_periods) + " " + _vm._s(_vm._f("toCSBasedOnNumber")(ol.type, ol.number_of_periods)) + ". \n            ")])
  })) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListActions_vue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_010c1387_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListActions_vue__ = __webpack_require__(528);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_010c1387_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListActions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddZulp_vue__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListZulp_vue__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddZum_vue__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListZum_vue__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Visit_modals_ActionContravention_vue__ = __webpack_require__(524);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      waitForResponse: false,

      actionsReload: '',
      actionsPending: false,
      openedAddZulpActionId: false,
      openedAddZumActionId: false,

      limitContravention: false
    };
  },

  props: ['doUpdate', 'diagnosisId', 'actions'],
  methods: {
    updateDiagnosis: function updateDiagnosis() {
      this.$emit('update');
    },
    removeAction: function removeAction(id) {
      var _this = this;

      this.waitForResponse = true;
      this.$http.delete('action/' + id).then(function (response) {
        _this.$emit('update');
      }, function (response) {});
    },
    openCloseAddZulpActionId: function openCloseAddZulpActionId(actionId) {
      if (this.openedAddZulpActionId === actionId) {
        this.openedAddZulpActionId = false;
      } else {
        this.openedAddZulpActionId = actionId;
      }
    },
    openCloseAddZumActionId: function openCloseAddZumActionId(actionId) {
      if (this.openedAddZumActionId === actionId) {
        this.openedAddZumActionId = false;
      } else {
        this.openedAddZumActionId = actionId;
      }
    },
    showModalOperationInfo: function showModalOperationInfo(operation) {
      this.$emit('openOperationModal', operation);
    },
    showModalActionContravention: function showModalActionContravention(limitContravention) {
      this.limitContravention = limitContravention;
      this.$modal.show('action-contravention');
    }
  },
  watch: {},
  beforeMount: function beforeMount() {},

  components: {
    AddZulp: __WEBPACK_IMPORTED_MODULE_0__AddZulp_vue__["a" /* default */],
    ListZulp: __WEBPACK_IMPORTED_MODULE_1__ListZulp_vue__["a" /* default */],
    AddZum: __WEBPACK_IMPORTED_MODULE_2__AddZum_vue__["a" /* default */],
    ListZum: __WEBPACK_IMPORTED_MODULE_3__ListZum_vue__["a" /* default */],
    ActionContravention: __WEBPACK_IMPORTED_MODULE_4__views_Visit_modals_ActionContravention_vue__["a" /* default */]
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddZulp_vue__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6cc6270_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddZulp_vue__ = __webpack_require__(512);
function injectStyle (ssrContext) {
  __webpack_require__(509)
  __webpack_require__(510)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6cc6270"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddZulp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6cc6270_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddZulp_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      nic: 1,
      selected: null,

      zulp: {
        medicine: '',
        amount: 1,
        insuranceCoverSequenceNumber: 1
      },
      zulpPending: false,
      zulpDone: false,
      zulpError: false,

      medicines: [],
      medicinesError: false,
      medicinesPending: false
    };
  },

  props: ['actionId'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    showModalSelectedZULPInfo: function showModalSelectedZULPInfo(zulp) {
      this.$emit('openOperationModal', zulp);
    },
    selectMedicine: function selectMedicine(val) {
      this.zulp.medicine = val.code;
      document.getElementById('addZulpButton').focus();
    },
    saveZulp: function saveZulp() {
      this.postZulp(this.actionId, this.zulp);
    },
    selectOperation: function selectOperation(val) {
      this.zulp.operation = val.code;
      document.getElementById('addZulpButton').focus();
    },
    changeInternal: function changeInternal() {
      this.zulp.internal = !this.zulp.internal;
    }
  },
  beforeMount: function beforeMount() {},

  watch: {
    zulpDone: function zulpDone(val) {
      if (val === true) {
        this.zulp = {
          medicine: '',
          amount: 1,
          insuranceCoverSequenceNumber: 1
        };
        this.$emit('update');
        this.zulpDone = false;

        this.selected = null;
        this.medicines = [];
      }
    }
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-secondary p-1"
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveZulp($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("ZULP")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "id": "searchMedicine",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat lék",
      "open-direction": "bottom",
      "options": _vm.medicines,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": true,
      "selectLabel": "",
      "data-testid": 'visit-zulp-search-' + _vm.actionId
    },
    on: {
      "search-change": _vm.getMedicines,
      "select": _vm.selectMedicine
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_vm._v(_vm._s(props.option.label))])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), (_vm.selected) ? _c('v-popover', [_c('button', {
    staticClass: "btn btn-sm btn-outline-primary mr-sm-2",
    attrs: {
      "type": "button",
      "title": "informace o úhradách",
      "aria-label": "informace o úhradách",
      "data-testid": 'visit-zulp-coverage-trigger-' + _vm.actionId
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    attrs: {
      "data-testid": 'visit-zulp-coverage-popover-' + _vm.actionId
    }
  }, [_c('h3', [_vm._v("Insurance Covers")]), _vm._v(" "), _vm._l((_vm.selected.actual_insruance_cover), function(ic) {
    return [_c('div', [_c('h4', [_vm._v("Úhrada " + _vm._s(ic.sequence_number))]), _vm._v(" "), (ic.indication_limitation) ? _c('p', [_vm._v(_vm._s(ic.indication_limitation.text))]) : _vm._e()])]
  }), _vm._v(" "), _c('div', {
    staticClass: "container tooltip_container tooltip_1_col"
  })], 2)])], 2) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Množství")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zulp.amount),
      expression: "zulp.amount"
    }],
    staticClass: "form-control mr-sm-2 form-control-sm col-sm-1",
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "max": "999",
      "aria-describedby": "operationHelp",
      "id": "amount",
      "data-testid": 'visit-zulp-amount-' + _vm.actionId
    },
    domProps: {
      "value": (_vm.zulp.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zulp.amount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.selected) ? [_c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceCoverSequenceNumber"
    }
  }, [_vm._v("Typ úhrady")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zulp.insuranceCoverSequenceNumber),
      expression: "zulp.insuranceCoverSequenceNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "insuranceCoverSequenceNumber",
      "id": "insuranceCoverSequenceNumber",
      "data-testid": 'visit-zulp-cover-' + _vm.actionId
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zulp.insuranceCoverSequenceNumber = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.selected.actual_insruance_cover), function(ic) {
    return _c('option', {
      domProps: {
        "value": ic.sequence_number
      }
    }, [_vm._v(_vm._s(ic.sequence_number))])
  }))] : _vm._e(), _vm._v(" "), (!_vm.zulpPending) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "id": "addZulpButton",
      "data-testid": 'visit-zulp-add-' + _vm.actionId
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListZulp_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7700dbe5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListZulp_vue__ = __webpack_require__(515);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListZulp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7700dbe5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListZulp_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      waitForResponse: false,

      zulpReload: '',
      zulpPending: false,

      deletZulpPending: false,
      deletZulpDone: false,
      deletZulpError: false
    };
  },

  props: ['doUpdate', 'diagnosisId', 'zulp'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    updateDiagnosis: function updateDiagnosis() {
      this.$emit('update');
    },
    removeZulp: function removeZulp(id) {
      this.deleteZulp(id);
    }
  },
  watch: {
    deletZulpDone: function deletZulpDone(val) {
      if (val === true) {
        this.deletZulpPending = false;
        this.deletZulpDone = false;
        this.deletZulpError = false;
        this.$emit('update');
      }
    }
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.zulp.length > 0) ? _vm._l((_vm.zulp), function(z) {
    return _c('div', {
      staticClass: "card-text",
      attrs: {
        "data-testid": 'visit-zulp-' + z.id
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between border border-light"
    }, [_c('div', {
      staticClass: "p-0"
    }, [_vm._v("\n                    " + _vm._s(z.medicine.label) + " "), _c('span', [_vm._v(" množství: " + _vm._s(z.amount) + " ")]), _vm._v(" úhrada: " + _vm._s(z.insurance_cover_sequence_number) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [(!_vm.zulpPending) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": 'visit-zulp-delete-' + z.id
      },
      on: {
        "click": function($event) {
          _vm.zulpPending ? null : _vm.removeZulp(z.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-outline-danger disabled"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddZum_vue__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15827e59_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddZum_vue__ = __webpack_require__(520);
function injectStyle (ssrContext) {
  __webpack_require__(517)
  __webpack_require__(518)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15827e59"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddZum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15827e59_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddZum_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selected: null,

      zum: {
        material: '',
        amount: 1
      },
      zumPending: false,
      zumDone: false,
      zumError: false,

      materials: [],
      materialsError: false,
      materialsPending: false
    };
  },

  props: ['actionId', 'operation'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    selectMaterial: function selectMaterial(val) {
      this.zum.material = val.code;
      document.getElementById('addZumsButton').focus();
    },
    saveZums: function saveZums() {
      this.postZum(this.actionId, this.zum);
    },
    selectOperation: function selectOperation(val) {
      this.zum.operation = val.code;
      document.getElementById('addZumsButton').focus();
    },
    changeInternal: function changeInternal() {
      this.zum.internal = !this.zum.internal;
    }
  },
  beforeMount: function beforeMount() {},

  watch: {
    zumDone: function zumDone(val) {
      if (val === true) {
        this.zum = {
          material: '',
          amount: 1
        };
        this.$emit('update');
        this.zumDone = false;

        this.selected = null;
        this.materials = [];
      }
    }
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-secondary p-1"
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveZums($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("ZUM")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "id": "searchMaterial",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat materiál",
      "open-direction": "bottom",
      "options": _vm.materials,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": true,
      "selectLabel": "",
      "data-testid": 'visit-zum-search-' + _vm.actionId
    },
    on: {
      "search-change": _vm.getMaterials,
      "select": _vm.selectMaterial
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.label))])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Množství")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zum.amount),
      expression: "zum.amount"
    }],
    staticClass: "form-control mr-sm-2 form-control-sm col-sm-1",
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "max": "999",
      "aria-describedby": "operationHelp",
      "id": "amount",
      "data-testid": 'visit-zum-amount-' + _vm.actionId
    },
    domProps: {
      "value": (_vm.zum.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zum.amount = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.zumPending) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "id": "addZumsButton",
      "data-testid": 'visit-zum-add-' + _vm.actionId
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListZum_vue__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa6d99c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListZum_vue__ = __webpack_require__(523);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListZum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa6d99c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ListZum_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      waitForResponse: false,

      zumReload: '',
      zumPending: false,

      deletZumPending: false,
      deletZumDone: false,
      deletZumError: false
    };
  },

  props: ['doUpdate', 'diagnosisId', 'zum'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    updateDiagnosis: function updateDiagnosis() {
      this.$emit('update');
    },
    removeZum: function removeZum(id) {
      this.deleteZum(id);
    }
  },
  watch: {
    deletZumDone: function deletZumDone(val) {
      if (val === true) {
        this.deletZumPending = false;
        this.deletZumDone = false;
        this.deletZumError = false;
        this.$emit('update');
      }
    }
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.zum.length > 0) ? _vm._l((_vm.zum), function(z) {
    return _c('div', {
      staticClass: "card-text",
      attrs: {
        "data-testid": 'visit-zum-' + z.id
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between border border-light"
    }, [_c('div', {
      staticClass: "p-0"
    }, [_vm._v("\n                    " + _vm._s(z.material.label) + " "), _c('span', [_vm._v(" množství: " + _vm._s(z.amount) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [(!_vm.zumPending) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": 'visit-zum-delete-' + z.id
      },
      on: {
        "click": function($event) {
          _vm.zumPending ? null : _vm.removeZum(z.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-outline-danger disabled"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionContravention_vue__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395423f4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ActionContravention_vue__ = __webpack_require__(527);
function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-395423f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionContravention_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395423f4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ActionContravention_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ['limitContravention'],

  watch: {}
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "60%",
      "scrollable": true,
      "name": "action-contravention",
      "classes": "modal_default",
      "clickToClose": true
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3')]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._l((_vm.limitContravention), function(limitContraventionPerType, key) {
    return [(limitContraventionPerType.type === 'frequency') ? _vm._l((limitContraventionPerType.actions), function(lcpAction) {
      return _c('tr', [_c('td', [_vm._v("\n                                " + _vm._s(limitContraventionPerType.comment) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(lcpAction.visit_date) + "\n                            ")]), _vm._v(" "), _c('td', [(lcpAction.visit_id == _vm.$route.params.visitid) ? [_vm._v("\n                                    tato návštěva\n                                ")] : [_c('router-link', {
        attrs: {
          "to": {
            name: 'VisitDiagnosis',
            params: {
              clientid: _vm.$route.params.clientid,
              visitid: lcpAction.visit_id
            }
          },
          "target": "_blank"
        }
      }, [_vm._v("\n                                        zobrazit návštěvu "), _c('i', {
        staticClass: "fa fa-external-link",
        attrs: {
          "aria-hidden": "true"
        }
      })])]], 2)])
    }) : (limitContraventionPerType.type === 'non_contracted') ? [_c('tr', [_c('td', [_vm._v("\n                                " + _vm._s(limitContraventionPerType.comment) + "\n                            ")])])] : _vm._e()]
  })], 2)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.actions.length > 0) ? _vm._l((_vm.actions), function(action, index) {
    return _c('div', {
      staticClass: "card-text",
      attrs: {
        "data-testid": 'visit-action-' + action.id
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between border border-light",
      class: (action.limit_contravention !== null ? 'bg-danger-light' : '')
    }, [(action.internal) ? _c('div', {
      staticClass: "p-0 text-secondary"
    }, [_vm._v("\n                    " + _vm._s(action.operation.code) + " "), _c('i', {
      staticClass: "fa fa-hand-spock-o text-danger",
      attrs: {
        "title": "interní výkon",
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(action.operation.name) + "\n                ")]) : _c('div', {
      staticClass: "p-0"
    }, [(action.limit_contravention !== null) ? [_c('button', {
      staticClass: "btn btn-sm btn-outline-danger mr-sm-2",
      attrs: {
        "title": "porušení pravidel vykazování",
        "type": "button",
        "id": "contraventionActionButton"
      },
      on: {
        "click": function($event) {
          _vm.showModalActionContravention(action.limit_contravention)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })])] : _vm._e(), _vm._v("\n                    " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                    "), _c('span', {
      staticClass: "text-primary"
    }, [_c('i', {
      staticClass: "fa fa-diamond",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                        " + _vm._s(action.operation.point_total) + "\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-outline-primary mr-sm-2",
      attrs: {
        "type": "button",
        "id": "infoActionButton",
        "data-testid": 'visit-action-info-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.showModalOperationInfo(action.operation)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    })]), _vm._v(" "), (action.operation.zulp === true && _vm.openedAddZulpActionId === action.id) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": 'visit-zulp-toggle-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.openCloseAddZulpActionId(action.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    }), _vm._v(" ZULP")]) : _vm._e(), _vm._v(" "), (action.operation.zulp === true && _vm.openedAddZulpActionId !== action.id) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-success",
      attrs: {
        "data-testid": 'visit-zulp-toggle-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.openCloseAddZulpActionId(action.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" ZULP")]) : _vm._e(), _vm._v(" "), (action.operation.zum === true && _vm.openedAddZumActionId === action.id) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": 'visit-zum-toggle-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.openCloseAddZumActionId(action.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    }), _vm._v(" ZUM")]) : _vm._e(), _vm._v(" "), (action.operation.zum === true && _vm.openedAddZumActionId !== action.id) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-success",
      attrs: {
        "data-testid": 'visit-zum-toggle-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.openCloseAddZumActionId(action.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" ZUM")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [_c('i', [_vm._v(_vm._s(action.note))])]), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [(action.zulp.length < 1 && action.zum.length < 1) ? [(!_vm.actionsPending) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": 'visit-action-delete-' + action.id
      },
      on: {
        "click": function($event) {
          _vm.actionsPending ? null : _vm.removeAction(action.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-outline-danger disabled"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e()], 2)]), _vm._v(" "), _c('list-zulp', {
      attrs: {
        "zulp": action.zulp
      },
      on: {
        "update": _vm.updateDiagnosis
      }
    }), _vm._v(" "), (action.id === _vm.openedAddZulpActionId) ? [_c('add-zulp', {
      attrs: {
        "action-id": action.id
      },
      on: {
        "update": _vm.updateDiagnosis
      }
    })] : _vm._e(), _vm._v(" "), _c('list-zum', {
      attrs: {
        "zum": action.zum
      },
      on: {
        "update": _vm.updateDiagnosis
      }
    }), _vm._v(" "), (action.id === _vm.openedAddZumActionId) ? [_c('add-zum', {
      attrs: {
        "operation": action.operation.code,
        "action-id": action.id
      },
      on: {
        "update": _vm.updateDiagnosis
      }
    })] : _vm._e()], 2)
  }) : _vm._e(), _vm._v(" "), _c('action-contravention', {
    attrs: {
      "limit-contravention": _vm.limitContravention
    }
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationInfo_vue__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_239984e6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_OperationInfo_vue__ = __webpack_require__(532);
function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-239984e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_239984e6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_OperationInfo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ['operation'],

  watch: {}
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "60%",
      "scrollable": true,
      "name": "operation-info",
      "classes": "modal_default",
      "clickToClose": true,
      "data-testid": "visit-operation-info"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.operation.code) + " - " + _vm._s(_vm.operation.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-sm-3 p-0"
  }, [_c('h4', [_vm._v(_vm._s(_vm.operation.point_total) + " bodů")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 p-0"
  }, [_c('h4', [_vm._v(_vm._s(_vm.operation.duration) + " minut")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("popis")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.operation.description !== "" ? _vm.operation.description : '-'))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("čím výkon začíná")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.operation.start_description !== "" ? _vm.operation.start_description : '-'))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("obsah a rozsah výkonu")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.operation.scope_description !== "" ? _vm.operation.scope_description : '-'))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("čím výkon končí")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.operation.end_description !== "" ? _vm.operation.end_description : '-'))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("podmínky")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.operation.condition_description !== "" ? _vm.operation.condition_description : '-'))])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.diagnoses.length > 0) ? _vm._l((_vm.diagnoses), function(d, index) {
    return _c('div', {
      staticClass: "card-text",
      attrs: {
        "data-testid": 'visit-diagnosis-' + d.id
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('div', {
      staticClass: "p-0"
    }, [_vm._v("\n                    " + _vm._s(d.disease.code) + " - " + _vm._s(d.disease.name_cs) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [_c('i', [_vm._v(_vm._s(d.note))])]), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [(d.actions.length < 1) ? [(!_vm.deleteDiagnosisPending) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": 'visit-diagnosis-delete-' + d.id
      },
      on: {
        "click": function($event) {
          _vm.removeDiagnosis(d.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-danger btn-sm disabled"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e()], 2)]), _vm._v(" "), _c('list-actions', {
      attrs: {
        "actions": d.actions
      },
      on: {
        "update": _vm.updateDiagnosis,
        "openOperationModal": _vm.openModalWithOperation
      }
    }), _vm._v(" "), ((_vm.diagnoses.length - 1) === index) ? [_c('add-action', {
      attrs: {
        "diagnosisListIndex": index,
        "focus-input": _vm.focusAddActionInput,
        "diagnosis-id": d.id
      },
      on: {
        "focused": _vm.isFocused,
        "update": _vm.updateDiagnosis,
        "openOperationModal": _vm.openModalWithOperation
      }
    })] : [_c('add-action', {
      attrs: {
        "diagnosisListIndex": index,
        "diagnosis-id": d.id
      },
      on: {
        "update": _vm.updateDiagnosis,
        "openOperationModal": _vm.openModalWithOperation
      }
    })], _vm._v(" "), _c('hr', {
      staticClass: "border-primary"
    })], 2)
  }) : (_vm.diagnosesPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n    ")]) : _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n        (žádná diagnóza nebyla přidána)\n    ")]), _vm._v(" "), _c('operation-info', {
    attrs: {
      "operation": _vm.selectedOperation
    }
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDiagnosis_vue__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c06e9f8_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddDiagnosis_vue__ = __webpack_require__(537);
function injectStyle (ssrContext) {
  __webpack_require__(535)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c06e9f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDiagnosis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c06e9f8_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddDiagnosis_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selected: '',
      fromSearch: '',

      diagnosis: {},
      diagnosisPending: false,
      diagnosisError: false,
      diagnosisDone: false,

      diseases: [],
      diseasesPending: false,
      diseasesError: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: ['focusInput'],
  methods: {
    saveDiagnosis: function saveDiagnosis() {
      this.postDiagnosis(this.$route.params.visitid, this.diagnosis);
    },
    selectDisease: function selectDisease(val) {
      this.diagnosis.disease = val.code;
      document.getElementById('addDiagnosisButton').focus();
    }
  },
  beforeMount: function beforeMount() {},

  watch: {
    focusInput: function focusInput(val) {
      if (val === true) {
        this.$refs.addDiagnosisSearchInput.$el.focus();
      }
    },
    diagnosisDone: function diagnosisDone(val) {
      this.diagnosis = {};
      if (val === true) {
        this.$emit('update');
        this.diagnosisDone = false;
        this.diseases = [];
        this.selected = '';
      }
    }
  },
  components: {}
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveDiagnosis($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "disease"
    }
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    ref: "addDiagnosisSearchInput",
    attrs: {
      "id": "search",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat diagnózu",
      "options": _vm.diseases,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": true,
      "selectLabel": "",
      "data-testid": "visit-diagnosis-search"
    },
    on: {
      "search-change": _vm.getDiseases,
      "select": _vm.selectDisease
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "note"
    }
  }, [_vm._v("Poznámka")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diagnosis.note),
      expression: "diagnosis.note"
    }],
    staticClass: "form-control form-control-sm mr-sm-2",
    attrs: {
      "type": "text",
      "aria-describedby": "operationHelp",
      "id": "note",
      "data-testid": "visit-diagnosis-note"
    },
    domProps: {
      "value": (_vm.diagnosis.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.diagnosis.note = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "id": "addDiagnosisButton",
      "data-testid": "visit-diagnosis-add"
    }
  }, [_vm._v("Přidat diagnózu")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDiagnosisTemplate_vue__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6900dd92_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddDiagnosisTemplate_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6900dd92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDiagnosisTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6900dd92_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddDiagnosisTemplate_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selected: '',
      fromSearch: '',

      diagnosisTemplate: null,
      diagnosisTemplatePending: false,
      diagnosisTemplateError: false,
      diagnosisTemplateDone: false,

      diagnosisTemplates: [],
      diagnosisTemplatesPending: false,
      diagnosisTemplatesError: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    saveDiagnosisTemplate: function saveDiagnosisTemplate() {
      this.postDiagnosisTemplate(this.$route.params.visitid, this.diagnosisTemplate);
    },
    selectDiagnosisTemplate: function selectDiagnosisTemplate(val) {
      this.diagnosisTemplate = val.id;
      document.getElementById('addDiagnosisTemplateButton').focus();
    }
  },
  beforeMount: function beforeMount() {
    this.getDiagnosisTemplates();
  },

  watch: {
    diagnosisTemplateDone: function diagnosisTemplateDone(val) {
      if (val === true) {
        this.$emit('update');
        this.diagnosisTemplateDone = false;
        this.selected = '';
      }
    }
  },
  components: {}
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveDiagnosisTemplate($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "disease"
    }
  }, [_vm._v("Diagnózy a výkony dle šablony")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "id": "search",
      "label": "name",
      "track-by": "id",
      "placeholder": "vybrat šablonu",
      "options": _vm.diagnosisTemplates,
      "multiple": false,
      "internal-search": false,
      "close-on-select": true,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": false,
      "selectLabel": ""
    },
    on: {
      "select": _vm.selectDiagnosisTemplate
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "id": "addDiagnosisTemplateButton"
    }
  }, [_vm._v("Přidat podle šablony")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "visit-diagnosis"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('list-diagnosis', {
    attrs: {
      "focus-input": _vm.focusAddActionInput,
      "do-update": _vm.reloadDiagnosis
    },
    on: {
      "focused": _vm.isFocused,
      "updated": _vm.updateDiagnosisDone,
      "disease": _vm.primaryDisease
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-info"
  }, [_c('add-diagnosis', {
    attrs: {
      "focus-input": _vm.focusAddDiagnosisInput
    },
    on: {
      "update": _vm.updateDiagnosis
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-secondary"
  }, [_c('add-diagnosis-template', {
    on: {
      "update": _vm.updateDiagnosis
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitMedicalReport_vue__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1ed1d7c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitMedicalReport_vue__ = __webpack_require__(557);
function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1ed1d7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitMedicalReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1ed1d7c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitMedicalReport_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MedicalReportNew_vue__ = __webpack_require__(546);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {},
  beforeMount: function beforeMount() {},

  watch: {},
  components: {
    MedicalReport: __WEBPACK_IMPORTED_MODULE_1__MedicalReportNew_vue__["a" /* default */]
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicalReportNew_vue__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a93563_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MedicalReportNew_vue__ = __webpack_require__(556);
function injectStyle (ssrContext) {
  __webpack_require__(547)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28a93563"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicalReportNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a93563_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MedicalReportNew_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MedicalReport_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnamnesisEditor_vue__ = __webpack_require__(552);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hostname: __webpack_require__(3),

      customToolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }]],
      editorSettings: {
        modules: {
          keyboard: {
            bindings: {
              tab: {
                key: 9,
                handler: function handler(range, context) {}
              },
              'remove tab': {
                key: 9,
                shiftKey: true,
                collapsed: true,
                prefix: /\t$/,
                handler: function handler() {}
              }
            }
          }
        }
      },
      medicalReportText: '',
      medicalReportOldText: false,
      medicalReportLoading: false,
      medicalReportPending: false,
      medicalReportError: false,
      medicalReportChanged: false,

      tasks: false,
      tasksError: false,
      tasksPending: true,
      openedTaskId: false,

      clientAnamnesis: false,
      clientAnamnesisError: false,
      clientAnamnesisPending: false,
      clientAnamnesisDone: false,

      editingAnamneses: [],

      forceSaveAnamneses: [],
      forceSave: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    openTaskId: function openTaskId(num, result) {
      if (this.openedTaskId === num) {
        this.openedTaskId = false;
      } else {
        this.openedTaskId = num;
      }
    },
    saveMedicalReport: function saveMedicalReport() {
      this.postMedicalReport(this.$route.params.visitid, this.medicalReportText);
    },
    copyAndInsertReport: function copyAndInsertReport(report) {
      this.clientAnamnesis[0].text = report;
    },
    editAnamnesis: function editAnamnesis(identifier) {
      if (this.isEditingAnamnesis(identifier) === false) {
        this.editingAnamneses.push(identifier);
      }
    },
    isEditingAnamnesis: function isEditingAnamnesis(identifier) {
      for (var i = 0; i < this.editingAnamneses.length; i++) {
        if (this.editingAnamneses[i] === identifier) {
          return true;
        }
      }
      return false;
    },
    anamnesisSaved: function anamnesisSaved(id) {
      var index = this.forceSave.indexOf(id);
      if (index > -1) {
        this.forceSave.splice(index, 1);
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getMedicalReport(this.$route.params.visitid);
    this.getMedicalReportAndLabResultOfClient(this.$store.state.clientId, this.$route.params.visitid);
    this.getClientAnamnesisByVisit(this.$route.params.visitid);
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.params.visitid !== from.params.visitid) {
        this.getMedicalReport(this.$route.params.visitid);
        this.getMedicalReportOfClient(this.$store.state.clientId);
        this.getClientAnamnesisByVisit(this.$route.params.visitid);
        this.isChanged = false;
        this.getVisit();
      }
    },
    clientAnamnesisDone: function clientAnamnesisDone(val) {
      if (val === true) {
        this.$nextTick(function () {
          var that = this;
          var elements = document.getElementsByClassName('anamnesisBlock');

          var _loop = function _loop(i) {
            var toolbarNode = elements[i].children[0].children[0];
            var newNode = document.createElement('div');
            newNode.className = 'anamnesisTitle';
            newNode.innerText = elements[i].getAttribute('data-anamnesis-text');
            elements[i].children[0].insertBefore(newNode, toolbarNode);
            elements[i].children[0].getElementsByClassName('ql-editor')[0].addEventListener('focus', function (e) {
              for (var j = 0; j < elements.length; j++) {
                elements[j].classList.remove('focused');
              }

              elements[i].classList.add('focused');
            });
            elements[i].addEventListener('blur', function (e) {
              elements[i].classList.remove('focused');
            });
            elements[i].children[0].getElementsByClassName('ql-editor')[0].addEventListener('blur', function (e) {
              that.forceSave.push(elements[i].id);
            });
            elements[i].children[0].getElementsByClassName('ql-editor')[0].addEventListener('keydown', function (e) {
              if (e.keyCode === 9 && i !== elements.length - 1) {
                elements[i].classList.remove('focused');

                var inputToFocus = elements[i + 1].children[0].getElementsByClassName('ql-editor')[0];
                inputToFocus.focus();

                var range = void 0;
                var selection = void 0;
                if (document.createRange) {
                  range = document.createRange();
                  range.selectNodeContents(inputToFocus);
                  range.collapse(false);
                  selection = window.getSelection();
                  selection.removeAllRanges();
                  selection.addRange(range);
                } else if (document.selection) {
                  range = document.body.createTextRange();
                  range.moveToElementText(inputToFocus);
                  range.collapse(false);
                  range.select();
                }
              }
            });
          };

          for (var i = 0; i < elements.length; i++) {
            _loop(i);
          }

          document.getElementById('anamnesisNO').children[0].focus();
        }, this);
      }
    }
  },
  components: {
    AnamnesisEditor: __WEBPACK_IMPORTED_MODULE_2__AnamnesisEditor_vue__["a" /* default */],
    MedicalReport: __WEBPACK_IMPORTED_MODULE_1__MedicalReport_vue__["a" /* default */]
  },
  beforeRouteLeave: function beforeRouteLeave(to, from) {
    this.saveMedicalReport();
  }
});

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MedicalReport_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hostname: __webpack_require__(3),
      customToolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'color': [] }], [{ 'align': [] }]],
      medicalReportText: '',
      medicalReportOldText: false,
      medicalReportLoading: false,
      medicalReportPending: false,
      medicalReportError: false,
      medicalReportChanged: false,

      tasks: false,
      tasksError: false,
      tasksPending: true,
      openedTaskId: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  methods: {
    openTaskId: function openTaskId(num, result) {
      if (this.openedTaskId === num) {
        this.openedTaskId = false;
      } else {
        this.openedTaskId = num;
      }
    },
    saveMedicalReport: function saveMedicalReport() {
      this.postMedicalReport(this.$route.params.visitid, this.medicalReportText);
    },
    copyAndInsertReport: function copyAndInsertReport(report) {
      this.medicalReportText = report;
    }
  },
  beforeMount: function beforeMount() {
    this.getMedicalReport(this.$route.params.visitid);
    this.getMedicalReportAndLabResultOfClient(this.$store.state.clientId);
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.params.visitid !== from.params.visitid) {
        this.getMedicalReport(this.$route.params.visitid);
        this.getMedicalReportOfClient(this.$store.state.clientId);
        this.isChanged = false;
        this.getVisit();
      }
    },

    medicalReportText: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (newVal) {
      this.saveMedicalReport();
    }, 1000)
  },
  components: {
    MedicalReport: __WEBPACK_IMPORTED_MODULE_2__MedicalReport_vue__["a" /* default */],
    VueEditor: __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["VueEditor"]
  },
  beforeRouteLeave: function beforeRouteLeave(to, from) {
    this.saveMedicalReport();
  }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.medicalReportLoading) ? _c('div', {
    staticClass: "card-body row m-0"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('vue-editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.medicalReportText),
      callback: function($$v) {
        _vm.medicalReportText = $$v
      },
      expression: "medicalReportText"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.medicalReportPending) ? _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")]) : (!_vm.medicalReportPending && _vm.medicalReportText !== _vm.medicalReportOldText) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": _vm.saveMedicalReport
    }
  }, [_vm._v("Uložit")]) : [_c('button', {
    staticClass: "btn btn-sm btn-success disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v("Uloženo")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "target": "_blank",
      "role": "button",
      "href": _vm.hostname.hostname + 'visit/' + _vm.$route.params.visitid + '/medical_report/pdf'
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Tisknout zprávu")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.tasks), function(task, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: _vm.openedTaskId === index ? 'border border-primary border-bottom-0' : ''
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [(_vm.openedTaskId === index) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      on: {
        "click": function($event) {
          _vm.openTaskId(index, task)
        }
      }
    }, [_vm._v("-")]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      on: {
        "click": function($event) {
          _vm.openTaskId(index, task)
        }
      }
    }, [_vm._v("+")])]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(task.date_cs))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [(task.type === 'lab_result') ? _c('span', [_c('i', {
      staticClass: "fa fa-flask fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Laboratorní výsledek")]) : _c('span', [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Lékařská zpráva")])]), _c('td', {
      staticClass: "col-sm-5"
    })]), _vm._v(" "), (_vm.openedTaskId === index) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0"
    }, [(task.type === 'lab_result') ? _c('td', {
      staticClass: "col-md-12"
    }, [_c('b', [_vm._v("Laboratorní výsledek")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text"
      },
      domProps: {
        "innerHTML": _vm._s(task.result)
      }
    }), _vm._v(" "), _c('b', [_vm._v("Hodnocení")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text"
      },
      domProps: {
        "innerHTML": _vm._s(task.evaluation)
      }
    })]) : _c('td', {
      staticClass: "col-md-12"
    }, [_c('b', [_vm._v("Lékařská zpráva")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-primary",
      on: {
        "click": function($event) {
          _vm.copyAndInsertReport(task.text)
        }
      }
    }, [_vm._v("Zkopírovat")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text"
      },
      domProps: {
        "innerHTML": _vm._s(task.text)
      }
    }), _vm._v(" "), (task.visit) ? [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((task.visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                            " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                        ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                            ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                            ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(1, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(task.visit.medicament.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((task.visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + " " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])])]) : _vm._e()
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Datum")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Typ")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-5"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnamnesisEditor_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1299a2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AnamnesisEditor_vue__ = __webpack_require__(555);
function injectStyle (ssrContext) {
  __webpack_require__(553)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a1299a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnamnesisEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1299a2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AnamnesisEditor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_editor__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_editor__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AnamnesisEditor',
  data: function data() {
    return {
      customToolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }]],
      editorSettings: {
        modules: {
          keyboard: {
            bindings: {
              tab: {
                key: 9,
                handler: function handler(range, context) {}
              },
              'remove tab': {
                key: 9,
                shiftKey: true,
                collapsed: true,
                prefix: /\t$/,
                handler: function handler() {}
              }
            }
          }
        }
      },
      textChanged: false,
      anamnesisLoading: false,
      anamnesisPending: false,
      anamnesisError: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: ['anamnesis', 'forceSave'],
  watch: {
    'anamnesis.text': function anamnesisText(newVal, oldVal) {
      this.debouncedSaveAnamnesis(newVal);
      this.textChanged = true;
    },
    forceSave: function forceSave(newVal) {
      if (newVal.includes('an-' + this.anamnesis.anamnesis_type.shortcode) && this.textChanged === true) {
        this.saveAnamnesis();
        this.textChanged = false;
        this.$emit('saved', 'an-' + this.anamnesis.anamnesis_type.shortcode);
      }
    }
  },
  methods: {
    debouncedSaveAnamnesis: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (string) {
      if (this.textChanged) {
        this.saveAnamnesis();
      }
      this.textChanged = false;
    }, 1000),
    saveAnamnesis: function saveAnamnesis() {
      var objectToSave = {
        'text': this.anamnesis.text,
        'anamnesis_type_id': this.anamnesis.anamnesis_type.id
      };
      this.postAnamnesisByVisit(this.$route.params.visitid, objectToSave);
    }
  },
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_2_vue2_editor__["VueEditor"]
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-1 mb-0 anamnesisBlock",
    attrs: {
      "id": 'an-' + _vm.anamnesis.anamnesis_type.shortcode,
      "data-testid": 'visit-medical-report-anamnesis-' + _vm.anamnesis.anamnesis_type.shortcode,
      "data-anamnesis-text": _vm.anamnesis.anamnesis_type.shortcode + ' - ' + _vm.anamnesis.anamnesis_type.name
    }
  }, [_c('vue-editor', {
    class: 'anamnesis-editor',
    attrs: {
      "id": 'anamnesis' + _vm.anamnesis.anamnesis_type.shortcode,
      "editorToolbar": _vm.customToolbar,
      "editorOptions": _vm.editorSettings
    },
    model: {
      value: (_vm.anamnesis.text),
      callback: function($$v) {
        _vm.anamnesis.text = $$v
      },
      expression: "anamnesis.text"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.medicalReportLoading) ? _c('div', {
    staticClass: "card-body row m-0"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.clientAnamnesis !== false) ? _vm._l((_vm.clientAnamnesis), function(ca) {
    return _c('anamnesis-editor', {
      attrs: {
        "anamnesis": ca,
        "force-save": _vm.forceSave
      },
      on: {
        "saved": _vm.anamnesisSaved
      }
    })
  }) : _vm._e(), _vm._v(" "), [_c('a', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "target": "_blank",
      "role": "button",
      "data-testid": "visit-medical-report-print",
      "href": _vm.hostname.hostname + 'visit/' + _vm.$route.params.visitid + '/medical_report/pdf'
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Tisknout zprávu\n        ")])], _vm._v(" "), (_vm.medicalReportText !== '') ? [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "visit-medical-report-existing"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Stará lékařská zpráva")]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    domProps: {
      "innerHTML": _vm._s(_vm.medicalReportText)
    }
  })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "data-testid": "visit-medical-report-history"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.tasks), function(task, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: _vm.openedTaskId === index ? 'border border-primary border-bottom-0' : '',
      attrs: {
        "data-testid": 'visit-medical-report-history-row-' + index
      }
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [(_vm.openedTaskId === index) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'visit-medical-report-history-toggle-' + index
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(index, task)
        }
      }
    }, [_vm._v("-")]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'visit-medical-report-history-toggle-' + index
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(index, task)
        }
      }
    }, [_vm._v("+")])]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(task.date_cs))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [(task.type === 'lab_result') ? _c('span', [_c('i', {
      staticClass: "fa fa-flask fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Laboratorní výsledek")]) : _c('span', [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Lékařská zpráva")])]), _c('td', {
      staticClass: "col-sm-5"
    })]), _vm._v(" "), (_vm.openedTaskId === index) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0",
      attrs: {
        "data-testid": 'visit-medical-report-history-detail-' + index
      }
    }, [(task.type === 'lab_result') ? _c('td', {
      staticClass: "col-md-12"
    }, [_c('b', [_vm._v("Laboratorní výsledek")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text"
      },
      domProps: {
        "innerHTML": _vm._s(task.result)
      }
    }), _vm._v(" "), _c('b', [_vm._v("Hodnocení")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text"
      },
      domProps: {
        "innerHTML": _vm._s(task.evaluation)
      }
    })]) : _c('td', {
      staticClass: "col-md-12"
    }, [_c('b', [_vm._v("Lékařská zpráva")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'visit-medical-report-history-copy-' + index
      },
      on: {
        "click": function($event) {
          _vm.copyAndInsertReport(task.text)
        }
      }
    }, [_vm._v("Zkopírovat")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text"
      },
      domProps: {
        "innerHTML": _vm._s(task.text)
      }
    }), _vm._v(" "), (task.visit) ? [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((task.visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                            " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                        ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                            ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                            ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(1, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(task.visit.medicament.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((task.visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + " " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])])]) : _vm._e()
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Datum")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Typ")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-5"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "visit-medical-report-page"
    }
  }, [_c('medical-report')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitMedicament_vue__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_083c3968_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VisitMedicament_vue__ = __webpack_require__(577);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitMedicament_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_083c3968_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VisitMedicament_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListMedicament_vue__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Prescribtion_ListPrescription_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListPreviousMedicament_vue__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Prescribtion_AddMedicament_vue__ = __webpack_require__(218);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reloadMedicament: false,
      reloadPrescription: false,
      medicamentToCopy: false,

      actualClientAnamnesis: false,
      actualClientAnamnesisError: false,
      actualClientAnamnesisPending: false,
      actualClientAnamnesisDone: false,

      pharmAnamnesis: false,
      allergicAnamnesis: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    updateMedicament: function updateMedicament() {
      this.reloadPrescription = true;
    },
    updateMedicamentDone: function updateMedicamentDone() {
      this.reloadMedicament = false;
    },
    copyMedicament: function copyMedicament(medicament) {
      this.medicamentToCopy = medicament;
    },
    updatePrescriptions: function updatePrescriptions() {
      this.reloadPrescription = true;
      this.updateMedicament();
    },
    updatePrescriptionDone: function updatePrescriptionDone() {
      this.reloadPrescription = false;
    }
  },
  computed: {
    visitId: function visitId() {
      return this.$route.params.visitid;
    },
    clientId: function clientId() {
      return this.$route.params.clientid;
    }
  },
  watch: {
    actualClientAnamnesis: function actualClientAnamnesis(val) {
      var _this = this;

      if (val) {
        this.pharmAnamnesis = false;
        this.allergicAnamnesis = false;
        val.forEach(function (element) {
          if (element.anamnesis_type.id === 6 && element.text !== '') {
            _this.pharmAnamnesis = element;
          }
          if (element.anamnesis_type.id === 5 && element.text !== '') {
            _this.allergicAnamnesis = element;
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.getActualClientAnamnesis(this.$route.params.clientid);
  },

  components: {
    ListMedicament: __WEBPACK_IMPORTED_MODULE_1__ListMedicament_vue__["a" /* default */],
    ListPrescription: __WEBPACK_IMPORTED_MODULE_2__views_Prescribtion_ListPrescription_vue__["a" /* default */],
    ListPreviousMedicament: __WEBPACK_IMPORTED_MODULE_3__ListPreviousMedicament_vue__["a" /* default */],
    AddMedicament: __WEBPACK_IMPORTED_MODULE_4__views_Prescribtion_AddMedicament_vue__["a" /* default */]
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListMedicament_vue__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bc38102_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListMedicament_vue__ = __webpack_require__(566);
function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8bc38102"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListMedicament_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bc38102_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListMedicament_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Client_modals_ElectronicPrescription_vue__ = __webpack_require__(216);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hostname: __webpack_require__(3),

      prescriptions: false,
      prescriptionsPending: false,
      prescriptionsError: false,

      medicaments: false,
      medicamentsPending: false,
      medicamentsError: false,
      medicamentsDone: false,

      deleteMedicamentPending: false,
      deleteMedicamentDone: false,
      deleteMedicamentError: false,

      secondMedicament: '',

      selectedSeparatedIds: [],
      selectedEPrescriptionIds: [],
      allMedicamentIds: [],

      postPrescriptionsPending: false,
      postPrescriptionsDone: false,
      postPrescriptionsError: false,

      modalEPrescriptionOpened: false
    };
  },

  props: ['doUpdate'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  computed: {
    unselectedSeparatedIds: function unselectedSeparatedIds() {
      var ids = [];

      for (var index = 0; index < this.medicaments.length; ++index) {
        if (this.selectedSeparatedIds.indexOf(this.medicaments[index].id) === -1) {
          ids.push(this.medicaments[index].id);
        }
      }

      return ids;
    },
    recipeCount: function recipeCount() {
      return this.selectedSeparatedIds.length + Math.ceil(this.unselectedSeparatedIds.length / 2);
    }
  },
  methods: {
    addToSelected: function addToSelected(id) {
      if (this.selectedSeparatedIds.indexOf(id) === -1) {
        this.selectedSeparatedIds.push(id);
      }
    },
    removeFromSelected: function removeFromSelected(id) {
      for (var index = 0; index < this.selectedSeparatedIds.length; ++index) {
        if (this.selectedSeparatedIds[index] === id) {
          this.selectedSeparatedIds.splice(index, 1);
        }
      }
    },
    addToSelectedEPrescription: function addToSelectedEPrescription(id) {
      if (this.selectedEPrescriptionIds.indexOf(id) === -1) {
        this.selectedEPrescriptionIds.push(id);
      }
    },
    removeFromSelectedEPrescription: function removeFromSelectedEPrescription(id) {
      for (var index = 0; index < this.selectedEPrescriptionIds.length; ++index) {
        if (this.selectedEPrescriptionIds[index] === id) {
          this.selectedEPrescriptionIds.splice(index, 1);
        }
      }
    },
    getAllMedicamentIds: function getAllMedicamentIds() {
      this.selectedSeparatedIds = [];
      this.selectedEPrescriptionIds = [];
      this.allMedicamentIds = [];
      for (var i = 0; i < this.medicaments.length; i++) {
        this.allMedicamentIds.push(this.medicaments[i].id);
        this.addToSelected(this.medicaments[i].id);
        this.addToSelectedEPrescription(this.medicaments[i].id);
      }
    },
    copyMedicament: function copyMedicament(medicament) {
      this.$emit('copied', medicament);
    },
    removeMedicament: function removeMedicament(id) {
      this.secondMedicament = '';
      this.deleteMedicament(id);
      this.selectedSeparatedIds.splice(this.selectedSeparatedIds.indexOf(id), 1);
    },
    medicamentsListUpdated: function medicamentsListUpdated() {
      this.$emit('updated');
    },
    selectSecondMedicament: function selectSecondMedicament(id) {
      this.secondMedicament = id;
    },
    deselectSecondMedicament: function deselectSecondMedicament() {
      this.secondMedicament = '';
    },
    generatePrescriptions: function generatePrescriptions() {
      this.postPrescriptionsFromMedicamentsByVisit(this.$route.params.visitid);
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    updatePrescriptions: function updatePrescriptions() {
      this.$emit('prescription-created');
    }
  },
  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.getVisitUnprescribedMedicaments(this.$route.params.visitid);
        this.$emit('updated');
      }
    },
    deleteMedicamentDone: function deleteMedicamentDone(val) {
      if (val === true) {
        this.getVisitUnprescribedMedicaments(this.$route.params.visitid);
        this.deleteMedicamentDone = false;
      }
    },
    '$route.params.visitid': function $routeParamsVisitid() {
      this.secondMedicament = '';
      this.getVisitUnprescribedMedicaments(this.$route.params.visitid);
    },
    medicamentsDone: function medicamentsDone(val) {
      if (val === true) {
        this.getAllMedicamentIds();
      }
    },
    postPrescriptionsDone: function postPrescriptionsDone(val) {
      if (val === true) {
        this.$emit('prescription-created');
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getVisitUnprescribedMedicaments(this.$route.params.visitid);
  },

  components: {
    ElectronicPrescription: __WEBPACK_IMPORTED_MODULE_1__views_Client_modals_ElectronicPrescription_vue__["a" /* default */]
  }
});

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      modalOpened: false,
      electronicPrescriptions: false,
      electronicPrescriptionsPending: true,
      electronicPrescriptionsError: false,
      deleteElectronicPrescriptionDone: false,
      deleteElectronicPrescriptionPending: false,
      deleteElectronicPrescriptionError: false,
      epPending: false,
      epDone: false,
      epError: false
    };
  },

  props: ['opened'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    onHidden: function onHidden() {},
    onOpen: function onOpen() {
      this.init();
      this.getUnpreparedElectronicPrescriptions(this.visitId);
    },
    getUnpreparedElectronicPrescriptions: function getUnpreparedElectronicPrescriptions() {
      var _this = this;

      this.electronicPrescriptionsPending = true;
      this.$http.get('client/' + this.$route.params.clientid + '/prescription_electronic', { params: { status: 'UNPREPARED', filter_date: this.$moment().format('DD.MM.YYYY') } }).then(function (response) {
        _this.electronicPrescriptions = response.data;
        for (var index = 0; index < _this.electronicPrescriptions.length; index++) {
          _this.electronicPrescriptions[index].patientNotificationType = 'NO';
          _this.electronicPrescriptions[index].validity = 14;
          for (var medicamentIndex = 0; medicamentIndex < _this.electronicPrescriptions[index].medicaments.length; medicamentIndex++) {
            if (_this.electronicPrescriptions[index].medicaments[medicamentIndex].medicine.indication_group && _this.electronicPrescriptions[index].medicaments[medicamentIndex].medicine.indication_group.code === 15) {
              _this.electronicPrescriptions[index].validity = 5;
            }
          }
        }
        _this.electronicPrescriptionsPending = false;
      }, function (response) {
        _this.electronicPrescriptionsError = response.body.error;
        _this.electronicPrescriptionsPending = false;
      });
    },
    init: function init() {
      this.electronicPrescriptions = false;
      this.electronicPrescriptionsPending = false;
      this.electronicPrescriptionsError = false;
    },
    updateEPrescription: function updateEPrescription(ep) {
      var _this2 = this;

      var epForUpdate = {
        id: ep.id,
        acute: ep.acute,
        family: ep.family,
        note: ep.note,
        validity: ep.validity,
        patientNotificationType: ep.patientNotificationType
      };
      this.epPending = true;
      this.$http.put('prescription_electronic/' + epForUpdate.id, epForUpdate, { emulateJSON: true }).then(function (response) {
        _this2.epPending = false;
        _this2.epDone = true;
      }).catch(function (error) {
        _this2.epError = error.response.data.errors;
        _this2.epPending = false;
      });
    },
    removeEPrescription: function removeEPrescription(ep) {
      this.deleteElectronicPrescription(ep);
    }
  },
  watch: {
    opened: function opened(val) {
      if (val === true) {}
    },
    '$route': function $route(to, from) {
      if (to.params.visitId !== from.params.visitId && typeof to.params.visitId !== 'undefined') {}
    },
    epDone: function epDone(val) {
      if (val === true) {
        this.getUnpreparedElectronicPrescriptions();
        this.$emit('prescription-updated');
        this.epDone = false;
      }
    },
    deleteElectronicPrescriptionDone: function deleteElectronicPrescriptionDone(val) {
      if (val === true) {
        this.getUnpreparedElectronicPrescriptions();
        this.deleteElectronicPrescriptionDone = false;
      }
    },
    electronicPrescriptionsPending: function electronicPrescriptionsPending(val) {
      if (val === false && this.electronicPrescriptions.length < 1) {
        this.$modal.hide('electronic-prescription');
      }
    }
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "90%",
      "scrollable": true,
      "name": "electronic-prescription",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "opened": _vm.onOpen,
      "closed": _vm.onHidden
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Doplnění údajů k eReceptům\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Předepsané léky")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Akutní")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Rodina")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Poznámka")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Platnost")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Notifikace")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.electronicPrescriptions), function(ep, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', [_vm._l((ep.medicaments), function(m, index) {
      return [_c('span', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                      " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _c('br')]
    })], 2), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "switch switch-lg switch-text switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ep.acute),
        expression: "ep.acute"
      }],
      staticClass: "switch-input",
      attrs: {
        "type": "checkbox",
        "id": "acute",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(ep.acute) ? _vm._i(ep.acute, null) > -1 : (ep.acute)
      },
      on: {
        "__c": function($event) {
          var $$a = ep.acute,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (ep.acute = $$a.concat($$v))
            } else {
              $$i > -1 && (ep.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            ep.acute = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-label",
      attrs: {
        "data-on": "Ano",
        "data-off": "Ne"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-handle"
    })])]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "switch switch-lg switch-text switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ep.family),
        expression: "ep.family"
      }],
      staticClass: "switch-input",
      attrs: {
        "type": "checkbox",
        "id": "family",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(ep.family) ? _vm._i(ep.family, null) > -1 : (ep.family)
      },
      on: {
        "__c": function($event) {
          var $$a = ep.family,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (ep.family = $$a.concat($$v))
            } else {
              $$i > -1 && (ep.family = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            ep.family = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-label",
      attrs: {
        "data-on": "Ano",
        "data-off": "Ne"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-handle"
    })])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ep.note),
        expression: "ep.note"
      }],
      staticClass: "form-control form-control-sm mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "note",
        "id": "note"
      },
      domProps: {
        "value": (ep.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          ep.note = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ep.validity),
        expression: "ep.validity"
      }],
      staticClass: "mr-sm-2",
      attrs: {
        "aria-describedby": "valid",
        "id": "valid"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          ep.validity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 14
      }
    }, [_vm._v("14 dnů")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 5
      }
    }, [_vm._v("5 dnů")])]), _vm._v(" "), (ep.validity.toString() === '14') ? _c('span', [_vm._v("běžný recept")]) : _vm._e(), _vm._v(" "), (ep.validity.toString() === '5') ? _c('span', [_vm._v("antibiotika či"), _c('br'), _vm._v("chemoterapeutika")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ep.patientNotificationType),
        expression: "ep.patientNotificationType"
      }],
      staticClass: "mr-sm-2",
      attrs: {
        "aria-describedby": "notification",
        "id": "notification"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          ep.patientNotificationType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((ep.possible_notification), function(pn, index) {
      return _c('option', {
        domProps: {
          "value": pn.key
        }
      }, [_vm._v(_vm._s(pn.label))])
    }))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.updateEPrescription(ep)
        }
      }
    }, [_vm._v("Uložit")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeEPrescription(ep)
        }
      }
    }, [_vm._v("Smazat")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.medicaments) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.medicaments), function(m, index) {
    return [_c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "align-middle col-md-7"
    }, [_vm._v("\n                      " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                      " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.disease !== null ? m.disease.code : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.amount) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.dosage) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.repeating) + "\n\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-md-1 row justify-content-between m-0"
    }, [(!_vm.deleteMedicamentPending) ? _c('button', {
      staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
      on: {
        "click": function($event) {
          _vm.removeMedicament(m.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled btn_line-heigh-1"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "col-md-8"
    }, [(m.electronic_prescription === true) ? _c('small', {
      staticClass: "text_shown"
    }, [_vm._v("ERecept")]) : _c('small', {
      staticClass: "text_shown"
    }, [_vm._v("Papírový")]), _vm._v(" |\n                    "), _c('small', {
      class: m.paid_by_sick === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("hradí pacient")]), _vm._v(" |\n                    "), _c('small', {
      class: m.acute === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("akutní")]), _vm._v(" |\n                    "), _c('small', {
      class: m.family === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("rodina")]), _vm._v(" |\n                    "), _c('small', {
      class: m.separate === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("samostatně")]), _vm._v(" |\n                    "), _c('small', [_vm._v("notifikace: "), _c('span', {
      staticClass: "text_shown"
    }, [_vm._v(_vm._s(m.patient_notification_type))])]), _vm._v(" |\n                    "), _c('small', [_vm._v("platnost: "), _c('span', {
      staticClass: "text_shown"
    }, [_vm._v(_vm._s(m.validity_in_days) + " dní")])])]), _vm._v(" "), _c('td', {
      staticClass: "col-md-4"
    }, [_vm._v("\n                    " + _vm._s(m.note) + "\n                  ")])])]
  }), _vm._v(" "), (_vm.medicaments.length > 0) ? [_c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('td', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-left col-md-3"
  }, [(_vm.medicaments.length > 0) ? _c('button', {
    staticClass: "btn btn-sm btn-success btn_line-heigh-1",
    on: {
      "click": function($event) {
        _vm.generatePrescriptions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" vytvořit recepty")]) : _c('button', {
    staticClass: "btn btn-sm btn-success disabled btn_line-heigh-1"
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" vytvořit recepty")])])])] : _vm._e()], 2)])]) : (_vm.medicamentsPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n    ")]) : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n        (žádný lék nebyl přidán)\n    ")])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-md-7"
  }, [_vm._v("Lék")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Počet bal.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Dávkování")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Opak.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hostname: __webpack_require__(3),

      prescriptions: false,
      prescriptionsPending: false,
      prescriptionsError: false,

      selectedSeparatedIds: [],
      selectedEPrescriptionIds: [],
      allMedicamentIds: [],

      hasUnpreparedElectronicPrescription: false,

      toDeleteElectronicPrescriptionReason: '',
      toDeleteElectronicPrescriptionId: null,
      sendToSuklElectronicPrescriptionDone: false,

      deleteElectronicPrescriptionPending: false,
      deleteElectronicPrescriptionError: false,
      deleteElectronicPrescriptionDone: false
    };
  },

  props: ['doUpdate', 'clientId', 'visitId'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  computed: {
    testIdPrefix: function testIdPrefix() {
      return this.visitId ? 'visit' : 'client';
    },
    prescriptionsPrintedCount: function prescriptionsPrintedCount() {
      var count = 0;
      for (var index = 0; index < this.prescriptions.length; index++) {
        if (this.prescriptions[index].type === 'printed' || this.prescriptions[index].type === 'electronic' && this.prescriptions[index].status === 'PREPARED') {
          count++;
        }
      }

      return count;
    },
    prescriptionsElectronicCount: function prescriptionsElectronicCount() {
      this.hasUnpreparedElectronicPrescription = false;
      var count = 0;
      for (var index = 0; index < this.prescriptions.length; index++) {
        if (this.prescriptions[index].type === 'electronic') {
          if (this.prescriptions[index].status === 'PREPARED') {
            count++;
          }
          if (this.prescriptions[index].status === 'UNPREPARED') {
            this.hasUnpreparedElectronicPrescription = true;
          }
        }
      }

      return count;
    }
  },
  methods: {
    removePrescription: function removePrescription(ep) {
      if (ep.type === 'printed') {} else {
        ep.reason = this.toDeleteElectronicPrescriptionReason;
        this.deleteElectronicPrescription(ep);
      }
    },
    setElectronicOPrescriptionToDelete: function setElectronicOPrescriptionToDelete(id) {
      this.toDeleteElectronicPrescriptionId = id;
    },
    updatePrescriptions: function updatePrescriptions() {
      if (this.visitId) {
        this.getPrescriptions(this.visitId);
      } else {
        this.getClientPrescriptions(this.clientId, this.$moment().format('DD.MM.YYYY'));
      }
      this.$emit('updated');
    }
  },
  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.updatePrescriptions();
      }
    },
    visitId: function visitId() {
      this.updatePrescriptions();
    },
    clientId: function clientId() {
      this.updatePrescriptions();
    },
    deleteElectronicPrescriptionDone: function deleteElectronicPrescriptionDone(val) {
      if (val === true) {
        this.updatePrescriptions();
        this.deleteElectronicPrescriptionDone = false;
      }
    },
    sendToSuklElectronicPrescriptionDone: function sendToSuklElectronicPrescriptionDone(val) {
      if (val === true) {
        this.updatePrescriptions();
        this.sendToSuklElectronicPrescriptionDone = false;
      }
    }
  },
  beforeMount: function beforeMount() {
    this.updatePrescriptions();
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.prescriptions) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.prescriptions), function(p) {
    return [_vm._l((p.medicaments), function(m, index) {
      return [_c('tr', {
        staticClass: "row m-0",
        class: (p.status === 'ERROR' ? 'bg-danger-light' : ''),
        attrs: {
          "data-testid": index === 0 ? _vm.testIdPrefix + '-prescription-' + p.id : undefined
        }
      }, [(index === 0) ? _c('td', {
        staticClass: "text-left col-md-1"
      }, [(p.type === 'printed') ? _c('span', [_vm._v("papírový")]) : _vm._e(), _vm._v(" "), (p.type === 'electronic') ? _c('span', {
        staticClass: "font-weight-bold"
      }, [(p.status === 'UNPREPARED') ? _c('i', {
        staticClass: "fa fa-minus-circle text-warning",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (p.status === 'ERROR') ? _c('i', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ({
            content: p.last_eprescription_message,
            classes: ['danger', 'half']
          }),
          expression: "{\n                                            content: p.last_eprescription_message,\n                                            classes: ['danger', 'half']}"
        }],
        staticClass: "fa fa-exclamation-circle text-danger",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), (p.status === 'PREPARED') ? _c('i', {
        staticClass: "fa fa-check-circle text-success",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "green"
      }, [_vm._v("E")]), _vm._v("RECEPT\n                                    ")]) : _vm._e()]) : _c('td', {
        staticClass: "col-md-1 empty_cell"
      }), _vm._v(" "), _c('td', {
        staticClass: "align-middle col-md-5"
      }, [_vm._v("\n                                    " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                                    " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                                ")]), _vm._v(" "), _c('td', {
        staticClass: "align-middle col-md-1"
      }, [_vm._v("\n                                    " + _vm._s(m.disease !== null ? m.disease.code : '') + "\n                                ")]), _vm._v(" "), _c('td', {
        staticClass: "align-middle col-md-1"
      }, [_vm._v("\n                                    " + _vm._s(_vm._f("boolToCS")(m.paid_by_sick)) + "\n                                ")]), _vm._v(" "), _c('td', {
        staticClass: "align-middle col-md-1"
      }, [_vm._v("\n                                    " + _vm._s(m.amount) + "\n                                ")]), _vm._v(" "), _c('td', {
        staticClass: "align-middle col-md-1"
      }, [_vm._v("\n                                    " + _vm._s(m.dosage) + "\n                                ")]), _vm._v(" "), (index === 0) ? _c('td', {
        staticClass: "align-middle col-md-1"
      }, [(p.patient_notification_type === 'SMS') ? _c('span', [_vm._v("SMS")]) : (p.patient_notification_type === 'EMAIL') ? _c('span', [_vm._v("e-mail")]) : _c('span', {
        staticClass: "fa fa-minus",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e(), _vm._v(" "), (index === 0) ? _c('td', {
        staticClass: "text-left col-md-1"
      }, [(p.status !== 'DELETED') ? [(p.type === 'printed' || p.status === 'UNPREPARED') ? [_c('button', {
        staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
        on: {
          "click": function($event) {
            _vm.removePrescription(p)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      })])] : _vm._e(), _vm._v(" "), (_vm.toDeleteElectronicPrescriptionId === p.id) ? [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.toDeleteElectronicPrescriptionReason),
          expression: "toDeleteElectronicPrescriptionReason"
        }],
        staticClass: "form-control form-control-sm",
        attrs: {
          "type": "text",
          "aria-describedby": "reason",
          "id": "reason",
          "placeholder": "důvod zrušení eR."
        },
        domProps: {
          "value": (_vm.toDeleteElectronicPrescriptionReason)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.toDeleteElectronicPrescriptionReason = $event.target.value
          }
        }
      }), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
        on: {
          "click": function($event) {
            _vm.removePrescription(p)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      })])] : [(p.status === 'PREPARED') ? [_c('button', {
        staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
        on: {
          "click": function($event) {
            _vm.setElectronicOPrescriptionToDelete(p.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times",
        attrs: {
          "aria-hidden": "true"
        }
      })])] : _vm._e(), _vm._v(" "), (p.type === 'printed' || p.status === 'PREPARED') ? [_c('a', {
        staticClass: "btn btn-sm btn-success btn_line-heigh-1",
        attrs: {
          "target": "_blank",
          "href": _vm.hostname.hostname + 'prescription/printed/pdf?id=' + p.id
        }
      }, [_c('i', {
        staticClass: "fa fa-print",
        attrs: {
          "aria-hidden": "true"
        }
      })])] : _vm._e()], _vm._v(" "), (p.status === 'ERROR') ? [_c('button', {
        staticClass: "btn btn-sm btn-primary btn_line-heigh-1",
        on: {
          "click": function($event) {
            _vm.sendToSuklElectronicPrescription(p.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-repeat",
        attrs: {
          "aria-hidden": "true"
        }
      })])] : _vm._e()] : [_c('span', {
        staticClass: "text-danger font-weight-bold"
      }, [_vm._v("SMAZÁNO")])]], 2) : _c('td', {
        staticClass: "col-md-1 empty_cell"
      })])]
    })]
  }), _vm._v(" "), (_vm.prescriptions.length > 0) ? [_c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-md-5"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-left col-md-4 pt-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-secondary",
    on: {
      "click": function($event) {
        _vm.updatePrescriptions()
      }
    }
  }, [_vm._v("aktualizuj seznam")]), _vm._v(" "), (_vm.prescriptionsPrintedCount > 0) ? [(_vm.visitId) ? _c('a', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "target": "_blank",
      "href": _vm.hostname.hostname + 'prescription/printed/pdf?visit_id=' + _vm.visitId
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" recepty (" + _vm._s(_vm.prescriptionsPrintedCount) + ")")]) : _c('a', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "target": "_blank",
      "href": _vm.hostname.hostname + 'prescription/printed/pdf?client_id=' + _vm.clientId + '&date=' + _vm.$moment().format('DD.MM.YYYY')
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" recepty (" + _vm._s(_vm.prescriptionsPrintedCount) + ")")])] : _c('a', {
    staticClass: "btn btn-sm btn-success disabled",
    attrs: {
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" recepty (0)")])], 2)])] : _vm._e()], 2)])]) : (_vm.prescriptionsPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")]) : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n            (žádný recept nebyl vypsán)\n        ")])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Recept")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-5"
  }, [_vm._v("Lék")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Diag.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Hradí pacient")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Počet bal.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Dávkování")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Notifikace")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPreviousMedicament_vue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03849c56_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListPreviousMedicament_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03849c56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPreviousMedicament_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03849c56_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListPreviousMedicament_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      medicaments: false,
      medicamentsPending: false,
      medicamentsError: false
    };
  },

  props: ['doUpdate'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  computed: {},
  methods: {
    copyMedicament: function copyMedicament(medicament) {
      this.$emit('copied', medicament);
    },
    medicamentsListUpdated: function medicamentsListUpdated() {
      this.$emit('updated');
    }
  },
  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.getClientMedicaments(this.$store.state.clientId, this.$route.params.visitid);
        this.$emit('updated');
      }
    },
    '$route.params.visitid': function $routeParamsVisitid() {
      this.getClientMedicaments(this.$store.state.clientId, this.$route.params.visitid);
    }
  },
  beforeMount: function beforeMount() {
    this.getClientMedicaments(this.$store.state.clientId, this.$route.params.visitid);
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.medicaments) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.medicaments), function(m, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      attrs: {
        "data-testid": 'visit-medicament-history-' + m.id
      }
    }, [_c('td', {
      staticClass: "align-middle col-md-5"
    }, [_vm._v("\n                      " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                      " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.disease !== null ? m.disease.code : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("boolToCS")(m.paid_by_sick)) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.amount) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.dosage) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left col-md-2"
    }, [_vm._v("\n                        " + _vm._s(m.created_at) + "\n                      "), (m.prescription) ? [(m.prescription.patient_notification_type === 'SMS') ? _c('i', {
      staticClass: "fa fa-mobile-phone",
      attrs: {
        "title": "Recept odeslán přes SMS",
        "aria-hidden": "true"
      }
    }) : (m.prescription.patient_notification_type === 'EMAIL') ? _c('i', {
      staticClass: "fa fa-envelope-o",
      attrs: {
        "title": "Recept odeslán přes e-mail",
        "aria-hidden": "true"
      }
    }) : _c('i', {
      staticClass: "fa fa-ban text-danger",
      attrs: {
        "title": "Bez notifikace o receptu",
        "aria-hidden": "true"
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "col-md-1 row justify-content-start m-0"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary btn_line-heigh-1",
      attrs: {
        "title": "kopírovat",
        "data-testid": 'visit-medicament-copy-' + m.id
      },
      on: {
        "click": function($event) {
          _vm.copyMedicament(m)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]
  })], 2)])]) : (_vm.medicamentsPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n    ")]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-md-5"
  }, [_vm._v("Lék")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Hradí pacient")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Počet bal.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Dávkování")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Předepsáno")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      medicineType: 'hvlp',
      selected: null,
      selectedDisease: null,

      fromSearch: '',
      medicament: {
        medicine: '',
        individual_medicine: '',
        disease: null,
        amount: 1,
        dosage: '',
        paid_by_sick: false,
        validity_in_days: 14,
        repeating: null,
        electronic_prescription: true,
        patient_notification_type: false,
        separate: true
      },
      originalMedicamentValidityInDays: 14,

      medicamentPending: false,
      medicamentError: false,
      medicamentDone: false,

      medicines: [],
      medicinesError: false,
      medicinesPending: false,

      individualMedicines: [],
      individualMedicinesError: false,
      individualMedicinesPending: false,

      diseases: [],
      diseasesPending: false,
      diseasesError: false,

      clientMedicineInfo: false,
      clientMedicineInfoPending: false,
      clientMedicineInfoError: false,
      clientMedicineInfoDone: false,
      readyToDuplicate: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: ['copiedMedicament', 'clientId', 'visitId'],
  methods: {
    getResult: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (text) {
      if (text.length > 2) {
        this.getMedicines(text);
      }
    }, 600),
    switchMedicineType: function switchMedicineType(newType) {
      if (newType === 'hvlp') {
        this.medicineType = 'hvlp';
        this.medicament.individual_medicine = null;
      } else {
        this.medicineType = 'iplp';
        this.medicament.medicine = null;
      }
    },
    duplicateMedicineByCode: function duplicateMedicineByCode(code) {
      this.readyToDuplicate = true;
      this.getMedicines(code);
    },
    saveMedicament: function saveMedicament() {
      for (var property in this.medicament) {
        if (this.medicament.hasOwnProperty(property) && this.medicament[property] === '') {
          this.medicament[property] = null;
        }
      }
      this.medicamentError = false;
      this.postMedicament(this.medicament, this.clientId, this.visitId);
    },
    selectMedicine: function selectMedicine(val) {
      this.medicament.medicine = { 'code': val.code };
      this.getClientMedicineInfo(this.clientId, val.code);
    },
    selectIndividualMedicine: function selectIndividualMedicine(val) {
      this.medicament.individual_medicine = { 'id': val.id };
      this.getClientIndividualMedicineInfo(this.clientId, val.id);
    },
    medicamentAdded: function medicamentAdded() {
      this.$emit('update');
    },
    selectDisease: function selectDisease(val) {
      this.medicament.disease = { 'code': val.code };
    },
    repeatingChanged: function repeatingChanged(event) {
      if (event.target.valueAsNumber > 1) {
        this.medicament.validity_in_days = 182;
      } else {
        this.medicament.validity_in_days = this.originalMedicamentValidityInDays;
      }
    },
    acuteChanged: function acuteChanged() {
      if (this.medicament.acute === true) {
        this.medicament.validity_in_days = 1;
      } else {
        this.medicament.validity_in_days = this.originalMedicamentValidityInDays;
      }
    }
  },
  computed: {
    testIdPrefix: function testIdPrefix() {
      return this.visitId ? 'visit' : 'client';
    },
    validToDate: function validToDate() {
      return this.$moment().add(this.medicament.validity_in_days, 'days').format('L');
    }
  },
  watch: {
    medicinesPending: function medicinesPending(val) {
      if (val === false && this.readyToDuplicate === true) {
        this.selected = this.medicines[0];
        this.selectMedicine({ code: this.medicines[0].code });
      }
    },
    medicamentDone: function medicamentDone(val) {
      if (val === true) {
        this.medicament = {
          medicine: '',
          disease: null,
          amount: 1,
          dosage: '',
          paid_by_sick: false,
          validity_in_days: 14,
          repeating: null,
          electronic_prescription: true,
          patient_notification_type: null,
          separate: true
        };
        this.clientMedicineInfo = false;
        this.selected = null;
        this.$emit('update');
        this.medicamentDone = false;
      }
    },
    clientMedicineInfoDone: function clientMedicineInfoDone(val) {
      if (val === true && this.readyToDuplicate === true) {
        this.medicament.disease = this.copiedMedicament.disease;
        this.medicament.amount = this.copiedMedicament.amount;
        this.medicament.dosage = this.copiedMedicament.dosage;
        this.medicament.family = this.copiedMedicament.family;
        this.medicament.paid_by_sick = this.copiedMedicament.paid_by_sick;
        this.medicament.repeating = this.copiedMedicament.repeating;

        if (this.copiedMedicament.prescription && this.copiedMedicament.prescription.patient_notification_type) {
          this.medicament.patient_notification_type = this.copiedMedicament.prescription.patient_notification_type;
        } else {
          this.medicament.patient_notification_type = this.clientMedicineInfo.possible_notifications[this.clientMedicineInfo.possible_notifications.length - 1].key;
        }
        this.medicament.validity_in_days = this.clientMedicineInfo.validity;
        this.originalMedicamentValidityInDays = this.clientMedicineInfo.validity;

        this.readyToDuplicate = false;
      } else if (val === true) {
        if (this.clientMedicineInfo.disease) {
          this.selectedDisease = this.clientMedicineInfo.disease;
          this.selectDisease(this.clientMedicineInfo.disease);
        } else {
          this.selectedDisease = null;
          this.medicament.disease = null;
        }

        if (this.clientMedicineInfo.dosage) {
          this.medicament.dosage = this.clientMedicineInfo.dosage;
        } else {
          this.medicament.dosage = '';
        }
        this.medicament.patient_notification_type = this.clientMedicineInfo.possible_notifications[this.clientMedicineInfo.possible_notifications.length - 1].key;
        this.medicament.paid_by_sick = this.clientMedicineInfo.paid_by_sick;
        this.medicament.validity_in_days = this.clientMedicineInfo.validity;
        this.originalMedicamentValidityInDays = this.clientMedicineInfo.validity;
      }
    },
    copiedMedicament: function copiedMedicament(val) {
      if (val !== null) {
        this.duplicateMedicineByCode(val.medicine.code);
      }
    }
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.medicineType === 'hvlp') ? _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": _vm.testIdPrefix + '-medicament-type-hvlp'
    }
  }, [_vm._v("HVLP")]) : _c('button', {
    staticClass: "nav-link",
    attrs: {
      "data-testid": _vm.testIdPrefix + '-medicament-type-hvlp'
    },
    on: {
      "click": function($event) {
        _vm.switchMedicineType('hvlp')
      }
    }
  }, [_vm._v("HVLP")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.medicineType === 'iplp') ? _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": _vm.testIdPrefix + '-medicament-type-iplp'
    }
  }, [_vm._v("IPLP")]) : _c('button', {
    staticClass: "nav-link",
    attrs: {
      "data-testid": _vm.testIdPrefix + '-medicament-type-iplp'
    },
    on: {
      "click": function($event) {
        _vm.switchMedicineType('iplp')
      }
    }
  }, [_vm._v("IPLP")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-info"
  }, [_c('div', {
    staticClass: "card-text"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveMedicament($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-row align-items-end"
  }, [(_vm.medicineType === 'hvlp') ? _c('div', {
    staticClass: "col-sm-11 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "searchMedicine"
    }
  }, [_vm._v("Lék")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "searchMedicine",
      "label": "label",
      "track-by": "code",
      "open-direction": "bottom",
      "placeholder": "vyhledat lék",
      "options": _vm.medicines,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 400,
      "show-no-results": false,
      "hide-selected": false,
      "selectLabel": "vybrat",
      "data-testid": _vm.testIdPrefix + '-medicament-search'
    },
    on: {
      "search-change": _vm.getResult,
      "select": _vm.selectMedicine
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-0 font-sm"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [(props.option.has_actual_insruance_cover === true) ? _c('i', {
          staticClass: "fas fa-coins",
          staticStyle: {
            "color": "goldenrod"
          }
        }) : _vm._e(), _vm._v("\n                                  " + _vm._s(props.option.label) + "\n                                ")])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), (_vm.medicamentError.medicine) ? _c('small', {
    staticClass: "form-text font-weight-bold",
    attrs: {
      "id": "medicineError"
    }
  }, [_vm._v(_vm._s(_vm.medicamentError.medicine.message))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.medicineType === 'iplp') ? _c('div', {
    staticClass: "col-sm-11 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "searchMedicine"
    }
  }, [_vm._v("Individuální léčivý přípravek")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "searchMedicine",
      "label": "name",
      "track-by": "id",
      "placeholder": "vyhledat lék",
      "options": _vm.individualMedicines,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": false,
      "selectLabel": "vybrat"
    },
    on: {
      "search-change": _vm.getIndividualMedicines,
      "select": _vm.selectIndividualMedicine
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title available"
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v("\n                                  " + _vm._s(props.option.name) + "\n                                ")])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), (_vm.medicamentError.medicine) ? _c('small', {
    staticClass: "form-text font-weight-bold",
    attrs: {
      "id": "medicineError"
    }
  }, [_vm._v(_vm._s(_vm.medicamentError.medicine.message))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 mb-2"
  }, [(_vm.clientMedicineInfoPending === true) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-2x fa-fw"
  }) : _vm._e()])]), _vm._v(" "), (_vm.medicineType === 'iplp' && _vm.selected) ? _c('div', {
    staticClass: "form-row"
  }, [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.selected.preparation_process)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "searchDiagnosis"
    }
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "searchDiagnosis",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat diagnózu",
      "options": _vm.diseases,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getDiseases,
      "select": _vm.selectDisease
    },
    model: {
      value: (_vm.selectedDisease),
      callback: function($$v) {
        _vm.selectedDisease = $$v
      },
      expression: "selectedDisease"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "paidBySick"
    }
  }, [_vm._v("Hradí pacient")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.paid_by_sick),
      expression: "medicament.paid_by_sick"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "paidBySick",
      "checked": "",
      "data-testid": _vm.testIdPrefix + '-medicament-paid-by-client'
    },
    domProps: {
      "checked": Array.isArray(_vm.medicament.paid_by_sick) ? _vm._i(_vm.medicament.paid_by_sick, null) > -1 : (_vm.medicament.paid_by_sick)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.medicament.paid_by_sick,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.medicament.paid_by_sick = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.medicament.paid_by_sick = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.medicament.paid_by_sick = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-begin"
  }, [_c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Počet balení")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.amount),
      expression: "medicament.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "amount",
      "min": "1",
      "data-testid": _vm.testIdPrefix + '-medicament-amount'
    },
    domProps: {
      "value": (_vm.medicament.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medicament.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "dosage"
    }
  }, [_vm._v("Dávkování")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.dosage),
      expression: "medicament.dosage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "operationHelp",
      "id": "dosage",
      "data-testid": _vm.testIdPrefix + '-medicament-dosage'
    },
    domProps: {
      "value": (_vm.medicament.dosage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medicament.dosage = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.medicamentError.dosage) ? _c('small', {
    staticClass: "form-text font-weight-bold",
    attrs: {
      "id": "dosageError"
    }
  }, [_vm._v(_vm._s(_vm.medicamentError.dosage.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "repeating"
    }
  }, [_vm._v("Opakování")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.repeating),
      expression: "medicament.repeating"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "repeating",
      "min": "2",
      "step": "1",
      "disabled": _vm.medicament.electronic_prescription !== true
    },
    domProps: {
      "value": (_vm.medicament.repeating)
    },
    on: {
      "change": _vm.repeatingChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medicament.repeating = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "acute"
    }
  }, [_vm._v("Akutní")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.acute),
      expression: "medicament.acute"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "acute",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.medicament.acute) ? _vm._i(_vm.medicament.acute, null) > -1 : (_vm.medicament.acute)
    },
    on: {
      "change": _vm.acuteChanged,
      "__c": function($event) {
        var $$a = _vm.medicament.acute,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.medicament.acute = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.medicament.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.medicament.acute = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "family"
    }
  }, [_vm._v("Rodina")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.family),
      expression: "medicament.family"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "family",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.medicament.family) ? _vm._i(_vm.medicament.family, null) > -1 : (_vm.medicament.family)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.medicament.family,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.medicament.family = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.medicament.family = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.medicament.family = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "separate"
    }
  }, [_vm._v("Samostatně")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-secondary disabled"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.separate),
      expression: "medicament.separate"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "separate",
      "checked": "",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.medicament.separate) ? _vm._i(_vm.medicament.separate, null) > -1 : (_vm.medicament.separate)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.medicament.separate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.medicament.separate = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.medicament.separate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.medicament.separate = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "validityInDays"
    }
  }, [_vm._v("Platnost (dní)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.validity_in_days),
      expression: "medicament.validity_in_days"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "validityInDays",
      "min": "1",
      "max": "365"
    },
    domProps: {
      "value": (_vm.medicament.validity_in_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medicament.validity_in_days = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text font-weight-bold"
  }, [_vm._v("do " + _vm._s(_vm.validToDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "acute"
    }
  }, [_vm._v("E-RECEPT")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.electronic_prescription),
      expression: "medicament.electronic_prescription"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "type",
      "checked": "",
      "data-testid": _vm.testIdPrefix + '-medicament-electronic'
    },
    domProps: {
      "checked": Array.isArray(_vm.medicament.electronic_prescription) ? _vm._i(_vm.medicament.electronic_prescription, null) > -1 : (_vm.medicament.electronic_prescription)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.medicament.electronic_prescription,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.medicament.electronic_prescription = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.medicament.electronic_prescription = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.medicament.electronic_prescription = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "notification"
    }
  }, [_vm._v("Notifikace")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.patient_notification_type),
      expression: "medicament.patient_notification_type"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "notification",
      "id": "notification",
      "disabled": _vm.medicament.electronic_prescription !== true,
      "data-testid": _vm.testIdPrefix + '-medicament-notification'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.medicament.patient_notification_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.clientMedicineInfo.possible_notifications), function(pn, index) {
    return _c('option', {
      domProps: {
        "value": pn.key
      }
    }, [_vm._v(_vm._s(pn.label) + "\n              ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("Poznámka")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.note),
      expression: "medicament.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "operationHelp",
      "id": "note",
      "data-testid": _vm.testIdPrefix + '-medicament-note'
    },
    domProps: {
      "value": (_vm.medicament.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medicament.note = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit",
      "data-testid": _vm.testIdPrefix + '-medicament-add'
    }
  }, [_vm._v("Přidat lék")])])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "visit-medicaments"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('list-prescription', {
    attrs: {
      "do-update": _vm.reloadPrescription,
      "clientId": _vm.clientId,
      "visitId": _vm.visitId
    },
    on: {
      "updated": _vm.updatePrescriptionDone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.pharmAnamnesis || _vm.allergicAnamnesis) ? _c('div', {
    staticClass: "card-body bg-danger-light"
  }, [(_vm.allergicAnamnesis) ? [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.allergicAnamnesis.anamnesis_type.shortcode) + " - " + _vm._s(_vm.allergicAnamnesis.anamnesis_type.name))]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.allergicAnamnesis.text)
    }
  })] : _vm._e(), _vm._v(" "), (_vm.pharmAnamnesis) ? [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.pharmAnamnesis.anamnesis_type.shortcode) + " - " + _vm._s(_vm.pharmAnamnesis.anamnesis_type.name))]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pharmAnamnesis.text)
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('add-medicament', {
    attrs: {
      "client-id": _vm.clientId,
      "visit-id": _vm.visitId,
      "visiv-on:update": _vm.updateMedicament,
      "copied-medicament": _vm.medicamentToCopy
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-light"
  }, [_c('list-previous-medicament', {
    on: {
      "copied": _vm.copyMedicament
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitVoucher_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b24a5fea_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VisitVoucher_vue__ = __webpack_require__(592);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitVoucher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b24a5fea_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VisitVoucher_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Voucher_ListVoucher_vue__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListPreviousVoucher_vue__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Voucher_AddVoucher_vue__ = __webpack_require__(588);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reloadVoucher: false,
      voucherToCopy: false,

      actualClientAnamnesis: false,
      actualClientAnamnesisError: false,
      actualClientAnamnesisPending: false,
      actualClientAnamnesisDone: false,

      pharmAnamnesis: false,
      allergicAnamnesis: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    updateVoucher: function updateVoucher() {
      this.reloadVoucher = true;
    },
    updateVoucherDone: function updateVoucherDone() {
      this.reloadVoucher = false;
    },
    copyVoucher: function copyVoucher(voucher) {
      this.voucherToCopy = voucher;
    },
    updateVouchers: function updateVouchers() {
      this.reloadVoucher = true;
      this.updateVoucher();
    }
  },
  computed: {
    visitId: function visitId() {
      return this.$route.params.visitid;
    },
    clientId: function clientId() {
      return this.$route.params.clientid;
    }
  },
  watch: {
    actualClientAnamnesis: function actualClientAnamnesis(val) {
      var _this = this;

      if (val) {
        this.pharmAnamnesis = false;
        this.allergicAnamnesis = false;
        val.forEach(function (element) {
          if (element.anamnesis_type.id === 6 && element.text !== '') {
            _this.pharmAnamnesis = element;
          }
          if (element.anamnesis_type.id === 5 && element.text !== '') {
            _this.allergicAnamnesis = element;
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.getActualClientAnamnesis(this.$route.params.clientid);
  },

  components: {
    ListVoucher: __WEBPACK_IMPORTED_MODULE_1__views_Voucher_ListVoucher_vue__["a" /* default */],
    ListPreviousVoucher: __WEBPACK_IMPORTED_MODULE_2__ListPreviousVoucher_vue__["a" /* default */],
    AddVoucher: __WEBPACK_IMPORTED_MODULE_3__views_Voucher_AddVoucher_vue__["a" /* default */]
  }
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListVoucher_vue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3600ebe2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListVoucher_vue__ = __webpack_require__(583);
function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3600ebe2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListVoucher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3600ebe2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListVoucher_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hostname: __webpack_require__(3),

      vouchers: false,
      vouchersPending: false,
      vouchersError: false,

      selectedSeparatedIds: [],
      selectedEPrescriptionIds: [],
      allMedicamentIds: [],

      hasUnpreparedElectronicPrescription: false,

      toDeleteElectronicPrescriptionReason: '',
      toDeleteElectronicPrescriptionId: null,

      sendToSuklElectronicVoucherDone: false,

      deleteElectronicVoucherPending: false,
      deleteElectronicVoucherError: false,
      deleteElectronicVoucherDone: false
    };
  },

  props: ['doUpdate', 'clientId', 'visitId'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  computed: {
    vouchersPrintedCount: function vouchersPrintedCount() {
      var count = 0;
      for (var index = 0; index < this.vouchers.length; index++) {
        if (this.vouchers[index].type === 'printed' || this.vouchers[index].type === 'electronic' && this.vouchers[index].status === 'PREPARED') {
          count++;
        }
      }

      return count;
    },
    vouchersElectronicCount: function vouchersElectronicCount() {
      this.hasUnpreparedElectronicPrescription = false;
      var count = 0;
      for (var index = 0; index < this.vouchers.length; index++) {
        if (this.vouchers[index].type === 'electronic') {
          if (this.vouchers[index].status === 'PREPARED') {
            count++;
          }
          if (this.vouchers[index].status === 'UNPREPARED') {
            this.hasUnpreparedElectronicPrescription = true;
          }
        }
      }

      return count;
    }
  },
  methods: {
    removeVoucher: function removeVoucher(ep) {
      if (ep.type === 'printed') {} else {
        ep.reason = this.toDeleteElectronicPrescriptionReason;
        this.deleteElectronicVoucher(ep);
      }
    },
    setElectronicOPrescriptionToDelete: function setElectronicOPrescriptionToDelete(id) {
      this.toDeleteElectronicPrescriptionId = id;
    },
    updateVouchers: function updateVouchers() {
      if (this.visitId) {
        this.getVouchers(this.visitId);
      } else {
        this.getClientVouchers(this.clientId, this.$moment().format('DD.MM.YYYY'));
      }
      this.$emit('updated');
    }
  },
  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.updateVouchers();
      }
    },
    visitId: function visitId() {
      this.updateVouchers();
    },
    clientId: function clientId() {
      this.updateVouchers();
    },
    deleteElectronicPrescriptionDone: function deleteElectronicPrescriptionDone(val) {
      if (val === true) {
        this.updateVouchers();
        this.deleteElectronicPrescriptionDone = false;
      }
    },
    sendToSuklElectronicVoucherDone: function sendToSuklElectronicVoucherDone(val) {
      if (val === true) {
        this.updateVouchers();
        this.sendToSuklElectronicVoucherDone = false;
      }
    }
  },
  beforeMount: function beforeMount() {
    this.updateVouchers();
  }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.vouchers) ? _c('div', {
    attrs: {
      "data-testid": "visit-voucher-list"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.vouchers), function(p) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: (p.status === 'ERROR' ? 'bg-danger-light' : ''),
      attrs: {
        "data-testid": 'visit-voucher-row-' + p.id
      }
    }, [_c('td', {
      staticClass: "text-left col-md-1"
    }, [_c('span', {
      staticClass: "font-weight-bold"
    }, [(p.status === 'UNPREPARED') ? _c('i', {
      staticClass: "fa fa-minus-circle text-warning",
      attrs: {
        "aria-hidden": "true",
        "data-testid": 'visit-voucher-status-' + p.id
      }
    }) : _vm._e(), _vm._v(" "), (p.status === 'ERROR') ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: p.last_evoucher_message,
          classes: ['danger', 'half']
        }),
        expression: "{\n                                              content: p.last_evoucher_message,\n                                              classes: ['danger', 'half']}"
      }],
      staticClass: "fa fa-exclamation-circle text-danger",
      attrs: {
        "aria-hidden": "true",
        "data-testid": 'visit-voucher-status-' + p.id
      }
    }) : _vm._e(), _vm._v(" "), (p.status === 'PREPARED') ? _c('i', {
      staticClass: "fa fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true",
        "data-testid": 'visit-voucher-status-' + p.id
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "green"
    }, [_vm._v("E")]), _vm._v("Poukaz\n                                   ")])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-5"
    }, [_vm._v("\n                                    " + _vm._s(p.medical_device ? p.medical_device.label : '')), _c('br'), _vm._v("\n                                    " + _vm._s(p.medical_device ? p.medical_device.description : '') + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                                    " + _vm._s(p.disease !== null ? p.disease.code : '') + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                                    " + _vm._s(p.payment ? 'UHR' + p.payment : 'pacient') + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                                    " + _vm._s(p.quantity) + " " + _vm._s(p.temporary_duration_months ? '(na ' + p.temporary_duration_months + ' měs.)' : '') + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [(p.patient_notification_type === 'SMS') ? _c('span', [_vm._v("SMS")]) : (p.patient_notification_type === 'EMAIL') ? _c('span', [_vm._v("e-mail")]) : _c('span', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-left col-md-1"
    }, [(p.status !== 'DELETED') ? [(p.type === 'printed' || p.status === 'UNPREPARED') ? [_c('button', {
      staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
      attrs: {
        "data-testid": 'visit-voucher-delete-' + p.id
      },
      on: {
        "click": function($event) {
          _vm.removeVoucher(p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.toDeleteElectronicPrescriptionId === p.id) ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.toDeleteElectronicPrescriptionReason),
        expression: "toDeleteElectronicPrescriptionReason"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "text",
        "aria-describedby": "reason",
        "id": "reason",
        "placeholder": "důvod zrušení eR.",
        "data-testid": 'visit-voucher-cancel-reason-' + p.id
      },
      domProps: {
        "value": (_vm.toDeleteElectronicPrescriptionReason)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.toDeleteElectronicPrescriptionReason = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
      attrs: {
        "data-testid": 'visit-voucher-delete-' + p.id
      },
      on: {
        "click": function($event) {
          _vm.removeVoucher(p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : [(p.status === 'PREPARED') ? [_c('button', {
      staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
      attrs: {
        "data-testid": 'visit-voucher-delete-' + p.id
      },
      on: {
        "click": function($event) {
          _vm.setElectronicOPrescriptionToDelete(p.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e()], _vm._v(" "), (p.status === 'ERROR') ? [_c('button', {
      staticClass: "btn btn-sm btn-primary btn_line-heigh-1",
      attrs: {
        "data-testid": 'visit-voucher-retry-' + p.id
      },
      on: {
        "click": function($event) {
          _vm.sendToSuklElectronicVoucher(p.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-repeat",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e()] : [_c('span', {
      staticClass: "text-danger font-weight-bold"
    }, [_vm._v("SMAZÁNO")])]], 2)])]
  }), _vm._v(" "), (_vm.vouchers.length > 0) ? [_c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-md-5"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-left col-md-4 pt-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "data-testid": "visit-voucher-refresh"
    },
    on: {
      "click": function($event) {
        _vm.updateVouchers()
      }
    }
  }, [_vm._v("aktualizuj seznam")])])])] : _vm._e()], 2)])]) : (_vm.vouchersPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")]) : _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-testid": "visit-voucher-empty"
    }
  }, [_vm._v("\n            (žádný poukaz nebyl vypsán)\n        ")])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-md-5"
  }, [_vm._v("Lék")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Diag.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("úhrada")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Počet bal.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Notifikace")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPreviousVoucher_vue__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7370797e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListPreviousVoucher_vue__ = __webpack_require__(587);
function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7370797e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPreviousVoucher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7370797e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListPreviousVoucher_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      vouchers: false,
      vouchersPending: false,
      vouchersError: false
    };
  },

  props: ['doUpdate'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  computed: {},
  methods: {
    copyVoucher: function copyVoucher(voucher) {
      this.$emit('copied', voucher);
    },
    vouchersListUpdated: function vouchersListUpdated() {
      this.$emit('updated');
    }
  },
  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.getClientVouchers(this.$store.state.clientId, this.$route.params.visitid);
        this.$emit('updated');
      }
    },
    '$route.params.visitid': function $routeParamsVisitid() {
      this.getClientVouchers(this.$store.state.clientId, this.$route.params.visitid);
    }
  },
  beforeMount: function beforeMount() {
    this.getClientVouchers(this.$store.state.clientId, this.$route.params.visitid);
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.vouchers) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.vouchers), function(m, index) {
    return [_c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "align-middle col-md-5"
    }, [_vm._v("\n                      " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                      " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.disease !== null ? m.disease.code : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("boolToCS")(m.paid_by_sick)) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.amount) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.dosage) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left col-md-2"
    }, [_vm._v("\n                        " + _vm._s(m.created_at) + "\n                      "), (m.prescription) ? [(m.prescription.patient_notification_type === 'SMS') ? _c('i', {
      staticClass: "fa fa-mobile-phone",
      attrs: {
        "title": "Recept odeslán přes SMS",
        "aria-hidden": "true"
      }
    }) : (m.prescription.patient_notification_type === 'EMAIL') ? _c('i', {
      staticClass: "fa fa-envelope-o",
      attrs: {
        "title": "Recept odeslán přes e-mail",
        "aria-hidden": "true"
      }
    }) : _c('i', {
      staticClass: "fa fa-ban text-danger",
      attrs: {
        "title": "Bez notifikace o receptu",
        "aria-hidden": "true"
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "col-md-1 row justify-content-start m-0"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary btn_line-heigh-1",
      attrs: {
        "title": "kopírovat"
      },
      on: {
        "click": function($event) {
          _vm.copyVoucher(m)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]
  })], 2)])]) : (_vm.vouchersPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n    ")]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-md-5"
  }, [_vm._v("Lék")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Hradí pacient")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Počet bal.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Dávkování")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Předepsáno")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddVoucher_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6644368b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AddVoucher_vue__ = __webpack_require__(591);
function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddVoucher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6644368b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AddVoucher_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selected: null,
      selectedDisease: null,

      fromSearch: '',
      voucher: {
        medicalDevice: '',
        disease: null,
        incontinence_grade: null,
        amount: 1,
        paid_by_sick: false,
        validity_in_days: 30,
        electronic_prescription: true,
        patient_notification_type: false,
        separate: true,
        temporary: true,
        temporary_duration_months: null,
        payment: 1
      },
      originalVoucherValidityInDays: 30,

      voucherPending: false,
      voucherError: false,
      voucherDone: false,

      medicalDevices: [],
      medicalDevicesError: false,
      medicalDevicesPending: false,

      diseases: [],
      diseasesPending: false,
      diseasesError: false,

      clientMedicalDeviceInfo: false,
      clientMedicalDeviceInfoPending: false,
      clientMedicalDeviceInfoError: false,
      clientMedicalDeviceInfoDone: false,
      readyToDuplicate: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: ['copiedVoucher', 'clientId', 'visitId'],
  methods: {
    getResult: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (text) {
      if (text.length > 2) {
        this.getMedicalDevices(text);
      }
    }, 600),
    duplicateMedicalDeviceByCode: function duplicateMedicalDeviceByCode(code) {
      this.readyToDuplicate = true;
      this.getMedicalDevices(code);
    },
    saveVoucher: function saveVoucher() {
      for (var property in this.voucher) {
        if (this.voucher.hasOwnProperty(property) && this.voucher[property] === '') {
          this.voucher[property] = null;
        }
      }
      this.voucherError = false;
      this.postVoucher(this.voucher, this.clientId, this.visitId);
    },
    selectMedicalDevice: function selectMedicalDevice(val) {
      this.voucher.medicalDevice = { 'code': val.code };
      this.getClientMedicalDeviceInfo(this.clientId, '0000009');
    },
    voucherAdded: function voucherAdded() {
      this.$emit('update');
    },
    selectDisease: function selectDisease(val) {
      this.voucher.disease = { 'code': val.code };
    }
  },
  computed: {
    validToDate: function validToDate() {
      return this.$moment().add(this.voucher.validity_in_days, 'days').format('L');
    }
  },
  watch: {
    'voucher.incontinence_grade': function voucherIncontinence_grade(val) {
      if (val === 3) {
        this.voucher.payment = 3;
      } else if (val === 2) {
        this.voucher.payment = 2;
      } else if (val === 1) {
        this.voucher.payment = 1;
      }
    },
    medicalDevicesPending: function medicalDevicesPending(val) {
      if (val === false && this.readyToDuplicate === true) {
        this.selected = this.medicalDevices[0];
        this.selectMedicalDevice({ code: this.medicalDevices[0].code });
      }
    },
    voucherPending: function voucherPending(val) {
      if (val === false) {
        this.voucher = {
          medicalDevice: '',
          disease: null,
          incontinence_grade: null,
          amount: 1,
          paid_by_sick: false,
          validity_in_days: 30,
          electronic_prescription: true,
          patient_notification_type: false,
          separate: true,
          temporary: true,
          temporary_duration_months: null,
          payment: 1
        };
        this.clientMedicalDeviceInfo = false;
        this.selected = null;
        this.selectedDisease = null;
        this.$emit('update');
        this.voucherDone = false;
      }
    },
    clientMedicalDeviceInfoDone: function clientMedicalDeviceInfoDone(val) {
      if (val === true && this.readyToDuplicate === true) {
        this.voucher.disease = this.copiedVoucher.disease;
        this.voucher.amount = this.copiedVoucher.amount;
        this.voucher.family = this.copiedVoucher.family;
        this.voucher.paid_by_sick = this.copiedVoucher.paid_by_sick;

        if (this.copiedVoucher && this.copiedVoucher.patient_notification_type) {
          this.voucher.patient_notification_type = this.copiedVoucher.patient_notification_type;
        } else {
          this.voucher.patient_notification_type = this.clientMedicalDeviceInfo.possible_notifications[this.clientMedicalDeviceInfo.possible_notifications.length - 1].key;
        }
        this.voucher.validity_in_days = this.clientMedicalDeviceInfo.validity;
        this.originalVoucherValidityInDays = this.clientMedicalDeviceInfo.validity;

        this.readyToDuplicate = false;
      } else if (val === true) {
        if (this.clientMedicalDeviceInfo.disease) {
          this.selectedDisease = this.clientMedicalDeviceInfo.disease;
          this.selectDisease(this.clientMedicalDeviceInfo.disease);
        } else {
          this.selectedDisease = null;
          this.voucher.disease = null;
        }
        this.voucher.patient_notification_type = this.clientMedicalDeviceInfo.possible_notifications[this.clientMedicalDeviceInfo.possible_notifications.length - 1].key;
        this.voucher.paid_by_sick = this.clientMedicalDeviceInfo.paid_by_sick;
        this.voucher.validity_in_days = this.clientMedicalDeviceInfo.validity;
        this.originalVoucherValidityInDays = this.clientMedicalDeviceInfo.validity;
      }
    },
    copiedVoucher: function copiedVoucher(val) {
      if (val !== null) {
        this.duplicateMedicalDeviceByCode(val.medicalDevice.code);
      }
    }
  }
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-info"
  }, [_c('div', {
    staticClass: "card-text"
  }, [_c('form', {
    attrs: {
      "data-testid": "visit-voucher-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveVoucher($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-11 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "searchMedicalDevice"
    }
  }, [_vm._v("Zdravotnický prostředek")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "searchMedicalDevice",
      "label": "label",
      "track-by": "code",
      "open-direction": "bottom",
      "placeholder": "vyhledat zdravotnický prostředek",
      "data-testid": "visit-voucher-device-search",
      "options": _vm.medicalDevices,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 400,
      "show-no-results": false,
      "hide-selected": false,
      "selectLabel": "vybrat"
    },
    on: {
      "search-change": _vm.getResult,
      "select": _vm.selectMedicalDevice
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-0 font-sm"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [(props.option.has_actual_insruance_cover === true) ? _c('i', {
          staticClass: "fas fa-coins",
          staticStyle: {
            "color": "goldenrod"
          }
        }) : _vm._e(), _vm._v("\n                                  " + _vm._s(props.option.label) + "\n                                ")])]), _vm._v(" "), _c('div', {
          staticClass: "row m-0 font-xs font-weight-normal"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('span', [_vm._v("\n                                     " + _vm._s(props.option.description) + "\n                                  ")])])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), (_vm.voucherError.medicalDevice) ? _c('small', {
    staticClass: "form-text font-weight-bold",
    attrs: {
      "id": "medicalDeviceError"
    }
  }, [_vm._v(_vm._s(_vm.voucherError.medicalDevice.message))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 mb-2"
  }, [(_vm.clientMedicalDeviceInfoPending === true) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-2x fa-fw"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "searchDiagnosis"
    }
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "searchDiagnosis",
      "label": "label",
      "track-by": "code",
      "data-testid": "visit-voucher-disease-search",
      "placeholder": "vyhledat diagnózu",
      "options": _vm.diseases,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getDiseases,
      "select": _vm.selectDisease
    },
    model: {
      value: (_vm.selectedDisease),
      callback: function($$v) {
        _vm.selectedDisease = $$v
      },
      expression: "selectedDisease"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "paidBySick"
    }
  }, [_vm._v("Hradí pacient")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.paid_by_sick),
      expression: "voucher.paid_by_sick"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "paidBySick",
      "checked": "",
      "data-testid": "visit-voucher-paid-by-client"
    },
    domProps: {
      "checked": Array.isArray(_vm.voucher.paid_by_sick) ? _vm._i(_vm.voucher.paid_by_sick, null) > -1 : (_vm.voucher.paid_by_sick)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.voucher.paid_by_sick,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.voucher.paid_by_sick = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.voucher.paid_by_sick = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.voucher.paid_by_sick = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-begin"
  }, [_c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Počet balení")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.amount),
      expression: "voucher.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "amount",
      "min": "1",
      "data-testid": "visit-voucher-quantity"
    },
    domProps: {
      "value": (_vm.voucher.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "temporary"
    }
  }, [_vm._v("Dočasná")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.temporary),
      expression: "voucher.temporary"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "temporary",
      "checked": "",
      "data-testid": "visit-voucher-temporary"
    },
    domProps: {
      "checked": Array.isArray(_vm.voucher.temporary) ? _vm._i(_vm.voucher.temporary, null) > -1 : (_vm.voucher.temporary)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.voucher.temporary,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.voucher.temporary = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.voucher.temporary = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.voucher.temporary = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "temporary_duration_months"
    }
  }, [_vm._v("na počet měsíců")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.temporary_duration_months),
      expression: "voucher.temporary_duration_months"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "temporary_duration_months",
      "min": "1",
      "max": "365",
      "data-testid": "visit-voucher-temporary-months"
    },
    domProps: {
      "value": (_vm.voucher.temporary_duration_months)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.temporary_duration_months = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "family"
    }
  }, [_vm._v("Rodina")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.family),
      expression: "voucher.family"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "family",
      "checked": "",
      "data-testid": "visit-voucher-family"
    },
    domProps: {
      "checked": Array.isArray(_vm.voucher.family) ? _vm._i(_vm.voucher.family, null) > -1 : (_vm.voucher.family)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.voucher.family,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.voucher.family = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.voucher.family = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.voucher.family = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "validityInDays"
    }
  }, [_vm._v("Platnost (dní)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.validity_in_days),
      expression: "voucher.validity_in_days"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "validityInDays",
      "min": "1",
      "max": "365",
      "data-testid": "visit-voucher-validity"
    },
    domProps: {
      "value": (_vm.voucher.validity_in_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.validity_in_days = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text font-weight-bold"
  }, [_vm._v("do " + _vm._s(_vm.validToDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "incontinence_grade"
    }
  }, [_vm._v("Stupeň inkontinence")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.incontinence_grade === null
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.incontinence_grade),
      expression: "voucher.incontinence_grade"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "data-testid": "visit-voucher-incontinence-none"
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.voucher.incontinence_grade, null)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.incontinence_grade = null
      }
    }
  }), _vm._v(" ne\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.incontinence_grade === 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.incontinence_grade),
      expression: "voucher.incontinence_grade"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "data-testid": "visit-voucher-incontinence-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.voucher.incontinence_grade, 1)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.incontinence_grade = 1
      }
    }
  }), _vm._v(" 1\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.incontinence_grade === 2
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.incontinence_grade),
      expression: "voucher.incontinence_grade"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off",
      "data-testid": "visit-voucher-incontinence-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.voucher.incontinence_grade, 2)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.incontinence_grade = 2
      }
    }
  }), _vm._v(" 2\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.incontinence_grade === 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.incontinence_grade),
      expression: "voucher.incontinence_grade"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option3",
      "autocomplete": "off",
      "data-testid": "visit-voucher-incontinence-3"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.voucher.incontinence_grade, 3)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.incontinence_grade = 3
      }
    }
  }), _vm._v(" 3\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("E-Poukaz")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.electronic_prescription),
      expression: "voucher.electronic_prescription"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "type",
      "data-testid": "visit-voucher-electronic",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.voucher.electronic_prescription) ? _vm._i(_vm.voucher.electronic_prescription, null) > -1 : (_vm.voucher.electronic_prescription)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.voucher.electronic_prescription,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.voucher.electronic_prescription = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.voucher.electronic_prescription = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.voucher.electronic_prescription = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "notification"
    }
  }, [_vm._v("Notifikace")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.patient_notification_type),
      expression: "voucher.patient_notification_type"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "notification",
      "id": "notification",
      "disabled": _vm.voucher.electronic_prescription !== true,
      "data-testid": "visit-voucher-notification"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.voucher.patient_notification_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.clientMedicalDeviceInfo.possible_notifications), function(pn, index) {
    return _c('option', {
      domProps: {
        "value": pn.key
      }
    }, [_vm._v(_vm._s(pn.label) + "\n              ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "payment"
    }
  }, [_vm._v("Úhrada (UHR)")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.payment === null
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.payment),
      expression: "voucher.payment"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "data-testid": "visit-voucher-payment-none"
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.voucher.payment, null)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.payment = null
      }
    }
  }), _vm._v(" ne\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.payment === 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.payment),
      expression: "voucher.payment"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off",
      "data-testid": "visit-voucher-payment-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.voucher.payment, 1)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.payment = 1
      }
    }
  }), _vm._v(" 1\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.payment === 2
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.payment),
      expression: "voucher.payment"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option3",
      "autocomplete": "off",
      "data-testid": "visit-voucher-payment-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.voucher.payment, 2)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.payment = 2
      }
    }
  }), _vm._v(" 2\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.payment === 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.payment),
      expression: "voucher.payment"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option4",
      "autocomplete": "off",
      "data-testid": "visit-voucher-payment-3"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.voucher.payment, 3)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.payment = 3
      }
    }
  }), _vm._v(" 3\n              ")])])])]), _vm._v(" "), _vm._m(0)])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit",
      "data-testid": "visit-voucher-submit"
    }
  }, [_vm._v("Vystavit poukaz")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('list-voucher', {
    attrs: {
      "do-update": _vm.reloadVoucher,
      "clientId": _vm.clientId,
      "visitId": _vm.visitId
    },
    on: {
      "updated": _vm.updateVoucherDone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('add-voucher', {
    attrs: {
      "client-id": _vm.clientId,
      "visit-id": _vm.visitId,
      "copied-voucher": _vm.voucherToCopy
    },
    on: {
      "update": _vm.updateVoucher
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-light"
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentComponent_vue__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86717aaa_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentComponent_vue__ = __webpack_require__(600);
function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86717aaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86717aaa_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentComponent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentList_vue__ = __webpack_require__(596);






var STATUS_INITIAL = 0;
var STATUS_SAVING = 1;
var STATUS_SUCCESS = 2;
var STATUS_FAILED = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadPending: false,
      uploadDone: false,
      uploadFieldName: 'files',
      fileCount: 0,
      previewFiles: [],
      imgFiles: null,
      reloadList: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  computed: {
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  watch: {
    uploadDone: function uploadDone(val) {
      if (val === true) {
        this.reloadList = true;
        this.reset();
      }
    }
  },
  methods: {
    reset: function reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
      this.fileCount = 0;
    },
    save: function save(formData) {
      this.uploadDone = false;

      this.currentStatus = STATUS_SAVING;

      this.uploadFile(formData);
    },
    filesChange: function filesChange(fieldName, fileList) {
      var _this = this;

      var self = this;

      var formData = new FormData();

      if (!fileList.length) return;
      this.fileCount = fileList.length;

      var _loop = function _loop(i) {
        var file = fileList[i];
        var picReader = new FileReader();

        if (file.type.match('image')) {
          picReader.addEventListener('load', function (event) {
            var picFile = event.target;
            self.previewFiles[i] = picFile.result;
          });
          picReader.readAsDataURL(file);
        }

        _this.$emit('input', fileList[0]);
        formData.append('files[' + i + ']', file);
        if (_this.$route.params.visitid) {
          formData.append('visit_id', _this.$route.params.visitid);
        }
        formData.append('client_id', _this.$route.params.clientid);
      };

      for (var i = 0; i < fileList.length; i++) {
        _loop(i);
      }

      this.$nextTick(function () {});

      this.save(formData);
    }
  },
  mounted: function mounted() {
    this.reset();
  },

  components: {
    DocumentList: __WEBPACK_IMPORTED_MODULE_1__DocumentList_vue__["a" /* default */]
  }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentList_vue__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c4f640_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentList_vue__ = __webpack_require__(599);
function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13c4f640"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c4f640_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PaginationComponent_vue__ = __webpack_require__(25);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      getParams: {
        p: 1,
        s: 'file_date-',
        f: {},
        pp: 20
      },
      setting: __webpack_require__(3),
      listData: false,
      listError: false,
      listPagination: null,
      listPending: false,

      documentDeletePending: false,
      documentDeleteDone: false,
      documentDeleteError: null
    };
  },

  props: ['reload'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    setPage: function setPage(number) {
      this.getParams.p = number;
      this.loadDocuments();
    },
    loadDocuments: function loadDocuments() {
      this.getDocuments(this.getParams);
    },
    clickDeleteDocument: function clickDeleteDocument(id) {
      this.deleteDocument(id);
    }
  },
  beforeMount: function beforeMount() {
    this.getParams.f = { 'visit': this.$route.params.visitid, 'client': this.$route.params.clientid };

    this.loadDocuments();
  },

  watch: {
    reload: function reload(val) {
      if (val === true) {
        this.loadDocuments();
      }
    },
    listPending: function listPending(val, oldVal) {
      if (oldVal === true && val === false) {
        this.$emit('listReloaded');
      }
    },
    documentDeletePending: function documentDeletePending(val, oldVal) {
      if (oldVal === true && val === false) {
        this.loadDocuments();
      }
    }
  },
  components: {
    PaginationComponent: __WEBPACK_IMPORTED_MODULE_1__components_PaginationComponent_vue__["a" /* default */]
  },
  filters: {}
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-4 mb-1"
  }, [(_vm.listData.length > 0) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.listData), function(document, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      attrs: {
        "data-testid": 'document-' + document.id
      }
    }, [_c('td', {
      staticClass: "col-sm-6"
    }, [_c('a', {
      attrs: {
        "href": _vm.setting.hostname + 'document/' + document.id + '/view',
        "target": "_blank",
        "data-testid": 'document-view-' + document.id
      }
    }, [_vm._v(_vm._s(document.original_file_name))]), _vm._v(" |\n                    "), _c('a', {
      attrs: {
        "href": _vm.setting.hostname + 'document/' + document.id + '/save',
        "target": "_blank",
        "data-testid": 'document-download-' + document.id
      }
    }, [_vm._v("stáhnout")])]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v("\n                      " + _vm._s(document.file_size_nicely) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                      " + _vm._s(document.file_date) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                      " + _vm._s(document.uploaded_by ? document.uploaded_by.fullname : '') + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "data-testid": 'document-delete-' + document.id
      },
      on: {
        "click": function($event) {
          _vm.deleteDocument(document.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]
  })], 2)]), _vm._v(" "), _c('pagination-component', {
    attrs: {
      "list-pagination": _vm.listPagination
    },
    on: {
      "set-page": _vm.setPage
    }
  })], 1) : (_vm.listPending) ? _c('div', [_vm._m(1)]) : _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n          (nebyl nalezen žádný dokument)\n      ")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-6"
  }, [_vm._v("Název")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Velikost")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Datum")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Nahrál")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n              (načítám)\n      ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "documents"
    }
  }, [(_vm.isInitial || _vm.isSaving) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "name": _vm.uploadFieldName,
      "multiple": "",
      "disabled": _vm.isSaving,
      "data-testid": "document-upload"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files)
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n                Sem přetáhni soubory, nebo kliknu pro nahrání\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', {
    attrs: {
      "data-testid": "document-upload-status"
    }
  }, [_vm._v("\n                Nahrávám " + _vm._s(_vm.fileCount) + " soubor...\n            ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('document-list', {
    attrs: {
      "reload": _vm.reloadList
    },
    on: {
      "listReloaded": function($event) {
        _vm.reloadList = false
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10fc7ba4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__ = __webpack_require__(607);
function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10fc7ba4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10fc7ba4_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VisitPurposes_vue__ = __webpack_require__(604);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      today: '',
      waitForData: false,
      setting: __webpack_require__(3),
      useGovData: false,
      justtry: 1,
      get_params: {
        firstname: '',
        lastname: '',
        pid: ''
      },
      countries: [],
      client: {
        healthinsurance: {}
      },
      errors: {},
      beck: document.referrer,
      patientInfo: true
    };
  },

  components: {
    VisitPurposes: __WEBPACK_IMPORTED_MODULE_0__components_VisitPurposes_vue__["a" /* default */]
  },
  methods: {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitPurposes_vue__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_265195e3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VisitPurposes_vue__ = __webpack_require__(606);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitPurposes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_265195e3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_VisitPurposes_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setting: __webpack_require__(3),
      visit_purposes: '',
      edited_visit_purpose: {
        id: '',
        purpose: '',
        duration: '',
        default: ''
      },
      minutes_per_window: 5,
      waitForResponse: false,
      waitForSave: false,
      id_default: '',
      id_hovered: '',
      visit_purpose: {
        purpose: '',
        duration: 30 / this.minutes_per_window }
    };
  },

  methods: {
    getVisitPurposes: function getVisitPurposes() {
      var _this = this;

      this.waitForResponse = true;
      this.$http.get(this.setting.hostname + 'visit_purpose').then(function (response) {
        _this.visit_purposes = response.data;
        _this.waitForResponse = false;
      }, function (response) {
        _this.waitForResponse = false;
      });
    },
    changeDefaultTo: function changeDefaultTo(newId) {
      var _this2 = this;

      var visitPurposeOldDefault = { id: this.id_default, default: false };
      this.$http.put(this.setting.hostname + 'visit_purpose/' + this.id_default, visitPurposeOldDefault, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        var visitPurposeNewDefault = { id: newId, default: true };
        _this2.$http.put(_this2.setting.hostname + 'visit_purpose/' + newId, visitPurposeNewDefault, { emulateJSON: true }).then(function (response) {
          _this2.submited = response.data;
          _this2.getVisitPurposes();
        }, function (response) {
          _this2.errors = response.data.errors;
        });
      }, function (response) {
        _this2.errors = response.data.errors;
      });
    },
    postVisitPurpose: function postVisitPurpose() {
      var _this3 = this;

      this.waitForSave = true;
      this.$http.post(this.setting.hostname + 'visit_purpose', this.visit_purpose, { emulateJSON: true }).then(function (response) {
        _this3.waitForSave = false;
        _this3.getVisitPurposes();
      }, function (response) {
        _this3.errors = response.data.errors;
        _this3.waitForSave = false;
      });
    },
    putVisitPurpose: function putVisitPurpose() {
      var _this4 = this;

      this.$http.put(this.setting.hostname + 'visit_purpose/' + this.edited_visit_purpose.id, this.edited_visit_purpose, { emulateJSON: true }).then(function (response) {
        _this4.submited = response.data;
        _this4.getVisitPurposes();
        _this4.edited_visit_purpose = '';
      }, function (response) {
        _this4.errors = response.data.errors;
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getVisitPurposes();
  }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Nastavení druhů návštěv\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row between_rows justify-content-center"
  }, [(_vm.visit_purposes.length > 0 && !_vm.waitForResponse) ? _c('table', {
    staticClass: "table",
    attrs: {
      "data-testid": "settings-visit-purpose-list"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.visit_purposes), function(visit_purpose, index) {
    return _c('tr', {
      key: visit_purpose.id,
      attrs: {
        "data-testid": 'settings-visit-purpose-row-' + visit_purpose.id
      }
    }, [(_vm.edited_visit_purpose.id != visit_purpose.id) ? _c('td', {
      attrs: {
        "data-testid": 'settings-visit-purpose-name-' + visit_purpose.id
      }
    }, [_vm._v(_vm._s(visit_purpose.purpose))]) : _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edited_visit_purpose.purpose),
        expression: "edited_visit_purpose.purpose"
      }],
      staticClass: "form-control mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "purposeHelp",
        "id": "editPurpose",
        "data-testid": 'settings-visit-purpose-edit-name-' + visit_purpose.id
      },
      domProps: {
        "value": (_vm.edited_visit_purpose.purpose)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.edited_visit_purpose.purpose = $event.target.value
        }
      }
    })]), _vm._v(" "), (_vm.edited_visit_purpose.id != visit_purpose.id) ? _c('td', [_vm._v(_vm._s(visit_purpose.duration * _vm.minutes_per_window) + " minut")]) : _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edited_visit_purpose.duration),
        expression: "edited_visit_purpose.duration"
      }],
      staticClass: "form-control mr-sm-2",
      attrs: {
        "id": "editDuration",
        "data-testid": 'settings-visit-purpose-edit-duration-' + visit_purpose.id
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.edited_visit_purpose.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "disabled": "",
        "selected": ""
      }
    }, [_vm._v("zvolit čas")]), _vm._v(" "), _vm._l((24), function(duration) {
      return _c('option', {
        domProps: {
          "value": duration
        }
      }, [_vm._v(_vm._s(duration * 5) + " minut")])
    })], 2)]), _vm._v(" "), (visit_purpose.default == true) ? _c('td', {
      attrs: {
        "data-defualt": _vm.id_default = visit_purpose.id,
        "data-testid": 'settings-visit-purpose-default-' + visit_purpose.id
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    })]) : _c('td', {
      attrs: {
        "data-testid": 'settings-visit-purpose-make-default-' + visit_purpose.id
      },
      on: {
        "mouseover": function($event) {
          _vm.id_hovered = visit_purpose.id
        },
        "mouseleave": function($event) {
          _vm.id_hovered = ''
        },
        "click": function($event) {
          _vm.changeDefaultTo(visit_purpose.id)
        }
      }
    }, [(_vm.id_hovered == visit_purpose.id) ? _c('i', {
      staticClass: "fa fa-check-circle-o"
    }) : _c('i', {
      staticClass: "fa fa-circle-o"
    })]), _vm._v(" "), (_vm.edited_visit_purpose.id != visit_purpose.id) ? _c('td', [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "data-testid": 'settings-visit-purpose-edit-' + visit_purpose.id
      },
      on: {
        "click": function($event) {
          _vm.edited_visit_purpose = Object.assign({}, visit_purpose)
        }
      }
    }, [_vm._v("Upravit")])]) : _c('td', [_c('button', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "data-testid": 'settings-visit-purpose-save-' + visit_purpose.id
      },
      on: {
        "click": function($event) {
          _vm.putVisitPurpose()
        }
      }
    }, [_vm._v("Uložit")])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.waitForResponse) ? _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-block bg-light"
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postVisitPurpose($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "purpose"
    }
  }, [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit_purpose.purpose),
      expression: "visit_purpose.purpose"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "type": "text",
      "aria-describedby": "purposeHelp",
      "id": "purpose",
      "data-testid": "settings-visit-purpose-new-name"
    },
    domProps: {
      "value": (_vm.visit_purpose.purpose)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visit_purpose.purpose = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "purposeHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Délka návštěvy:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit_purpose.duration),
      expression: "visit_purpose.duration"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "id": "duration",
      "data-testid": "settings-visit-purpose-new-duration"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit_purpose.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit čas")]), _vm._v(" "), _vm._l((24), function(duration) {
    return _c('option', {
      domProps: {
        "value": duration
      }
    }, [_vm._v(_vm._s(duration * 5) + " minut")])
  })], 2), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "settings-visit-purpose-add"
    }
  }, [_vm._v("Přidat druh návštěvy")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('th', [_vm._v("Délka návštěvy")]), _vm._v(" "), _c('th', [_vm._v("Výchozí")]), _vm._v(" "), _c('th')])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_reception",
    attrs: {
      "data-testid": "settings-page"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('visit-purposes')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddVisit_vue__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38fecbfc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddVisit_vue__ = __webpack_require__(615);
function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38fecbfc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddVisit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38fecbfc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddVisit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmVisitModal_vue__ = __webpack_require__(611);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasData: false,
      waitForSave: false,
      calendarSize: 'week',
      startWindow: 97,
      endWindow: 241,
      windowsPerHour: 12,
      startHour: 96 / 12,
      setting: __webpack_require__(3),
      visits: [],
      doctors: '',
      branches: '',
      selectedWindow: null,
      lastDuration: '',
      visit_purposes: '',
      selected_element: null,
      visit: {
        date: '',
        clientid: this.$route.params.clientid,
        doctorid: 1,
        duration: 6,
        operation: ''
      },
      get_params: {
        from: '',
        to: '',
        doctorid: ''
      },
      start_date: '',
      end_date: '',
      begin_of_month: '',
      end_of_month: '',
      today: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
      actual_select: {
        selected: false,
        time: '',
        date: '',
        window: '',
        day: ''
      },
      showModal: false,
      purposeid: ''
    };
  },

  methods: {
    postVisit: function postVisit() {
      var _this = this;

      this.waitForSave = true;
      this.visit.purposeid = this.purposeid;
      this.$http.post(this.setting.hostname + 'visit', this.visit, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.getVisits();
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    windowToTime: function windowToTime(window) {
      window = window - 1;
      var hour = Math.floor(window / this.windowsPerHour);
      var minute = window % this.windowsPerHour * 5;
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().hour(hour).minute(minute);
    },
    clearLastSelect: function clearLastSelect() {
      if (this.selectedWindow) {
        var element = this.selectedWindow;
        console.log(element.tagName);
        for (var i = 0; i < this.lastDuration; i++) {
          element.classList.remove('selected_window');
          element = element.nextSibling;
        }
      }
    },
    prepareVisit: function prepareVisit(window, date, event) {
      this.actual_select.window = window;
      this.actual_select.selected = true;
      var forTime = this.windowToTime(window);
      this.actual_select.date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).hour(forTime.hour()).minute(forTime.minute());
      this.visit.date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('L');
      this.visit.timewindow = window;

      this.clearLastSelect();
      var element = event.target;
      this.selectedWindow = event.target;

      this.lastDuration = this.visit.duration;
      for (var i = 0; i < this.visit.duration; i++) {
        element.classList.add('selected_window');
        element = element.nextSibling;
      }
    },
    changeSelectedWindows: function changeSelectedWindows() {
      if (this.selectedWindow) {
        var element = this.selectedWindow;
        this.clearLastSelect();
        this.lastDuration = this.visit.duration;
        for (var i = 0; i < this.visit.duration; i++) {
          element.classList.add('selected_window');
          element = element.nextSibling;
        }
      }
    },
    getRightClassForTd: function getRightClassForTd(items) {
      var classes = '';
      items.forEach(function (item) {
        if (!classes.includes(item.type)) {
          classes = classes + ' ' + item.type;
        } else {
          classes = classes + ' ' + item.type + '-multi';
        }
      });
      return classes;
    },
    initialSet: function initialSet() {
      __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('cs');
      this.actualPeriod();
    },
    getDoctors: function getDoctors() {
      var _this2 = this;

      this.$http.get(this.setting.hostname + 'doctor').then(function (response) {
        _this2.doctors = response.data;
      }, function (response) {});
    },
    getBranches: function getBranches() {
      var _this3 = this;

      this.$http.get(this.setting.hostname + 'branch').then(function (response) {
        _this3.branches = response.data;
      }, function (response) {});
    },
    getVisits: function getVisits() {
      var _this4 = this;

      this.hasData = false;
      this.get_params.from = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.start_date).format('DD.MM.YYYY');
      this.get_params.to = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.end_date).format('DD.MM.YYYY');
      this.get_params.doctorid = this.visit.doctorid;
      this.$http.get(this.setting.hostname + 'visit', { params: this.get_params }).then(function (response) {
        _this4.visits = response.data.visits;
        _this4.hasData = true;
      }, function (response) {});
    },
    actualPeriod: function actualPeriod() {
      if (this.calendarSize === 'week') {
        this.start_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('isoWeek');
        this.end_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('isoWeek');
      } else if (this.calendarSize === 'month') {
        this.start_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('month');
        this.end_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('month');
      } else {
        this.start_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
        this.start_date = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
      }
    },
    nextPeriod: function nextPeriod() {
      if (this.calendarSize === 'week') {
        this.start_date = this.start_date.add(1, 'weeks');
        this.end_date = this.end_date.add(1, 'weeks');
      } else if (this.calendarSize === 'month') {
        this.start_date = this.start_date.add(1, 'months');
        this.end_date = this.end_date.add(1, 'months');
      } else {
        this.start_date = this.start_date.add(1, 'days');
        this.end_date = this.end_date.add(1, 'days');
      }
    },
    previousPeriod: function previousPeriod() {
      if (this.calendarSize === 'week') {
        this.start_date = this.start_date.subtract(1, 'weeks');
        this.end_date = this.end_date.subtract(1, 'weeks');
      } else if (this.calendarSize === 'month') {
        this.start_date = this.start_date.subtract(1, 'months');
        this.end_date = this.end_date.subtract(1, 'months');
      } else {
        this.start_date = this.start_date.subtract(1, 'days');
        this.end_date = this.end_date.subtract(1, 'days');
      }
    },
    loadCalendar: function loadCalendar() {
      this.getVisits();
    },

    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date);
    },
    hoverWindows: function hoverWindows(event) {
      var element = event.target;
      for (var i = 0; i < this.visit.duration; i++) {
        element.classList.add('hovered_window');
        element = element.nextSibling;
      }
    },
    unhoverWindows: function unhoverWindows(event) {
      var element = event.target;
      for (var i = 0; i < this.visit.duration; i++) {
        element.classList.remove('hovered_window');
        element = element.nextSibling;
      }
    },
    getVisitPurposes: function getVisitPurposes() {
      var _this5 = this;

      this.waitForResponse = true;
      this.$http.get(this.setting.hostname + 'visit_purpose').then(function (response) {
        _this5.visit_purposes = response.data;
        _this5.visit_purposes.forEach(function (visitPurpose) {
          if (visitPurpose.default === true) {
            this.visit.operation = visitPurpose.purpose;
            this.visit.duration = visitPurpose.duration;
          }
        });
        _this5.waitForResponse = false;
      }, function (response) {
        _this5.waitForResponse = false;
      });
    },
    changeVisitDuration: function changeVisitDuration(event) {
      console.log(event.target.tagName);
    }
  },
  beforeMount: function beforeMount() {
    this.getDoctors();
    this.initialSet();
    this.getVisitPurposes();
  },
  isSelected: function isSelected(indexD, indexTM) {
    return false;
  },

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__ConfirmVisitModal_vue__["a" /* default */]
  },
  watch: {
    purposeid: function purposeid(val) {}
  }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmVisitModal_vue__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f3aca0_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmVisitModal_vue__ = __webpack_require__(614);
function injectStyle (ssrContext) {
  __webpack_require__(612)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55f3aca0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmVisitModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f3aca0_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmVisitModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  template: '#modal-template',
  props: ['show'],
  data: function data() {
    return {
      title: '',
      body: ''
    };
  },

  methods: {
    close: function close() {
      this.$emit('close');
      this.title = '';
      this.body = '';
    },
    savePost: function savePost() {

      this.close();
    }
  },
  mounted: function mounted() {
    var _this = this;

    document.addEventListener('keydown', function (e) {
      if (_this.show && e.keyCode === 27) {
        _this.close();
      }
    });
  }

});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-template"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("New Post")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n                        Title\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n                        Body\n                        "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body),
      expression: "body"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.savePost()
      }
    }
  }, [_vm._v("\n                        Save\n                    ")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Naplánovat návštěvu\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postVisit($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "doctor"
    }
  }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.doctorid),
      expression: "visit.doctorid"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.doctorid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.loadCalendar()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit doktora")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.branchid),
      expression: "visit.branchid"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat pobočku"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.branchid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.loadCalendar()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit pobočku")]), _vm._v(" "), _vm._l((_vm.branches), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "doctorHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("za účelem")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purposeid),
      expression: "purposeid"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "operation"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.purposeid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeVisitDuration]
    }
  }, _vm._l((_vm.visit_purposes), function(visit_purpose) {
    return _c('option', {
      domProps: {
        "value": visit_purpose.id
      }
    }, [_vm._v(_vm._s(visit_purpose.purpose))])
  })), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "operationHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Délka návštěvy:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.duration),
      expression: "visit.duration"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "id": "duration"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeSelectedWindows()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit čas")]), _vm._v(" "), _vm._l((24), function(duration) {
    return _c('option', {
      domProps: {
        "value": duration
      }
    }, [_vm._v(_vm._s(duration * 5) + " minut")])
  })], 2), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Přidat návštěvu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.actual_select.selected) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.moment(_vm.actual_select.date).format('dddd')) + " " + _vm._s(_vm.moment(_vm.actual_select.date).format('LL')) + " v " + _vm._s(_vm.moment(_vm.actual_select.date).format('LT'))), _c('br')]) : _c('div', [_vm._v("\n            Vyberte den a čas v kalendáři\n        ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.previousPeriod() + _vm.getVisits()
      }
    }
  }, [_vm._v("Předchozí")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.calendarSize === 'day'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calendarSize),
      expression: "calendarSize"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "value": "day"
    },
    domProps: {
      "checked": _vm._q(_vm.calendarSize, "day")
    },
    on: {
      "__c": function($event) {
        _vm.calendarSize = "day"
      }
    }
  }), _vm._v(" den\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.calendarSize === 'week'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calendarSize),
      expression: "calendarSize"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off",
      "value": "week"
    },
    domProps: {
      "checked": _vm._q(_vm.calendarSize, "week")
    },
    on: {
      "__c": function($event) {
        _vm.calendarSize = "week"
      }
    }
  }), _vm._v(" týden\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.calendarSize === 'month'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calendarSize),
      expression: "calendarSize"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option3",
      "autocomplete": "off",
      "value": "month"
    },
    domProps: {
      "checked": _vm._q(_vm.calendarSize, "month")
    },
    on: {
      "__c": function($event) {
        _vm.calendarSize = "month"
      }
    }
  }), _vm._v(" měsíc\n                ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.nextPeriod() + _vm.getVisits()
      }
    }
  }, [_vm._v("Následující")])])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div'), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(_vm.get_params.from) + " - " + _vm._s(_vm.get_params.to) + "\n            ")]), _vm._v(" "), _c('div')]), _vm._v(" "), (_vm.visit.doctorid) ? _c('table', {
    staticClass: "table table_calendar"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / _vm.windowsPerHour)), function(times, index) {
    return _c('th', {
      attrs: {
        "colspan": _vm.windowsPerHour
      }
    }, [_vm._v("\n                    " + _vm._s((index + _vm.startHour) < 10 ? '0' + (index + _vm.startHour) : (index + _vm.startHour)) + "\n                ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / (_vm.windowsPerHour / 2))), function(times, index) {
    return _c('th', {
      staticClass: "halfHour",
      attrs: {
        "colspan": (_vm.windowsPerHour / 2)
      }
    }, [_vm._v("\n                     \n                ")])
  })], 2), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.hasData) ? _c('tbody', _vm._l(((this.end_date.diff(this.start_date, 'days') + 1)), function(n) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.moment(_vm.start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.moment(_vm.start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        class: _vm.getRightClassForTd(_vm.visits[_vm.moment(_vm.start_date).add(n - 1, 'days').format('YYYY-MM-DD')][_vm.startWindow + cell - 1]) + ' ' + ((cell % _vm.windowsPerHour === 0) ? 'hourly' : '') + ' ' + ((cell % _vm.windowsPerHour === _vm.windowsPerHour / 2) ? 'halfhourly' : ''),
        attrs: {
          "data-window-id": n + '_' + (_vm.startWindow + cell - 1)
        },
        on: {
          "mouseover": _vm.hoverWindows,
          "mouseleave": _vm.unhoverWindows,
          "click": function($event) {
            _vm.prepareVisit(_vm.startWindow + cell - 1, _vm.moment(_vm.start_date).add(n - 1, 'days'), $event)
          }
        }
      }, [_vm._v("\n                     \n                ")])
    })], 2)
  })) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-body text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ShowClient',
        params: {
          clientid: this.$route.params.clientid
        }
      }
    }
  }, [_vm._v("\n            zpět na klienta\n        ")])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientVisit_vue__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a52435e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientVisit_vue__ = __webpack_require__(629);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientVisit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a52435e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientVisit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_ChangeVisit_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_AddVisit_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modals_AddVisitNow_vue__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_HomeReceptionist_components_VisitChangeState_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_HomeDoctor_components_VisitChangeState_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Client_modals_VisitLog_vue__ = __webpack_require__(625);











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hostname: __webpack_require__(3),
      selectedStates: ['scheduled', 'arrived', 'elaborated', 'completed'],
      visits: [],
      visitsPending: false,
      visitsError: false,
      past_visits: '',
      show_past_visits: false,
      neco_se_stalo_s_id: '',
      modalAddVisitOpened: false,
      modalAddVisitNowOpened: false,
      modalChangeVisitOpened: false,
      modalChangeVisitId: null,
      changePending: false,
      update_visit: {},
      showedVisitDetail: [],
      editingVisitId: false,
      editingVisit: {},
      waitForSave: false,
      modalVisitLogOpened: false,
      modalVisitLogId: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* default */]],
  props: ['doUpdate'],
  methods: {
    hasRole: function hasRole(role) {
      var roles = JSON.parse(this.$ls.get('role'));
      for (var i = 0; i < roles.length; i++) {
        if (roles[i] === role) {
          return true;
        }
      }
      return false;
    },
    editVisit: function editVisit(note, id) {
      this.editingVisitId = id;
      this.editingVisit = {
        note: note
      };
    },
    putVisit: function putVisit() {
      var _this = this;

      this.waitForSave = true;
      this.$http.put('visit/' + this.editingVisitId, this.editingVisit, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.editingVisitId = false;
        _this.editingVisit = {};
        _this.updateVisits();
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    showHideVisitDetail: function showHideVisitDetail(index) {
      if (this.showedVisitDetail.indexOf(index) === -1) {
        this.showedVisitDetail.push(index);
      } else {
        this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1);
      }
    },
    showPastVisits: function showPastVisits() {
      this.show_past_visits = true;
      if (this.past_visits === '') {
        this.getClientsPastVisits();
      }
    },
    cancelVisit: function cancelVisit(visitId) {
      var _this2 = this;

      this.changePending = true;
      this.update_visit.state = 'canceled';
      this.$http.put('visit/' + visitId, this.update_visit, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        _this2.changePending = false;
        _this2.updateVisits('home');
      }).catch(function (error) {
        _this2.changeError = error.response.data.errors;
        _this2.changePending = false;
      });
    },
    hidePastVisits: function hidePastVisits() {
      this.show_past_visits = false;
    },
    changeState: function changeState(id) {
      this.neco_se_stalo_s_id = id;
    },
    clientVisitsUpdated: function clientVisitsUpdated() {
      this.$emit('updated');
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    showModalClientVisitChange: function showModalClientVisitChange(visitId) {
      this.modalChangeVisitOpened = true;
      this.modalChangeVisitId = visitId;
      this.showModal('client-visit-change');
    },
    showModalClientVisitAdd: function showModalClientVisitAdd() {
      this.modalAddVisitOpened = true;
      this.showModal('client-visit-add');
    },
    showModalClientVisitNowAdd: function showModalClientVisitNowAdd() {
      this.modalAddVisitNowOpened = true;
      this.showModal('client-visit-now-add');
    },
    changeVisitUpdated: function changeVisitUpdated() {
      this.modalChangeVisitOpened = false;
      this.updateVisits();
    },
    showModalVisitLog: function showModalVisitLog(visitId) {
      this.modalVisitLogId = visitId;
      this.modalVisitLogOpened = true;
      this.showModal('visit-log');
    },
    updateVisits: function updateVisits() {
      this.getClientsVisits(this.selectedStates, this.$route.params.clientid);
    }
  },
  beforeMount: function beforeMount() {
    this.updateVisits();
  },

  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.updateVisits();
      }
    },

    selectedStates: function selectedStates() {
      this.updateVisits();
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {
        this.updateVisits();
      }
    }
  },
  components: {
    ClientVisitChange: __WEBPACK_IMPORTED_MODULE_0__modals_ChangeVisit_vue__["a" /* default */],
    ClientVisitAdd: __WEBPACK_IMPORTED_MODULE_1__modals_AddVisit_vue__["a" /* default */],
    ClientVisitNowAdd: __WEBPACK_IMPORTED_MODULE_2__modals_AddVisitNow_vue__["a" /* default */],
    VisitChangeStateReceptionist: __WEBPACK_IMPORTED_MODULE_4__views_HomeReceptionist_components_VisitChangeState_vue__["a" /* default */],
    VisitChangeStateDoctor: __WEBPACK_IMPORTED_MODULE_5__views_HomeDoctor_components_VisitChangeState_vue__["a" /* default */],
    VisitLog: __WEBPACK_IMPORTED_MODULE_6__views_Client_modals_VisitLog_vue__["a" /* default */]
  }
});

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(22);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasData: false,
      calendarSize: 'week',
      startWindow: 43,
      endWindow: 127,
      windowsPerHour: 6,
      windowSize: 5,
      startHour: 7,
      setting: __webpack_require__(3),
      selectedWindow: null,
      lastDuration: '',
      visit_purposes: '',
      selected_element: null,
      visit: {
        reschedule: true,
        time_window: '',
        date: '',
        client_id: null,
        planned_for: null,
        branch_id: null,
        duration: 6,
        note: '',
        acute: false,
        purpose_id: '',
        notify: true
      },
      old_visit: {},
      get_params: {
        from: '',
        to: '',
        doctorid: ''
      },
      get_free_time_params: {
        minimal_length: ''
      },
      start_date: '',
      end_date: '',
      begin_of_month: '',
      end_of_month: '',
      today: this.$moment(),
      actual_select: {
        selected: false,
        time: '',
        date: '',
        window: '',
        day: ''
      },
      modalOpened: false,
      visitPurposeError: '',
      render_end_date: '',
      render_start_date: '',
      selectedDate: new Date(),

      visits: false,
      visitsPending: false,
      visitsError: false,

      visitPending: false,
      visitDone: false,
      visitError: false,

      doctors: false,
      doctorsPending: false,
      doctorsError: false,

      branches: false,
      branchesPending: false,
      branchesError: false,

      putVisitPending: false,
      putVisitDone: false,
      putVisitError: false,

      finished: false,

      freeTimePending: false,
      freeTime: false,
      freeTimeError: false,
      preselectedWindow: false,
      preselectedDate: false
    };
  },

  props: ['opened', 'visitId'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    updateVisit: function updateVisit() {
      this.visit.reschedule = true;

      this.putVisit(this.visitId, this.visit, ['acute', 'client_id', 'date', 'duration', 'note', 'notify', 'planned_for', 'purpose_id', 'reschedule', 'time_window', 'branch_id']);
    },
    windowToTime: function windowToTime(window) {
      window = window - 1;
      var hour = Math.floor(window / this.windowsPerHour);
      var minute = window % this.windowsPerHour * 10;
      return this.$moment().hour(hour).minute(minute);
    },
    clearLastSelect: function clearLastSelect() {
      if (this.selectedWindow) {
        var element = this.selectedWindow;
        for (var i = 0; i < this.lastDuration; i++) {
          element.classList.remove('selected_window');
          if (element.nextSibling === null) {
            break;
          }
          element = element.nextSibling;
        }
      }
    },
    setCalendarTo: function setCalendarTo(date, window) {
      var selectedDate = this.$moment(date, 'DD.MM.YYYY');
      this.hasData = false;
      this.new_start_date = this.$moment(selectedDate).startOf('isoWeek');
      if (!this.new_start_date.isSame(this.start_date, 'day')) {
        this.start_date = this.$moment(this.new_start_date);
        this.end_date = this.$moment(selectedDate).endOf('isoWeek');
        this.renderDates();
        this.loadCalendar();
      }
      this.preselectedWindow = window;
      this.preselectedDate = this.$moment(selectedDate);
    },
    visitPurposeChanged: function visitPurposeChanged(event) {
      this.visit.duration = event.target.options[event.target.selectedIndex].getAttribute('data-duration');
      this.changeSelectedWindows();
    },
    prepareVisit: function prepareVisit(window, date, target) {
      if (target.getAttribute('data-branch-id')) {
        this.visit.branch_id = target.getAttribute('data-branch-id');
      }
      this.actual_select.window = window;
      this.actual_select.selected = true;
      var forTime = this.windowToTime(window);
      this.actual_select.date = this.$moment(date).hour(forTime.hour()).minute(forTime.minute());
      this.visit.date = this.$moment(date).format('L');
      this.visit.time_window = window * 2 - 1;

      this.clearLastSelect();
      var element = target;
      this.selectedWindow = target;
      this.lastDuration = this.visit.duration / 2;
      for (var i = 0; i < this.visit.duration / 2; i++) {
        element.classList.add('selected_window');
        if (element.nextSibling === null) {
          break;
        }
        element = element.nextSibling;
      }
    },
    changeSelectedWindows: function changeSelectedWindows() {
      if (this.selectedWindow) {
        var element = this.selectedWindow;
        this.clearLastSelect();
        this.lastDuration = this.visit.duration / 2;
        for (var i = 0; i < this.visit.duration / 2; i++) {
          element.classList.add('selected_window');
          if (element.nextSibling === null) {
            break;
          }
          element = element.nextSibling;
        }
        if (this.visit.duration === 0) {
          element.classList.add('selected_window');
        }
      }
    },
    getRightClassForTd: function getRightClassForTd(item) {
      var classes = item.type;
      var self = this;

      if (item.clients > 0) {
        classes += ' clients';
      }

      item.visit.forEach(function (visit) {
        if (visit.id === self.visitId) {
          classes += ' original_window';
        }
      });

      return classes;
    },
    getBranchIdForTd: function getBranchIdForTd(item) {
      return item.branchId;
    },
    initialSet: function initialSet() {
      this.$moment.locale('cs');
      this.get_params = {
        from: '',
        to: '',
        doctorid: ''
      };
      this.actualPeriod();
    },
    getVisits: function getVisits() {
      var params = { date: this.get_params.from };
      this.getWeekVisitsForDoctor(this.get_params.doctorid, params);
    },
    getVisit: function getVisit(visitId) {
      var _this = this;

      this.$http.get('/visit/' + visitId).then(function (response) {
        _this.visit = response.data;
        _this.visit.planned_for = response.data.planned_for.id;
        _this.visit.purpose_id = response.data.visit_purpose.id;
        _this.visit.branch_id = response.data.branch.id;
        _this.visitDone = true;
      }, function (response) {});
    },
    actualPeriod: function actualPeriod() {
      this.hasData = false;
      this.start_date = this.$moment().startOf('isoWeek');
      this.end_date = this.$moment().endOf('isoWeek');
      this.renderDates();
      this.loadCalendar();
    },
    nextPeriod: function nextPeriod() {
      this.hasData = false;
      this.start_date = this.start_date.add(1, 'weeks');
      this.end_date = this.end_date.add(1, 'weeks');
      this.renderDates();
      this.loadCalendar();
    },
    previousPeriod: function previousPeriod() {
      this.hasData = false;
      this.start_date = this.start_date.subtract(1, 'weeks');
      this.end_date = this.end_date.subtract(1, 'weeks');
      this.renderDates();
      this.loadCalendar();
    },
    renderDates: function renderDates() {
      this.render_start_date = this.start_date;
      this.render_end_date = this.end_date;
      this.get_params.from = this.$moment(this.start_date).format('DD.MM.YYYY');
      this.get_params.to = this.$moment(this.end_date).format('DD.MM.YYYY');
    },
    loadCalendar: function loadCalendar() {
      this.get_params.doctorid = this.visit.planned_for;
      if (this.visit.planned_for !== null && this.visit.planned_for !== undefined) {
        this.getVisits();
      }
    },
    loadFreeTime: function loadFreeTime() {
      this.get_free_time_params.minimal_length = this.visit.duration / 2;
      if (this.visit.planned_for !== null && this.visit.planned_for !== undefined) {
        this.getFreeTimeForDoctor(this.visit.planned_for, this.get_free_time_params);
      }
    },
    hoverWindows: function hoverWindows(event) {
      var element = event.target;
      for (var i = 0; i < this.visit.duration / 2; i++) {
        element.classList.add('hovered_window');
        if (element.nextSibling === null) {
          break;
        }
        element = element.nextSibling;
      }
    },
    unhoverWindows: function unhoverWindows(event) {
      var element = event.target;
      for (var i = 0; i < this.visit.duration / 2; i++) {
        element.classList.remove('hovered_window');
        if (element.nextSibling === null) {
          break;
        }
        element = element.nextSibling;
      }
    },
    getVisitPurposes: function getVisitPurposes() {
      var _this2 = this;

      this.waitForResponse = true;
      this.$http.get('visit_purpose').then(function (response) {
        _this2.visit_purposes = response.data;
        var visit = _this2.visit;
        _this2.visit_purposes.forEach(function (visitPurpose) {
          if (visitPurpose.default === true) {
            visit.purpose_id = visitPurpose.id;
          }
        });
        _this2.waitForResponse = false;
      }).catch(function (error) {
        _this2.visitPurposeError = error.response.data.errors;
        _this2.waitForResponse = false;
      });
    },
    visitUpdated: function visitUpdated() {
      this.$emit('update');
      this.finished = true;
      this.$modal.hide('client-visit-change');
      this.visits = false;
      this.visitsPending = false;
      this.visitsError = false;
      this.putVisitDone = false;
      this.visitDone = false;
      this.freeTime = false;
    },
    init: function init() {
      this.finished = false;
      if (this.visitId !== null) {
        this.getVisit(this.visitId);
      }
      this.visit.client_id = this.$route.params.clientid;
      this.getDoctors();
      this.getBranches();
      this.getVisitPurposes();
    },
    manualSelectDate: function manualSelectDate() {
      this.hasData = false;
      this.start_date = this.$moment(this.selectedDate).startOf('isoWeek');
      this.end_date = this.$moment(this.selectedDate).endOf('isoWeek');
      this.renderDates();
      this.loadCalendar();
    },
    changeNotification: function changeNotification() {
      this.visit.notify = !this.visit.notify;
    },
    windowsHover: function windowsHover(num) {
      var hoursFrom = Math.floor((num - 1) / 6);

      var hoursTo = Math.floor((Number(this.visit.duration) / 2 + num - 1) / 6);
      var minutesFrom = (num - 1) % 6 * 10;
      var minutesTo = (num - 1 + Number(this.visit.duration) / 2) % 6 * 10;
      return hoursFrom + ':' + minutesFrom.toString().padStart(2, 0) + ' - ' + hoursTo + ':' + minutesTo.toString().padStart(2, 0);
    },
    windowsHoverVisits: function windowsHoverVisits(visits) {
      var returnString = '';
      visits.forEach(function (visit) {
        returnString += '<br>' + visit.visit.timeFrom + ' - ' + visit.visit.timeTo + '<br>' + visit.visit_purpose.purpose;
      });

      return returnString;
    },
    visitSlotHover: function visitSlotHover(visit) {
      return visit.visit_purpose.purpose;
    }
  },
  watch: {
    visitId: function visitId(val) {
      if (val !== null) {
        this.getVisit(val);
        this.init();
      }
    },
    visitDone: function visitDone(val) {
      if (val === true) {
        this.selectedDate = this.$moment(this.visit.date, 'D.M.YYYY').toDate();
        this.manualSelectDate();
      }
    },

    'visit.planned_for': function visitPlanned_for(val) {
      if (val !== null && val !== undefined) {
        this.loadCalendar();
        this.loadFreeTime();
      }
    },
    'visit.duration': function visitDuration(val) {
      if (this.visit.planned_for !== null) {
        this.loadFreeTime();
      }
    },
    branchesPending: function branchesPending(val) {
      if (val === false) {
        for (var i = 0; i < this.branches.length; i++) {}
      }
    },
    visitsPending: function visitsPending(val) {
      if (val === false && this.preselectedWindow !== false) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick().then(function () {
          this.prepareVisit(this.preselectedWindow, this.preselectedDate, document.querySelectorAll('td[data-window-id="' + (this.preselectedDate.isoWeekday() - 1) + '_' + this.preselectedWindow + '"]')[0]);
          this.preselectedDate = false;
          this.preselectedWindow = false;
        }.bind(this));
      }
    },
    preselectedDate: function preselectedDate(val) {
      if (val !== false && this.visitsPending === false) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick().then(function () {
          this.prepareVisit(this.preselectedWindow, this.preselectedDate, document.querySelectorAll('td[data-window-id="' + (this.preselectedDate.isoWeekday() - 1) + '_' + this.preselectedWindow + '"]')[0]);
          this.preselectedDate = false;
          this.preselectedWindow = false;
        }.bind(this));
      }
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {
        this.init();
      }
    },
    putVisitDone: function putVisitDone(val) {
      if (val === true) {
        this.visitUpdated();
      }
    },
    opened: function opened(val) {
      if (val === true && this.finished === true) {
        this.init();
      }
    }
  }
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "95%",
      "scrollable": true,
      "name": "client-visit-change",
      "classes": "modal_default",
      "clickToClose": true
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "visit-reschedule-dialog"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Přeplánovat návštěvu\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('form', [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "doctor"
    }
  }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.planned_for),
      expression: "visit.planned_for"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "visit-reschedule-doctor"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.planned_for = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.loadCalendar()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit doktora")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.branch_id),
      expression: "visit.branch_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "branchHelp",
      "id": "branch",
      "placeholder": "vybrat pobočku",
      "data-testid": "visit-reschedule-branch"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.branch_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit pobočku")]), _vm._v(" "), _vm._l((_vm.branches), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "doctorHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("za účelem")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.purpose_id),
      expression: "visit.purpose_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "operation",
      "data-testid": "visit-reschedule-purpose"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.purpose_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.visitPurposeChanged($event)
      }]
    }
  }, _vm._l((_vm.visit_purposes), function(visit_purpose) {
    return _c('option', {
      attrs: {
        "data-duration": visit_purpose.duration
      },
      domProps: {
        "value": visit_purpose.id
      }
    }, [_vm._v(_vm._s(visit_purpose.purpose))])
  })), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "operationHelp"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-inline mt-2"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Délka návštěvy:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.duration),
      expression: "visit.duration"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "id": "duration",
      "data-testid": "visit-reschedule-duration"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeSelectedWindows()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit čas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("0 minut")]), _vm._v(" "), _vm._l((24), function(duration) {
    return (duration % 2 === 0) ? _c('option', {
      domProps: {
        "value": duration
      }
    }, [_vm._v(_vm._s(duration * 5) + " minut")]) : _vm._e()
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "acute"
    }
  }, [_vm._v("\n                            akutní "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.acute),
      expression: "visit.acute"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "acute",
      "data-testid": "visit-reschedule-acute"
    },
    domProps: {
      "checked": Array.isArray(_vm.visit.acute) ? _vm._i(_vm.visit.acute, null) > -1 : (_vm.visit.acute)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.visit.acute,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.visit.acute = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.visit.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.visit.acute = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.visit.notify) ? _c('i', {
    staticClass: "fa fa-bell-o fa-2x text-success",
    attrs: {
      "title": "notifikace jsou zapnuté",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.changeNotification
    }
  }) : _c('i', {
    staticClass: "fa fa-bell-slash fa-2x text-danger",
    attrs: {
      "title": "notifikace jsou VYPNUTY",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.changeNotification
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka:")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.note),
      expression: "visit.note"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "note",
      "rows": "2",
      "data-testid": "visit-reschedule-note"
    },
    domProps: {
      "value": (_vm.visit.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visit.note = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('table', {
    staticClass: "table table_free_time"
  }, _vm._l((_vm.freeTime), function(ft) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ft.date) + " (" + _vm._s(_vm.$moment(ft.date, 'DD.MM.YYYY').format('dddd')) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$moment(_vm.windowToTime(ft.window)).format('LT')) + " (" + _vm._s(_vm._f("minutesToCsTime")(_vm._f("windowToMinute")(ft.length))) + ")")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-outline-success btn-xs m-1",
      on: {
        "click": function($event) {
          _vm.setCalendarTo(ft.date, ft.window)
        }
      }
    }, [_vm._v("vybrat")])])])
  }))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.actual_select.selected) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.$moment(_vm.actual_select.date).format('dddd')) + " " + _vm._s(_vm.$moment(_vm.actual_select.date).format('LL')) + " v " + _vm._s(_vm.$moment(_vm.actual_select.date).format('LT'))), _c('br')]) : _c('div', [_vm._v("\n            Vyberte den a čas v kalendáři\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-testid": "visit-reschedule-previous-week"
    },
    on: {
      "click": function($event) {
        _vm.previousPeriod()
      }
    }
  }, [_vm._v("Předchozí")])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.actualPeriod
    }
  }, [_vm._v("aktuální týden")])]), _vm._v(" "), _c('div', [_c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput"
    },
    on: {
      "input": _vm.manualSelectDate
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-testid": "visit-reschedule-next-week"
    },
    on: {
      "click": function($event) {
        _vm.nextPeriod()
      }
    }
  }, [_vm._v("Následující")])])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div'), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(_vm.get_params.from) + " - " + _vm._s(_vm.get_params.to) + "\n            ")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "div_table"
  }, [_c('table', {
    staticClass: "table table_calendar"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / _vm.windowsPerHour)), function(times, index) {
    return _c('th', {
      attrs: {
        "colspan": _vm.windowsPerHour
      }
    }, [_vm._v("\n                        " + _vm._s((index + _vm.startHour) < 10 ? '0' + (index + _vm.startHour) : (index + _vm.startHour)) + "\n                    ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / (_vm.windowsPerHour / 2))), function(times, index) {
    return _c('th', {
      staticClass: "halfHour",
      attrs: {
        "colspan": (_vm.windowsPerHour / 2)
      }
    }, [_vm._v("\n                         \n                    ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th')])]), _vm._v(" "), (_vm.visits !== false) ? _c('tbody', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._l((7), function(n) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$moment(_vm.render_start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$moment(_vm.render_start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ({
            content: '<b>' + _vm.windowsHover(_vm.startWindow + cell - 1) + '</b><br>' + (_vm.visits[n - 1][cell + _vm.startWindow - 1]['visit'].length > 0 ? _vm.windowsHoverVisits(_vm.visits[n - 1][cell + _vm.startWindow - 1]['visit']) : ''),
            placement: 'bottom-center',
            classes: ['info']
          }),
          expression: "{\n                            content: '<b>' + windowsHover(startWindow + cell - 1) + '</b><br>' + (visits[n-1][cell + startWindow - 1]['visit'].length > 0 ? windowsHoverVisits(visits[n-1][cell + startWindow - 1]['visit']) : ''),\n                            placement: 'bottom-center',\n                            classes: ['info']}"
        }],
        class: _vm.getRightClassForTd(_vm.visits[n - 1][cell + _vm.startWindow - 1]) + ' ' + ((cell % _vm.windowsPerHour === 0) ? 'hourly' : '') + ' ' + ((cell % _vm.windowsPerHour === _vm.windowsPerHour / 2) ? 'halfhourly' : ''),
        attrs: {
          "data-window-id": (n - 1) + '_' + (_vm.startWindow + cell - 1),
          "data-testid": 'visit-reschedule-slot-' + (n - 1) + '-' + (_vm.startWindow + cell - 1),
          "data-branch-id": _vm.getBranchIdForTd(_vm.visits[n - 1][cell + _vm.startWindow - 1])
        },
        on: {
          "mouseover": _vm.hoverWindows,
          "mouseleave": _vm.unhoverWindows,
          "click": function($event) {
            _vm.prepareVisit(_vm.startWindow + cell - 1, _vm.$moment(_vm.render_start_date).add(n - 1, 'days'), $event.target)
          }
        }
      }, [_vm._v("\n                           \n                          "), _vm._l((_vm.visits[n - 1][cell + _vm.startWindow - 1]['visit']), function(visit) {
        return [_c('div', {
          staticStyle: {
            "position": "relative"
          }
        }, [_c('div', {
          staticClass: "visit_slot",
          staticStyle: {
            "position": "absolute"
          },
          style: ({
            backgroundColor: '#' + visit.visit_purpose.color,
            top: visit.row_slot_number * 6 + 'px'
          }),
          attrs: {
            "title": _vm.visitSlotHover(visit)
          }
        })])]
      })], 2)
    })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return [(_vm.visits[n - 1][cell + _vm.startWindow - 1]['skipNote'] === 0 || _vm.visits[n - 1][cell + _vm.startWindow - 1]['type'] !== 'work') ? _c('td', {
        staticStyle: {
          "position": "relative"
        },
        attrs: {
          "colspan": _vm.visits[n - 1][cell + _vm.startWindow - 1]['note'] ? _vm.visits[n - 1][cell + _vm.startWindow - 1]['note']['windowsCount'] : 1
        }
      }, [_c('div', {
        staticStyle: {
          "position": "absolute",
          "overflow": "hidden",
          "text-overflow": "ellipsis",
          "width": "100%",
          "text-align": "center"
        }
      }, [_vm._v("\n                            " + _vm._s(_vm.visits[n - 1][cell + _vm.startWindow - 1]['note'] ? _vm.visits[n - 1][cell + _vm.startWindow - 1]['note']['text'] : '') + "\n                          ")])]) : _vm._e()]
    })], 2)]
  })], 2) : _c('tbody', _vm._l((7), function(n) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$moment(_vm.render_start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$moment(_vm.render_start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        staticClass: "blank_windows"
      }, [_vm._v("\n                         \n                    ")])
    })], 2)
  }))]), _vm._v(" "), (_vm.visits === false || _vm.visitsPending === true) ? _c('div', {
    staticClass: "table_overlay"
  }, [(_vm.visitsPending === true) ? _c('div', {}, [_c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "h4"
  })])]) : (_vm.visits === false) ? _c('div', {
    staticClass: "text-danger"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "h4"
  }, [_vm._v("Musíte zvolit doktora")])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body text-center"
  }, [(!_vm.putVisitPending) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "visit-reschedule-submit"
    },
    on: {
      "click": _vm.updateVisit
    }
  }, [_vm._v("Přeplánovat návštěvu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddVisitNow_vue__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9937938c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddVisitNow_vue__ = __webpack_require__(624);
function injectStyle (ssrContext) {
  __webpack_require__(622)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9937938c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddVisitNow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9937938c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddVisitNow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lastDuration: '',
      visit_purposes: '',
      visit: {
        client_id: null,
        planned_for: null,
        duration: 6,
        note: '',
        acute: false,
        purpose_id: '',
        unplanned_visit: true,
        visit_template_id: false
      },
      modalOpened: false,
      visitPurposeError: '',

      visitPending: false,
      visitDone: false,
      visitError: false,

      doctors: false,
      doctorsPending: false,
      doctorsError: false,

      visitTemplates: false
    };
  },

  props: ['opened'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    onHidden: function onHidden() {},
    onOpen: function onOpen() {
      document.getElementById('doctor').focus();
    },
    visitPurposeChanged: function visitPurposeChanged(event) {
      this.visit.duration = event.target.options[event.target.selectedIndex].getAttribute('data-duration');
      if (this.visit_purposes[event.target.selectedIndex].visit_normal_templates.length > 0) {
        this.visitTemplates = this.visit_purposes[event.target.selectedIndex].visit_normal_templates;
        this.visit.visit_template_id = this.visitTemplates[0].id;
      } else {
        this.visitTemplates = false;
      }
    },
    initialSet: function initialSet() {
      this.visit = {
        client_id: null,
        planned_for: null,
        duration: 6,
        note: '',
        acute: false,
        purpose_id: '',
        unplanned_visit: true,
        visit_template_id: false
      };
    },
    getVisitPurposes: function getVisitPurposes() {
      var _this = this;

      this.waitForResponse = true;
      this.$http.get('visit_purpose').then(function (response) {
        _this.visit_purposes = response.data;
        var visit = _this.visit;
        _this.visit_purposes.forEach(function (visitPurpose) {
          if (visitPurpose.default === true) {
            visit.purpose_id = visitPurpose.id;
          }
        });
        _this.waitForResponse = false;
      }).catch(function (error) {
        _this.visitPurposeError = error.response.data.errors;
        _this.waitForResponse = false;
      });
    },
    init: function init() {
      this.initialSet();
      this.visit.client_id = this.$route.params.clientid;
      this.getDoctors();
      this.getVisitPurposes();
    }
  },
  watch: {
    opened: function opened(val) {
      if (val === true) {
        this.init();
      }
    },
    visitDone: function visitDone(val) {
      if (val === true) {
        this.$emit('update');
        this.visitDone = false;
        this.initialSet();
        this.visit.client_id = this.$route.params.clientid;
        this.$modal.hide('client-visit-now-add');
      }
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {
        this.init();
      }
    }
  }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "90%",
      "scrollable": true,
      "name": "client-visit-now-add",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "opened": _vm.onOpen,
      "closed": _vm.onHidden
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "visit-now-dialog"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Naplánovat návštěvu\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postVisit(_vm.visit)
      }
    }
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "doctor"
    }
  }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.planned_for),
      expression: "visit.planned_for"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "autofocus": "autofocus",
      "data-testid": "visit-now-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.planned_for = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit doktora")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "doctorHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("za účelem")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.purpose_id),
      expression: "visit.purpose_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "operation",
      "data-testid": "visit-now-purpose"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.purpose_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.visitPurposeChanged($event)
      }]
    }
  }, _vm._l((_vm.visit_purposes), function(visit_purpose) {
    return _c('option', {
      attrs: {
        "data-duration": visit_purpose.duration
      },
      domProps: {
        "value": visit_purpose.id
      }
    }, [_vm._v(_vm._s(visit_purpose.purpose))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.visit_template_id),
      expression: "visit.visit_template_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "visitTemplateSelect",
      "disabled": _vm.visitTemplates === false,
      "data-testid": "visit-now-template"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.visit_template_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.visitTemplates), function(visit_template, index) {
    return _c('option', {
      domProps: {
        "value": visit_template.id,
        "selected": index === 0
      }
    }, [_vm._v(_vm._s(visit_template.name))])
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("bez šablony")])], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "operationHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Délka návštěvy:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.duration),
      expression: "visit.duration"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "id": "duration",
      "data-testid": "visit-now-duration"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit čas")]), _vm._v(" "), _vm._l((24), function(duration) {
    return (duration % 2 === 0) ? _c('option', {
      domProps: {
        "value": duration
      }
    }, [_vm._v(_vm._s(duration * 5) + " minut")]) : _vm._e()
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "acute"
    }
  }, [_vm._v("\n                    akutní "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.acute),
      expression: "visit.acute"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "acute",
      "data-testid": "visit-now-acute"
    },
    domProps: {
      "checked": Array.isArray(_vm.visit.acute) ? _vm._i(_vm.visit.acute, null) > -1 : (_vm.visit.acute)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.visit.acute,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.visit.acute = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.visit.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.visit.acute = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-inline mt-2"
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.note),
      expression: "visit.note"
    }],
    staticClass: "form-control col-sm-9 ml-sm-1 mr-sm-2",
    attrs: {
      "type": "text",
      "aria-describedby": "noteHelp",
      "id": "note",
      "data-testid": "visit-now-note"
    },
    domProps: {
      "value": (_vm.visit.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visit.note = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.visitPending) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "data-testid": "visit-now-submit"
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitLog_vue__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec85990a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitLog_vue__ = __webpack_require__(628);
function injectStyle (ssrContext) {
  __webpack_require__(626)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec85990a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec85990a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_VisitLog_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      modalOpened: false,
      logVisit: false,
      logVisitPending: true,
      logVisitError: false
    };
  },

  props: ['opened', 'visitId'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    onHidden: function onHidden() {},
    onOpen: function onOpen() {
      this.init();
      this.getlogVisit(this.visitId);
    },
    getlogVisit: function getlogVisit(visitId) {
      var _this = this;

      this.logVisitPending = true;
      this.$http.get('log_visit/' + visitId).then(function (response) {
        _this.logVisit = response.data;
        _this.logVisitPending = false;
      }, function (response) {
        _this.logVisitError = response.body.error;
        _this.logVisitPending = false;
      });
    },
    init: function init() {
      this.logVisit = false;
      this.logVisitPending = false;
      this.logVisitError = false;
    }
  },
  watch: {
    opened: function opened(val) {
      if (val === true) {}
    },
    '$route': function $route(to, from) {
      if (to.params.visitId !== from.params.visitId && typeof to.params.visitId !== 'undefined') {}
    }
  }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "90%",
      "scrollable": true,
      "name": "visit-log",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "opened": _vm.onOpen,
      "closed": _vm.onHidden
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": 'client-visit-log-' + _vm.visitId + '-dialog'
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Historie úprav návštěvy\n    ")]), _vm._v(" "), (_vm.logVisit.length > 0 && _vm.logVisitPending !== true) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("verze")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("akce")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("změna")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("provedl")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("datum a čas")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.logVisit), function(log) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(log.version))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.action))]), _vm._v(" "), _c('td', [_vm._l((log.data), function(value, key) {
      return [_c('span', [_c('i', [_vm._v(_vm._s(key))]), _vm._v(": "), _c('b', [_vm._v(_vm._s(value))])]), _c('br')]
    })], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.logged_at))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.logVisit.length < 1 && _vm.logVisitPending !== true) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._v("\n        návštěva bez historie\n    ")]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "client-visits"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 text-center"
  }, [(_vm.selectedStates.indexOf('scheduled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "scheduled",
      "data-testid": "client-visits-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('scheduled')
      }
    }
  }, [_vm._v("plánovaní")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "scheduled",
      "data-testid": "client-visits-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('scheduled'), 1)
      }
    }
  }, [_vm._v("plánovaní")]), _vm._v(" "), (_vm.selectedStates.indexOf('arrived') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "arrived"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('arrived')
      }
    }
  }, [_vm._v("v čekárně")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "arrived"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('arrived'), 1)
      }
    }
  }, [_vm._v("v čekárně")]), _vm._v(" "), (_vm.selectedStates.indexOf('elaborated') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('elaborated')
      }
    }
  }, [_vm._v("rozpracovaní")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('elaborated'), 1)
      }
    }
  }, [_vm._v("rozpracovaní")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "completed",
      "data-testid": "client-visits-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("splněno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "completed",
      "data-testid": "client-visits-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("splněno")]), _vm._v(" "), (_vm.selectedStates.indexOf('failed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('failed') + _vm.selectedStates.push('excused')
      }
    }
  }, [_vm._v("nepřišel")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('failed'), 1) + _vm.selectedStates.splice(_vm.selectedStates.indexOf('excused'), 1)
      }
    }
  }, [_vm._v("nepřišel")]), _vm._v(" "), (_vm.selectedStates.indexOf('canceled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled",
      "data-testid": "client-visits-filter-canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('canceled')
      }
    }
  }, [_vm._v("zrušeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled",
      "data-testid": "client-visits-filter-canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('canceled'), 1)
      }
    }
  }, [_vm._v("zrušeno")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": _vm.updateVisits
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-outline-success",
    attrs: {
      "data-testid": "client-visit-now-open"
    },
    on: {
      "click": _vm.showModalClientVisitNowAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" přišel bez objednání")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-outline-success",
    attrs: {
      "data-testid": "client-visit-schedule-open"
    },
    on: {
      "click": _vm.showModalClientVisitAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" naplánovat návštěvu")])])])]), _vm._v(" "), (_vm.visits.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l(((_vm.visits)), function(visit, index) {
    return [_c('tr', {
      attrs: {
        "data-testid": 'client-visit-' + visit.id
      }
    }, [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "rowspan": "2"
      }
    }, [(_vm.hasRole('receptionist')) ? _c('visit-change-state-receptionist', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id,
        "test-prefix": "client"
      },
      on: {
        "update": _vm.updateVisits
      }
    }) : (_vm.hasRole('doctor')) ? _c('visit-change-state-doctor', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id,
        "test-prefix": "client"
      },
      on: {
        "update": _vm.updateVisits
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(visit.hasData) ? [_c('button', {
      staticClass: "btn btn-sm btn_extra_small btn-primary",
      on: {
        "click": function($event) {
          _vm.showHideVisitDetail(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.hasLoggedUserRole('doctor')) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'ShowVisit',
          params: {
            clientid: _vm.$route.params.clientid,
            visitid: visit.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(visit.date) + " od " + _vm._s(visit.timeFrom) + " do " + _vm._s(visit.timeTo) + " (" + _vm._s(_vm._f("minutesToCsTime")(visit.duration * 5)) + ")\n                        ")]) : [_vm._v("\n                            " + _vm._s(visit.date) + " od " + _vm._s(visit.timeFrom) + " do " + _vm._s(visit.timeTo) + " (" + _vm._s(_vm._f("minutesToCsTime")(visit.duration * 5)) + ")\n                        ")]], 2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "colspan": "2"
      }
    }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('label', {
      attrs: {
        "for": "note"
      }
    }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.putVisit(visit)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingVisit.note),
        expression: "editingVisit.note"
      }],
      staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "noteHelp",
        "id": "note",
        "data-testid": 'client-visit-note-' + visit.id
      },
      domProps: {
        "value": (_vm.editingVisit.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingVisit.note = $event.target.value
        }
      }
    }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "data-testid": 'client-visit-save-' + visit.id
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])])] : [_c('button', {
      staticClass: "btn btn-sm btn-link text-secondary",
      attrs: {
        "data-testid": 'client-visit-edit-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.editVisit(visit.note, visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "border-top-0 text-right",
      attrs: {
        "colspan": "1"
      }
    }, [(visit.state === 'scheduled') ? [_c('button', {
      staticClass: "btn btn-sm btn-warning",
      attrs: {
        "data-testid": 'client-visit-reschedule-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.showModalClientVisitChange(visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-plus-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" přeobjednat")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": 'client-visit-cancel-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.cancelVisit(visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-times-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" zrušit návštěvu")])] : _vm._e(), _c('br'), _vm._v("\n                        " + _vm._s(visit.planned_for.fullname) + "\n                        "), (visit.planned_by && visit.planned_at) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne ' + visit.planned_at,
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                              content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne ' + visit.planned_at,\n                              placement: 'bottom-center',\n                              classes: ['info']}"
      }],
      staticClass: "text-info fa fa-lg fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "text-secondary",
      attrs: {
        "data-testid": 'client-visit-log-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.showModalVisitLog(visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-history",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 2)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('tr', [_c('td', {
      staticClass: "border-top-0"
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {}, [_c('h6', [_vm._v("Výsledná zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                        " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                    ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                        ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                        ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(1, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(visit.medicament.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                                              " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])])]) : _vm._e()]
  })], 2)])]) : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(3)]), _vm._v(" "), _c('client-visit-change', {
    attrs: {
      "opened": _vm.modalChangeVisitOpened,
      "visit-id": _vm.modalChangeVisitId
    },
    on: {
      "update": _vm.changeVisitUpdated
    }
  }), _vm._v(" "), _c('client-visit-add', {
    attrs: {
      "opened": _vm.modalAddVisitOpened
    },
    on: {
      "update": _vm.updateVisits
    }
  }), _vm._v(" "), _c('client-visit-now-add', {
    attrs: {
      "opened": _vm.modalAddVisitNowOpened
    },
    on: {
      "update": _vm.updateVisits
    }
  }), _vm._v(" "), _c('visit-log', {
    attrs: {
      "opened": _vm.modalVisitLogOpened,
      "visit-id": _vm.modalVisitLogId
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Datum / čas"), _c('br'), _vm._v("Klient")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAnamnesis_vue__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae475e0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientAnamnesis_vue__ = __webpack_require__(632);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientAnamnesis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae475e0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientAnamnesis_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_ChangeVisit_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      actualClientAnamnesis: false,
      actualClientAnamnesisError: false,
      actualClientAnamnesisPending: false,
      actualClientAnamnesisDone: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  props: ['doUpdate'],
  methods: {},
  beforeMount: function beforeMount() {
    this.getActualClientAnamnesis(this.$route.params.clientid);
  },

  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.updateVisits();
      }
    },

    selectedStates: function selectedStates() {
      this.updateVisits();
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {
        this.getActualClientAnamnesis(this.$route.params.clientid);
      }
    }
  },
  components: {
    ClientVisitChange: __WEBPACK_IMPORTED_MODULE_0__modals_ChangeVisit_vue__["a" /* default */]
  }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.actualClientAnamnesis.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('ul', {
    staticClass: "list-group",
    attrs: {
      "data-testid": "client-anamnesis-list"
    }
  }, _vm._l((_vm.actualClientAnamnesis), function(a) {
    return _c('li', {
      staticClass: "list-group-item",
      attrs: {
        "data-testid": "client-anamnesis-entry",
        "data-anamnesis-type-id": a.anamnesis_type.id
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(a.anamnesis_type.shortcode) + " - " + _vm._s(a.anamnesis_type.name))]), _c('br'), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(a.text)
      }
    })])
  }))]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientResult_vue__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2c73acc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientResult_vue__ = __webpack_require__(636);
function injectStyle (ssrContext) {
  __webpack_require__(634)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e2c73acc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2c73acc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientResult_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PaginationComponent_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      visits_header_title: '',
      hostname: __webpack_require__(3),
      getParams: {
        p: 1,
        s: 'received_on-',
        f: {},
        pp: 20
      },
      selectedStates: [],
      print_date: '',
      assignedTo: '',
      doctors: [],
      doctorsPending: false,
      doctorsError: false,
      selectedDoctorId: null,
      showDoctorModal: false,
      selectedDate: '',
      listData: false,
      listError: false,
      listPagination: null,
      listPending: false,
      editingTaskId: false,
      editingTask: {},
      waitForSave: false,
      openedTaskId: false,
      openedTaskEvaluation: '',
      updatedTask: {
        evaluation: '',
        state: '',
        client_id: false,
        include_result_to_email: true
      },
      selected: '',
      clients: [],
      clientsPending: false,
      clientsError: false,
      state: '',
      sendResultPending: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    setPage: function setPage(number) {
      this.getParams.p = number;
      this.getDoctorsDayTasks();
    },
    openTaskId: function openTaskId(num, result) {
      if (this.openedTaskId === num) {
        this.openedTaskId = false;
        this.openedTaskEvaluation = '';
      } else {
        this.openedTaskId = num;

        this.updatedTask = {
          evaluation: result.evaluation,
          state: result.state,
          client_id: result.client_id,
          include_result_to_email: true
        };
      }
    },
    getDoctorsDayTasks: function getDoctorsDayTasks() {
      this.getResults(this.getParams);
    },

    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date);
    },
    showModalChangeTaskDoctor: function showModalChangeTaskDoctor(selectedDoctorId) {
      this.selectedDoctorId = selectedDoctorId;
      this.showModal('visit-change-doctor');
    },
    showModal: function showModal(name) {
      console.log('zobrazuji modal');
      this.$modal.show(name);
    },
    selectClient: function selectClient(value) {
      this.updatedTask.client_id = value.id;
      this.updatedTask.state = 'assigned';
    },
    getResult: function getResult(text) {
      if (text.length > 2) {
        this.searchClients(text);
      }
    },
    putResult: function putResult(resultId) {
      var _this = this;

      var params = {
        include_result_to_email: true,
        dont_send_email: false
      };
      this.sendResultPending = true;
      this.$http.put('result/' + resultId, params, { emulateJSON: true }).then(function (response) {
        _this.sendResultPending = false;
      }, function (response) {
        _this.errors = response.data.errors;
        _this.sendResultPending = true;
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getDoctors();
    __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('cs');
    this.selectedStates = ['completed'];
    this.getParams.f.client = this.$route.params.clientid;
    this.getDoctorsDayTasks();
  },

  watch: {
    selectedStates: function selectedStates(val) {
      this.getParams.f.state = val;
      this.getDoctorsDayTasks();
    },
    assignedTo: function assignedTo(val) {
      if (val === null) {
        delete this.getParams.f.assigned_to;
      } else {
        this.getParams.f.assigned_to = val;
      }

      this.getDoctorsDayTasks();
    },
    selectedDate: function selectedDate(val) {
      localStorage.setItem('home_date', __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format('DD.MM.YYYY'));
      this.selected_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(val);
      this.setDateAndLoad();
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {
        this.getParams.f.client = to.params.clientid;
        this.getDoctorsDayTasks();
      }
    }
  },
  components: {
    PaginationComponent: __WEBPACK_IMPORTED_MODULE_2__components_PaginationComponent_vue__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a
  },
  filters: {}
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "client-results-page"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-center"
  }, [(_vm.doctors.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignedTo),
      expression: "assignedTo"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "client-results-doctor-filter"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assignedTo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("všichni doktoři")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.selectedStates.indexOf('accepted') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "accepted",
      "data-testid": "client-results-filter-accepted"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('accepted')
      }
    }
  }, [_vm._v("nepřiřazené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "accepted",
      "data-testid": "client-results-filter-accepted"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('accepted'), 1)
      }
    }
  }, [_vm._v("nepřiřazené")]), _vm._v(" "), (_vm.selectedStates.indexOf('assigned') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "assigned",
      "data-testid": "client-results-filter-assigned"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('assigned')
      }
    }
  }, [_vm._v("nevyhodnocené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "assigned",
      "data-testid": "client-results-filter-assigned"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('assigned'), 1)
      }
    }
  }, [_vm._v("nevyhodnocené")]), _vm._v(" "), (_vm.selectedStates.indexOf('wait_for_doctor') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "wait_for_doctor",
      "data-testid": "client-results-filter-wait-for-doctor"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('wait_for_doctor')
      }
    }
  }, [_vm._v("předáno na doktora")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "wait_for_doctor",
      "data-testid": "client-results-filter-wait-for-doctor"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('wait_for_doctor'), 1)
      }
    }
  }, [_vm._v("předáno na doktora")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled",
      "data-testid": "client-results-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("dokončeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled",
      "data-testid": "client-results-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("dokončeno")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "client-results-refresh"
    },
    on: {
      "click": function($event) {
        _vm.getDoctorsDayTasks()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.listData.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.listData), function(task, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: _vm.openedTaskId === task.id ? 'border border-primary border-bottom-0' : '',
      attrs: {
        "data-testid": 'client-results-row-' + task.id
      }
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [(_vm.openedTaskId === task.id) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'client-results-toggle-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(task.id, task)
        }
      }
    }, [_vm._v("-")]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'client-results-toggle-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(task.id, task)
        }
      }
    }, [_vm._v("+")])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-sm-2",
      attrs: {
        "data-testid": 'client-results-state-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("taskStateToCS")(task.state)) + "\n\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'client-results-client-' + task.id
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'client-results-doctor-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(task.assigned_to ? task.assigned_to.fullname : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'client-results-received-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(task.received_on) + "\n                    ")])]), _vm._v(" "), (_vm.openedTaskId === task.id) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0 border-bottom-0",
      attrs: {
        "data-testid": 'client-results-client-info-' + task.id
      }
    }, [_c('td', {
      staticClass: "col-md-12"
    }, [_vm._v("\n                        " + _vm._s(task.client_info_line) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.openedTaskId === task.id) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0",
      attrs: {
        "data-testid": 'client-results-detail-' + task.id
      }
    }, [_c('td', {
      staticClass: "col-md-6"
    }, [_c('b', {
      staticClass: "p-4"
    }, [_vm._v("Laboratorní výsledek")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "target": "_blank",
        "role": "button",
        "href": _vm.hostname.hostname + 'result/' + task.id + '/pdf',
        "data-testid": 'client-results-print-' + task.id
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    }), _vm._v(" Tisknout")]), _vm._v(" "), (_vm.sendResultPending === false) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'client-results-resend-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.putResult(task.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-mail-forward",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")]) : _c('button', {
      staticClass: "btn btn-sm btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")]), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace",
        "font-size": "medium"
      },
      attrs: {
        "id": "result_text",
        "data-testid": 'client-results-content-' + task.id
      },
      domProps: {
        "innerHTML": _vm._s(task.result)
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-md-6"
    }, [(task.state === 'completed') ? [_vm._v("\n                            Zpráva odeslaná klientovi:"), _c('br'), _c('br'), _vm._v(" "), _c('p', {
      attrs: {
        "data-testid": 'client-results-evaluation-' + task.id
      }
    }, [_c('b', [_vm._v("\n                                    " + _vm._s(task.evaluation) + "\n                                ")])])] : _vm._e()], 2)]) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('pagination-component', {
    attrs: {
      "list-pagination": _vm.listPagination
    },
    on: {
      "set-page": _vm.setPage
    }
  })], 1) : (_vm.listPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "client-results-empty"
    }
  }, [_vm._m(2)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Stav")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Klient")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Doktor")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Datum přijetí")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (nebyl nalezen žádný výsledek dle požadavků)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientMessage_vue__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3388e55a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientMessage_vue__ = __webpack_require__(639);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3388e55a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientMessage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_ChangeVisit_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedStates: ['scheduled', 'arrived', 'elaborated'],
      setting: __webpack_require__(3),
      visits: [],
      visitsPending: false,
      visitsError: false,
      past_visits: '',
      show_past_visits: false,
      neco_se_stalo_s_id: '',
      modalChangeVisitOpened: false,
      modalChangeVisitId: null,
      changePending: false,
      update_visit: {},
      showedVisitDetail: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  props: ['doUpdate'],
  methods: {
    showHideVisitDetail: function showHideVisitDetail(index) {
      if (this.showedVisitDetail.indexOf(index) === -1) {
        this.showedVisitDetail.push(index);
      } else {
        this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1);
      }
    },
    showPastVisits: function showPastVisits() {
      this.show_past_visits = true;
      if (this.past_visits === '') {
        this.getClientsPastVisits();
      }
    },
    cancelVisit: function cancelVisit(visitId) {
      var _this = this;

      this.changePending = true;
      this.update_visit.state = 'canceled';
      this.$http.put('visit/' + visitId, this.update_visit, { emulateJSON: true }).then(function (response) {
        _this.submited = response.data;
        _this.changePending = false;
        _this.updateVisits('home');
      }).catch(function (error) {
        _this.changeError = error.response.data.errors;
        _this.changePending = false;
      });
    },
    hidePastVisits: function hidePastVisits() {
      this.show_past_visits = false;
    },
    changeState: function changeState(id) {
      this.neco_se_stalo_s_id = id;
    },
    clientVisitsUpdated: function clientVisitsUpdated() {
      this.$emit('updated');
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    showModalClientVisitChange: function showModalClientVisitChange(visitId) {
      this.modalChangeVisitOpened = true;
      this.modalChangeVisitId = visitId;
      this.showModal('client-visit-change');
    },
    updateVisits: function updateVisits() {
      this.getClientsVisits(this.selectedStates, this.$route.params.clientid);
    }
  },
  beforeMount: function beforeMount() {
    this.updateVisits();
  },

  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.updateVisits();
      }
    },

    selectedStates: function selectedStates() {
      this.updateVisits();
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {
        this.updateVisits();
      }
    }
  },
  components: {
    ClientVisitChange: __WEBPACK_IMPORTED_MODULE_0__modals_ChangeVisit_vue__["a" /* default */]
  }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.visits.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l(((_vm.visits)), function(visit, index) {
    return [_c('tr', [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "rowspan": "2"
      }
    }, [(visit.state === 'scheduled') ? _c('i', {
      staticClass: "fa fa-2x fa-circle-o text-info",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'arrived') ? _c('i', {
      staticClass: "fa fa-2x fa-clock-o text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'completed') ? _c('i', {
      staticClass: "fa fa-2x fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'elaborated') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'failed') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'excused') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'canceled') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(visit.hasData) ? [_c('button', {
      staticClass: "btn btn-sm btn_extra_small btn-primary",
      on: {
        "click": function($event) {
          _vm.showHideVisitDetail(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v("\n                        " + _vm._s(visit.date) + " od " + _vm._s(visit.timeFrom) + " do " + _vm._s(visit.timeTo) + "\n                    ")], 2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "colspan": "2"
      }
    }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))]), _vm._v(" "), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "border-top-0",
      attrs: {
        "colspan": "3"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "border-top-0 text-right",
      attrs: {
        "colspan": "1"
      }
    }, [(visit.state === 'scheduled') ? [_c('button', {
      staticClass: "btn btn-sm btn-warning",
      on: {
        "click": function($event) {
          _vm.showModalClientVisitChange(visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-plus-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" přeobjednat")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.cancelVisit(visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-times-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" zrušit návštěvu")])] : _vm._e(), _c('br'), _vm._v("\n                        " + _vm._s(visit.planned_for.fullname) + "\n                        ")], 2)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('tr', [_c('td', {
      staticClass: "border-top-0"
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(visit.medical_report) ? _c('div', {}, [_c('h6', [_vm._v("Výsledná zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? _vm._l((diagnose.actions), function(action) {
        return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                    " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                ")])])
      }) : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(1, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(visit.medicament.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                                              " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])])]) : _vm._e()]
  })], 2)])]) : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(3)]), _vm._v(" "), _c('client-visit-change', {
    attrs: {
      "opened": _vm.modalChangeVisitOpened,
      "visit-id": _vm.modalChangeVisitId
    },
    on: {
      "update": _vm.updateVisits
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Datum / čas"), _c('br'), _vm._v("Klient")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListMedicament_vue__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Prescribtion_ListPrescription_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListPreviousMedicament_vue__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Prescribtion_AddMedicament_vue__ = __webpack_require__(218);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reloadMedicament: false,
      reloadPrescription: false,
      medicamentToCopy: false,

      actualClientAnamnesis: false,
      actualClientAnamnesisError: false,
      actualClientAnamnesisPending: false,
      actualClientAnamnesisDone: false,

      pharmAnamnesis: false,
      allergicAnamnesis: false
    };
  },

  props: ['propClientId'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    updateMedicament: function updateMedicament() {
      this.reloadPrescription = true;
    },
    updateMedicamentDone: function updateMedicamentDone() {
      this.reloadMedicament = false;
    },
    copyMedicament: function copyMedicament(medicament) {
      this.medicamentToCopy = medicament;
    },
    updatePrescriptions: function updatePrescriptions() {
      this.reloadPrescription = true;
      this.updateMedicament();
    },
    updatePrescriptionDone: function updatePrescriptionDone() {
      this.reloadPrescription = false;
    }
  },
  computed: {
    clientId: function clientId() {
      if (this.propClientId) {
        return this.propClientId;
      } else {
        return this.$route.params.clientid;
      }
    }
  },
  watch: {
    actualClientAnamnesis: function actualClientAnamnesis(val) {
      var _this = this;

      if (val) {
        this.pharmAnamnesis = false;
        this.allergicAnamnesis = false;
        val.forEach(function (element) {
          if (element.anamnesis_type.id === 6 && element.text !== '') {
            _this.pharmAnamnesis = element;
          }
          if (element.anamnesis_type.id === 5 && element.text !== '') {
            _this.allergicAnamnesis = element;
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.getActualClientAnamnesis(this.clientId);
  },

  components: {
    ListMedicament: __WEBPACK_IMPORTED_MODULE_1__ListMedicament_vue__["a" /* default */],
    ListPrescription: __WEBPACK_IMPORTED_MODULE_2__views_Prescribtion_ListPrescription_vue__["a" /* default */],
    ListPreviousMedicament: __WEBPACK_IMPORTED_MODULE_3__ListPreviousMedicament_vue__["a" /* default */],
    AddMedicament: __WEBPACK_IMPORTED_MODULE_4__views_Prescribtion_AddMedicament_vue__["a" /* default */]
  }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListMedicament_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bf96529_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListMedicament_vue__ = __webpack_require__(644);
function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bf96529"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListMedicament_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bf96529_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListMedicament_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Client_modals_ElectronicPrescription_vue__ = __webpack_require__(216);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hostname: __webpack_require__(3),

      prescriptions: false,
      prescriptionsPending: false,
      prescriptionsError: false,

      medicaments: false,
      medicamentsPending: false,
      medicamentsError: false,
      medicamentsDone: false,

      deleteMedicamentPending: false,
      deleteMedicamentDone: false,
      deleteMedicamentError: false,

      secondMedicament: '',

      selectedSeparatedIds: [],
      selectedEPrescriptionIds: [],
      allMedicamentIds: [],

      postPrescriptionsPending: false,
      postPrescriptionsDone: false,
      postPrescriptionsError: false,

      modalEPrescriptionOpened: false
    };
  },

  props: ['doUpdate'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  computed: {
    unselectedSeparatedIds: function unselectedSeparatedIds() {
      var ids = [];

      for (var index = 0; index < this.medicaments.length; ++index) {
        if (this.selectedSeparatedIds.indexOf(this.medicaments[index].id) === -1) {
          ids.push(this.medicaments[index].id);
        }
      }

      return ids;
    },
    recipeCount: function recipeCount() {
      return this.selectedSeparatedIds.length + Math.ceil(this.unselectedSeparatedIds.length / 2);
    }
  },
  methods: {
    addToSelected: function addToSelected(id) {
      if (this.selectedSeparatedIds.indexOf(id) === -1) {
        this.selectedSeparatedIds.push(id);
      }
    },
    removeFromSelected: function removeFromSelected(id) {
      for (var index = 0; index < this.selectedSeparatedIds.length; ++index) {
        if (this.selectedSeparatedIds[index] === id) {
          this.selectedSeparatedIds.splice(index, 1);
        }
      }
    },
    addToSelectedEPrescription: function addToSelectedEPrescription(id) {
      if (this.selectedEPrescriptionIds.indexOf(id) === -1) {
        this.selectedEPrescriptionIds.push(id);
      }
    },
    removeFromSelectedEPrescription: function removeFromSelectedEPrescription(id) {
      for (var index = 0; index < this.selectedEPrescriptionIds.length; ++index) {
        if (this.selectedEPrescriptionIds[index] === id) {
          this.selectedEPrescriptionIds.splice(index, 1);
        }
      }
    },
    getAllMedicamentIds: function getAllMedicamentIds() {
      this.selectedSeparatedIds = [];
      this.selectedEPrescriptionIds = [];
      this.allMedicamentIds = [];
      for (var i = 0; i < this.medicaments.length; i++) {
        this.allMedicamentIds.push(this.medicaments[i].id);
        this.addToSelected(this.medicaments[i].id);
        this.addToSelectedEPrescription(this.medicaments[i].id);
      }
    },
    copyMedicament: function copyMedicament(medicament) {
      this.$emit('copied', medicament);
    },
    removeMedicament: function removeMedicament(id) {
      this.secondMedicament = '';
      this.deleteMedicament(id);
      this.selectedSeparatedIds.splice(this.selectedSeparatedIds.indexOf(id), 1);
    },
    medicamentsListUpdated: function medicamentsListUpdated() {
      this.$emit('updated');
    },
    selectSecondMedicament: function selectSecondMedicament(id) {
      this.secondMedicament = id;
    },
    deselectSecondMedicament: function deselectSecondMedicament() {
      this.secondMedicament = '';
    },
    generatePrescriptions: function generatePrescriptions() {
      this.postPrescriptionsFromMedicamentsByClient(this.$route.params.clientid);
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    updatePrescriptions: function updatePrescriptions() {
      this.$emit('prescription-created');
    }
  },
  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.getClientUnprescribedMedicaments(this.$route.params.clientid);

        this.$emit('updated');
      }
    },
    deleteMedicamentDone: function deleteMedicamentDone(val) {
      if (val === true) {
        this.getClientUnprescribedMedicaments(this.$route.params.clientid);
        this.deleteMedicamentDone = false;
      }
    },
    '$route.params.clientid': function $routeParamsClientid() {
      this.secondMedicament = '';
      this.getClientUnprescribedMedicaments(this.$route.params.clientid);
    },
    medicamentsDone: function medicamentsDone(val) {
      if (val === true) {
        this.getAllMedicamentIds();
      }
    },
    postPrescriptionsDone: function postPrescriptionsDone(val) {
      if (val === true) {
        this.$emit('prescription-created');
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getClientUnprescribedMedicaments(this.$route.params.clientid);
  },

  components: {
    ElectronicPrescription: __WEBPACK_IMPORTED_MODULE_1__views_Client_modals_ElectronicPrescription_vue__["a" /* default */]
  }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.medicaments) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.medicaments), function(m, index) {
    return [_c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "align-middle col-md-7"
    }, [_vm._v("\n                      " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                      " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.disease !== null ? m.disease.code : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.amount) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.dosage) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.repeating) + "\n\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-md-1 row justify-content-between m-0"
    }, [(!_vm.deleteMedicamentPending) ? _c('button', {
      staticClass: "btn btn-sm btn-danger btn_line-heigh-1",
      on: {
        "click": function($event) {
          _vm.removeMedicament(m.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled btn_line-heigh-1"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "col-md-8"
    }, [(m.electronic_prescription === true) ? _c('small', {
      staticClass: "text_shown"
    }, [_vm._v("ERecept")]) : _c('small', {
      staticClass: "text_shown"
    }, [_vm._v("Papírový")]), _vm._v(" |\n                    "), _c('small', {
      class: m.paid_by_sick === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("hradí pacient")]), _vm._v(" |\n                    "), _c('small', {
      class: m.acute === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("akutní")]), _vm._v(" |\n                    "), _c('small', {
      class: m.family === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("rodina")]), _vm._v(" |\n                    "), _c('small', {
      class: m.separate === true ? 'text_shown' : 'text_almost_hidden'
    }, [_vm._v("samostatně")]), _vm._v(" |\n                    "), _c('small', [_vm._v("notifikace: "), _c('span', {
      staticClass: "text_shown"
    }, [_vm._v(_vm._s(m.patient_notification_type))])]), _vm._v(" |\n                    "), _c('small', [_vm._v("platnost: "), _c('span', {
      staticClass: "text_shown"
    }, [_vm._v(_vm._s(m.validity_in_days) + " dní")])])]), _vm._v(" "), _c('td', {
      staticClass: "col-md-4"
    }, [_vm._v("\n                    " + _vm._s(m.note) + "\n                  ")])])]
  }), _vm._v(" "), (_vm.medicaments.length > 0) ? [_c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('td', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-left col-md-3"
  }, [(_vm.medicaments.length > 0) ? _c('button', {
    staticClass: "btn btn-sm btn-success btn_line-heigh-1",
    on: {
      "click": function($event) {
        _vm.generatePrescriptions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" vytvořit recepty")]) : _c('button', {
    staticClass: "btn btn-sm btn-success disabled btn_line-heigh-1"
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" vytvořit recepty")])])])] : _vm._e()], 2)])]) : (_vm.medicamentsPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n    ")]) : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n        (žádný lék nebyl přidán)\n    ")])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-md-7"
  }, [_vm._v("Lék")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Počet bal.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Dávkování")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Opak.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPreviousMedicament_vue__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8471000_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListPreviousMedicament_vue__ = __webpack_require__(648);
function injectStyle (ssrContext) {
  __webpack_require__(646)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8471000"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPreviousMedicament_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8471000_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ListPreviousMedicament_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      medicaments: false,
      medicamentsPending: false,
      medicamentsError: false
    };
  },

  props: ['doUpdate', 'clientId'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  computed: {},
  methods: {
    copyMedicament: function copyMedicament(medicament) {
      this.$emit('copied', medicament);
    },
    medicamentsListUpdated: function medicamentsListUpdated() {
      this.$emit('updated');
    }
  },
  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.getClientPrescribedMedicaments(this.clientId);
        this.$emit('updated');
      }
    },
    clientId: function clientId() {
      this.getClientPrescribedMedicaments(this.clientId);
    }
  },
  beforeMount: function beforeMount() {
    this.getClientPrescribedMedicaments(this.clientId);
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.medicaments) ? _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.medicaments), function(m, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      attrs: {
        "data-testid": 'client-medicament-history-' + m.id
      }
    }, [_c('td', {
      staticClass: "align-middle col-md-5"
    }, [_vm._v("\n                      " + _vm._s(m.medicine ? m.medicine.label : '') + "\n                      " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.disease !== null ? m.disease.code : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("boolToCS")(m.paid_by_sick)) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.amount) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-md-1"
    }, [_vm._v("\n                        " + _vm._s(m.dosage) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left col-md-2"
    }, [_vm._v("\n                        " + _vm._s(m.created_at) + "\n                      "), (m.prescription) ? [(m.prescription.patient_notification_type === 'SMS') ? _c('i', {
      staticClass: "fa fa-mobile-phone",
      attrs: {
        "title": "Recept odeslán přes SMS",
        "aria-hidden": "true"
      }
    }) : (m.prescription.patient_notification_type === 'EMAIL') ? _c('i', {
      staticClass: "fa fa-envelope-o",
      attrs: {
        "title": "Recept odeslán přes e-mail",
        "aria-hidden": "true"
      }
    }) : _c('i', {
      staticClass: "fa fa-ban text-danger",
      attrs: {
        "title": "Bez notifikace o receptu",
        "aria-hidden": "true"
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "col-md-1 row justify-content-start m-0"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary btn_line-heigh-1",
      attrs: {
        "title": "kopírovat",
        "data-testid": 'client-medicament-copy-' + m.id
      },
      on: {
        "click": function($event) {
          _vm.copyMedicament(m)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]
  })], 2)])]) : (_vm.medicamentsPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n    ")]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-md-5"
  }, [_vm._v("Lék")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Hradí pacient")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Počet bal.")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  }, [_vm._v("Dávkování")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Předepsáno")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-1"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "client-medicaments"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('list-prescription', {
    attrs: {
      "do-update": _vm.reloadPrescription,
      "clientId": _vm.clientId,
      "visitId": null
    },
    on: {
      "updated": _vm.updatePrescriptionDone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.pharmAnamnesis || _vm.allergicAnamnesis) ? _c('div', {
    staticClass: "card-body bg-danger-light"
  }, [(_vm.allergicAnamnesis) ? [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.allergicAnamnesis.anamnesis_type.shortcode) + " - " + _vm._s(_vm.allergicAnamnesis.anamnesis_type.name))]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.allergicAnamnesis.text)
    }
  })] : _vm._e(), _vm._v(" "), (_vm.pharmAnamnesis) ? [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.pharmAnamnesis.anamnesis_type.shortcode) + " - " + _vm._s(_vm.pharmAnamnesis.anamnesis_type.name))]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pharmAnamnesis.text)
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('add-medicament', {
    attrs: {
      "client-id": _vm.clientId,
      "visit-id": null,
      "copied-medicament": _vm.medicamentToCopy
    },
    on: {
      "update": _vm.updateMedicament
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-light"
  }, [_c('list-previous-medicament', {
    attrs: {
      "client-id": _vm.clientId
    },
    on: {
      "copied": _vm.copyMedicament
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientMedicalReport_vue__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f168d90_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientMedicalReport_vue__ = __webpack_require__(657);
function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f168d90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientMedicalReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f168d90_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientMedicalReport_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_editor__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Client_popovers_MedicalReportConfirmSave_vue__ = __webpack_require__(653);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      visits_header_title: '',
      hostname: __webpack_require__(3),
      get_params: {
        date: ''
      },
      selectedStates: [],
      print_date: '',
      assignedTo: '',
      doctors: [],
      doctorsPending: false,
      doctorsError: false,
      selectedDoctorId: null,
      showDoctorModal: false,
      selectedDate: '',
      medicalReports: false,
      medicalReportsError: false,
      medicalReportsPending: true,
      editingTaskId: false,
      editingTask: {},
      waitForSave: false,
      openedMedicalReportId: false,
      openedTaskEvaluation: '',
      editedMedicalReportId: false,
      updatedTask: {
        evaluation: '',
        state: '',
        client_id: false,
        include_result_to_email: true
      },
      selected: '',
      clients: [],
      clientsPending: false,
      clientsError: false,
      state: '',
      customToolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'color': [] }], [{ 'align': [] }]],
      editedMedicalReportText: '',
      editedMedicalReportPrintDate: false,

      medicalReportPending: false,
      medicalReportError: false,
      medicalReportDone: false,
      printMedicalReportPending: false,
      sendMedicalReportPending: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    downloadPdf: function downloadPdf(medicalReport) {
      var _this = this;

      this.printMedicalReportPending = true;
      var params = {
        updated_text: this.editedMedicalReportText,
        print_date: this.editedMedicalReportPrintDate !== false ? this.$moment(this.editedMedicalReportPrintDate).format('DD.MM.YYYY') : false
      };
      this.$http.post('visit/' + medicalReport.visit.id + '/medical_report/pdf', params, { responseType: 'arraybuffer' }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });

        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'medical_report_' + _this.$moment().format('YYYYMMDD') + '_' + medicalReport.visit.id + '.pdf';
        link.click();

        _this.printMedicalReportPending = false;
      }).catch(function (error) {
        console.log(error);
        _this.printMedicalReportPending = false;
      });
    },
    sendMedicalReport: function sendMedicalReport(medicalReport) {
      var _this2 = this;

      this.sendMedicalReportPending = true;
      var params = {
        updated_text: this.editedMedicalReportText,
        print_date: this.editedMedicalReportPrintDate !== false ? this.$moment(this.editedMedicalReportPrintDate).format('DD.MM.YYYY') : false
      };
      this.$http.post('visit/' + medicalReport.visit.id + '/medical_report/email', params, { responseType: 'arraybuffer' }).then(function (response) {
        _this2.sendMedicalReportPending = false;
      }).catch(function (error) {
        console.log(error);
        _this2.sendMedicalReportPending = false;
      });
    },
    saveEditedMedicalReport: function saveEditedMedicalReport(visitId) {
      console.log('ukladam!! :)');
      this.postMedicalReport(visitId, this.editedMedicalReportText);
    },
    openMedicalReportId: function openMedicalReportId(num, result) {
      if (this.openedMedicalReportId === num) {
        this.openedMedicalReportId = false;
        this.openedMedicalReportEvaluation = '';
      } else {
        this.openedMedicalReportId = num;

        this.updatedTask = {
          evaluation: result.evaluation,
          state: result.state,
          client_id: result.client_id,
          include_result_to_email: true
        };
      }
    },
    editMedicalReportId: function editMedicalReportId(num, medicalReport) {
      if (this.editedMedicalReportId === num) {
        this.editedMedicalReportId = false;
        this.editedMedicalReportPrintDate = false;
        this.editedMedicalReportText = '';
      } else {
        this.editedMedicalReportId = num;
        this.editedMedicalReportText = medicalReport.text;
        this.editedMedicalReportPrintDate = new Date();
      }
    },
    loadMedicalReportOfClient: function loadMedicalReportOfClient() {
      this.getMedicalReportOfClient(this.$route.params.clientid);
    },
    showModalChangeTaskDoctor: function showModalChangeTaskDoctor(selectedDoctorId) {
      this.selectedDoctorId = selectedDoctorId;
      this.showModal('visit-change-doctor');
    },
    showModal: function showModal(name) {
      console.log('zobrazuji modal');
      this.$modal.show(name);
    },
    selectClient: function selectClient(value) {
      this.updatedTask.client_id = value.id;
      this.updatedTask.state = 'assigned';
    },
    getResult: function getResult(text) {
      if (text.length > 2) {
        this.searchClients(text);
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getDoctors();
    this.selectedStates = ['completed'];
    this.loadMedicalReportOfClient();
  },

  watch: {
    medicalReportDone: function medicalReportDone(val) {
      if (val === true) {
        this.loadMedicalReportOfClient();
        this.medicalReportDone = false;
      }
    },

    selectedStates: function selectedStates(val) {
      this.loadMedicalReportOfClient();
    },
    assignedTo: function assignedTo() {
      this.loadMedicalReportOfClient();
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {
        this.loadMedicalReportOfClient();
      }
    }
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a,
    VueEditor: __WEBPACK_IMPORTED_MODULE_2_vue2_editor__["VueEditor"],
    MedicalReportConfirmSave: __WEBPACK_IMPORTED_MODULE_3__views_Client_popovers_MedicalReportConfirmSave_vue__["a" /* default */]
  },
  filters: {}
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicalReportConfirmSave_vue__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a45f09c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MedicalReportConfirmSave_vue__ = __webpack_require__(656);
function injectStyle (ssrContext) {
  __webpack_require__(654)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a45f09c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicalReportConfirmSave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a45f09c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MedicalReportConfirmSave_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      changePending: false,
      changeError: null,
      visit: {},
      isOpen: false
    };
  },

  methods: {
    confirm: function confirm() {
      this.$emit('confirmed');
    }
  },
  watch: {}
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "autoHide": true
    }
  }, [_c('button', {
    staticClass: "tooltip-target btn btn-sm btn-outline-success mr-2",
    attrs: {
      "data-testid": "client-medical-report-save"
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Uložit")]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h3', [_vm._v("opravdu?")]), _vm._v(" "), _c('b', {
    staticClass: "text-danger"
  }, [_vm._v("uložením přepíšete původní lékařskou zprávu")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    directives: [{
      name: "close-popover",
      rawName: "v-close-popover"
    }],
    staticClass: "tooltip-target btn btn-success",
    attrs: {
      "data-testid": "client-medical-report-save-confirm"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Uložit")])])])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "client-medical-reports-page"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "client-medical-reports-refresh"
    },
    on: {
      "click": function($event) {
        _vm.loadMedicalReportOfClient()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.medicalReports.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.medicalReports), function(mr, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: _vm.openedMedicalReportId === mr.id ? 'border border-primary border-bottom-0' : '',
      attrs: {
        "data-testid": 'client-medical-report-row-' + mr.id
      }
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [(_vm.openedMedicalReportId === mr.id) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'client-medical-report-toggle-' + mr.id
      },
      on: {
        "click": function($event) {
          _vm.openMedicalReportId(mr.id, mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'client-medical-report-toggle-' + mr.id
      },
      on: {
        "click": function($event) {
          _vm.openMedicalReportId(mr.id, mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(mr.visit.date))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(mr.visit.planned_for.fullname))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-5"
    })]), _vm._v(" "), (_vm.openedMedicalReportId === mr.id) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0",
      attrs: {
        "data-testid": 'client-medical-report-detail-' + mr.id
      }
    }, [(_vm.editedMedicalReportId === mr.id) ? [_c('td', {
      staticClass: "col-md-6 border"
    }, [_c('b', {
      staticClass: "p-4"
    }, [_vm._v("Původní lékařská zpráva")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "medical_report_text"
      },
      domProps: {
        "innerHTML": _vm._s(mr.text)
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-md-6 border"
    }, [_c('b', {
      staticClass: "p-4"
    }, [_vm._v("Úprava lékařské zprávy")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-warning",
      on: {
        "click": function($event) {
          _vm.editMedicalReportId(mr.id, mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" zrušit úpravu")]), _vm._v(" "), _c('div', {
      staticClass: "p-4"
    }, [_c('vue-editor', {
      attrs: {
        "editorToolbar": _vm.customToolbar,
        "data-testid": 'client-medical-report-editor-' + mr.id
      },
      model: {
        value: (_vm.editedMedicalReportText),
        callback: function($$v) {
          _vm.editedMedicalReportText = $$v
        },
        expression: "editedMedicalReportText"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "p-4"
    }, [_c('label', {
      attrs: {
        "for": "printDate"
      }
    }, [_vm._v("Datum tisku:")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "placeholder": "vybrat datum tisku",
        "format": "dd.MM.yyyy",
        "language": "cs",
        "monday-first": true,
        "full-month-name": true,
        "name": "printDate",
        "id": "printDate",
        "data-testid": 'client-medical-report-print-date-' + mr.id
      },
      model: {
        value: (_vm.editedMedicalReportPrintDate),
        callback: function($$v) {
          _vm.editedMedicalReportPrintDate = $$v
        },
        expression: "editedMedicalReportPrintDate"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "row m-0 p-4"
    }, [(_vm.medicalReportPending === false) ? _c('medical-report-confirm-save', {
      on: {
        "confirmed": function($event) {
          _vm.saveEditedMedicalReport(mr.visit.id)
        }
      }
    }) : _c('button', {
      staticClass: "btn btn-outline-success disabled mr-2",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Uložit")]), _vm._v(" "), (_vm.printMedicalReportPending === false) ? _c('button', {
      staticClass: "btn btn-sm btn-primary mr-2",
      on: {
        "click": function($event) {
          _vm.downloadPdf(mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-print",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Tisknout")]) : _c('button', {
      staticClass: "btn btn-sm btn-primary disabled mr-2",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Tisknout")]), _vm._v(" "), (_vm.sendMedicalReportPending === false) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      on: {
        "click": function($event) {
          _vm.sendMedicalReport(mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-mail-forward",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")]) : _c('button', {
      staticClass: "btn btn-sm btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")])], 1)])] : _c('td', {
      staticClass: "col-md-12"
    }, [_c('b', {
      staticClass: "p-4"
    }, [_vm._v("Lékařská zpráva")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-warning mr-2",
      attrs: {
        "data-testid": 'client-medical-report-edit-' + mr.id
      },
      on: {
        "click": function($event) {
          _vm.editMedicalReportId(mr.id, mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" upravit")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "target": "_blank",
        "role": "button",
        "data-testid": 'client-medical-report-print-' + mr.id,
        "href": _vm.hostname.hostname + 'visit/' + mr.visit.id + '/medical_report/pdf'
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    }), _vm._v(" Tisknout")]), _vm._v(" "), (_vm.sendMedicalReportPending === false) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'client-medical-report-email-' + mr.id
      },
      on: {
        "click": function($event) {
          _vm.sendMedicalReport(mr)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-mail-forward",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")]) : _c('button', {
      staticClass: "btn btn-sm btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")]), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "medical_report_text"
      },
      domProps: {
        "innerHTML": _vm._s(mr.text)
      }
    })])], 2) : _vm._e()]
  })], 2)])]) : (_vm.medicalReportsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Datum návštěvy")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Doktor")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-5"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (nebyl nalezen žádný výsledek dle požadavků)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientTask_vue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68563142_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientTask_vue__ = __webpack_require__(664);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientTask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68563142_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientTask_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_AddTask_vue__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_HomeReceptionist_components_VisitTaskChangeState_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_HomeDoctor_components_VisitTaskChangeState_vue__ = __webpack_require__(207);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hostname: __webpack_require__(3),
      selectedStates: ['scheduled', 'arrived', 'elaborated', 'completed'],
      visits: [],
      visitsPending: false,
      visitsError: false,
      past_visits: '',
      show_past_visits: false,
      neco_se_stalo_s_id: '',
      modalAddVisitOpened: false,
      modalAddVisitNowOpened: false,
      modalChangeVisitOpened: false,
      modalChangeVisitId: null,
      changePending: false,
      update_visit: {},
      showedVisitDetail: [],
      editingVisitId: false,
      editingVisit: {},
      waitForSave: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  props: ['doUpdate'],
  methods: {
    hasRole: function hasRole(role) {
      var roles = JSON.parse(this.$ls.get('role'));
      for (var i = 0; i < roles.length; i++) {
        if (roles[i] === role) {
          return true;
        }
      }
      return false;
    },
    editVisit: function editVisit(note, id) {
      this.editingVisitId = id;
      this.editingVisit = {
        note: note
      };
    },
    putVisit: function putVisit() {
      var _this = this;

      this.waitForSave = true;
      this.$http.put('visit_task/' + this.editingVisitId, this.editingVisit, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.editingVisitId = false;
        _this.editingVisit = {};
        _this.updateVisits();
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    showHideVisitDetail: function showHideVisitDetail(index) {
      if (this.showedVisitDetail.indexOf(index) === -1) {
        this.showedVisitDetail.push(index);
      } else {
        this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1);
      }
    },
    showPastVisits: function showPastVisits() {
      this.show_past_visits = true;
      if (this.past_visits === '') {
        this.getClientsPastVisits();
      }
    },
    cancelVisitTask: function cancelVisitTask(visitId) {
      var _this2 = this;

      this.changePending = true;
      this.update_visit.state = 'canceled';
      this.$http.put('visit_task/' + visitId, this.update_visit, { emulateJSON: true }).then(function (response) {
        _this2.submited = response.data;
        _this2.changePending = false;
        _this2.updateVisits('home');
      }).catch(function (error) {
        _this2.changeError = error.response.data.errors;
        _this2.changePending = false;
      });
    },
    hidePastVisits: function hidePastVisits() {
      this.show_past_visits = false;
    },
    changeState: function changeState(id) {
      this.neco_se_stalo_s_id = id;
    },
    clientVisitsUpdated: function clientVisitsUpdated() {
      this.$emit('updated');
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    showModalClientVisitChange: function showModalClientVisitChange(visitId) {
      this.modalChangeVisitOpened = true;
      this.modalChangeVisitId = visitId;
      this.showModal('client-visit-change');
    },
    showModalClientTaskAdd: function showModalClientTaskAdd() {
      this.modalAddVisitOpened = true;
      this.showModal('client-task-add');
    },
    showModalClientVisitNowAdd: function showModalClientVisitNowAdd() {
      this.modalAddVisitNowOpened = true;
      this.showModal('client-visit-now-add');
    },
    updateVisits: function updateVisits() {
      this.getClientsVisitTasks(this.selectedStates, this.$route.params.clientid);
    }
  },
  beforeMount: function beforeMount() {
    this.updateVisits();
  },

  watch: {
    doUpdate: function doUpdate(val) {
      if (val === true) {
        this.updateVisits();
      }
    },

    selectedStates: function selectedStates() {
      this.updateVisits();
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {
        this.updateVisits();
      }
    }
  },
  components: {
    ClientTaskAdd: __WEBPACK_IMPORTED_MODULE_0__modals_AddTask_vue__["a" /* default */],
    VisitTaskChangeStateReceptionist: __WEBPACK_IMPORTED_MODULE_2__views_HomeReceptionist_components_VisitTaskChangeState_vue__["a" /* default */],
    VisitTaskChangeStateDoctor: __WEBPACK_IMPORTED_MODULE_3__views_HomeDoctor_components_VisitTaskChangeState_vue__["a" /* default */]
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTask_vue__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13453698_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddTask_vue__ = __webpack_require__(663);
function injectStyle (ssrContext) {
  __webpack_require__(661)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13453698"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13453698_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddTask_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lastDuration: '',
      visit_purposes: '',
      visit: {
        client_id: null,
        planned_for: null,
        duration: 6,
        note: '',
        acute: false,
        purpose_id: '',
        visit_template_id: false,
        unplanned_visit: true
      },
      modalOpened: false,
      visitPurposeError: '',

      visitPending: false,
      visitDone: false,
      visitError: false,

      doctors: false,
      doctorsPending: false,
      doctorsError: false,

      visitTemplates: false
    };
  },

  props: ['opened'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    onHidden: function onHidden() {},
    onOpen: function onOpen() {
      document.getElementById('doctor').focus();
    },
    visitPurposeChanged: function visitPurposeChanged(event) {
      this.visit.duration = event.target.options[event.target.selectedIndex].getAttribute('data-duration');
      if (this.visit_purposes[event.target.selectedIndex].visit_task_templates.length > 0) {
        this.visitTemplates = this.visit_purposes[event.target.selectedIndex].visit_task_templates;
        this.visit.visit_template_id = this.visitTemplates[0].id;
      } else {
        this.visitTemplates = false;
      }
    },
    initialSet: function initialSet() {
      this.visit = {
        client_id: null,
        planned_for: null,
        duration: 6,
        note: '',
        acute: false,
        purpose_id: '',
        unplanned_visit: true,
        visit_template_id: false
      };
    },
    getVisitPurposes: function getVisitPurposes() {
      var _this = this;

      this.waitForResponse = true;
      this.$http.get('visit_task_purpose').then(function (response) {
        _this.visit_purposes = response.data;
        var visit = _this.visit;
        _this.visit_purposes.forEach(function (visitPurpose) {
          if (visitPurpose.default === true) {
            visit.purpose_id = visitPurpose.id;
          }
        });
        _this.waitForResponse = false;
      }).catch(function (error) {
        _this.visitPurposeError = error.response.data.errors;
        _this.waitForResponse = false;
      });
    },
    init: function init() {
      this.initialSet();
      this.visit.client_id = this.$route.params.clientid;
      this.getDoctors();
      this.getVisitPurposes();
    }
  },
  watch: {
    opened: function opened(val) {
      if (val === true) {
        this.init();
      }
    },
    visitDone: function visitDone(val) {
      if (val === true) {
        this.$emit('update');
        this.visitDone = false;
        this.initialSet();
        this.visit.client_id = this.$route.params.clientid;
        this.$modal.hide('client-task-add');
      }
    },
    '$route': function $route(to, from) {
      if (to.params.clientid !== from.params.clientid && typeof to.params.clientid !== 'undefined') {
        this.init();
      }
    }
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "90%",
      "scrollable": true,
      "name": "client-task-add",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "opened": _vm.onOpen,
      "closed": _vm.onHidden
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "client-task-add"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Naplánovat úkol\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postVisitTask(_vm.visit)
      }
    }
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "doctor"
    }
  }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.planned_for),
      expression: "visit.planned_for"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "autofocus": "autofocus",
      "data-testid": "client-task-add-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.planned_for = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit doktora")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "doctorHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("za účelem")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.purpose_id),
      expression: "visit.purpose_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "visitPurposeSelect",
      "data-testid": "client-task-add-purpose"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.purpose_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.visitPurposeChanged($event)
      }]
    }
  }, _vm._l((_vm.visit_purposes), function(visit_purpose) {
    return _c('option', {
      domProps: {
        "value": visit_purpose.id
      }
    }, [_vm._v(_vm._s(visit_purpose.purpose))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.visit_template_id),
      expression: "visit.visit_template_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "visitTemplateSelect",
      "disabled": _vm.visitTemplates === false,
      "data-testid": "client-task-add-template"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.visit_template_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.visitTemplates), function(visit_template, index) {
    return _c('option', {
      domProps: {
        "value": visit_template.id,
        "selected": index === 0
      }
    }, [_vm._v(_vm._s(visit_template.name))])
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("bez šablony")])], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "acute"
    }
  }, [_vm._v("\n                    prioritní "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.acute),
      expression: "visit.acute"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "acute",
      "data-testid": "client-task-add-priority"
    },
    domProps: {
      "checked": Array.isArray(_vm.visit.acute) ? _vm._i(_vm.visit.acute, null) > -1 : (_vm.visit.acute)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.visit.acute,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.visit.acute = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.visit.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.visit.acute = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "operationHelp"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-inline mt-2"
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.note),
      expression: "visit.note"
    }],
    staticClass: "form-control col-sm-9 ml-sm-1 mr-sm-2",
    attrs: {
      "type": "text",
      "aria-describedby": "noteHelp",
      "id": "note",
      "data-testid": "client-task-add-note"
    },
    domProps: {
      "value": (_vm.visit.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visit.note = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.visitPending) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "data-testid": "client-task-add-submit"
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "client-tasks"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 text-center"
  }, [(_vm.selectedStates.indexOf('scheduled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "scheduled",
      "data-testid": "client-tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('scheduled')
      }
    }
  }, [_vm._v("plánovaní")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "scheduled",
      "data-testid": "client-tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('scheduled'), 1)
      }
    }
  }, [_vm._v("plánovaní")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "completed",
      "data-testid": "client-tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("splněno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "completed",
      "data-testid": "client-tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("splněno")]), _vm._v(" "), (_vm.selectedStates.indexOf('canceled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled",
      "data-testid": "client-tasks-filter-canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('canceled')
      }
    }
  }, [_vm._v("zrušeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled",
      "data-testid": "client-tasks-filter-canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('canceled'), 1)
      }
    }
  }, [_vm._v("zrušeno")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "client-tasks-refresh"
    },
    on: {
      "click": _vm.updateVisits
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-outline-success",
    attrs: {
      "data-testid": "client-task-add-open"
    },
    on: {
      "click": _vm.showModalClientTaskAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" naplánovat úkol")])])])]), _vm._v(" "), (_vm.visits.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l(((_vm.visits)), function(visit, index) {
    return [_c('tr', {
      attrs: {
        "data-testid": 'client-task-' + visit.id
      }
    }, [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "rowspan": "2"
      }
    }, [(_vm.hasRole('receptionist')) ? _c('visit-task-change-state-receptionist', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id,
        "test-prefix": "client-task"
      },
      on: {
        "update": _vm.updateVisits
      }
    }) : (_vm.hasRole('doctor')) ? _c('visit-task-change-state-doctor', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id,
        "test-prefix": "client-task"
      },
      on: {
        "update": _vm.updateVisits
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(visit.hasData) ? [_c('button', {
      staticClass: "btn btn-sm btn_extra_small btn-primary",
      attrs: {
        "data-testid": 'client-task-detail-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.showHideVisitDetail(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.hasLoggedUserRole('doctor')) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'ShowVisit',
          params: {
            clientid: _vm.$route.params.clientid,
            visitid: visit.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(visit.date) + "\n                        ")]) : [_vm._v("\n                            " + _vm._s(visit.date) + "\n                        ")]], 2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "colspan": "2"
      }
    }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('label', {
      attrs: {
        "for": "note"
      }
    }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.putVisit(visit)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingVisit.note),
        expression: "editingVisit.note"
      }],
      staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "noteHelp",
        "id": "note",
        "data-testid": 'client-task-note-' + visit.id
      },
      domProps: {
        "value": (_vm.editingVisit.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingVisit.note = $event.target.value
        }
      }
    }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "data-testid": 'client-task-save-' + visit.id
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])])] : [_c('button', {
      staticClass: "btn btn-sm btn-link text-secondary",
      attrs: {
        "data-testid": 'client-task-edit-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.editVisit(visit.note, visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "border-top-0",
      attrs: {
        "colspan": "3"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "border-top-0 text-right",
      attrs: {
        "colspan": "1"
      }
    }, [(visit.state === 'scheduled') ? [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.cancelVisitTask(visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-times-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" zrušit návštěvu")])] : _vm._e(), _c('br'), _vm._v("\n                        " + _vm._s(visit.planned_for.fullname) + "\n                        "), (visit.planned_by && visit.planned_at) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne ' + visit.planned_at,
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                              content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne ' + visit.planned_at,\n                              placement: 'bottom-center',\n                              classes: ['info']}"
      }],
      staticClass: "text-info fa fa-lg fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()], 2)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('tr', [_c('td', {
      staticClass: "border-top-0"
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {}, [_c('h6', [_vm._v("Výsledná zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                        " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                    ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                        ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                        ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(1, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(visit.medicament.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                                              " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])])]) : _vm._e()]
  })], 2)])]) : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(3)]), _vm._v(" "), _c('client-task-add', {
    attrs: {
      "opened": _vm.modalAddVisitOpened
    },
    on: {
      "update": _vm.updateVisits
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Datum / čas"), _c('br'), _vm._v("Klient")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reporting_vue__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5b0620_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Reporting_vue__ = __webpack_require__(672);
function injectStyle (ssrContext) {
  __webpack_require__(666)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a5b0620"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reporting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5b0620_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Reporting_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReportingList_vue__ = __webpack_require__(668);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    ReportingList: __WEBPACK_IMPORTED_MODULE_0__components_ReportingList_vue__["a" /* default */]
  },
  methods: {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportingList_vue__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d7805f1_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ReportingList_vue__ = __webpack_require__(671);
function injectStyle (ssrContext) {
  __webpack_require__(669)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d7805f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportingList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d7805f1_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ReportingList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      getParams: {
        date_from: '',
        date_to: ''
      },
      visits: false,
      visitsPending: false,
      visitsError: false,
      dateFrom: '',
      dateTo: ''
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  methods: {
    loadVisitsReportong: function loadVisitsReportong() {
      this.visits = [];
      this.getVisitsReporting(this.getParams);
    }
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a
  },
  beforeMount: function beforeMount() {
    this.loadVisitsReportong();
  },

  watch: {
    dateFrom: function dateFrom(date) {
      this.getParams.date_from = this.$moment(date).format('DD.MM.YYYY');
      this.getParams.date_to = this.$moment(date).format('DD.MM.YYYY');
      this.loadVisitsReportong();
    }
  }

});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "dateFrom"
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }), _vm._v(" "), (_vm.visits.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.visits), function(visit) {
    return _c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "col-sm-3"
    }, [(visit.state === 'scheduled') ? _c('i', {
      staticClass: "fa fa-2x fa-circle-o text-info",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'arrived') ? _c('i', {
      staticClass: "fa fa-2x fa-clock-o text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'completed') ? _c('i', {
      staticClass: "fa fa-2x fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'elaborated') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'failed') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'excused') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'canceled') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (visit.client.insurance_number) ? _c('span', [_vm._v("ČP: "), _c('b', [_vm._v(_vm._s(visit.client.insurance_number))])]) : _c('span', [_vm._v("RČ: "), _c('b', [_vm._v(_vm._s(visit.client.p_i_n))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'ShowVisit',
          params: {
            clientid: visit.client.id,
            visitid: visit.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-right text-info",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(visit.client.first_name) + " " + _vm._s(visit.client.last_name)), _c('br'), _vm._v(" "), (visit.client.health_insurance) ? _c('span', {
      staticClass: "badge badge-lg badge-secondary badge_health_insurance",
      class: '_' + visit.client.health_insurance.code
    }, [_vm._v(_vm._s(visit.client.health_insurance.code === '---' ? visit.client.health_insurance.shortcut : visit.client.health_insurance.code))]) : _c('span', {
      staticClass: "badge badge-lg pointer badge-warning badge_health_insurance",
      attrs: {
        "role": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybí zdrav. pojišťovna")])], 1), _vm._v(" "), (visit.diagnosis.length > 0) ? _c('td', {
      staticClass: "col-sm-6 p-0"
    }, [_c('table', {
      staticClass: "table table-bordered m-0"
    }, _vm._l((visit.diagnosis), function(d) {
      return _c('tr', {
        staticClass: "row m-0"
      }, [_c('td', {
        staticClass: "col-sm-4"
      }, [_vm._v(_vm._s(d.disease.code) + " - " + _vm._s(d.disease.name_cs))]), _vm._v(" "), (d.actions.length > 0) ? _c('td', {
        staticClass: "col-sm-8 p-0"
      }, [_c('table', {
        staticClass: "table table-bordered m-0"
      }, _vm._l((d.actions), function(a) {
        return _c('tr', {
          staticClass: "row m-0"
        }, [_c('td', {
          staticClass: "col-sm-6"
        }, [_vm._v("\n                                                " + _vm._s(a.operation.code) + "  - " + _vm._s(a.operation.name) + "\n                                            ")]), _vm._v(" "), (a.zulp.length > 0) ? _c('td', {
          staticClass: "col-sm-6 p-0"
        }, [_c('table', {
          staticClass: "table table-bordered m-0"
        }, _vm._l((a.zulp), function(z) {
          return _c('tr', {}, [_c('td', {}, [_vm._v("\n                                                            " + _vm._s(z.amount) + "x " + _vm._s(z.medicine.label) + "\n                                                        ")])])
        }))]) : _vm._e()])
      }))]) : _c('td', {
        staticClass: "col-sm-8"
      }, [_vm._m(2, true)])])
    }))]) : _c('td', {
      staticClass: "col-sm-6"
    }, [_vm._m(3, true)]), _vm._v(" "), (visit.medicament.length > 0) ? _c('td', {
      staticClass: "col-sm-3 p-0"
    }, [_c('table', {
      staticClass: "table table-bordered m-0"
    }, _vm._l((visit.medicament), function(m) {
      return _c('tr', {
        staticClass: "m-0"
      }, [_c('td', [_vm._v(_vm._s(m.amount) + "x " + _vm._s(m.medicine ? m.medicine.label : '') + " " + _vm._s(m.individual_medicine ? m.individual_medicine.name : '') + " " + _vm._s(m.paid_by_sick === true ? ' - hradí nemocný' : ''))])])
    }))]) : _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v("\n                        U návštěvy nebyl předepsán lék\n                    ")])])
  }))])]) : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(4)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(5)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Seznam návštěv, diagnóz, výkonů a léků")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("RČ/ČP / Klient / pojišťovna")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Výkon(y)")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("ZULP")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Léky")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("\n                                        DIAGNÓZA NEMÁ PŘIŘAZENÉ VÝKONY\n                                        "), _c('i', {
    staticClass: "fa fa-close fa-2x text-danger"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n                            U NÁVŠTĚVY NENÍ DIAGNÓZA\n                            "), _c('i', {
    staticClass: "fa fa-close fa-2x text-danger"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_doctor"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('reporting-list')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistic_vue__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164a3038_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Statistic_vue__ = __webpack_require__(725);
function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-164a3038"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164a3038_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Statistic_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Statistic_components_Statistic_vue__ = __webpack_require__(676);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    Statistic: __WEBPACK_IMPORTED_MODULE_0__views_Statistic_components_Statistic_vue__["a" /* default */]
  },
  methods: {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistic_vue__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02177ef3_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Statistic_vue__ = __webpack_require__(724);
function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02177ef3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02177ef3_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Statistic_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_InsuranceMonthBarChart__ = __webpack_require__(679);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      disableFutureDates: {
        from: this.$moment().add(1, 'd').toDate()
      },
      selectedDate: this.$moment().toDate(),

      monthStatistics: false,
      monthStatisticsPending: true,
      monthStatisticsDone: false,
      monthStatisticsError: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    loadMonthStatistics: function loadMonthStatistics() {
      var getParams = {
        date: this.$moment(this.selectedDate).format('MM.YYYY')
      };
      this.getMonthStatistics(getParams);
    },
    previousMonth: function previousMonth() {
      this.selectedDate = this.$moment(this.selectedDate).subtract(1, 'months').toDate();
      this.loadMonthStatistics();
    },
    nextMonth: function nextMonth() {
      this.selectedDate = this.$moment(this.selectedDate).add(1, 'months').toDate();
      this.loadMonthStatistics();
    },
    init: function init() {
      this.loadMonthStatistics();
    }
  },
  watch: {
    doctorId: function doctorId(val) {
      this.visits = false;
      if (val !== null && val !== undefined) {
        document.title = 'clinico - ' + this.doctors.find(this.findDoctorById).fullname;
        this.loadCalendar();
      }
    }
  },
  beforeMount: function beforeMount() {
    this.init();
  },

  components: {
    InsuranceMonthBarChart: __WEBPACK_IMPORTED_MODULE_1__charts_InsuranceMonthBarChart__["a" /* default */]
  }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(220);


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ['labels', 'datasets', 'reload'],
  methods: {
    render: function render() {
      this.renderChart({
        labels: this.labels,
        datasets: this.datasets
      }, {
        responsive: true,
        maintainAspectRatio: false
      });
    }
  },
  mounted: function mounted() {
    this.render();
  },

  watch: {
    reload: function reload(val) {
      if (val === true) {
        this.render();
      }
    }
  }
});

/***/ }),
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "statistics-page"
    }
  }, [_c('div', {
    staticClass: "row justify-content-center p-1"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "title": "Předchozí měsíc",
      "data-testid": "statistics-previous-month"
    },
    on: {
      "click": function($event) {
        _vm.previousMonth()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "MMMM yyyy",
      "language": "cs",
      "disabled": _vm.disableFutureDates,
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datePickerBorderLessInput",
      "minimumView": 'month',
      "maximumView": 'year',
      "initialView": 'month'
    },
    on: {
      "input": function($event) {
        _vm.loadMonthStatistics()
      }
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  }), _vm._v(" "), (_vm.$moment(_vm.selectedDate).format('YYYYMM') < _vm.$moment().format('YYYYMM')) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "title": "Následující měsíc",
      "data-testid": "statistics-next-month"
    },
    on: {
      "click": function($event) {
        _vm.nextMonth()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })]) : _c('button', {
    staticClass: "btn btn-sm btn-primary disabled",
    attrs: {
      "type": "button",
      "title": "Následující měsíc",
      "disabled": "disabled",
      "data-testid": "statistics-next-month"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [(_vm.monthStatistics) ? _c('insurance-month-bar-chart', {
    attrs: {
      "labels": _vm.monthStatistics.labels,
      "reload": _vm.monthStatisticsDone,
      "datasets": _vm.monthStatistics.per_company
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.monthStatistics) ? _c('table', {
    staticClass: "table table-hover",
    attrs: {
      "data-testid": "statistics-insurance-table"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.monthStatistics.per_company), function(company) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(company.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(company.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(company.visit_counts))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(company.total / company.visit_counts)))])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.monthStatistics.total.total))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.monthStatistics.total.visit_counts))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(Math.round(_vm.monthStatistics.total.total / _vm.monthStatistics.total.visit_counts)))])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.monthStatistics) ? _c('table', {
    staticClass: "table table-hover",
    attrs: {
      "data-testid": "statistics-doctor-table"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.monthStatistics.per_doctors), function(doctor) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(doctor.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(doctor.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(doctor.visit_counts))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(doctor.total / doctor.visit_counts)))])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.monthStatistics.total.total))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.monthStatistics.total.visit_counts))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(Math.round(_vm.monthStatistics.total.total / _vm.monthStatistics.total.visit_counts)))])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.monthStatistics) ? _c('table', {
    staticClass: "table table-hover",
    attrs: {
      "data-testid": "statistics-operation-table"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.monthStatistics.per_operations), function(operation) {
    return _c('tr', [_c('td', {
      attrs: {
        "title": operation.title
      }
    }, [_vm._v(_vm._s(operation.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operation.points))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operation.count))])])
  }))]) : _vm._e()])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_vm._v("pojišťovny")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("pojišťovna")]), _vm._v(" "), _c('th', [_vm._v("body")]), _vm._v(" "), _c('th', [_vm._v("počet návštěv")]), _vm._v(" "), _c('th', [_vm._v("průměrná výtěžnost b/n")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("celkem")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_vm._v("doktoři")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("doktor")]), _vm._v(" "), _c('th', [_vm._v("body")]), _vm._v(" "), _c('th', [_vm._v("počet návštěv")]), _vm._v(" "), _c('th', [_vm._v("průměrná výtěžnost b/n")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("celkem")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_vm._v("výkony")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("výkon")]), _vm._v(" "), _c('th', [_vm._v("body")]), _vm._v(" "), _c('th', [_vm._v("počet")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('statistic')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Result_vue__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d895862_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Result_vue__ = __webpack_require__(737);
function injectStyle (ssrContext) {
  __webpack_require__(727)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d895862"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Result_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d895862_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Result_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Results_vue__ = __webpack_require__(729);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    Results: __WEBPACK_IMPORTED_MODULE_0__components_Results_vue__["a" /* default */]
  },
  methods: {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8ab72fc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__ = __webpack_require__(736);
function injectStyle (ssrContext) {
  __webpack_require__(730)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f8ab72fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8ab72fc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_ClientMedicament__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PaginationComponent_vue__ = __webpack_require__(25);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      getParams: {
        p: 1,
        s: 'received_on-',
        f: {},
        pp: 20
      },
      selectedStates: [],
      print_date: '',
      assignedTo: '',
      doctors: [],
      doctorsPending: false,
      doctorsError: false,
      selectedDoctorId: null,
      showDoctorModal: false,
      showClientMedicamentModal: false,
      selectedDate: '',
      listData: false,
      listError: false,
      listPagination: null,
      listPending: false,
      clientPreviousTasks: false,
      clientPreviousTasksError: false,
      clientPreviousTasksPending: true,
      waiting: true,
      editingTaskId: false,
      editingTask: {},
      waitForSave: false,
      openedTaskId: false,

      openedClientResults: false,
      openedTaskEvaluation: '',
      updatedTask: {
        evaluation: '',
        state: '',
        client_id: false,
        include_result_to_email: true,
        dont_send_email: false
      },
      selected: '',
      clients: [],
      clientsPending: false,
      clientsError: false,
      state: '',
      openedClientTaskId: false,

      tasks: false,
      tasksError: false,
      tasksPending: true
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  methods: {
    setPage: function setPage(number) {
      this.getParams.p = number;
      this.getDoctorsDayTasks();
    },
    openTaskId: function openTaskId(num, result) {
      if (this.openedTaskId === num) {
        this.openedTaskId = false;
        this.openedTaskEvaluation = '';
        this.clientPreviousTasks = false;
        this.clientPreviousTasksError = false;
        this.clientPreviousTasksPending = true;
      } else {
        this.openedTaskId = num;
        if (result.client) {
          this.getMedicalReportAndLabResultOfClient(result.client.id, null);
        }

        this.updatedTask = {
          evaluation: result.evaluation,
          state: result.state,
          client_id: result.client_id,
          include_result_to_email: true
        };
      }
    },
    openClientTaskId: function openClientTaskId(num) {
      if (this.openedClientTaskId === num) {
        this.openedClientTaskId = false;
      } else {
        this.openedClientTaskId = num;
      }
    },
    getClientPreviousResults: function getClientPreviousResults(clientId, exceptResultId) {
      var getParams = {
        states: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(['completed']),
        client_id: clientId,
        except: exceptResultId
      };
      this.getClientPreviousTasks(getParams);
    },
    copyResultText: function copyResultText() {
      var range = window.getSelection().getRangeAt(0);
      range.selectNode(document.getElementById('result_text'));
      window.getSelection().addRange(range);
      document.execCommand('copy');
    },
    countLinesTextResult: function countLinesTextResult(text) {
      return text.split(/\r\n|\r|\n/).length + 5;
    },
    putTask: function putTask() {
      var _this = this;

      this.waitForSave = true;
      this.$http.put('result/' + this.openedTaskId, this.updatedTask, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.openedTaskId = false;

        _this.updatedTask.dont_send_email = false;
        _this.getDoctorsDayTasks();
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    handOverToDoctroAndSubmit: function handOverToDoctroAndSubmit() {
      this.updatedTask.state = 'wait_for_doctor';
      this.putTask();
    },
    setWithoutEmail: function setWithoutEmail() {
      this.updatedTask.state = 'completed';
      this.updatedTask.dont_send_email = true;
      this.putTask();
    },
    completeAndSubmit: function completeAndSubmit() {
      this.updatedTask.state = 'completed';
      this.putTask();
    },
    assignAndSubmit: function assignAndSubmit() {
      this.putTask();
    },
    getDoctorsDayTasks: function getDoctorsDayTasks() {
      this.getResults(this.getParams);
    },
    selectToday: function selectToday() {
      this.selectedDate = this.$moment().toDate();
    },
    selectTomorrow: function selectTomorrow() {
      this.selectedDate = this.$moment().add(1, 'days').toDate();
    },
    setDateAndLoad: function setDateAndLoad() {
      switch (this.selected_date.startOf('day').diff(this.$moment().startOf('day'), 'days')) {
        case 0:
          this.print_date = 'Dnes (' + this.$moment(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        case 1:
          this.print_date = 'Zítra (' + this.$moment(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        case -1:
          this.print_date = 'Včera (' + this.$moment(this.selected_date).format('DD.MM.YYYY') + ')';
          break;
        default:
          this.print_date = this.$moment(this.selected_date).format('dddd') + ' (' + this.$moment(this.selected_date).format('DD.MM.YYYY') + ')';
      }
      this.getDoctorsDayTasks();
      this.waiting = false;
    },
    showModalClientMedicament: function showModalClientMedicament(selectedDoctorId) {
      this.selectedDoctorId = selectedDoctorId;
      this.showModal('client-medicament');
    },
    showModal: function showModal(name) {
      this.$modal.show(name);
    },
    selectClient: function selectClient(value) {
      this.updatedTask.client_id = value.id;
      this.updatedTask.state = 'assigned';
    },
    getResult: function getResult(text) {
      if (text.length > 2) {
        this.searchClients(text);
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getDoctors();
    if (this.userHasRole('doctor')) {
      this.waiting = true;
      this.assignedTo = this.$ls.get('userid');
      this.selectedStates = ['wait_for_doctor'];
    } else {
      this.selectToday();
      localStorage.setItem('home_date', this.$moment().format('DD.MM.YYYY'));
      this.selectedStates = ['assigned', 'accepted'];
    }
  },

  watch: {
    selectedStates: function selectedStates(val) {
      this.getParams.f.state = val;
      this.getDoctorsDayTasks();
    },
    assignedTo: function assignedTo(val) {
      if (val === null) {
        delete this.getParams.f.assigned_to;
      } else {
        this.getParams.f.assigned_to = val;
      }

      this.getDoctorsDayTasks();
    },
    selectedDate: function selectedDate(val) {
      localStorage.setItem('home_date', this.$moment(val).format('DD.MM.YYYY'));
      this.selected_date = this.$moment(val);
      this.setDateAndLoad();
    }
  },
  components: {
    PaginationComponent: __WEBPACK_IMPORTED_MODULE_3__components_PaginationComponent_vue__["a" /* default */],

    ClientMedicament: __WEBPACK_IMPORTED_MODULE_2__Modal_ClientMedicament__["a" /* default */]
  },
  filters: {}
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientMedicament_vue__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5842cba_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientMedicament_vue__ = __webpack_require__(735);
function injectStyle (ssrContext) {
  __webpack_require__(733)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f5842cba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientMedicament_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5842cba_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ClientMedicament_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Client_components_ClientMedicament__ = __webpack_require__(219);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reloadMedicament: false,
      reloadPrescription: false,
      medicamentToCopy: false
    };
  },

  props: ['opened', 'doctorId', 'propClient'],
  methods: {
    beforeOpen: function beforeOpen() {
      console.log('oteviram modalko');
    }
  },
  watch: {},
  computed: {},
  components: {
    ClientMedicament: __WEBPACK_IMPORTED_MODULE_0__views_Client_components_ClientMedicament__["a" /* default */]
  }
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "80%",
      "scrollable": true,
      "name": "client-medicament",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "lab-results-prescription-dialog"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Vypsání receptu pro " + _vm._s(_vm.propClient.full_name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('client-medicament', {
    attrs: {
      "prop-client-id": _vm.propClient.id
    }
  })], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "lab-results-page"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-center"
  }, [(_vm.doctors.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignedTo),
      expression: "assignedTo"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "lab-results-doctor-filter"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assignedTo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("všichni doktoři")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.selectedStates.indexOf('accepted') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "accepted",
      "data-testid": "lab-results-filter-accepted"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('accepted')
      }
    }
  }, [_vm._v("nepřiřazené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "accepted",
      "data-testid": "lab-results-filter-accepted"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('accepted'), 1)
      }
    }
  }, [_vm._v("nepřiřazené")]), _vm._v(" "), (_vm.selectedStates.indexOf('assigned') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "assigned",
      "data-testid": "lab-results-filter-assigned"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('assigned')
      }
    }
  }, [_vm._v("nevyhodnocené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "assigned",
      "data-testid": "lab-results-filter-assigned"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('assigned'), 1)
      }
    }
  }, [_vm._v("nevyhodnocené")]), _vm._v(" "), (_vm.selectedStates.indexOf('wait_for_doctor') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "wait_for_doctor",
      "data-testid": "lab-results-filter-wait-for-doctor"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('wait_for_doctor')
      }
    }
  }, [_vm._v("předáno na doktora")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "wait_for_doctor",
      "data-testid": "lab-results-filter-wait-for-doctor"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('wait_for_doctor'), 1)
      }
    }
  }, [_vm._v("předáno na doktora")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled",
      "data-testid": "lab-results-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("dokončeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled",
      "data-testid": "lab-results-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("dokončeno")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "lab-results-refresh"
    },
    on: {
      "click": function($event) {
        _vm.getDoctorsDayTasks()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.listData.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.listData), function(task, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: _vm.openedTaskId === task.id ? 'border border-primary border-bottom-0' : '',
      attrs: {
        "data-testid": 'lab-results-row-' + task.id
      }
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [(_vm.openedTaskId === task.id) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'lab-results-toggle-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(task.id, task)
        }
      }
    }, [_vm._v("-")]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'lab-results-toggle-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(task.id, task)
        }
      }
    }, [_vm._v("+")])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-sm-2",
      attrs: {
        "data-testid": 'lab-results-state-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("taskStateToCS")(task.state)) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'lab-results-client-' + task.id
      }
    }, [(task.client) ? [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: task.client.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                            " + _vm._s(task.client.full_name) + "\n                        ")] : [_vm._v("klient nepřiřazen")]], 2), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'lab-results-doctor-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(task.assigned_to ? task.assigned_to.fullname : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'lab-results-received-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(task.received_on) + "\n                    ")])]), _vm._v(" "), (_vm.openedTaskId === task.id) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0",
      attrs: {
        "data-testid": 'lab-results-detail-' + task.id
      }
    }, [_c('td', {
      staticClass: "col-md-6"
    }, [_c('b', [_vm._v("Laboratorní výsledek:")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace"
      },
      attrs: {
        "id": "result_text",
        "data-testid": 'lab-results-content-' + task.id
      },
      domProps: {
        "innerHTML": _vm._s(task.result)
      },
      on: {
        "click": _vm.copyResultText
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-md-6"
    }, [_c('div', [(task.client) ? [(task.state !== 'completed') ? [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": "exampleFormControlTextarea1"
      }
    }, [_vm._v("Zpráva klientovi:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Dobrý den,")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedTask.evaluation),
        expression: "updatedTask.evaluation"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "exampleFormControlTextarea1",
        "rows": "10",
        "data-testid": 'lab-results-evaluation-' + task.id
      },
      domProps: {
        "value": (_vm.updatedTask.evaluation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedTask.evaluation = $event.target.value
        }
      }
    }), _vm._v(" "), _vm._m(2, true)]), _vm._v(" "), _c('div', [_c('label', {
      attrs: {
        "for": "includeResultToMessage"
      }
    }, [_vm._v("Přidat laboratorní výsledek do zprávy")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedTask.include_result_to_email),
        expression: "updatedTask.include_result_to_email"
      }],
      attrs: {
        "type": "checkbox",
        "id": "includeResultToMessage",
        "data-testid": 'lab-results-include-result-' + task.id
      },
      domProps: {
        "checked": Array.isArray(_vm.updatedTask.include_result_to_email) ? _vm._i(_vm.updatedTask.include_result_to_email, null) > -1 : (_vm.updatedTask.include_result_to_email)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.updatedTask.include_result_to_email,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.updatedTask.include_result_to_email = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.updatedTask.include_result_to_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.updatedTask.include_result_to_email = $$c
          }
        }
      }
    })]), _vm._v(" "), (task.client.email_address.length < 1) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("Nelze odpovědět, klient nemá vyplněnou emailovou adresu.")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-between m-0"
    }, [_c('div', [(task.client.email_address.length > 0) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "data-testid": 'lab-results-complete-email-' + task.id
      },
      on: {
        "click": _vm.completeAndSubmit
      }
    }, [_vm._v("Odpovědět a odsplnit")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-outline-success",
      attrs: {
        "data-testid": 'lab-results-complete-' + task.id
      },
      on: {
        "click": _vm.setWithoutEmail
      }
    }, [_vm._v("Pouze odsplnit")])]), _vm._v(" "), (_vm.hasRole('doctor')) ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "data-testid": 'lab-results-prescription-' + task.id
      },
      on: {
        "click": _vm.showModalClientMedicament
      }
    }, [_vm._v("Vypsat recept")]) : _vm._e(), _vm._v(" "), (task.state === 'assigned') ? _c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "data-testid": 'lab-results-hand-off-' + task.id
      },
      on: {
        "click": _vm.handOverToDoctroAndSubmit
      }
    }, [_vm._v("Předat na doktora")]) : _vm._e(), _vm._v(" "), _c('client-medicament', {
      attrs: {
        "prop-client": task.client
      }
    })], 1)] : [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": "evaluationSent"
      }
    }, [_vm._v("Zpráva odeslaná klientovi:")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedTask.evaluation),
        expression: "updatedTask.evaluation"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "evaluationSent",
        "rows": "10",
        "disabled": "disabled"
      },
      domProps: {
        "value": (_vm.updatedTask.evaluation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedTask.evaluation = $event.target.value
        }
      }
    })])]] : [_c('multiselect', {
      attrs: {
        "reset-after": false,
        "id": "search",
        "label": "label",
        "track-by": "code",
        "placeholder": "vyhledat klienta",
        "open-direction": "bottom",
        "options": _vm.clients,
        "multiple": false,
        "searchable": true,
        "internal-search": false,
        "close-on-select": true,
        "options-limit": 300,
        "limit": 3,
        "max-height": 600,
        "show-no-results": false,
        "clear-on-select": true,
        "selectLabel": "",
        "data-testid": 'lab-results-client-search-' + task.id
      },
      on: {
        "search-change": _vm.getResult,
        "select": _vm.selectClient
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    }), _vm._v(" "), (_vm.selected) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "data-testid": 'lab-results-assign-' + task.id
      },
      on: {
        "click": _vm.assignAndSubmit
      }
    }, [_vm._v("Přiřadit klienta")]) : _c('button', {
      staticClass: "btn btn-success disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_vm._v("Přiřadit klienta")])]], 2), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', [_vm._l((_vm.tasks), function(task, index) {
      return [_c('tr', {
        staticClass: "row m-0",
        class: _vm.openedClientTaskId === index ? 'border border-primary border-bottom-0' : ''
      }, [_c('td', {
        staticClass: "align-middle col-sm-1"
      }, [(_vm.openedClientTaskId === index) ? _c('button', {
        staticClass: "btn btn-sm btn-primary",
        on: {
          "click": function($event) {
            _vm.openClientTaskId(index, task)
          }
        }
      }, [_vm._v("-")]) : _c('button', {
        staticClass: "btn btn-sm btn-secondary",
        on: {
          "click": function($event) {
            _vm.openClientTaskId(index, task)
          }
        }
      }, [_vm._v("+")])]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-3"
      }, [_vm._v(_vm._s(task.date_cs))]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-3"
      }, [(task.type === 'lab_result') ? _c('span', [_c('i', {
        staticClass: "fa fa-flask fa-lg",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Laboratorní výsledek")]) : _c('span', [_c('i', {
        staticClass: "fa fa-pencil-square-o",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Lékařská zpráva")])]), _c('td', {
        staticClass: "col-sm-5"
      })]), _vm._v(" "), (_vm.openedClientTaskId === index) ? _c('tr', {
        staticClass: "row m-0 border border-primary border-top-0"
      }, [(task.type === 'lab_result') ? _c('td', {
        staticClass: "col-md-12"
      }, [_c('b', [_vm._v("Laboratorní výsledek")]), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "p-4",
        staticStyle: {
          "white-space": "pre-wrap",
          "font-family": "monospace, monospace"
        },
        attrs: {
          "id": "result_text"
        },
        domProps: {
          "innerHTML": _vm._s(task.result)
        }
      }), _vm._v(" "), _c('b', [_vm._v("Hodnocení")]), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "p-4",
        staticStyle: {
          "white-space": "pre-wrap",
          "font-family": "monospace, monospace"
        },
        attrs: {
          "id": "result_text"
        },
        domProps: {
          "innerHTML": _vm._s(task.evaluation)
        }
      })]) : _c('td', {
        staticClass: "col-md-12"
      }, [_c('b', [_vm._v("Lékařská zpráva")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm btn-primary",
        on: {
          "click": function($event) {
            _vm.copyAndInsertReport(task.text)
          }
        }
      }, [_vm._v("Zkopírovat")]), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "p-4",
        staticStyle: {
          "white-space": "pre-wrap",
          "font-family": "monospace, monospace"
        },
        attrs: {
          "id": "result_text"
        },
        domProps: {
          "innerHTML": _vm._s(task.text)
        }
      }), _vm._v(" "), (task.visit) ? [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
        staticClass: "table"
      }, [_c('tbody', [_vm._l((task.visit.diagnosis), function(diagnose) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
          return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                              " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                            ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
            return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                              ")])])
          }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
            return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                                   zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                              ")])])
          }) : _vm._e()]
        })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(4, true)])]]
      })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(task.visit.medicament.length > 0) ? [_c('table', {
        staticClass: "table"
      }, [_c('tbody', _vm._l((task.visit.medicament), function(m) {
        return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + " " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
      }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])] : _vm._e()], 2)]) : _vm._e()]
    })], 2)])])])]) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('pagination-component', {
    attrs: {
      "list-pagination": _vm.listPagination
    },
    on: {
      "set-page": _vm.setPage
    }
  })], 1) : (_vm.listPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(5)]) : _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "lab-results-empty"
    }
  }, [_vm._m(6)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Laboratorní výsledky")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Stav")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Klient")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Doktor")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Datum přijetí")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_vm._v("S pozdravem"), _c('br'), _vm._v("\n                                                Urosanté")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("Datum odběru")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-5"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (nebyl nalezen žádný výsledek dle požadavků)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_doctor"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('results')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractualReporting_vue__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ecd037c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ContractualReporting_vue__ = __webpack_require__(745);
function injectStyle (ssrContext) {
  __webpack_require__(739)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ecd037c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractualReporting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ecd037c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ContractualReporting_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ContractualReporting_vue__ = __webpack_require__(741);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    ContractualReporting: __WEBPACK_IMPORTED_MODULE_0__components_ContractualReporting_vue__["a" /* default */]
  },
  methods: {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractualReporting_vue__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28cebb47_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ContractualReporting_vue__ = __webpack_require__(744);
function injectStyle (ssrContext) {
  __webpack_require__(742)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28cebb47"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractualReporting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28cebb47_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ContractualReporting_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PaginationComponent_vue__ = __webpack_require__(25);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      generateParams: {
        date: null,
        filter_insurance_company_code: '111,201,205,207,209,211,213',
        exclude_diagnosis_code: 'X3720',
        filter_diagnosis_code: '',
        filter_visit_id: '',
        filter_clients: '',
        repair: false,
        dry: true
      },
      selectedDate: null,
      hostname: __webpack_require__(3),
      generateContractualReportsPending: false,
      generateContractualReportsDone: false,
      generateContractualReports: null,
      generateContractualReportsError: false,

      deleteContractualReportPending: false,
      deleteContractualReportDone: false,
      deleteContractualReportError: false,
      selectedIds: [],

      getParams: {
        p: 1,
        s: 'created_at-',
        f: {},
        pp: 20
      },
      selectedStates: [],
      print_date: '',
      assignedTo: '',
      doctors: [],
      doctorsPending: false,
      doctorsError: false,
      selectedDoctorId: null,
      showDoctorModal: false,
      listData: false,
      listError: false,
      listPagination: null,
      listPending: false,
      clientPreviousTasks: false,
      clientPreviousTasksError: false,
      clientPreviousTasksPending: true,
      waiting: true,
      editingTaskId: false,
      editingTask: {},
      waitForSave: false,
      openedTaskId: false,
      openedTaskEvaluation: '',
      updatedTask: {
        evaluation: '',
        state: '',
        client_id: false,
        include_result_to_email: true,
        dont_send_email: false
      },
      selected: '',
      clients: [],
      clientsPending: false,
      clientsError: false,
      state: '',
      openedClientTaskId: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  methods: {
    setPage: function setPage(number) {
      this.getParams.p = number;
      this.getDoctorsDayTasks();
    },
    getDoctorsDayTasks: function getDoctorsDayTasks() {
      this.getContractualReports(this.getParams);
    },
    generate: function generate() {
      this.getGenerateContractualReports(this.generateParams);
    }
  },
  beforeMount: function beforeMount() {
    this.getDoctorsDayTasks(this.generateContractualReports);
  },

  watch: {
    selectedDate: function selectedDate(val) {
      if (val !== null) {
        this.generateParams.date = this.$moment(val).format('DD.MM.YYYY');
      }
    },
    generateContractualReportsDone: function generateContractualReportsDone(val) {
      if (val === true) {}
    }
  },
  components: {
    PaginationComponent: __WEBPACK_IMPORTED_MODULE_1__components_PaginationComponent_vue__["a" /* default */]
  },
  filters: {}
});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "contractual-reporting-page"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Měsíc pro generování dávky "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "validFrom",
      "input-class": "datapickerInput",
      "data-testid": "contractual-reporting-month"
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtr. pojišťovny\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.filter_insurance_company_code),
      expression: "generateParams.filter_insurance_company_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrované pojišťovny",
      "data-testid": "contractual-reporting-insurance-filter"
    },
    domProps: {
      "value": (_vm.generateParams.filter_insurance_company_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generateParams.filter_insurance_company_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Vyřazené diagnózy\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.exclude_diagnosis_code),
      expression: "generateParams.exclude_diagnosis_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Vyřazené diagnózy",
      "data-testid": "contractual-reporting-excluded-diagnoses"
    },
    domProps: {
      "value": (_vm.generateParams.exclude_diagnosis_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generateParams.exclude_diagnosis_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtr. diagnózy\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.filter_diagnosis_code),
      expression: "generateParams.filter_diagnosis_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrované diagnózy",
      "data-testid": "contractual-reporting-diagnosis-filter"
    },
    domProps: {
      "value": (_vm.generateParams.filter_diagnosis_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generateParams.filter_diagnosis_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-check col-md-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.repair),
      expression: "generateParams.repair"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "repair",
      "data-testid": "contractual-reporting-repair"
    },
    domProps: {
      "checked": Array.isArray(_vm.generateParams.repair) ? _vm._i(_vm.generateParams.repair, "") > -1 : (_vm.generateParams.repair)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.generateParams.repair,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.generateParams.repair = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.generateParams.repair = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.generateParams.repair = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "repair"
    }
  }, [_vm._v("\n                    Opravné\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check col-md-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.dry),
      expression: "generateParams.dry"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "test",
      "data-testid": "contractual-reporting-dry-run"
    },
    domProps: {
      "checked": Array.isArray(_vm.generateParams.dry) ? _vm._i(_vm.generateParams.dry, "") > -1 : (_vm.generateParams.dry)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.generateParams.dry,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.generateParams.dry = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.generateParams.dry = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.generateParams.dry = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "test"
    }
  }, [_vm._v("\n                    Test\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n              Filtr. návštěvy dle id\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.filter_visit_id),
      expression: "generateParams.filter_visit_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrované návštěvy",
      "data-testid": "contractual-reporting-visit-filter"
    },
    domProps: {
      "value": (_vm.generateParams.filter_visit_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generateParams.filter_visit_id = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n              Filtr. klientů dle id\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateParams.filter_clients),
      expression: "generateParams.filter_clients"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrovaní klienty",
      "data-testid": "contractual-reporting-client-filter"
    },
    domProps: {
      "value": (_vm.generateParams.filter_clients)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generateParams.filter_clients = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4 justify-content-end"
  }, [_c('div', {
    staticClass: "col-md-1 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "contractual-reporting-generate"
    },
    on: {
      "click": function($event) {
        _vm.generate()
      }
    }
  }, [_vm._v("Generovat")])])])]), _vm._v(" "), (_vm.generateContractualReportsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.generateContractualReports !== null) ? _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "contractual-reporting-generated"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.generateContractualReports), function(cr, index) {
    return [_c('tr', {
      staticClass: "row m-0"
    }, [_c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v("\n                " + _vm._s(cr.insurance_company_code) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v("\n                " + _vm._s(cr.insurance_type_code) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v("\n                " + _vm._s(cr.repair ? 'O' : 'P') + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                " + _vm._s(cr.points) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                " + _vm._s(cr.price) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                " + _vm._s(cr.number) + "\n              ")])])]
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": function($event) {
        _vm.getDoctorsDayTasks()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.listData.length > 0) ? _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "contractual-reporting-list"
    }
  }, [(_vm.selectedIds.length > 0) ? _c('a', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "href": _vm.hostname.hostname + 'contractual_reports/file_zip?ids=' + _vm.selectedIds.toString(),
      "target": "_blank",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" Stáhnout zazipované")]) : _c('a', {
    staticClass: "btn btn-sm btn-success disabled",
    attrs: {
      "role": "button",
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" Stáhnout zazipované")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_vm._l((_vm.listData), function(cr, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      attrs: {
        "data-testid": 'contractual-reporting-row-' + cr.id
      }
    }, [_c('td', {
      staticClass: "col-sm-1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedIds),
        expression: "selectedIds"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "data-testid": 'contractual-reporting-select-' + cr.id
      },
      domProps: {
        "value": cr.id,
        "checked": Array.isArray(_vm.selectedIds) ? _vm._i(_vm.selectedIds, cr.id) > -1 : (_vm.selectedIds)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = cr.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedIds = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedIds = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1",
      attrs: {
        "title": cr.insurance_company.name
      }
    }, [_vm._v("\n                        " + _vm._s(cr.insurance_company.code) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1",
      attrs: {
        "title": cr.insurance_type.name
      }
    }, [_vm._v("\n                        " + _vm._s(cr.insurance_type.code) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1",
      attrs: {
        "title": cr.repair ? 'Opravná' : 'Původní'
      }
    }, [_vm._v("\n                        " + _vm._s(cr.repair ? 'O' : 'P') + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                        " + _vm._s(_vm.$moment(cr.created_at, 'DD.MM.YYYY H:mm').format('DD.MM.YYYY HH:mm')) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                        " + _vm._s(cr.points) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v("\n                        " + _vm._s(cr.price) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_vm._v("\n                        " + _vm._s(cr.number) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1"
    }, [_c('a', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "target": "_blank",
        "role": "button",
        "href": _vm.hostname.hostname + 'contractual_reports/' + cr.id + '/file'
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _vm._v(" "), (!_vm.deleteContractualReportPending) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": 'contractual-reporting-delete-' + cr.id
      },
      on: {
        "click": function($event) {
          _vm.deleteContractualReport(cr.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])])])]
  })], 2)]), _vm._v(" "), _c('pagination-component', {
    attrs: {
      "list-pagination": _vm.listPagination
    },
    on: {
      "set-page": _vm.setPage
    }
  })], 1) : (_vm.listPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(5)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(6)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Generování dávek")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n          (generuji)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Pojišťovna")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Typ")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Charakter")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Počet bodů")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Cena")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Kód souboru")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Přehled dříve vygenerovaných dávek")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Pojišťovna")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Typ")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Charakter")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Vygenerováno")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Počet bodů")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Cena")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("Kód souboru")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                  (načítám)\n          ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n              (nebyl nalezen žádný výsledek dle požadavků)\n          ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_doctor"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('contractual-reporting')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364a693c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__ = __webpack_require__(757);
function injectStyle (ssrContext) {
  __webpack_require__(747)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-364a693c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364a693c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tasks_vue__ = __webpack_require__(749);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    Results: __WEBPACK_IMPORTED_MODULE_0__components_Tasks_vue__["a" /* default */]
  },
  methods: {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3893951c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__ = __webpack_require__(756);
function injectStyle (ssrContext) {
  __webpack_require__(750)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3893951c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3893951c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TaskChangeState_vue__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__);










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      visits_header_title: '',
      setting: __webpack_require__(3),
      get_params: {
        date: ''
      },
      selectedStates: ['scheduled'],
      print_date: '',
      taskTemplate: '',
      taskTemplates: [],
      doctorsPending: false,
      doctorsError: false,
      selectedDoctorId: null,
      showDoctorModal: false,
      selectedDate: '',
      tasks: false,
      tasksError: false,
      tasksPending: true,
      clientPreviousTasks: false,
      clientPreviousTasksError: false,
      clientPreviousTasksPending: true,
      waiting: true,
      editingTaskId: false,
      editingTask: {},
      waitForSave: false,
      openedTaskId: false,
      openedTaskEvaluation: '',
      updatedTask: {
        evaluation: '',
        state: '',
        client_id: false,
        include_result_to_email: true
      },
      selected: '',
      clients: [],
      clientsPending: false,
      clientsError: false,
      state: '',
      openedClientTaskId: false,
      taskType: 0
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  methods: {
    editTask: function editTask(text, id) {
      this.editingTaskId = id;
      this.editingTask = {
        text: text
      };
    },
    putTask: function putTask() {
      var _this = this;

      this.waitForSave = true;
      this.$http.put('task/' + this.editingTaskId, this.editingTask, { emulateJSON: true }).then(function (response) {
        _this.waitForSave = false;
        _this.editingTaskId = false;
        _this.editingTask = {};
        _this.getDoctorsDayTasks();
      }, function (response) {
        _this.errors = response.data.errors;
        _this.waitForSave = false;
      });
    },
    getDoctorsDayTasks: function getDoctorsDayTasks() {
      var getParams = {
        states: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedStates)
      };
      if (this.taskType === 0) {
        this.getTasksOld(getParams);
      } else {
        this.getTasksCreatedByMedic(getParams);
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getDoctorsDayTasks();
  },

  watch: {
    taskType: function taskType(val, oldVal) {
      if (val !== oldVal) {
        console.log('jupii');
        this.getDoctorsDayTasks();
      }
    },

    selectedStates: function selectedStates(val) {
      this.getDoctorsDayTasks();
    },
    assignedTo: function assignedTo() {
      this.getDoctorsDayTasks();
    },
    selectedDate: function selectedDate(val) {
      this.selected_date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(val);
      this.setDateAndLoad();
    }
  },
  components: {
    TaskChangeState: __WEBPACK_IMPORTED_MODULE_3__components_TaskChangeState_vue__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default.a
  },
  filters: {}
});

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskChangeState_vue__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3fa040_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_TaskChangeState_vue__ = __webpack_require__(755);
function injectStyle (ssrContext) {
  __webpack_require__(753)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d3fa040"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskChangeState_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3fa040_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_TaskChangeState_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      setting: __webpack_require__(3),
      changePending: false,
      changeError: null,
      task: {},
      isOpen: false,
      states: {
        scheduled: 'nedokončeno',
        completed: 'dokončit',
        canceled: 'zrušit'
      }
    };
  },

  props: ['actualState', 'taskId'],
  methods: {
    changeState: function changeState(newState) {
      var _this = this;

      this.changePending = true;
      this.task.state = newState;
      this.$http.put('task/' + this.taskId, this.task, { emulateJSON: true }).then(function (response) {
        _this.submited = response.data;
        _this.changePending = false;
        _this.$emit('update');
        _this.close();
      }).catch(function (error) {
        _this.changeError = error.response.data.errors;
        _this.changePending = false;
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    }
  },
  watch: {}
});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "manual",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('button', {
    staticClass: "tooltip-target btn btn-sm btn-link",
    attrs: {
      "data-testid": 'tasks-state-button-' + _vm.taskId
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.actualState === 'scheduled') ? _c('i', {
    staticClass: "fa fa-2x fa-circle-o text-info",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'completed') ? _c('i', {
    staticClass: "fa fa-2x fa-check-circle text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.actualState === 'canceled') ? _c('i', {
    staticClass: "fa fa-2x fa-times-circle text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.states[_vm.actualState]))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.actualState === 'scheduled') ? [_c('button', {
    staticClass: "btn btn-danger m-1",
    attrs: {
      "data-testid": 'tasks-state-cancel-' + _vm.taskId
    },
    on: {
      "click": function($event) {
        _vm.changeState('canceled')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.canceled))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success m-1",
    attrs: {
      "data-testid": 'tasks-state-complete-' + _vm.taskId
    },
    on: {
      "click": function($event) {
        _vm.changeState('completed')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.states.completed))])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-danger mt-3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("zavřít")])])])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "tasks-page"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-center"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskType),
      expression: "taskType"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "typ úkolu",
      "data-testid": "tasks-feed-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.taskType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("mé úkoly")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("mnou zadané úkoly")])]), _vm._v(" "), (_vm.selectedStates.indexOf('scheduled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "scheduled",
      "data-testid": "tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('scheduled')
      }
    }
  }, [_vm._v("nesplněné")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "scheduled",
      "data-testid": "tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('scheduled'), 1)
      }
    }
  }, [_vm._v("nesplněné")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "completed",
      "data-testid": "tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("dokončené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "completed",
      "data-testid": "tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("dokončené")]), _vm._v(" "), (_vm.selectedStates.indexOf('canceled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled",
      "data-testid": "tasks-filter-canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('canceled')
      }
    }
  }, [_vm._v("zrušené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled",
      "data-testid": "tasks-filter-canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('canceled'), 1)
      }
    }
  }, [_vm._v("zrušené")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "tasks-refresh"
    },
    on: {
      "click": function($event) {
        _vm.getDoctorsDayTasks()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.tasks.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.tasks), function(task, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      attrs: {
        "data-testid": 'tasks-row-' + task.id
      }
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [_c('task-change-state', {
      attrs: {
        "actual-state": task.state,
        "task-id": task.id
      },
      on: {
        "update": _vm.getDoctorsDayTasks
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-left col-sm-2",
      attrs: {
        "data-testid": 'tasks-client-' + task.id
      }
    }, [(task.client !== null) ? [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: task.client.id
          }
        },
        "data-testid": 'tasks-client-link-' + task.id
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(task.client.full_name))]), _c('br'), (task.client.insurance_number) ? _c('span', [_vm._v("ČP: "), _c('b', [_vm._v(_vm._s(task.client.insurance_number))])]) : _c('span', [_vm._v("RČ: "), _c('b', [_vm._v(_vm._s(task.client.p_i_n))])])] : [_c('span', [_vm._v("- - -")])]], 2), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-sm-2",
      attrs: {
        "data-testid": 'tasks-kind-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(task.template !== null ? task.template.name : 'jiný') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-4",
      attrs: {
        "data-testid": 'tasks-text-' + task.id
      }
    }, [(_vm.editingTaskId === task.id) ? [_c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.putTask(task)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingTask.text),
        expression: "editingTask.text"
      }],
      staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "noteHelp",
        "id": "text",
        "data-testid": 'tasks-edit-input-' + task.id
      },
      domProps: {
        "value": (_vm.editingTask.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingTask.text = $event.target.value
        }
      }
    }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "data-testid": 'tasks-edit-save-' + task.id
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])])] : [_c('button', {
      staticClass: "btn btn-sm btn-link text-secondary",
      attrs: {
        "data-testid": 'tasks-edit-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.editTask(task.text, task.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" " + _vm._s(task.template !== null ? task.template.text + ' - ' : '') + _vm._s(task.text) + "\n                        ")]], 2), _vm._v(" "), _c('td', {
      staticClass: "col-sm-2",
      attrs: {
        "data-testid": 'tasks-assignees-' + task.id
      }
    }, [_vm._l((task.assigned_medics), function(assigned_medic, index) {
      return [_vm._v("\n                            " + _vm._s(assigned_medic.fullname)), (index != task.assigned_medics.length - 1) ? [_vm._v(", ")] : _vm._e()]
    })], 2), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1 text-right"
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'vytvořil/a: <b>' + task.created_by.fullname + '</b>' + (task.completed_by !== null ? '<br>splnil/a: <b>' + task.completed_by.fullname + '</b>' : ''),
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                            content: 'vytvořil/a: <b>' + task.created_by.fullname + '</b>' + (task.completed_by !== null ? '<br>splnil/a: <b>' + task.completed_by.fullname + '</b>': ''),\n                            placement: 'bottom-center',\n                            classes: ['info']}"
      }],
      staticClass: "fa fa-2x fa-info-circle text-info"
    })])])]
  })], 2)])]) : (_vm.tasksPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "tasks-empty"
    }
  }, [_vm._m(3)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Úkoly")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Klient")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Druh")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-4"
  }, [_vm._v("Úkol")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Úkol pro")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n                (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (nebyl nalezen žádný úkol)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_doctor"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('results')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(22);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  state: {
    clientId: false
  },
  mutations: {
    setClientId: function setClientId(state, clientId) {
      state.clientId = clientId;
    },
    unsetClientId: function unsetClientId(state) {
      state.clientId = false;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2b29e2b8_hasScoped_false_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__ = __webpack_require__(767);
function injectStyle (ssrContext) {
  __webpack_require__(765)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2b29e2b8_hasScoped_false_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(78);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(6);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "time-picker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayTime),
      expression: "displayTime"
    }],
    staticClass: "display-time",
    attrs: {
      "id": _vm.id,
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.displayTime)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDropdown($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayTime = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.hideClearButton) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDropdown && _vm.showClearBtn),
      expression: "!showDropdown && showClearBtn"
    }],
    staticClass: "clear-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clearTime($event)
      }
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticClass: "time-picker-overlay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDropdown($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdown),
      expression: "showDropdown"
    }],
    staticClass: "dropdown"
  }, [_c('div', {
    staticClass: "select-list"
  }, [_c('ul', {
    staticClass: "hours"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.hourType)
    }
  }), _vm._v(" "), _vm._l((_vm.hours), function(hr) {
    return _c('li', {
      class: {
        active: _vm.hour === hr
      },
      domProps: {
        "textContent": _vm._s(hr)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select('hour', hr)
        }
      }
    })
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "minutes"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.minuteType)
    }
  }), _vm._v(" "), _vm._l((_vm.minutes), function(m) {
    return _c('li', {
      class: {
        active: _vm.minute === m
      },
      domProps: {
        "textContent": _vm._s(m)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select('minute', m)
        }
      }
    })
  })], 2), _vm._v(" "), (_vm.secondType) ? _c('ul', {
    staticClass: "seconds"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.secondType)
    }
  }), _vm._v(" "), _vm._l((_vm.seconds), function(s) {
    return _c('li', {
      class: {
        active: _vm.second === s
      },
      domProps: {
        "textContent": _vm._s(s)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select('second', s)
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.apmType) ? _c('ul', {
    staticClass: "apms"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.apmType)
    }
  }), _vm._v(" "), _vm._l((_vm.apms), function(a) {
    return _c('li', {
      class: {
        active: _vm.apm === a
      },
      domProps: {
        "textContent": _vm._s(a)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select('apm', a)
        }
      }
    })
  })], 2) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[228]);


// WEBPACK FOOTER //
// static/js/app.da1fda1df59e3caef7d6.js